/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _text: { input: string; output: string; }
  chartType: { input: string; output: string; }
  jsonb: { input: string; output: string; }
  time: { input: string; output: string; }
  timestamp: { input: string; output: string; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']['input']>;
  _gt?: InputMaybe<Scalars['_text']['input']>;
  _gte?: InputMaybe<Scalars['_text']['input']>;
  _in?: InputMaybe<Array<Scalars['_text']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_text']['input']>;
  _lte?: InputMaybe<Scalars['_text']['input']>;
  _neq?: InputMaybe<Scalars['_text']['input']>;
  _nin?: InputMaybe<Array<Scalars['_text']['input']>>;
};

/** columns and relationships of "asyncJobs" */
export type AsyncJobs = {
  __typename?: 'asyncJobs';
  createdAt: Scalars['timestamptz']['output'];
  errorData?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  jobCompletedAt?: Maybe<Scalars['timestamptz']['output']>;
  jobStartedAt?: Maybe<Scalars['timestamptz']['output']>;
  jobStatus: Scalars['String']['output'];
  operationName: Scalars['String']['output'];
  operationParams: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "asyncJobs" */
export type AsyncJobs_Aggregate = {
  __typename?: 'asyncJobs_aggregate';
  aggregate?: Maybe<AsyncJobs_Aggregate_Fields>;
  nodes: Array<AsyncJobs>;
};

/** aggregate fields of "asyncJobs" */
export type AsyncJobs_Aggregate_Fields = {
  __typename?: 'asyncJobs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AsyncJobs_Max_Fields>;
  min?: Maybe<AsyncJobs_Min_Fields>;
};


/** aggregate fields of "asyncJobs" */
export type AsyncJobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AsyncJobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "asyncJobs". All fields are combined with a logical 'AND'. */
export type AsyncJobs_Bool_Exp = {
  _and?: InputMaybe<Array<AsyncJobs_Bool_Exp>>;
  _not?: InputMaybe<AsyncJobs_Bool_Exp>;
  _or?: InputMaybe<Array<AsyncJobs_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  errorData?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobCompletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  jobStartedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  jobStatus?: InputMaybe<String_Comparison_Exp>;
  operationName?: InputMaybe<String_Comparison_Exp>;
  operationParams?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asyncJobs" */
export enum AsyncJobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  AsyncJobsPkey = 'asyncJobs_pkey'
}

/** input type for inserting data into table "asyncJobs" */
export type AsyncJobs_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  errorData?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobCompletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  jobStartedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  operationParams?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type AsyncJobs_Max_Fields = {
  __typename?: 'asyncJobs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  errorData?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobCompletedAt?: Maybe<Scalars['timestamptz']['output']>;
  jobStartedAt?: Maybe<Scalars['timestamptz']['output']>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  operationName?: Maybe<Scalars['String']['output']>;
  operationParams?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type AsyncJobs_Min_Fields = {
  __typename?: 'asyncJobs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  errorData?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobCompletedAt?: Maybe<Scalars['timestamptz']['output']>;
  jobStartedAt?: Maybe<Scalars['timestamptz']['output']>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  operationName?: Maybe<Scalars['String']['output']>;
  operationParams?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "asyncJobs" */
export type AsyncJobs_Mutation_Response = {
  __typename?: 'asyncJobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AsyncJobs>;
};

/** on_conflict condition type for table "asyncJobs" */
export type AsyncJobs_On_Conflict = {
  constraint: AsyncJobs_Constraint;
  update_columns?: Array<AsyncJobs_Update_Column>;
  where?: InputMaybe<AsyncJobs_Bool_Exp>;
};

/** Ordering options when selecting data from "asyncJobs". */
export type AsyncJobs_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  errorData?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobCompletedAt?: InputMaybe<Order_By>;
  jobStartedAt?: InputMaybe<Order_By>;
  jobStatus?: InputMaybe<Order_By>;
  operationName?: InputMaybe<Order_By>;
  operationParams?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asyncJobs */
export type AsyncJobs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asyncJobs" */
export enum AsyncJobs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ErrorData = 'errorData',
  /** column name */
  Id = 'id',
  /** column name */
  JobCompletedAt = 'jobCompletedAt',
  /** column name */
  JobStartedAt = 'jobStartedAt',
  /** column name */
  JobStatus = 'jobStatus',
  /** column name */
  OperationName = 'operationName',
  /** column name */
  OperationParams = 'operationParams',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "asyncJobs" */
export type AsyncJobs_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  errorData?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobCompletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  jobStartedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  operationParams?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "asyncJobs" */
export type AsyncJobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AsyncJobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AsyncJobs_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  errorData?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobCompletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  jobStartedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  operationParams?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "asyncJobs" */
export enum AsyncJobs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ErrorData = 'errorData',
  /** column name */
  Id = 'id',
  /** column name */
  JobCompletedAt = 'jobCompletedAt',
  /** column name */
  JobStartedAt = 'jobStartedAt',
  /** column name */
  JobStatus = 'jobStatus',
  /** column name */
  OperationName = 'operationName',
  /** column name */
  OperationParams = 'operationParams',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AsyncJobs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AsyncJobs_Set_Input>;
  where: AsyncJobs_Bool_Exp;
};

/** Boolean expression to compare columns of type "chartType". All fields are combined with logical 'AND'. */
export type ChartType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['chartType']['input']>;
  _gt?: InputMaybe<Scalars['chartType']['input']>;
  _gte?: InputMaybe<Scalars['chartType']['input']>;
  _in?: InputMaybe<Array<Scalars['chartType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['chartType']['input']>;
  _lte?: InputMaybe<Scalars['chartType']['input']>;
  _neq?: InputMaybe<Scalars['chartType']['input']>;
  _nin?: InputMaybe<Array<Scalars['chartType']['input']>>;
};

/** columns and relationships of "chartsConfig" */
export type ChartsConfig = {
  __typename?: 'chartsConfig';
  config: Scalars['jsonb']['output'];
  contentId: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  entityId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  story: Stories;
  /** An object relationship */
  storyContent: StoryContents;
  storyId: Scalars['String']['output'];
  type: Scalars['chartType']['output'];
  updatedAt: Scalars['timestamp']['output'];
};


/** columns and relationships of "chartsConfig" */
export type ChartsConfigConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "chartsConfig" */
export type ChartsConfig_Aggregate = {
  __typename?: 'chartsConfig_aggregate';
  aggregate?: Maybe<ChartsConfig_Aggregate_Fields>;
  nodes: Array<ChartsConfig>;
};

export type ChartsConfig_Aggregate_Bool_Exp = {
  count?: InputMaybe<ChartsConfig_Aggregate_Bool_Exp_Count>;
};

export type ChartsConfig_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChartsConfig_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "chartsConfig" */
export type ChartsConfig_Aggregate_Fields = {
  __typename?: 'chartsConfig_aggregate_fields';
  avg?: Maybe<ChartsConfig_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ChartsConfig_Max_Fields>;
  min?: Maybe<ChartsConfig_Min_Fields>;
  stddev?: Maybe<ChartsConfig_Stddev_Fields>;
  stddev_pop?: Maybe<ChartsConfig_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ChartsConfig_Stddev_Samp_Fields>;
  sum?: Maybe<ChartsConfig_Sum_Fields>;
  var_pop?: Maybe<ChartsConfig_Var_Pop_Fields>;
  var_samp?: Maybe<ChartsConfig_Var_Samp_Fields>;
  variance?: Maybe<ChartsConfig_Variance_Fields>;
};


/** aggregate fields of "chartsConfig" */
export type ChartsConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "chartsConfig" */
export type ChartsConfig_Aggregate_Order_By = {
  avg?: InputMaybe<ChartsConfig_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ChartsConfig_Max_Order_By>;
  min?: InputMaybe<ChartsConfig_Min_Order_By>;
  stddev?: InputMaybe<ChartsConfig_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ChartsConfig_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ChartsConfig_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ChartsConfig_Sum_Order_By>;
  var_pop?: InputMaybe<ChartsConfig_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ChartsConfig_Var_Samp_Order_By>;
  variance?: InputMaybe<ChartsConfig_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ChartsConfig_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "chartsConfig" */
export type ChartsConfig_Arr_Rel_Insert_Input = {
  data: Array<ChartsConfig_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ChartsConfig_On_Conflict>;
};

/** aggregate avg on columns */
export type ChartsConfig_Avg_Fields = {
  __typename?: 'chartsConfig_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "chartsConfig" */
export type ChartsConfig_Avg_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "chartsConfig". All fields are combined with a logical 'AND'. */
export type ChartsConfig_Bool_Exp = {
  _and?: InputMaybe<Array<ChartsConfig_Bool_Exp>>;
  _not?: InputMaybe<ChartsConfig_Bool_Exp>;
  _or?: InputMaybe<Array<ChartsConfig_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  contentId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyContent?: InputMaybe<StoryContents_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<ChartType_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "chartsConfig" */
export enum ChartsConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChartsConfigPkey = 'chartsConfig_pkey',
  /** unique or primary key constraint on columns "contentId", "storyId" */
  UniqueChartsConfig = 'unique_charts_config'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ChartsConfig_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ChartsConfig_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ChartsConfig_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "chartsConfig" */
export type ChartsConfig_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "chartsConfig" */
export type ChartsConfig_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyContent?: InputMaybe<StoryContents_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['chartType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type ChartsConfig_Max_Fields = {
  __typename?: 'chartsConfig_max_fields';
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['chartType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "chartsConfig" */
export type ChartsConfig_Max_Order_By = {
  contentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ChartsConfig_Min_Fields = {
  __typename?: 'chartsConfig_min_fields';
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['chartType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "chartsConfig" */
export type ChartsConfig_Min_Order_By = {
  contentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "chartsConfig" */
export type ChartsConfig_Mutation_Response = {
  __typename?: 'chartsConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChartsConfig>;
};

/** on_conflict condition type for table "chartsConfig" */
export type ChartsConfig_On_Conflict = {
  constraint: ChartsConfig_Constraint;
  update_columns?: Array<ChartsConfig_Update_Column>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "chartsConfig". */
export type ChartsConfig_Order_By = {
  config?: InputMaybe<Order_By>;
  contentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyContent?: InputMaybe<StoryContents_Order_By>;
  storyId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chartsConfig */
export type ChartsConfig_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ChartsConfig_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "chartsConfig" */
export enum ChartsConfig_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  ContentId = 'contentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "chartsConfig" */
export type ChartsConfig_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['chartType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type ChartsConfig_Stddev_Fields = {
  __typename?: 'chartsConfig_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "chartsConfig" */
export type ChartsConfig_Stddev_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ChartsConfig_Stddev_Pop_Fields = {
  __typename?: 'chartsConfig_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "chartsConfig" */
export type ChartsConfig_Stddev_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ChartsConfig_Stddev_Samp_Fields = {
  __typename?: 'chartsConfig_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "chartsConfig" */
export type ChartsConfig_Stddev_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "chartsConfig" */
export type ChartsConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ChartsConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ChartsConfig_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['chartType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type ChartsConfig_Sum_Fields = {
  __typename?: 'chartsConfig_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "chartsConfig" */
export type ChartsConfig_Sum_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** update columns of table "chartsConfig" */
export enum ChartsConfig_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  ContentId = 'contentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ChartsConfig_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ChartsConfig_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ChartsConfig_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ChartsConfig_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ChartsConfig_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ChartsConfig_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ChartsConfig_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChartsConfig_Set_Input>;
  where: ChartsConfig_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ChartsConfig_Var_Pop_Fields = {
  __typename?: 'chartsConfig_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "chartsConfig" */
export type ChartsConfig_Var_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ChartsConfig_Var_Samp_Fields = {
  __typename?: 'chartsConfig_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "chartsConfig" */
export type ChartsConfig_Var_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ChartsConfig_Variance_Fields = {
  __typename?: 'chartsConfig_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "chartsConfig" */
export type ChartsConfig_Variance_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** columns and relationships of "copyProcessStatuses" */
export type CopyProcessStatuses = {
  __typename?: 'copyProcessStatuses';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "copyProcessStatuses" */
export type CopyProcessStatuses_Aggregate = {
  __typename?: 'copyProcessStatuses_aggregate';
  aggregate?: Maybe<CopyProcessStatuses_Aggregate_Fields>;
  nodes: Array<CopyProcessStatuses>;
};

/** aggregate fields of "copyProcessStatuses" */
export type CopyProcessStatuses_Aggregate_Fields = {
  __typename?: 'copyProcessStatuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<CopyProcessStatuses_Max_Fields>;
  min?: Maybe<CopyProcessStatuses_Min_Fields>;
};


/** aggregate fields of "copyProcessStatuses" */
export type CopyProcessStatuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CopyProcessStatuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "copyProcessStatuses". All fields are combined with a logical 'AND'. */
export type CopyProcessStatuses_Bool_Exp = {
  _and?: InputMaybe<Array<CopyProcessStatuses_Bool_Exp>>;
  _not?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
  _or?: InputMaybe<Array<CopyProcessStatuses_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "copyProcessStatuses" */
export enum CopyProcessStatuses_Constraint {
  /** unique or primary key constraint on columns "value" */
  CopyProcessStatusesPkey = 'copyProcessStatuses_pkey'
}

export enum CopyProcessStatuses_Enum {
  /** Error */
  Error = 'error',
  /** In Progress */
  InProgress = 'in_progress',
  /** Success */
  Success = 'success'
}

/** Boolean expression to compare columns of type "copyProcessStatuses_enum". All fields are combined with logical 'AND'. */
export type CopyProcessStatuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<CopyProcessStatuses_Enum>;
  _in?: InputMaybe<Array<CopyProcessStatuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CopyProcessStatuses_Enum>;
  _nin?: InputMaybe<Array<CopyProcessStatuses_Enum>>;
};

/** input type for inserting data into table "copyProcessStatuses" */
export type CopyProcessStatuses_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CopyProcessStatuses_Max_Fields = {
  __typename?: 'copyProcessStatuses_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CopyProcessStatuses_Min_Fields = {
  __typename?: 'copyProcessStatuses_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "copyProcessStatuses" */
export type CopyProcessStatuses_Mutation_Response = {
  __typename?: 'copyProcessStatuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CopyProcessStatuses>;
};

/** input type for inserting object relation for remote table "copyProcessStatuses" */
export type CopyProcessStatuses_Obj_Rel_Insert_Input = {
  data: CopyProcessStatuses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CopyProcessStatuses_On_Conflict>;
};

/** on_conflict condition type for table "copyProcessStatuses" */
export type CopyProcessStatuses_On_Conflict = {
  constraint: CopyProcessStatuses_Constraint;
  update_columns?: Array<CopyProcessStatuses_Update_Column>;
  where?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
};

/** Ordering options when selecting data from "copyProcessStatuses". */
export type CopyProcessStatuses_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: copyProcessStatuses */
export type CopyProcessStatuses_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "copyProcessStatuses" */
export enum CopyProcessStatuses_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "copyProcessStatuses" */
export type CopyProcessStatuses_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "copyProcessStatuses" */
export type CopyProcessStatuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CopyProcessStatuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CopyProcessStatuses_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "copyProcessStatuses" */
export enum CopyProcessStatuses_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type CopyProcessStatuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CopyProcessStatuses_Set_Input>;
  where: CopyProcessStatuses_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings = {
  __typename?: 'entityProgressTrackerSettings';
  colorCode: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  entityId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Aggregate = {
  __typename?: 'entityProgressTrackerSettings_aggregate';
  aggregate?: Maybe<EntityProgressTrackerSettings_Aggregate_Fields>;
  nodes: Array<EntityProgressTrackerSettings>;
};

/** aggregate fields of "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Aggregate_Fields = {
  __typename?: 'entityProgressTrackerSettings_aggregate_fields';
  avg?: Maybe<EntityProgressTrackerSettings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EntityProgressTrackerSettings_Max_Fields>;
  min?: Maybe<EntityProgressTrackerSettings_Min_Fields>;
  stddev?: Maybe<EntityProgressTrackerSettings_Stddev_Fields>;
  stddev_pop?: Maybe<EntityProgressTrackerSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EntityProgressTrackerSettings_Stddev_Samp_Fields>;
  sum?: Maybe<EntityProgressTrackerSettings_Sum_Fields>;
  var_pop?: Maybe<EntityProgressTrackerSettings_Var_Pop_Fields>;
  var_samp?: Maybe<EntityProgressTrackerSettings_Var_Samp_Fields>;
  variance?: Maybe<EntityProgressTrackerSettings_Variance_Fields>;
};


/** aggregate fields of "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityProgressTrackerSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EntityProgressTrackerSettings_Avg_Fields = {
  __typename?: 'entityProgressTrackerSettings_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "entityProgressTrackerSettings". All fields are combined with a logical 'AND'. */
export type EntityProgressTrackerSettings_Bool_Exp = {
  _and?: InputMaybe<Array<EntityProgressTrackerSettings_Bool_Exp>>;
  _not?: InputMaybe<EntityProgressTrackerSettings_Bool_Exp>;
  _or?: InputMaybe<Array<EntityProgressTrackerSettings_Bool_Exp>>;
  colorCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "entityProgressTrackerSettings" */
export enum EntityProgressTrackerSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityProgressTrackerSettingsPkey = 'entityProgressTrackerSettings_pkey',
  /** unique or primary key constraint on columns "entityId", "status" */
  UqEptsEntityStatus = 'uq_epts_entity_status'
}

/** input type for incrementing numeric columns in table "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Insert_Input = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EntityProgressTrackerSettings_Max_Fields = {
  __typename?: 'entityProgressTrackerSettings_max_fields';
  colorCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EntityProgressTrackerSettings_Min_Fields = {
  __typename?: 'entityProgressTrackerSettings_min_fields';
  colorCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Mutation_Response = {
  __typename?: 'entityProgressTrackerSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityProgressTrackerSettings>;
};

/** on_conflict condition type for table "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_On_Conflict = {
  constraint: EntityProgressTrackerSettings_Constraint;
  update_columns?: Array<EntityProgressTrackerSettings_Update_Column>;
  where?: InputMaybe<EntityProgressTrackerSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "entityProgressTrackerSettings". */
export type EntityProgressTrackerSettings_Order_By = {
  colorCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entityProgressTrackerSettings */
export type EntityProgressTrackerSettings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "entityProgressTrackerSettings" */
export enum EntityProgressTrackerSettings_Select_Column {
  /** column name */
  ColorCode = 'colorCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Set_Input = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type EntityProgressTrackerSettings_Stddev_Fields = {
  __typename?: 'entityProgressTrackerSettings_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EntityProgressTrackerSettings_Stddev_Pop_Fields = {
  __typename?: 'entityProgressTrackerSettings_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EntityProgressTrackerSettings_Stddev_Samp_Fields = {
  __typename?: 'entityProgressTrackerSettings_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "entityProgressTrackerSettings" */
export type EntityProgressTrackerSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityProgressTrackerSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityProgressTrackerSettings_Stream_Cursor_Value_Input = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type EntityProgressTrackerSettings_Sum_Fields = {
  __typename?: 'entityProgressTrackerSettings_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "entityProgressTrackerSettings" */
export enum EntityProgressTrackerSettings_Update_Column {
  /** column name */
  ColorCode = 'colorCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityProgressTrackerSettings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityProgressTrackerSettings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityProgressTrackerSettings_Set_Input>;
  where: EntityProgressTrackerSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EntityProgressTrackerSettings_Var_Pop_Fields = {
  __typename?: 'entityProgressTrackerSettings_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EntityProgressTrackerSettings_Var_Samp_Fields = {
  __typename?: 'entityProgressTrackerSettings_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EntityProgressTrackerSettings_Variance_Fields = {
  __typename?: 'entityProgressTrackerSettings_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "entityStoryColorSettings" */
export type EntityStoryColorSettings = {
  __typename?: 'entityStoryColorSettings';
  active: Scalars['String']['output'];
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  entityId: Scalars['Int']['output'];
  /** An array of hex color strings e.g. #143a89 */
  swatches: Scalars['jsonb']['output'];
};


/** columns and relationships of "entityStoryColorSettings" */
export type EntityStoryColorSettingsSwatchesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "entityStoryColorSettings" */
export type EntityStoryColorSettings_Aggregate = {
  __typename?: 'entityStoryColorSettings_aggregate';
  aggregate?: Maybe<EntityStoryColorSettings_Aggregate_Fields>;
  nodes: Array<EntityStoryColorSettings>;
};

export type EntityStoryColorSettings_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityStoryColorSettings_Aggregate_Bool_Exp_Count>;
};

export type EntityStoryColorSettings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entityStoryColorSettings" */
export type EntityStoryColorSettings_Aggregate_Fields = {
  __typename?: 'entityStoryColorSettings_aggregate_fields';
  avg?: Maybe<EntityStoryColorSettings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EntityStoryColorSettings_Max_Fields>;
  min?: Maybe<EntityStoryColorSettings_Min_Fields>;
  stddev?: Maybe<EntityStoryColorSettings_Stddev_Fields>;
  stddev_pop?: Maybe<EntityStoryColorSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EntityStoryColorSettings_Stddev_Samp_Fields>;
  sum?: Maybe<EntityStoryColorSettings_Sum_Fields>;
  var_pop?: Maybe<EntityStoryColorSettings_Var_Pop_Fields>;
  var_samp?: Maybe<EntityStoryColorSettings_Var_Samp_Fields>;
  variance?: Maybe<EntityStoryColorSettings_Variance_Fields>;
};


/** aggregate fields of "entityStoryColorSettings" */
export type EntityStoryColorSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Aggregate_Order_By = {
  avg?: InputMaybe<EntityStoryColorSettings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityStoryColorSettings_Max_Order_By>;
  min?: InputMaybe<EntityStoryColorSettings_Min_Order_By>;
  stddev?: InputMaybe<EntityStoryColorSettings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EntityStoryColorSettings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EntityStoryColorSettings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EntityStoryColorSettings_Sum_Order_By>;
  var_pop?: InputMaybe<EntityStoryColorSettings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EntityStoryColorSettings_Var_Samp_Order_By>;
  variance?: InputMaybe<EntityStoryColorSettings_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EntityStoryColorSettings_Append_Input = {
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Arr_Rel_Insert_Input = {
  data: Array<EntityStoryColorSettings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityStoryColorSettings_On_Conflict>;
};

/** aggregate avg on columns */
export type EntityStoryColorSettings_Avg_Fields = {
  __typename?: 'entityStoryColorSettings_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Avg_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entityStoryColorSettings". All fields are combined with a logical 'AND'. */
export type EntityStoryColorSettings_Bool_Exp = {
  _and?: InputMaybe<Array<EntityStoryColorSettings_Bool_Exp>>;
  _not?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
  _or?: InputMaybe<Array<EntityStoryColorSettings_Bool_Exp>>;
  active?: InputMaybe<String_Comparison_Exp>;
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum_Comparison_Exp>;
  contentType?: InputMaybe<StoryContentTypes_Enum_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  swatches?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "entityStoryColorSettings" */
export enum EntityStoryColorSettings_Constraint {
  /** unique or primary key constraint on columns "entityId", "colorTarget", "contentType" */
  EntityStoryColorSettingsPkey = 'entityStoryColorSettings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EntityStoryColorSettings_Delete_At_Path_Input = {
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EntityStoryColorSettings_Delete_Elem_Input = {
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EntityStoryColorSettings_Delete_Key_Input = {
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Insert_Input = {
  active?: InputMaybe<Scalars['String']['input']>;
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type EntityStoryColorSettings_Max_Fields = {
  __typename?: 'entityStoryColorSettings_max_fields';
  active?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Max_Order_By = {
  active?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityStoryColorSettings_Min_Fields = {
  __typename?: 'entityStoryColorSettings_min_fields';
  active?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Min_Order_By = {
  active?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Mutation_Response = {
  __typename?: 'entityStoryColorSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityStoryColorSettings>;
};

/** on_conflict condition type for table "entityStoryColorSettings" */
export type EntityStoryColorSettings_On_Conflict = {
  constraint: EntityStoryColorSettings_Constraint;
  update_columns?: Array<EntityStoryColorSettings_Update_Column>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "entityStoryColorSettings". */
export type EntityStoryColorSettings_Order_By = {
  active?: InputMaybe<Order_By>;
  colorTarget?: InputMaybe<Order_By>;
  contentType?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  swatches?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entityStoryColorSettings */
export type EntityStoryColorSettings_Pk_Columns_Input = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  entityId: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EntityStoryColorSettings_Prepend_Input = {
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "entityStoryColorSettings" */
export enum EntityStoryColorSettings_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ColorTarget = 'colorTarget',
  /** column name */
  ContentType = 'contentType',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Swatches = 'swatches'
}

/** input type for updating data in table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Set_Input = {
  active?: InputMaybe<Scalars['String']['input']>;
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type EntityStoryColorSettings_Stddev_Fields = {
  __typename?: 'entityStoryColorSettings_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Stddev_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EntityStoryColorSettings_Stddev_Pop_Fields = {
  __typename?: 'entityStoryColorSettings_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Stddev_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EntityStoryColorSettings_Stddev_Samp_Fields = {
  __typename?: 'entityStoryColorSettings_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Stddev_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityStoryColorSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityStoryColorSettings_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['String']['input']>;
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  /** An array of hex color strings e.g. #143a89 */
  swatches?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type EntityStoryColorSettings_Sum_Fields = {
  __typename?: 'entityStoryColorSettings_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Sum_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** update columns of table "entityStoryColorSettings" */
export enum EntityStoryColorSettings_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ColorTarget = 'colorTarget',
  /** column name */
  ContentType = 'contentType',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Swatches = 'swatches'
}

export type EntityStoryColorSettings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EntityStoryColorSettings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EntityStoryColorSettings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EntityStoryColorSettings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EntityStoryColorSettings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityStoryColorSettings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EntityStoryColorSettings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityStoryColorSettings_Set_Input>;
  where: EntityStoryColorSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EntityStoryColorSettings_Var_Pop_Fields = {
  __typename?: 'entityStoryColorSettings_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Var_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EntityStoryColorSettings_Var_Samp_Fields = {
  __typename?: 'entityStoryColorSettings_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Var_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EntityStoryColorSettings_Variance_Fields = {
  __typename?: 'entityStoryColorSettings_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "entityStoryColorSettings" */
export type EntityStoryColorSettings_Variance_Order_By = {
  entityId?: InputMaybe<Order_By>;
};

/** Entity Specific Settings for Stories */
export type EntityStorySettings = {
  __typename?: 'entityStorySettings';
  /** An array relationship */
  colors: Array<EntityStoryColorSettings>;
  /** An aggregate relationship */
  colors_aggregate: EntityStoryColorSettings_Aggregate;
  entityId: Scalars['Int']['output'];
  fontsHeadline: Scalars['String']['output'];
  fontsParagraph: Scalars['String']['output'];
  googleAnalyticsId: Scalars['String']['output'];
  logoFooter: Scalars['String']['output'];
  logoHeader: Scalars['String']['output'];
  logoPlacementFooterOnly: Scalars['Boolean']['output'];
  logoPlacementHeaderAsFooter: Scalars['Boolean']['output'];
  logoPlacementHeaderOnly: Scalars['Boolean']['output'];
  logoPlacementUniqueFooter: Scalars['Boolean']['output'];
};


/** Entity Specific Settings for Stories */
export type EntityStorySettingsColorsArgs = {
  distinct_on?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStoryColorSettings_Order_By>>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};


/** Entity Specific Settings for Stories */
export type EntityStorySettingsColors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStoryColorSettings_Order_By>>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};

/** aggregated selection of "entityStorySettings" */
export type EntityStorySettings_Aggregate = {
  __typename?: 'entityStorySettings_aggregate';
  aggregate?: Maybe<EntityStorySettings_Aggregate_Fields>;
  nodes: Array<EntityStorySettings>;
};

/** aggregate fields of "entityStorySettings" */
export type EntityStorySettings_Aggregate_Fields = {
  __typename?: 'entityStorySettings_aggregate_fields';
  avg?: Maybe<EntityStorySettings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EntityStorySettings_Max_Fields>;
  min?: Maybe<EntityStorySettings_Min_Fields>;
  stddev?: Maybe<EntityStorySettings_Stddev_Fields>;
  stddev_pop?: Maybe<EntityStorySettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EntityStorySettings_Stddev_Samp_Fields>;
  sum?: Maybe<EntityStorySettings_Sum_Fields>;
  var_pop?: Maybe<EntityStorySettings_Var_Pop_Fields>;
  var_samp?: Maybe<EntityStorySettings_Var_Samp_Fields>;
  variance?: Maybe<EntityStorySettings_Variance_Fields>;
};


/** aggregate fields of "entityStorySettings" */
export type EntityStorySettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityStorySettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EntityStorySettings_Avg_Fields = {
  __typename?: 'entityStorySettings_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "entityStorySettings". All fields are combined with a logical 'AND'. */
export type EntityStorySettings_Bool_Exp = {
  _and?: InputMaybe<Array<EntityStorySettings_Bool_Exp>>;
  _not?: InputMaybe<EntityStorySettings_Bool_Exp>;
  _or?: InputMaybe<Array<EntityStorySettings_Bool_Exp>>;
  colors?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
  colors_aggregate?: InputMaybe<EntityStoryColorSettings_Aggregate_Bool_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  fontsHeadline?: InputMaybe<String_Comparison_Exp>;
  fontsParagraph?: InputMaybe<String_Comparison_Exp>;
  googleAnalyticsId?: InputMaybe<String_Comparison_Exp>;
  logoFooter?: InputMaybe<String_Comparison_Exp>;
  logoHeader?: InputMaybe<String_Comparison_Exp>;
  logoPlacementFooterOnly?: InputMaybe<Boolean_Comparison_Exp>;
  logoPlacementHeaderAsFooter?: InputMaybe<Boolean_Comparison_Exp>;
  logoPlacementHeaderOnly?: InputMaybe<Boolean_Comparison_Exp>;
  logoPlacementUniqueFooter?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "entityStorySettings" */
export enum EntityStorySettings_Constraint {
  /** unique or primary key constraint on columns "entityId" */
  EntityStorySettingsEntityIdKey = 'entityStorySettings_entityId_key',
  /** unique or primary key constraint on columns "entityId" */
  EntityStorySettingsPkey = 'entityStorySettings_pkey'
}

/** input type for incrementing numeric columns in table "entityStorySettings" */
export type EntityStorySettings_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "entityStorySettings" */
export type EntityStorySettings_Insert_Input = {
  colors?: InputMaybe<EntityStoryColorSettings_Arr_Rel_Insert_Input>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fontsHeadline?: InputMaybe<Scalars['String']['input']>;
  fontsParagraph?: InputMaybe<Scalars['String']['input']>;
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  logoFooter?: InputMaybe<Scalars['String']['input']>;
  logoHeader?: InputMaybe<Scalars['String']['input']>;
  logoPlacementFooterOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementHeaderAsFooter?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementHeaderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementUniqueFooter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type EntityStorySettings_Max_Fields = {
  __typename?: 'entityStorySettings_max_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  fontsHeadline?: Maybe<Scalars['String']['output']>;
  fontsParagraph?: Maybe<Scalars['String']['output']>;
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  logoFooter?: Maybe<Scalars['String']['output']>;
  logoHeader?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EntityStorySettings_Min_Fields = {
  __typename?: 'entityStorySettings_min_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  fontsHeadline?: Maybe<Scalars['String']['output']>;
  fontsParagraph?: Maybe<Scalars['String']['output']>;
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  logoFooter?: Maybe<Scalars['String']['output']>;
  logoHeader?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "entityStorySettings" */
export type EntityStorySettings_Mutation_Response = {
  __typename?: 'entityStorySettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityStorySettings>;
};

/** input type for inserting object relation for remote table "entityStorySettings" */
export type EntityStorySettings_Obj_Rel_Insert_Input = {
  data: EntityStorySettings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityStorySettings_On_Conflict>;
};

/** on_conflict condition type for table "entityStorySettings" */
export type EntityStorySettings_On_Conflict = {
  constraint: EntityStorySettings_Constraint;
  update_columns?: Array<EntityStorySettings_Update_Column>;
  where?: InputMaybe<EntityStorySettings_Bool_Exp>;
};

/** Ordering options when selecting data from "entityStorySettings". */
export type EntityStorySettings_Order_By = {
  colors_aggregate?: InputMaybe<EntityStoryColorSettings_Aggregate_Order_By>;
  entityId?: InputMaybe<Order_By>;
  fontsHeadline?: InputMaybe<Order_By>;
  fontsParagraph?: InputMaybe<Order_By>;
  googleAnalyticsId?: InputMaybe<Order_By>;
  logoFooter?: InputMaybe<Order_By>;
  logoHeader?: InputMaybe<Order_By>;
  logoPlacementFooterOnly?: InputMaybe<Order_By>;
  logoPlacementHeaderAsFooter?: InputMaybe<Order_By>;
  logoPlacementHeaderOnly?: InputMaybe<Order_By>;
  logoPlacementUniqueFooter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entityStorySettings */
export type EntityStorySettings_Pk_Columns_Input = {
  entityId: Scalars['Int']['input'];
};

/** select columns of table "entityStorySettings" */
export enum EntityStorySettings_Select_Column {
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FontsHeadline = 'fontsHeadline',
  /** column name */
  FontsParagraph = 'fontsParagraph',
  /** column name */
  GoogleAnalyticsId = 'googleAnalyticsId',
  /** column name */
  LogoFooter = 'logoFooter',
  /** column name */
  LogoHeader = 'logoHeader',
  /** column name */
  LogoPlacementFooterOnly = 'logoPlacementFooterOnly',
  /** column name */
  LogoPlacementHeaderAsFooter = 'logoPlacementHeaderAsFooter',
  /** column name */
  LogoPlacementHeaderOnly = 'logoPlacementHeaderOnly',
  /** column name */
  LogoPlacementUniqueFooter = 'logoPlacementUniqueFooter'
}

/** input type for updating data in table "entityStorySettings" */
export type EntityStorySettings_Set_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fontsHeadline?: InputMaybe<Scalars['String']['input']>;
  fontsParagraph?: InputMaybe<Scalars['String']['input']>;
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  logoFooter?: InputMaybe<Scalars['String']['input']>;
  logoHeader?: InputMaybe<Scalars['String']['input']>;
  logoPlacementFooterOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementHeaderAsFooter?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementHeaderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementUniqueFooter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type EntityStorySettings_Stddev_Fields = {
  __typename?: 'entityStorySettings_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EntityStorySettings_Stddev_Pop_Fields = {
  __typename?: 'entityStorySettings_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EntityStorySettings_Stddev_Samp_Fields = {
  __typename?: 'entityStorySettings_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "entityStorySettings" */
export type EntityStorySettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityStorySettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityStorySettings_Stream_Cursor_Value_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fontsHeadline?: InputMaybe<Scalars['String']['input']>;
  fontsParagraph?: InputMaybe<Scalars['String']['input']>;
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  logoFooter?: InputMaybe<Scalars['String']['input']>;
  logoHeader?: InputMaybe<Scalars['String']['input']>;
  logoPlacementFooterOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementHeaderAsFooter?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementHeaderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoPlacementUniqueFooter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type EntityStorySettings_Sum_Fields = {
  __typename?: 'entityStorySettings_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "entityStorySettings" */
export enum EntityStorySettings_Update_Column {
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FontsHeadline = 'fontsHeadline',
  /** column name */
  FontsParagraph = 'fontsParagraph',
  /** column name */
  GoogleAnalyticsId = 'googleAnalyticsId',
  /** column name */
  LogoFooter = 'logoFooter',
  /** column name */
  LogoHeader = 'logoHeader',
  /** column name */
  LogoPlacementFooterOnly = 'logoPlacementFooterOnly',
  /** column name */
  LogoPlacementHeaderAsFooter = 'logoPlacementHeaderAsFooter',
  /** column name */
  LogoPlacementHeaderOnly = 'logoPlacementHeaderOnly',
  /** column name */
  LogoPlacementUniqueFooter = 'logoPlacementUniqueFooter'
}

export type EntityStorySettings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityStorySettings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityStorySettings_Set_Input>;
  where: EntityStorySettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EntityStorySettings_Var_Pop_Fields = {
  __typename?: 'entityStorySettings_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EntityStorySettings_Var_Samp_Fields = {
  __typename?: 'entityStorySettings_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EntityStorySettings_Variance_Fields = {
  __typename?: 'entityStorySettings_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "exportFolderPdfRequests" */
export type ExportFolderPdfRequests = {
  __typename?: 'exportFolderPdfRequests';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  folderId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  pdfOptions: Scalars['String']['output'];
  status: Scalars['String']['output'];
  suppressDisplayBanner: Scalars['Boolean']['output'];
};

/** aggregated selection of "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Aggregate = {
  __typename?: 'exportFolderPdfRequests_aggregate';
  aggregate?: Maybe<ExportFolderPdfRequests_Aggregate_Fields>;
  nodes: Array<ExportFolderPdfRequests>;
};

/** aggregate fields of "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Aggregate_Fields = {
  __typename?: 'exportFolderPdfRequests_aggregate_fields';
  avg?: Maybe<ExportFolderPdfRequests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ExportFolderPdfRequests_Max_Fields>;
  min?: Maybe<ExportFolderPdfRequests_Min_Fields>;
  stddev?: Maybe<ExportFolderPdfRequests_Stddev_Fields>;
  stddev_pop?: Maybe<ExportFolderPdfRequests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ExportFolderPdfRequests_Stddev_Samp_Fields>;
  sum?: Maybe<ExportFolderPdfRequests_Sum_Fields>;
  var_pop?: Maybe<ExportFolderPdfRequests_Var_Pop_Fields>;
  var_samp?: Maybe<ExportFolderPdfRequests_Var_Samp_Fields>;
  variance?: Maybe<ExportFolderPdfRequests_Variance_Fields>;
};


/** aggregate fields of "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ExportFolderPdfRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ExportFolderPdfRequests_Avg_Fields = {
  __typename?: 'exportFolderPdfRequests_avg_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "exportFolderPdfRequests". All fields are combined with a logical 'AND'. */
export type ExportFolderPdfRequests_Bool_Exp = {
  _and?: InputMaybe<Array<ExportFolderPdfRequests_Bool_Exp>>;
  _not?: InputMaybe<ExportFolderPdfRequests_Bool_Exp>;
  _or?: InputMaybe<Array<ExportFolderPdfRequests_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Int_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  fileUrl?: InputMaybe<String_Comparison_Exp>;
  finishedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  folderId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pdfOptions?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  suppressDisplayBanner?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "exportFolderPdfRequests" */
export enum ExportFolderPdfRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExportFolderPdfRequestsPkey = 'exportFolderPdfRequests_pkey'
}

/** input type for incrementing numeric columns in table "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Inc_Input = {
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfOptions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type ExportFolderPdfRequests_Max_Fields = {
  __typename?: 'exportFolderPdfRequests_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  folderId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfOptions?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ExportFolderPdfRequests_Min_Fields = {
  __typename?: 'exportFolderPdfRequests_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  folderId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfOptions?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Mutation_Response = {
  __typename?: 'exportFolderPdfRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ExportFolderPdfRequests>;
};

/** on_conflict condition type for table "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_On_Conflict = {
  constraint: ExportFolderPdfRequests_Constraint;
  update_columns?: Array<ExportFolderPdfRequests_Update_Column>;
  where?: InputMaybe<ExportFolderPdfRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "exportFolderPdfRequests". */
export type ExportFolderPdfRequests_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  fileUrl?: InputMaybe<Order_By>;
  finishedAt?: InputMaybe<Order_By>;
  folderId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pdfOptions?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  suppressDisplayBanner?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exportFolderPdfRequests */
export type ExportFolderPdfRequests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "exportFolderPdfRequests" */
export enum ExportFolderPdfRequests_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FileUrl = 'fileUrl',
  /** column name */
  FinishedAt = 'finishedAt',
  /** column name */
  FolderId = 'folderId',
  /** column name */
  Id = 'id',
  /** column name */
  PdfOptions = 'pdfOptions',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner'
}

/** input type for updating data in table "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfOptions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type ExportFolderPdfRequests_Stddev_Fields = {
  __typename?: 'exportFolderPdfRequests_stddev_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ExportFolderPdfRequests_Stddev_Pop_Fields = {
  __typename?: 'exportFolderPdfRequests_stddev_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ExportFolderPdfRequests_Stddev_Samp_Fields = {
  __typename?: 'exportFolderPdfRequests_stddev_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "exportFolderPdfRequests" */
export type ExportFolderPdfRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ExportFolderPdfRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ExportFolderPdfRequests_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfOptions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type ExportFolderPdfRequests_Sum_Fields = {
  __typename?: 'exportFolderPdfRequests_sum_fields';
  createdBy?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "exportFolderPdfRequests" */
export enum ExportFolderPdfRequests_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FileUrl = 'fileUrl',
  /** column name */
  FinishedAt = 'finishedAt',
  /** column name */
  FolderId = 'folderId',
  /** column name */
  Id = 'id',
  /** column name */
  PdfOptions = 'pdfOptions',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner'
}

export type ExportFolderPdfRequests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ExportFolderPdfRequests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExportFolderPdfRequests_Set_Input>;
  where: ExportFolderPdfRequests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ExportFolderPdfRequests_Var_Pop_Fields = {
  __typename?: 'exportFolderPdfRequests_var_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ExportFolderPdfRequests_Var_Samp_Fields = {
  __typename?: 'exportFolderPdfRequests_var_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ExportFolderPdfRequests_Variance_Fields = {
  __typename?: 'exportFolderPdfRequests_variance_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "exportStoriesChunks" */
export type ExportStoriesChunks = {
  __typename?: 'exportStoriesChunks';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  exportRequestId: Scalars['uuid']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  order: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  storyIds: Scalars['String']['output'];
};

/** aggregated selection of "exportStoriesChunks" */
export type ExportStoriesChunks_Aggregate = {
  __typename?: 'exportStoriesChunks_aggregate';
  aggregate?: Maybe<ExportStoriesChunks_Aggregate_Fields>;
  nodes: Array<ExportStoriesChunks>;
};

/** aggregate fields of "exportStoriesChunks" */
export type ExportStoriesChunks_Aggregate_Fields = {
  __typename?: 'exportStoriesChunks_aggregate_fields';
  avg?: Maybe<ExportStoriesChunks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ExportStoriesChunks_Max_Fields>;
  min?: Maybe<ExportStoriesChunks_Min_Fields>;
  stddev?: Maybe<ExportStoriesChunks_Stddev_Fields>;
  stddev_pop?: Maybe<ExportStoriesChunks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ExportStoriesChunks_Stddev_Samp_Fields>;
  sum?: Maybe<ExportStoriesChunks_Sum_Fields>;
  var_pop?: Maybe<ExportStoriesChunks_Var_Pop_Fields>;
  var_samp?: Maybe<ExportStoriesChunks_Var_Samp_Fields>;
  variance?: Maybe<ExportStoriesChunks_Variance_Fields>;
};


/** aggregate fields of "exportStoriesChunks" */
export type ExportStoriesChunks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ExportStoriesChunks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ExportStoriesChunks_Avg_Fields = {
  __typename?: 'exportStoriesChunks_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "exportStoriesChunks". All fields are combined with a logical 'AND'. */
export type ExportStoriesChunks_Bool_Exp = {
  _and?: InputMaybe<Array<ExportStoriesChunks_Bool_Exp>>;
  _not?: InputMaybe<ExportStoriesChunks_Bool_Exp>;
  _or?: InputMaybe<Array<ExportStoriesChunks_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  exportRequestId?: InputMaybe<Uuid_Comparison_Exp>;
  fileUrl?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  storyIds?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "exportStoriesChunks" */
export type ExportStoriesChunks_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "exportStoriesChunks" */
export type ExportStoriesChunks_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  exportRequestId?: InputMaybe<Scalars['uuid']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storyIds?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ExportStoriesChunks_Max_Fields = {
  __typename?: 'exportStoriesChunks_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  exportRequestId?: Maybe<Scalars['uuid']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storyIds?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ExportStoriesChunks_Min_Fields = {
  __typename?: 'exportStoriesChunks_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  exportRequestId?: Maybe<Scalars['uuid']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storyIds?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "exportStoriesChunks" */
export type ExportStoriesChunks_Mutation_Response = {
  __typename?: 'exportStoriesChunks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ExportStoriesChunks>;
};

/** Ordering options when selecting data from "exportStoriesChunks". */
export type ExportStoriesChunks_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exportRequestId?: InputMaybe<Order_By>;
  fileUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  storyIds?: InputMaybe<Order_By>;
};

/** select columns of table "exportStoriesChunks" */
export enum ExportStoriesChunks_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExportRequestId = 'exportRequestId',
  /** column name */
  FileUrl = 'fileUrl',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Status = 'status',
  /** column name */
  StoryIds = 'storyIds'
}

/** input type for updating data in table "exportStoriesChunks" */
export type ExportStoriesChunks_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  exportRequestId?: InputMaybe<Scalars['uuid']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storyIds?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ExportStoriesChunks_Stddev_Fields = {
  __typename?: 'exportStoriesChunks_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ExportStoriesChunks_Stddev_Pop_Fields = {
  __typename?: 'exportStoriesChunks_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ExportStoriesChunks_Stddev_Samp_Fields = {
  __typename?: 'exportStoriesChunks_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "exportStoriesChunks" */
export type ExportStoriesChunks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ExportStoriesChunks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ExportStoriesChunks_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  exportRequestId?: InputMaybe<Scalars['uuid']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storyIds?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ExportStoriesChunks_Sum_Fields = {
  __typename?: 'exportStoriesChunks_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

export type ExportStoriesChunks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ExportStoriesChunks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExportStoriesChunks_Set_Input>;
  where: ExportStoriesChunks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ExportStoriesChunks_Var_Pop_Fields = {
  __typename?: 'exportStoriesChunks_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ExportStoriesChunks_Var_Samp_Fields = {
  __typename?: 'exportStoriesChunks_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ExportStoriesChunks_Variance_Fields = {
  __typename?: 'exportStoriesChunks_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "internalPublishedStory" */
export type InternalPublishedStory = {
  __typename?: 'internalPublishedStory';
  _id: Scalars['String']['output'];
  contentHtml: Scalars['String']['output'];
  /** An object relationship */
  story: Stories;
  storyId: Scalars['String']['output'];
};

/** aggregated selection of "internalPublishedStory" */
export type InternalPublishedStory_Aggregate = {
  __typename?: 'internalPublishedStory_aggregate';
  aggregate?: Maybe<InternalPublishedStory_Aggregate_Fields>;
  nodes: Array<InternalPublishedStory>;
};

/** aggregate fields of "internalPublishedStory" */
export type InternalPublishedStory_Aggregate_Fields = {
  __typename?: 'internalPublishedStory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<InternalPublishedStory_Max_Fields>;
  min?: Maybe<InternalPublishedStory_Min_Fields>;
};


/** aggregate fields of "internalPublishedStory" */
export type InternalPublishedStory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InternalPublishedStory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "internalPublishedStory". All fields are combined with a logical 'AND'. */
export type InternalPublishedStory_Bool_Exp = {
  _and?: InputMaybe<Array<InternalPublishedStory_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<InternalPublishedStory_Bool_Exp>;
  _or?: InputMaybe<Array<InternalPublishedStory_Bool_Exp>>;
  contentHtml?: InputMaybe<String_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "internalPublishedStory" */
export enum InternalPublishedStory_Constraint {
  /** unique or primary key constraint on columns "_id" */
  InternalPublishedStoryPkey = 'internalPublishedStory_pkey',
  /** unique or primary key constraint on columns "storyId" */
  InternalPublishedStoryStoryIdKey = 'internalPublishedStory_storyId_key'
}

/** input type for inserting data into table "internalPublishedStory" */
export type InternalPublishedStory_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type InternalPublishedStory_Max_Fields = {
  __typename?: 'internalPublishedStory_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type InternalPublishedStory_Min_Fields = {
  __typename?: 'internalPublishedStory_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "internalPublishedStory" */
export type InternalPublishedStory_Mutation_Response = {
  __typename?: 'internalPublishedStory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InternalPublishedStory>;
};

/** on_conflict condition type for table "internalPublishedStory" */
export type InternalPublishedStory_On_Conflict = {
  constraint: InternalPublishedStory_Constraint;
  update_columns?: Array<InternalPublishedStory_Update_Column>;
  where?: InputMaybe<InternalPublishedStory_Bool_Exp>;
};

/** Ordering options when selecting data from "internalPublishedStory". */
export type InternalPublishedStory_Order_By = {
  _id?: InputMaybe<Order_By>;
  contentHtml?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: internalPublishedStory */
export type InternalPublishedStory_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "internalPublishedStory" */
export enum InternalPublishedStory_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  ContentHtml = 'contentHtml',
  /** column name */
  StoryId = 'storyId'
}

/** input type for updating data in table "internalPublishedStory" */
export type InternalPublishedStory_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "internalPublishedStory" */
export type InternalPublishedStory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InternalPublishedStory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InternalPublishedStory_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "internalPublishedStory" */
export enum InternalPublishedStory_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  ContentHtml = 'contentHtml',
  /** column name */
  StoryId = 'storyId'
}

export type InternalPublishedStory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InternalPublishedStory_Set_Input>;
  where: InternalPublishedStory_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "asyncJobs" */
  delete_asyncJobs?: Maybe<AsyncJobs_Mutation_Response>;
  /** delete single row from the table: "asyncJobs" */
  delete_asyncJobs_by_pk?: Maybe<AsyncJobs>;
  /** delete data from the table: "chartsConfig" */
  delete_chartsConfig?: Maybe<ChartsConfig_Mutation_Response>;
  /** delete single row from the table: "chartsConfig" */
  delete_chartsConfig_by_pk?: Maybe<ChartsConfig>;
  /** delete data from the table: "copyProcessStatuses" */
  delete_copyProcessStatuses?: Maybe<CopyProcessStatuses_Mutation_Response>;
  /** delete single row from the table: "copyProcessStatuses" */
  delete_copyProcessStatuses_by_pk?: Maybe<CopyProcessStatuses>;
  /** delete data from the table: "entityProgressTrackerSettings" */
  delete_entityProgressTrackerSettings?: Maybe<EntityProgressTrackerSettings_Mutation_Response>;
  /** delete single row from the table: "entityProgressTrackerSettings" */
  delete_entityProgressTrackerSettings_by_pk?: Maybe<EntityProgressTrackerSettings>;
  /** delete data from the table: "entityStoryColorSettings" */
  delete_entityStoryColorSettings?: Maybe<EntityStoryColorSettings_Mutation_Response>;
  /** delete single row from the table: "entityStoryColorSettings" */
  delete_entityStoryColorSettings_by_pk?: Maybe<EntityStoryColorSettings>;
  /** delete data from the table: "entityStorySettings" */
  delete_entityStorySettings?: Maybe<EntityStorySettings_Mutation_Response>;
  /** delete single row from the table: "entityStorySettings" */
  delete_entityStorySettings_by_pk?: Maybe<EntityStorySettings>;
  /** delete data from the table: "exportFolderPdfRequests" */
  delete_exportFolderPdfRequests?: Maybe<ExportFolderPdfRequests_Mutation_Response>;
  /** delete single row from the table: "exportFolderPdfRequests" */
  delete_exportFolderPdfRequests_by_pk?: Maybe<ExportFolderPdfRequests>;
  /** delete data from the table: "exportStoriesChunks" */
  delete_exportStoriesChunks?: Maybe<ExportStoriesChunks_Mutation_Response>;
  /** delete data from the table: "internalPublishedStory" */
  delete_internalPublishedStory?: Maybe<InternalPublishedStory_Mutation_Response>;
  /** delete single row from the table: "internalPublishedStory" */
  delete_internalPublishedStory_by_pk?: Maybe<InternalPublishedStory>;
  /** delete data from the table: "portalStory" */
  delete_portalStory?: Maybe<PortalStory_Mutation_Response>;
  /** delete single row from the table: "portalStory" */
  delete_portalStory_by_pk?: Maybe<PortalStory>;
  /** delete data from the table: "publicationBrandings" */
  delete_publicationBrandings?: Maybe<PublicationBrandings_Mutation_Response>;
  /** delete single row from the table: "publicationBrandings" */
  delete_publicationBrandings_by_pk?: Maybe<PublicationBrandings>;
  /** delete data from the table: "publicationExportPdfRequest" */
  delete_publicationExportPdfRequest?: Maybe<PublicationExportPdfRequest_Mutation_Response>;
  /** delete single row from the table: "publicationExportPdfRequest" */
  delete_publicationExportPdfRequest_by_pk?: Maybe<PublicationExportPdfRequest>;
  /** delete data from the table: "publicationFolders" */
  delete_publicationFolders?: Maybe<PublicationFolders_Mutation_Response>;
  /** delete single row from the table: "publicationFolders" */
  delete_publicationFolders_by_pk?: Maybe<PublicationFolders>;
  /** delete data from the table: "publicationFooterSettings" */
  delete_publicationFooterSettings?: Maybe<PublicationFooterSettings_Mutation_Response>;
  /** delete single row from the table: "publicationFooterSettings" */
  delete_publicationFooterSettings_by_pk?: Maybe<PublicationFooterSettings>;
  /** delete data from the table: "publicationNavigationMenuItems" */
  delete_publicationNavigationMenuItems?: Maybe<PublicationNavigationMenuItems_Mutation_Response>;
  /** delete single row from the table: "publicationNavigationMenuItems" */
  delete_publicationNavigationMenuItems_by_pk?: Maybe<PublicationNavigationMenuItems>;
  /** delete data from the table: "publicationNavigationMenuStories" */
  delete_publicationNavigationMenuStories?: Maybe<PublicationNavigationMenuStories_Mutation_Response>;
  /** delete single row from the table: "publicationNavigationMenuStories" */
  delete_publicationNavigationMenuStories_by_pk?: Maybe<PublicationNavigationMenuStories>;
  /** delete data from the table: "publicationSetupPdfStyles" */
  delete_publicationSetupPdfStyles?: Maybe<PublicationSetupPdfStyles_Mutation_Response>;
  /** delete single row from the table: "publicationSetupPdfStyles" */
  delete_publicationSetupPdfStyles_by_pk?: Maybe<PublicationSetupPdfStyles>;
  /** delete data from the table: "publicationStoryPdfSettings" */
  delete_publicationStoryPdfSettings?: Maybe<PublicationStoryPdfSettings_Mutation_Response>;
  /** delete single row from the table: "publicationStoryPdfSettings" */
  delete_publicationStoryPdfSettings_by_pk?: Maybe<PublicationStoryPdfSettings>;
  /** delete data from the table: "publicationTOCSettings" */
  delete_publicationTOCSettings?: Maybe<PublicationTocSettings_Mutation_Response>;
  /** delete single row from the table: "publicationTOCSettings" */
  delete_publicationTOCSettings_by_pk?: Maybe<PublicationTocSettings>;
  /** delete data from the table: "publications" */
  delete_publications?: Maybe<Publications_Mutation_Response>;
  /** delete single row from the table: "publications" */
  delete_publications_by_pk?: Maybe<Publications>;
  /** delete data from the table: "spreadsheetNamedRanges" */
  delete_spreadsheetNamedRanges?: Maybe<SpreadsheetNamedRanges_Mutation_Response>;
  /** delete single row from the table: "spreadsheetNamedRanges" */
  delete_spreadsheetNamedRanges_by_pk?: Maybe<SpreadsheetNamedRanges>;
  /** delete data from the table: "spreadsheetSplitTables" */
  delete_spreadsheetSplitTables?: Maybe<SpreadsheetSplitTables_Mutation_Response>;
  /** delete single row from the table: "spreadsheetSplitTables" */
  delete_spreadsheetSplitTables_by_pk?: Maybe<SpreadsheetSplitTables>;
  /** delete data from the table: "spreadsheets" */
  delete_spreadsheets?: Maybe<Spreadsheets_Mutation_Response>;
  /** delete data from the table: "spreadsheetsProcessingStatus" */
  delete_spreadsheetsProcessingStatus?: Maybe<SpreadsheetsProcessingStatus_Mutation_Response>;
  /** delete single row from the table: "spreadsheetsProcessingStatus" */
  delete_spreadsheetsProcessingStatus_by_pk?: Maybe<SpreadsheetsProcessingStatus>;
  /** delete single row from the table: "spreadsheets" */
  delete_spreadsheets_by_pk?: Maybe<Spreadsheets>;
  /** delete data from the table: "stories" */
  delete_stories?: Maybe<Stories_Mutation_Response>;
  /** delete data from the table: "storiesCopyProcesses" */
  delete_storiesCopyProcesses?: Maybe<StoriesCopyProcesses_Mutation_Response>;
  /** delete single row from the table: "storiesCopyProcesses" */
  delete_storiesCopyProcesses_by_pk?: Maybe<StoriesCopyProcesses>;
  /** delete single row from the table: "stories" */
  delete_stories_by_pk?: Maybe<Stories>;
  /** delete data from the table: "storyBudgetProposals" */
  delete_storyBudgetProposals?: Maybe<StoryBudgetProposals_Mutation_Response>;
  /** delete single row from the table: "storyBudgetProposals" */
  delete_storyBudgetProposals_by_pk?: Maybe<StoryBudgetProposals>;
  /** delete data from the table: "storyContentBlockTypes" */
  delete_storyContentBlockTypes?: Maybe<StoryContentBlockTypes_Mutation_Response>;
  /** delete single row from the table: "storyContentBlockTypes" */
  delete_storyContentBlockTypes_by_pk?: Maybe<StoryContentBlockTypes>;
  /** delete data from the table: "storyContentBlocks" */
  delete_storyContentBlocks?: Maybe<StoryContentBlocks_Mutation_Response>;
  /** delete single row from the table: "storyContentBlocks" */
  delete_storyContentBlocks_by_pk?: Maybe<StoryContentBlocks>;
  /** delete data from the table: "storyContentColorTargets" */
  delete_storyContentColorTargets?: Maybe<StoryContentColorTargets_Mutation_Response>;
  /** delete single row from the table: "storyContentColorTargets" */
  delete_storyContentColorTargets_by_pk?: Maybe<StoryContentColorTargets>;
  /** delete data from the table: "storyContentSpreadsheetReferences" */
  delete_storyContentSpreadsheetReferences?: Maybe<StoryContentSpreadsheetReferences_Mutation_Response>;
  /** delete single row from the table: "storyContentSpreadsheetReferences" */
  delete_storyContentSpreadsheetReferences_by_pk?: Maybe<StoryContentSpreadsheetReferences>;
  /** delete data from the table: "storyContentTypes" */
  delete_storyContentTypes?: Maybe<StoryContentTypes_Mutation_Response>;
  /** delete single row from the table: "storyContentTypes" */
  delete_storyContentTypes_by_pk?: Maybe<StoryContentTypes>;
  /** delete data from the table: "storyContents" */
  delete_storyContents?: Maybe<StoryContents_Mutation_Response>;
  /** delete single row from the table: "storyContents" */
  delete_storyContents_by_pk?: Maybe<StoryContents>;
  /** delete data from the table: "storyCopyProcesses" */
  delete_storyCopyProcesses?: Maybe<StoryCopyProcesses_Mutation_Response>;
  /** delete single row from the table: "storyCopyProcesses" */
  delete_storyCopyProcesses_by_pk?: Maybe<StoryCopyProcesses>;
  /** delete data from the table: "storyCustomColors" */
  delete_storyCustomColors?: Maybe<StoryCustomColors_Mutation_Response>;
  /** delete single row from the table: "storyCustomColors" */
  delete_storyCustomColors_by_pk?: Maybe<StoryCustomColors>;
  /** delete data from the table: "storyEmbeds" */
  delete_storyEmbeds?: Maybe<StoryEmbeds_Mutation_Response>;
  /** delete single row from the table: "storyEmbeds" */
  delete_storyEmbeds_by_pk?: Maybe<StoryEmbeds>;
  /** delete data from the table: "storyFolderActionSets" */
  delete_storyFolderActionSets?: Maybe<StoryFolderActionSets_Mutation_Response>;
  /** delete single row from the table: "storyFolderActionSets" */
  delete_storyFolderActionSets_by_pk?: Maybe<StoryFolderActionSets>;
  /** delete data from the table: "storyFolderGrants" */
  delete_storyFolderGrants?: Maybe<StoryFolderGrants_Mutation_Response>;
  /** delete single row from the table: "storyFolderGrants" */
  delete_storyFolderGrants_by_pk?: Maybe<StoryFolderGrants>;
  /** delete data from the table: "storyFolders" */
  delete_storyFolders?: Maybe<StoryFolders_Mutation_Response>;
  /** delete data from the table: "storyFoldersCopyProcesses" */
  delete_storyFoldersCopyProcesses?: Maybe<StoryFoldersCopyProcesses_Mutation_Response>;
  /** delete single row from the table: "storyFoldersCopyProcesses" */
  delete_storyFoldersCopyProcesses_by_pk?: Maybe<StoryFoldersCopyProcesses>;
  /** delete single row from the table: "storyFolders" */
  delete_storyFolders_by_pk?: Maybe<StoryFolders>;
  /** delete data from the table: "storyStates" */
  delete_storyStates?: Maybe<StoryStates_Mutation_Response>;
  /** delete single row from the table: "storyStates" */
  delete_storyStates_by_pk?: Maybe<StoryStates>;
  /** delete data from the table: "storyTemplateContentBlocks" */
  delete_storyTemplateContentBlocks?: Maybe<StoryTemplateContentBlocks_Mutation_Response>;
  /** delete single row from the table: "storyTemplateContentBlocks" */
  delete_storyTemplateContentBlocks_by_pk?: Maybe<StoryTemplateContentBlocks>;
  /** delete data from the table: "storyTemplateContents" */
  delete_storyTemplateContents?: Maybe<StoryTemplateContents_Mutation_Response>;
  /** delete single row from the table: "storyTemplateContents" */
  delete_storyTemplateContents_by_pk?: Maybe<StoryTemplateContents>;
  /** delete data from the table: "storyTemplateCustomColors" */
  delete_storyTemplateCustomColors?: Maybe<StoryTemplateCustomColors_Mutation_Response>;
  /** delete single row from the table: "storyTemplateCustomColors" */
  delete_storyTemplateCustomColors_by_pk?: Maybe<StoryTemplateCustomColors>;
  /** delete data from the table: "storyTemplates" */
  delete_storyTemplates?: Maybe<StoryTemplates_Mutation_Response>;
  /** delete single row from the table: "storyTemplates" */
  delete_storyTemplates_by_pk?: Maybe<StoryTemplates>;
  /** delete data from the table: "storyUsers" */
  delete_storyUsers?: Maybe<StoryUsers_Mutation_Response>;
  /** delete single row from the table: "storyUsers" */
  delete_storyUsers_by_pk?: Maybe<StoryUsers>;
  /** delete data from the table: "storyVisibilities" */
  delete_storyVisibilities?: Maybe<StoryVisibilities_Mutation_Response>;
  /** delete single row from the table: "storyVisibilities" */
  delete_storyVisibilities_by_pk?: Maybe<StoryVisibilities>;
  /** delete data from the table: "subjectPublicationClaims" */
  delete_subjectPublicationClaims?: Maybe<SubjectPublicationClaims_Mutation_Response>;
  /** delete single row from the table: "subjectPublicationClaims" */
  delete_subjectPublicationClaims_by_pk?: Maybe<SubjectPublicationClaims>;
  /** delete data from the table: "subjectStoryClaims" */
  delete_subjectStoryClaims?: Maybe<SubjectStoryClaims_Mutation_Response>;
  /** delete single row from the table: "subjectStoryClaims" */
  delete_subjectStoryClaims_by_pk?: Maybe<SubjectStoryClaims>;
  /** delete data from the table: "userPublicationViews" */
  delete_userPublicationViews?: Maybe<UserPublicationViews_Mutation_Response>;
  /** delete single row from the table: "userPublicationViews" */
  delete_userPublicationViews_by_pk?: Maybe<UserPublicationViews>;
  /** insert data into the table: "asyncJobs" */
  insert_asyncJobs?: Maybe<AsyncJobs_Mutation_Response>;
  /** insert a single row into the table: "asyncJobs" */
  insert_asyncJobs_one?: Maybe<AsyncJobs>;
  /** insert data into the table: "chartsConfig" */
  insert_chartsConfig?: Maybe<ChartsConfig_Mutation_Response>;
  /** insert a single row into the table: "chartsConfig" */
  insert_chartsConfig_one?: Maybe<ChartsConfig>;
  /** insert data into the table: "copyProcessStatuses" */
  insert_copyProcessStatuses?: Maybe<CopyProcessStatuses_Mutation_Response>;
  /** insert a single row into the table: "copyProcessStatuses" */
  insert_copyProcessStatuses_one?: Maybe<CopyProcessStatuses>;
  /** insert data into the table: "entityProgressTrackerSettings" */
  insert_entityProgressTrackerSettings?: Maybe<EntityProgressTrackerSettings_Mutation_Response>;
  /** insert a single row into the table: "entityProgressTrackerSettings" */
  insert_entityProgressTrackerSettings_one?: Maybe<EntityProgressTrackerSettings>;
  /** insert data into the table: "entityStoryColorSettings" */
  insert_entityStoryColorSettings?: Maybe<EntityStoryColorSettings_Mutation_Response>;
  /** insert a single row into the table: "entityStoryColorSettings" */
  insert_entityStoryColorSettings_one?: Maybe<EntityStoryColorSettings>;
  /** insert data into the table: "entityStorySettings" */
  insert_entityStorySettings?: Maybe<EntityStorySettings_Mutation_Response>;
  /** insert a single row into the table: "entityStorySettings" */
  insert_entityStorySettings_one?: Maybe<EntityStorySettings>;
  /** insert data into the table: "exportFolderPdfRequests" */
  insert_exportFolderPdfRequests?: Maybe<ExportFolderPdfRequests_Mutation_Response>;
  /** insert a single row into the table: "exportFolderPdfRequests" */
  insert_exportFolderPdfRequests_one?: Maybe<ExportFolderPdfRequests>;
  /** insert data into the table: "exportStoriesChunks" */
  insert_exportStoriesChunks?: Maybe<ExportStoriesChunks_Mutation_Response>;
  /** insert a single row into the table: "exportStoriesChunks" */
  insert_exportStoriesChunks_one?: Maybe<ExportStoriesChunks>;
  /** insert data into the table: "internalPublishedStory" */
  insert_internalPublishedStory?: Maybe<InternalPublishedStory_Mutation_Response>;
  /** insert a single row into the table: "internalPublishedStory" */
  insert_internalPublishedStory_one?: Maybe<InternalPublishedStory>;
  /** insert data into the table: "portalStory" */
  insert_portalStory?: Maybe<PortalStory_Mutation_Response>;
  /** insert a single row into the table: "portalStory" */
  insert_portalStory_one?: Maybe<PortalStory>;
  /** insert data into the table: "publicationBrandings" */
  insert_publicationBrandings?: Maybe<PublicationBrandings_Mutation_Response>;
  /** insert a single row into the table: "publicationBrandings" */
  insert_publicationBrandings_one?: Maybe<PublicationBrandings>;
  /** insert data into the table: "publicationExportPdfRequest" */
  insert_publicationExportPdfRequest?: Maybe<PublicationExportPdfRequest_Mutation_Response>;
  /** insert a single row into the table: "publicationExportPdfRequest" */
  insert_publicationExportPdfRequest_one?: Maybe<PublicationExportPdfRequest>;
  /** insert data into the table: "publicationFolders" */
  insert_publicationFolders?: Maybe<PublicationFolders_Mutation_Response>;
  /** insert a single row into the table: "publicationFolders" */
  insert_publicationFolders_one?: Maybe<PublicationFolders>;
  /** insert data into the table: "publicationFooterSettings" */
  insert_publicationFooterSettings?: Maybe<PublicationFooterSettings_Mutation_Response>;
  /** insert a single row into the table: "publicationFooterSettings" */
  insert_publicationFooterSettings_one?: Maybe<PublicationFooterSettings>;
  /** insert data into the table: "publicationNavigationMenuItems" */
  insert_publicationNavigationMenuItems?: Maybe<PublicationNavigationMenuItems_Mutation_Response>;
  /** insert a single row into the table: "publicationNavigationMenuItems" */
  insert_publicationNavigationMenuItems_one?: Maybe<PublicationNavigationMenuItems>;
  /** insert data into the table: "publicationNavigationMenuStories" */
  insert_publicationNavigationMenuStories?: Maybe<PublicationNavigationMenuStories_Mutation_Response>;
  /** insert a single row into the table: "publicationNavigationMenuStories" */
  insert_publicationNavigationMenuStories_one?: Maybe<PublicationNavigationMenuStories>;
  /** insert data into the table: "publicationSetupPdfStyles" */
  insert_publicationSetupPdfStyles?: Maybe<PublicationSetupPdfStyles_Mutation_Response>;
  /** insert a single row into the table: "publicationSetupPdfStyles" */
  insert_publicationSetupPdfStyles_one?: Maybe<PublicationSetupPdfStyles>;
  /** insert data into the table: "publicationStoryPdfSettings" */
  insert_publicationStoryPdfSettings?: Maybe<PublicationStoryPdfSettings_Mutation_Response>;
  /** insert a single row into the table: "publicationStoryPdfSettings" */
  insert_publicationStoryPdfSettings_one?: Maybe<PublicationStoryPdfSettings>;
  /** insert data into the table: "publicationTOCSettings" */
  insert_publicationTOCSettings?: Maybe<PublicationTocSettings_Mutation_Response>;
  /** insert a single row into the table: "publicationTOCSettings" */
  insert_publicationTOCSettings_one?: Maybe<PublicationTocSettings>;
  /** insert data into the table: "publications" */
  insert_publications?: Maybe<Publications_Mutation_Response>;
  /** insert a single row into the table: "publications" */
  insert_publications_one?: Maybe<Publications>;
  /** insert data into the table: "spreadsheetNamedRanges" */
  insert_spreadsheetNamedRanges?: Maybe<SpreadsheetNamedRanges_Mutation_Response>;
  /** insert a single row into the table: "spreadsheetNamedRanges" */
  insert_spreadsheetNamedRanges_one?: Maybe<SpreadsheetNamedRanges>;
  /** insert data into the table: "spreadsheetSplitTables" */
  insert_spreadsheetSplitTables?: Maybe<SpreadsheetSplitTables_Mutation_Response>;
  /** insert a single row into the table: "spreadsheetSplitTables" */
  insert_spreadsheetSplitTables_one?: Maybe<SpreadsheetSplitTables>;
  /** insert data into the table: "spreadsheets" */
  insert_spreadsheets?: Maybe<Spreadsheets_Mutation_Response>;
  /** insert data into the table: "spreadsheetsProcessingStatus" */
  insert_spreadsheetsProcessingStatus?: Maybe<SpreadsheetsProcessingStatus_Mutation_Response>;
  /** insert a single row into the table: "spreadsheetsProcessingStatus" */
  insert_spreadsheetsProcessingStatus_one?: Maybe<SpreadsheetsProcessingStatus>;
  /** insert a single row into the table: "spreadsheets" */
  insert_spreadsheets_one?: Maybe<Spreadsheets>;
  /** insert data into the table: "stories" */
  insert_stories?: Maybe<Stories_Mutation_Response>;
  /** insert data into the table: "storiesCopyProcesses" */
  insert_storiesCopyProcesses?: Maybe<StoriesCopyProcesses_Mutation_Response>;
  /** insert a single row into the table: "storiesCopyProcesses" */
  insert_storiesCopyProcesses_one?: Maybe<StoriesCopyProcesses>;
  /** insert a single row into the table: "stories" */
  insert_stories_one?: Maybe<Stories>;
  /** insert data into the table: "storyBudgetProposals" */
  insert_storyBudgetProposals?: Maybe<StoryBudgetProposals_Mutation_Response>;
  /** insert a single row into the table: "storyBudgetProposals" */
  insert_storyBudgetProposals_one?: Maybe<StoryBudgetProposals>;
  /** insert data into the table: "storyContentBlockTypes" */
  insert_storyContentBlockTypes?: Maybe<StoryContentBlockTypes_Mutation_Response>;
  /** insert a single row into the table: "storyContentBlockTypes" */
  insert_storyContentBlockTypes_one?: Maybe<StoryContentBlockTypes>;
  /** insert data into the table: "storyContentBlocks" */
  insert_storyContentBlocks?: Maybe<StoryContentBlocks_Mutation_Response>;
  /** insert a single row into the table: "storyContentBlocks" */
  insert_storyContentBlocks_one?: Maybe<StoryContentBlocks>;
  /** insert data into the table: "storyContentColorTargets" */
  insert_storyContentColorTargets?: Maybe<StoryContentColorTargets_Mutation_Response>;
  /** insert a single row into the table: "storyContentColorTargets" */
  insert_storyContentColorTargets_one?: Maybe<StoryContentColorTargets>;
  /** insert data into the table: "storyContentSpreadsheetReferences" */
  insert_storyContentSpreadsheetReferences?: Maybe<StoryContentSpreadsheetReferences_Mutation_Response>;
  /** insert a single row into the table: "storyContentSpreadsheetReferences" */
  insert_storyContentSpreadsheetReferences_one?: Maybe<StoryContentSpreadsheetReferences>;
  /** insert data into the table: "storyContentTypes" */
  insert_storyContentTypes?: Maybe<StoryContentTypes_Mutation_Response>;
  /** insert a single row into the table: "storyContentTypes" */
  insert_storyContentTypes_one?: Maybe<StoryContentTypes>;
  /** insert data into the table: "storyContents" */
  insert_storyContents?: Maybe<StoryContents_Mutation_Response>;
  /** insert a single row into the table: "storyContents" */
  insert_storyContents_one?: Maybe<StoryContents>;
  /** insert data into the table: "storyCopyProcesses" */
  insert_storyCopyProcesses?: Maybe<StoryCopyProcesses_Mutation_Response>;
  /** insert a single row into the table: "storyCopyProcesses" */
  insert_storyCopyProcesses_one?: Maybe<StoryCopyProcesses>;
  /** insert data into the table: "storyCustomColors" */
  insert_storyCustomColors?: Maybe<StoryCustomColors_Mutation_Response>;
  /** insert a single row into the table: "storyCustomColors" */
  insert_storyCustomColors_one?: Maybe<StoryCustomColors>;
  /** insert data into the table: "storyEmbeds" */
  insert_storyEmbeds?: Maybe<StoryEmbeds_Mutation_Response>;
  /** insert a single row into the table: "storyEmbeds" */
  insert_storyEmbeds_one?: Maybe<StoryEmbeds>;
  /** insert data into the table: "storyFolderActionSets" */
  insert_storyFolderActionSets?: Maybe<StoryFolderActionSets_Mutation_Response>;
  /** insert a single row into the table: "storyFolderActionSets" */
  insert_storyFolderActionSets_one?: Maybe<StoryFolderActionSets>;
  /** insert data into the table: "storyFolderGrants" */
  insert_storyFolderGrants?: Maybe<StoryFolderGrants_Mutation_Response>;
  /** insert a single row into the table: "storyFolderGrants" */
  insert_storyFolderGrants_one?: Maybe<StoryFolderGrants>;
  /** insert data into the table: "storyFolders" */
  insert_storyFolders?: Maybe<StoryFolders_Mutation_Response>;
  /** insert data into the table: "storyFoldersCopyProcesses" */
  insert_storyFoldersCopyProcesses?: Maybe<StoryFoldersCopyProcesses_Mutation_Response>;
  /** insert a single row into the table: "storyFoldersCopyProcesses" */
  insert_storyFoldersCopyProcesses_one?: Maybe<StoryFoldersCopyProcesses>;
  /** insert a single row into the table: "storyFolders" */
  insert_storyFolders_one?: Maybe<StoryFolders>;
  /** insert data into the table: "storyStates" */
  insert_storyStates?: Maybe<StoryStates_Mutation_Response>;
  /** insert a single row into the table: "storyStates" */
  insert_storyStates_one?: Maybe<StoryStates>;
  /** insert data into the table: "storyTemplateContentBlocks" */
  insert_storyTemplateContentBlocks?: Maybe<StoryTemplateContentBlocks_Mutation_Response>;
  /** insert a single row into the table: "storyTemplateContentBlocks" */
  insert_storyTemplateContentBlocks_one?: Maybe<StoryTemplateContentBlocks>;
  /** insert data into the table: "storyTemplateContents" */
  insert_storyTemplateContents?: Maybe<StoryTemplateContents_Mutation_Response>;
  /** insert a single row into the table: "storyTemplateContents" */
  insert_storyTemplateContents_one?: Maybe<StoryTemplateContents>;
  /** insert data into the table: "storyTemplateCustomColors" */
  insert_storyTemplateCustomColors?: Maybe<StoryTemplateCustomColors_Mutation_Response>;
  /** insert a single row into the table: "storyTemplateCustomColors" */
  insert_storyTemplateCustomColors_one?: Maybe<StoryTemplateCustomColors>;
  /** insert data into the table: "storyTemplates" */
  insert_storyTemplates?: Maybe<StoryTemplates_Mutation_Response>;
  /** insert a single row into the table: "storyTemplates" */
  insert_storyTemplates_one?: Maybe<StoryTemplates>;
  /** insert data into the table: "storyUsers" */
  insert_storyUsers?: Maybe<StoryUsers_Mutation_Response>;
  /** insert a single row into the table: "storyUsers" */
  insert_storyUsers_one?: Maybe<StoryUsers>;
  /** insert data into the table: "storyVisibilities" */
  insert_storyVisibilities?: Maybe<StoryVisibilities_Mutation_Response>;
  /** insert a single row into the table: "storyVisibilities" */
  insert_storyVisibilities_one?: Maybe<StoryVisibilities>;
  /** insert data into the table: "subjectPublicationClaims" */
  insert_subjectPublicationClaims?: Maybe<SubjectPublicationClaims_Mutation_Response>;
  /** insert a single row into the table: "subjectPublicationClaims" */
  insert_subjectPublicationClaims_one?: Maybe<SubjectPublicationClaims>;
  /** insert data into the table: "subjectStoryClaims" */
  insert_subjectStoryClaims?: Maybe<SubjectStoryClaims_Mutation_Response>;
  /** insert a single row into the table: "subjectStoryClaims" */
  insert_subjectStoryClaims_one?: Maybe<SubjectStoryClaims>;
  /** insert data into the table: "userPublicationViews" */
  insert_userPublicationViews?: Maybe<UserPublicationViews_Mutation_Response>;
  /** insert a single row into the table: "userPublicationViews" */
  insert_userPublicationViews_one?: Maybe<UserPublicationViews>;
  /** update data of the table: "asyncJobs" */
  update_asyncJobs?: Maybe<AsyncJobs_Mutation_Response>;
  /** update single row of the table: "asyncJobs" */
  update_asyncJobs_by_pk?: Maybe<AsyncJobs>;
  /** update multiples rows of table: "asyncJobs" */
  update_asyncJobs_many?: Maybe<Array<Maybe<AsyncJobs_Mutation_Response>>>;
  /** update data of the table: "chartsConfig" */
  update_chartsConfig?: Maybe<ChartsConfig_Mutation_Response>;
  /** update single row of the table: "chartsConfig" */
  update_chartsConfig_by_pk?: Maybe<ChartsConfig>;
  /** update multiples rows of table: "chartsConfig" */
  update_chartsConfig_many?: Maybe<Array<Maybe<ChartsConfig_Mutation_Response>>>;
  /** update data of the table: "copyProcessStatuses" */
  update_copyProcessStatuses?: Maybe<CopyProcessStatuses_Mutation_Response>;
  /** update single row of the table: "copyProcessStatuses" */
  update_copyProcessStatuses_by_pk?: Maybe<CopyProcessStatuses>;
  /** update multiples rows of table: "copyProcessStatuses" */
  update_copyProcessStatuses_many?: Maybe<Array<Maybe<CopyProcessStatuses_Mutation_Response>>>;
  /** update data of the table: "entityProgressTrackerSettings" */
  update_entityProgressTrackerSettings?: Maybe<EntityProgressTrackerSettings_Mutation_Response>;
  /** update single row of the table: "entityProgressTrackerSettings" */
  update_entityProgressTrackerSettings_by_pk?: Maybe<EntityProgressTrackerSettings>;
  /** update multiples rows of table: "entityProgressTrackerSettings" */
  update_entityProgressTrackerSettings_many?: Maybe<Array<Maybe<EntityProgressTrackerSettings_Mutation_Response>>>;
  /** update data of the table: "entityStoryColorSettings" */
  update_entityStoryColorSettings?: Maybe<EntityStoryColorSettings_Mutation_Response>;
  /** update single row of the table: "entityStoryColorSettings" */
  update_entityStoryColorSettings_by_pk?: Maybe<EntityStoryColorSettings>;
  /** update multiples rows of table: "entityStoryColorSettings" */
  update_entityStoryColorSettings_many?: Maybe<Array<Maybe<EntityStoryColorSettings_Mutation_Response>>>;
  /** update data of the table: "entityStorySettings" */
  update_entityStorySettings?: Maybe<EntityStorySettings_Mutation_Response>;
  /** update single row of the table: "entityStorySettings" */
  update_entityStorySettings_by_pk?: Maybe<EntityStorySettings>;
  /** update multiples rows of table: "entityStorySettings" */
  update_entityStorySettings_many?: Maybe<Array<Maybe<EntityStorySettings_Mutation_Response>>>;
  /** update data of the table: "exportFolderPdfRequests" */
  update_exportFolderPdfRequests?: Maybe<ExportFolderPdfRequests_Mutation_Response>;
  /** update single row of the table: "exportFolderPdfRequests" */
  update_exportFolderPdfRequests_by_pk?: Maybe<ExportFolderPdfRequests>;
  /** update multiples rows of table: "exportFolderPdfRequests" */
  update_exportFolderPdfRequests_many?: Maybe<Array<Maybe<ExportFolderPdfRequests_Mutation_Response>>>;
  /** update data of the table: "exportStoriesChunks" */
  update_exportStoriesChunks?: Maybe<ExportStoriesChunks_Mutation_Response>;
  /** update multiples rows of table: "exportStoriesChunks" */
  update_exportStoriesChunks_many?: Maybe<Array<Maybe<ExportStoriesChunks_Mutation_Response>>>;
  /** update data of the table: "internalPublishedStory" */
  update_internalPublishedStory?: Maybe<InternalPublishedStory_Mutation_Response>;
  /** update single row of the table: "internalPublishedStory" */
  update_internalPublishedStory_by_pk?: Maybe<InternalPublishedStory>;
  /** update multiples rows of table: "internalPublishedStory" */
  update_internalPublishedStory_many?: Maybe<Array<Maybe<InternalPublishedStory_Mutation_Response>>>;
  /** update data of the table: "portalStory" */
  update_portalStory?: Maybe<PortalStory_Mutation_Response>;
  /** update single row of the table: "portalStory" */
  update_portalStory_by_pk?: Maybe<PortalStory>;
  /** update multiples rows of table: "portalStory" */
  update_portalStory_many?: Maybe<Array<Maybe<PortalStory_Mutation_Response>>>;
  /** update data of the table: "publicationBrandings" */
  update_publicationBrandings?: Maybe<PublicationBrandings_Mutation_Response>;
  /** update single row of the table: "publicationBrandings" */
  update_publicationBrandings_by_pk?: Maybe<PublicationBrandings>;
  /** update multiples rows of table: "publicationBrandings" */
  update_publicationBrandings_many?: Maybe<Array<Maybe<PublicationBrandings_Mutation_Response>>>;
  /** update data of the table: "publicationExportPdfRequest" */
  update_publicationExportPdfRequest?: Maybe<PublicationExportPdfRequest_Mutation_Response>;
  /** update single row of the table: "publicationExportPdfRequest" */
  update_publicationExportPdfRequest_by_pk?: Maybe<PublicationExportPdfRequest>;
  /** update multiples rows of table: "publicationExportPdfRequest" */
  update_publicationExportPdfRequest_many?: Maybe<Array<Maybe<PublicationExportPdfRequest_Mutation_Response>>>;
  /** update data of the table: "publicationFolders" */
  update_publicationFolders?: Maybe<PublicationFolders_Mutation_Response>;
  /** update single row of the table: "publicationFolders" */
  update_publicationFolders_by_pk?: Maybe<PublicationFolders>;
  /** update multiples rows of table: "publicationFolders" */
  update_publicationFolders_many?: Maybe<Array<Maybe<PublicationFolders_Mutation_Response>>>;
  /** update data of the table: "publicationFooterSettings" */
  update_publicationFooterSettings?: Maybe<PublicationFooterSettings_Mutation_Response>;
  /** update single row of the table: "publicationFooterSettings" */
  update_publicationFooterSettings_by_pk?: Maybe<PublicationFooterSettings>;
  /** update multiples rows of table: "publicationFooterSettings" */
  update_publicationFooterSettings_many?: Maybe<Array<Maybe<PublicationFooterSettings_Mutation_Response>>>;
  /** update data of the table: "publicationNavigationMenuItems" */
  update_publicationNavigationMenuItems?: Maybe<PublicationNavigationMenuItems_Mutation_Response>;
  /** update single row of the table: "publicationNavigationMenuItems" */
  update_publicationNavigationMenuItems_by_pk?: Maybe<PublicationNavigationMenuItems>;
  /** update multiples rows of table: "publicationNavigationMenuItems" */
  update_publicationNavigationMenuItems_many?: Maybe<Array<Maybe<PublicationNavigationMenuItems_Mutation_Response>>>;
  /** update data of the table: "publicationNavigationMenuStories" */
  update_publicationNavigationMenuStories?: Maybe<PublicationNavigationMenuStories_Mutation_Response>;
  /** update single row of the table: "publicationNavigationMenuStories" */
  update_publicationNavigationMenuStories_by_pk?: Maybe<PublicationNavigationMenuStories>;
  /** update multiples rows of table: "publicationNavigationMenuStories" */
  update_publicationNavigationMenuStories_many?: Maybe<Array<Maybe<PublicationNavigationMenuStories_Mutation_Response>>>;
  /** update data of the table: "publicationSetupPdfStyles" */
  update_publicationSetupPdfStyles?: Maybe<PublicationSetupPdfStyles_Mutation_Response>;
  /** update single row of the table: "publicationSetupPdfStyles" */
  update_publicationSetupPdfStyles_by_pk?: Maybe<PublicationSetupPdfStyles>;
  /** update multiples rows of table: "publicationSetupPdfStyles" */
  update_publicationSetupPdfStyles_many?: Maybe<Array<Maybe<PublicationSetupPdfStyles_Mutation_Response>>>;
  /** update data of the table: "publicationStoryPdfSettings" */
  update_publicationStoryPdfSettings?: Maybe<PublicationStoryPdfSettings_Mutation_Response>;
  /** update single row of the table: "publicationStoryPdfSettings" */
  update_publicationStoryPdfSettings_by_pk?: Maybe<PublicationStoryPdfSettings>;
  /** update multiples rows of table: "publicationStoryPdfSettings" */
  update_publicationStoryPdfSettings_many?: Maybe<Array<Maybe<PublicationStoryPdfSettings_Mutation_Response>>>;
  /** update data of the table: "publicationTOCSettings" */
  update_publicationTOCSettings?: Maybe<PublicationTocSettings_Mutation_Response>;
  /** update single row of the table: "publicationTOCSettings" */
  update_publicationTOCSettings_by_pk?: Maybe<PublicationTocSettings>;
  /** update multiples rows of table: "publicationTOCSettings" */
  update_publicationTOCSettings_many?: Maybe<Array<Maybe<PublicationTocSettings_Mutation_Response>>>;
  /** update data of the table: "publications" */
  update_publications?: Maybe<Publications_Mutation_Response>;
  /** update single row of the table: "publications" */
  update_publications_by_pk?: Maybe<Publications>;
  /** update multiples rows of table: "publications" */
  update_publications_many?: Maybe<Array<Maybe<Publications_Mutation_Response>>>;
  /** update data of the table: "spreadsheetNamedRanges" */
  update_spreadsheetNamedRanges?: Maybe<SpreadsheetNamedRanges_Mutation_Response>;
  /** update single row of the table: "spreadsheetNamedRanges" */
  update_spreadsheetNamedRanges_by_pk?: Maybe<SpreadsheetNamedRanges>;
  /** update multiples rows of table: "spreadsheetNamedRanges" */
  update_spreadsheetNamedRanges_many?: Maybe<Array<Maybe<SpreadsheetNamedRanges_Mutation_Response>>>;
  /** update data of the table: "spreadsheetSplitTables" */
  update_spreadsheetSplitTables?: Maybe<SpreadsheetSplitTables_Mutation_Response>;
  /** update single row of the table: "spreadsheetSplitTables" */
  update_spreadsheetSplitTables_by_pk?: Maybe<SpreadsheetSplitTables>;
  /** update multiples rows of table: "spreadsheetSplitTables" */
  update_spreadsheetSplitTables_many?: Maybe<Array<Maybe<SpreadsheetSplitTables_Mutation_Response>>>;
  /** update data of the table: "spreadsheets" */
  update_spreadsheets?: Maybe<Spreadsheets_Mutation_Response>;
  /** update data of the table: "spreadsheetsProcessingStatus" */
  update_spreadsheetsProcessingStatus?: Maybe<SpreadsheetsProcessingStatus_Mutation_Response>;
  /** update single row of the table: "spreadsheetsProcessingStatus" */
  update_spreadsheetsProcessingStatus_by_pk?: Maybe<SpreadsheetsProcessingStatus>;
  /** update multiples rows of table: "spreadsheetsProcessingStatus" */
  update_spreadsheetsProcessingStatus_many?: Maybe<Array<Maybe<SpreadsheetsProcessingStatus_Mutation_Response>>>;
  /** update single row of the table: "spreadsheets" */
  update_spreadsheets_by_pk?: Maybe<Spreadsheets>;
  /** update multiples rows of table: "spreadsheets" */
  update_spreadsheets_many?: Maybe<Array<Maybe<Spreadsheets_Mutation_Response>>>;
  /** update data of the table: "stories" */
  update_stories?: Maybe<Stories_Mutation_Response>;
  /** update data of the table: "storiesCopyProcesses" */
  update_storiesCopyProcesses?: Maybe<StoriesCopyProcesses_Mutation_Response>;
  /** update single row of the table: "storiesCopyProcesses" */
  update_storiesCopyProcesses_by_pk?: Maybe<StoriesCopyProcesses>;
  /** update multiples rows of table: "storiesCopyProcesses" */
  update_storiesCopyProcesses_many?: Maybe<Array<Maybe<StoriesCopyProcesses_Mutation_Response>>>;
  /** update single row of the table: "stories" */
  update_stories_by_pk?: Maybe<Stories>;
  /** update multiples rows of table: "stories" */
  update_stories_many?: Maybe<Array<Maybe<Stories_Mutation_Response>>>;
  /** update data of the table: "storyBudgetProposals" */
  update_storyBudgetProposals?: Maybe<StoryBudgetProposals_Mutation_Response>;
  /** update single row of the table: "storyBudgetProposals" */
  update_storyBudgetProposals_by_pk?: Maybe<StoryBudgetProposals>;
  /** update multiples rows of table: "storyBudgetProposals" */
  update_storyBudgetProposals_many?: Maybe<Array<Maybe<StoryBudgetProposals_Mutation_Response>>>;
  /** update data of the table: "storyContentBlockTypes" */
  update_storyContentBlockTypes?: Maybe<StoryContentBlockTypes_Mutation_Response>;
  /** update single row of the table: "storyContentBlockTypes" */
  update_storyContentBlockTypes_by_pk?: Maybe<StoryContentBlockTypes>;
  /** update multiples rows of table: "storyContentBlockTypes" */
  update_storyContentBlockTypes_many?: Maybe<Array<Maybe<StoryContentBlockTypes_Mutation_Response>>>;
  /** update data of the table: "storyContentBlocks" */
  update_storyContentBlocks?: Maybe<StoryContentBlocks_Mutation_Response>;
  /** update single row of the table: "storyContentBlocks" */
  update_storyContentBlocks_by_pk?: Maybe<StoryContentBlocks>;
  /** update multiples rows of table: "storyContentBlocks" */
  update_storyContentBlocks_many?: Maybe<Array<Maybe<StoryContentBlocks_Mutation_Response>>>;
  /** update data of the table: "storyContentColorTargets" */
  update_storyContentColorTargets?: Maybe<StoryContentColorTargets_Mutation_Response>;
  /** update single row of the table: "storyContentColorTargets" */
  update_storyContentColorTargets_by_pk?: Maybe<StoryContentColorTargets>;
  /** update multiples rows of table: "storyContentColorTargets" */
  update_storyContentColorTargets_many?: Maybe<Array<Maybe<StoryContentColorTargets_Mutation_Response>>>;
  /** update data of the table: "storyContentSpreadsheetReferences" */
  update_storyContentSpreadsheetReferences?: Maybe<StoryContentSpreadsheetReferences_Mutation_Response>;
  /** update single row of the table: "storyContentSpreadsheetReferences" */
  update_storyContentSpreadsheetReferences_by_pk?: Maybe<StoryContentSpreadsheetReferences>;
  /** update multiples rows of table: "storyContentSpreadsheetReferences" */
  update_storyContentSpreadsheetReferences_many?: Maybe<Array<Maybe<StoryContentSpreadsheetReferences_Mutation_Response>>>;
  /** update data of the table: "storyContentTypes" */
  update_storyContentTypes?: Maybe<StoryContentTypes_Mutation_Response>;
  /** update single row of the table: "storyContentTypes" */
  update_storyContentTypes_by_pk?: Maybe<StoryContentTypes>;
  /** update multiples rows of table: "storyContentTypes" */
  update_storyContentTypes_many?: Maybe<Array<Maybe<StoryContentTypes_Mutation_Response>>>;
  /** update data of the table: "storyContents" */
  update_storyContents?: Maybe<StoryContents_Mutation_Response>;
  /** update single row of the table: "storyContents" */
  update_storyContents_by_pk?: Maybe<StoryContents>;
  /** update multiples rows of table: "storyContents" */
  update_storyContents_many?: Maybe<Array<Maybe<StoryContents_Mutation_Response>>>;
  /** update data of the table: "storyCopyProcesses" */
  update_storyCopyProcesses?: Maybe<StoryCopyProcesses_Mutation_Response>;
  /** update single row of the table: "storyCopyProcesses" */
  update_storyCopyProcesses_by_pk?: Maybe<StoryCopyProcesses>;
  /** update multiples rows of table: "storyCopyProcesses" */
  update_storyCopyProcesses_many?: Maybe<Array<Maybe<StoryCopyProcesses_Mutation_Response>>>;
  /** update data of the table: "storyCustomColors" */
  update_storyCustomColors?: Maybe<StoryCustomColors_Mutation_Response>;
  /** update single row of the table: "storyCustomColors" */
  update_storyCustomColors_by_pk?: Maybe<StoryCustomColors>;
  /** update multiples rows of table: "storyCustomColors" */
  update_storyCustomColors_many?: Maybe<Array<Maybe<StoryCustomColors_Mutation_Response>>>;
  /** update data of the table: "storyEmbeds" */
  update_storyEmbeds?: Maybe<StoryEmbeds_Mutation_Response>;
  /** update single row of the table: "storyEmbeds" */
  update_storyEmbeds_by_pk?: Maybe<StoryEmbeds>;
  /** update multiples rows of table: "storyEmbeds" */
  update_storyEmbeds_many?: Maybe<Array<Maybe<StoryEmbeds_Mutation_Response>>>;
  /** update data of the table: "storyFolderActionSets" */
  update_storyFolderActionSets?: Maybe<StoryFolderActionSets_Mutation_Response>;
  /** update single row of the table: "storyFolderActionSets" */
  update_storyFolderActionSets_by_pk?: Maybe<StoryFolderActionSets>;
  /** update multiples rows of table: "storyFolderActionSets" */
  update_storyFolderActionSets_many?: Maybe<Array<Maybe<StoryFolderActionSets_Mutation_Response>>>;
  /** update data of the table: "storyFolderGrants" */
  update_storyFolderGrants?: Maybe<StoryFolderGrants_Mutation_Response>;
  /** update single row of the table: "storyFolderGrants" */
  update_storyFolderGrants_by_pk?: Maybe<StoryFolderGrants>;
  /** update multiples rows of table: "storyFolderGrants" */
  update_storyFolderGrants_many?: Maybe<Array<Maybe<StoryFolderGrants_Mutation_Response>>>;
  /** update data of the table: "storyFolders" */
  update_storyFolders?: Maybe<StoryFolders_Mutation_Response>;
  /** update data of the table: "storyFoldersCopyProcesses" */
  update_storyFoldersCopyProcesses?: Maybe<StoryFoldersCopyProcesses_Mutation_Response>;
  /** update single row of the table: "storyFoldersCopyProcesses" */
  update_storyFoldersCopyProcesses_by_pk?: Maybe<StoryFoldersCopyProcesses>;
  /** update multiples rows of table: "storyFoldersCopyProcesses" */
  update_storyFoldersCopyProcesses_many?: Maybe<Array<Maybe<StoryFoldersCopyProcesses_Mutation_Response>>>;
  /** update single row of the table: "storyFolders" */
  update_storyFolders_by_pk?: Maybe<StoryFolders>;
  /** update multiples rows of table: "storyFolders" */
  update_storyFolders_many?: Maybe<Array<Maybe<StoryFolders_Mutation_Response>>>;
  /** update data of the table: "storyStates" */
  update_storyStates?: Maybe<StoryStates_Mutation_Response>;
  /** update single row of the table: "storyStates" */
  update_storyStates_by_pk?: Maybe<StoryStates>;
  /** update multiples rows of table: "storyStates" */
  update_storyStates_many?: Maybe<Array<Maybe<StoryStates_Mutation_Response>>>;
  /** update data of the table: "storyTemplateContentBlocks" */
  update_storyTemplateContentBlocks?: Maybe<StoryTemplateContentBlocks_Mutation_Response>;
  /** update single row of the table: "storyTemplateContentBlocks" */
  update_storyTemplateContentBlocks_by_pk?: Maybe<StoryTemplateContentBlocks>;
  /** update multiples rows of table: "storyTemplateContentBlocks" */
  update_storyTemplateContentBlocks_many?: Maybe<Array<Maybe<StoryTemplateContentBlocks_Mutation_Response>>>;
  /** update data of the table: "storyTemplateContents" */
  update_storyTemplateContents?: Maybe<StoryTemplateContents_Mutation_Response>;
  /** update single row of the table: "storyTemplateContents" */
  update_storyTemplateContents_by_pk?: Maybe<StoryTemplateContents>;
  /** update multiples rows of table: "storyTemplateContents" */
  update_storyTemplateContents_many?: Maybe<Array<Maybe<StoryTemplateContents_Mutation_Response>>>;
  /** update data of the table: "storyTemplateCustomColors" */
  update_storyTemplateCustomColors?: Maybe<StoryTemplateCustomColors_Mutation_Response>;
  /** update single row of the table: "storyTemplateCustomColors" */
  update_storyTemplateCustomColors_by_pk?: Maybe<StoryTemplateCustomColors>;
  /** update multiples rows of table: "storyTemplateCustomColors" */
  update_storyTemplateCustomColors_many?: Maybe<Array<Maybe<StoryTemplateCustomColors_Mutation_Response>>>;
  /** update data of the table: "storyTemplates" */
  update_storyTemplates?: Maybe<StoryTemplates_Mutation_Response>;
  /** update single row of the table: "storyTemplates" */
  update_storyTemplates_by_pk?: Maybe<StoryTemplates>;
  /** update multiples rows of table: "storyTemplates" */
  update_storyTemplates_many?: Maybe<Array<Maybe<StoryTemplates_Mutation_Response>>>;
  /** update data of the table: "storyUsers" */
  update_storyUsers?: Maybe<StoryUsers_Mutation_Response>;
  /** update single row of the table: "storyUsers" */
  update_storyUsers_by_pk?: Maybe<StoryUsers>;
  /** update multiples rows of table: "storyUsers" */
  update_storyUsers_many?: Maybe<Array<Maybe<StoryUsers_Mutation_Response>>>;
  /** update data of the table: "storyVisibilities" */
  update_storyVisibilities?: Maybe<StoryVisibilities_Mutation_Response>;
  /** update single row of the table: "storyVisibilities" */
  update_storyVisibilities_by_pk?: Maybe<StoryVisibilities>;
  /** update multiples rows of table: "storyVisibilities" */
  update_storyVisibilities_many?: Maybe<Array<Maybe<StoryVisibilities_Mutation_Response>>>;
  /** update data of the table: "subjectPublicationClaims" */
  update_subjectPublicationClaims?: Maybe<SubjectPublicationClaims_Mutation_Response>;
  /** update single row of the table: "subjectPublicationClaims" */
  update_subjectPublicationClaims_by_pk?: Maybe<SubjectPublicationClaims>;
  /** update multiples rows of table: "subjectPublicationClaims" */
  update_subjectPublicationClaims_many?: Maybe<Array<Maybe<SubjectPublicationClaims_Mutation_Response>>>;
  /** update data of the table: "subjectStoryClaims" */
  update_subjectStoryClaims?: Maybe<SubjectStoryClaims_Mutation_Response>;
  /** update single row of the table: "subjectStoryClaims" */
  update_subjectStoryClaims_by_pk?: Maybe<SubjectStoryClaims>;
  /** update multiples rows of table: "subjectStoryClaims" */
  update_subjectStoryClaims_many?: Maybe<Array<Maybe<SubjectStoryClaims_Mutation_Response>>>;
  /** update data of the table: "userPublicationViews" */
  update_userPublicationViews?: Maybe<UserPublicationViews_Mutation_Response>;
  /** update single row of the table: "userPublicationViews" */
  update_userPublicationViews_by_pk?: Maybe<UserPublicationViews>;
  /** update multiples rows of table: "userPublicationViews" */
  update_userPublicationViews_many?: Maybe<Array<Maybe<UserPublicationViews_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AsyncJobsArgs = {
  where: AsyncJobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AsyncJobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ChartsConfigArgs = {
  where: ChartsConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ChartsConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CopyProcessStatusesArgs = {
  where: CopyProcessStatuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CopyProcessStatuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EntityProgressTrackerSettingsArgs = {
  where: EntityProgressTrackerSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EntityProgressTrackerSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EntityStoryColorSettingsArgs = {
  where: EntityStoryColorSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EntityStoryColorSettings_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  entityId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EntityStorySettingsArgs = {
  where: EntityStorySettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EntityStorySettings_By_PkArgs = {
  entityId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ExportFolderPdfRequestsArgs = {
  where: ExportFolderPdfRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ExportFolderPdfRequests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ExportStoriesChunksArgs = {
  where: ExportStoriesChunks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InternalPublishedStoryArgs = {
  where: InternalPublishedStory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InternalPublishedStory_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PortalStoryArgs = {
  where: PortalStory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PortalStory_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationBrandingsArgs = {
  where: PublicationBrandings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationBrandings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationExportPdfRequestArgs = {
  where: PublicationExportPdfRequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationExportPdfRequest_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationFoldersArgs = {
  where: PublicationFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationFooterSettingsArgs = {
  where: PublicationFooterSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationFooterSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationNavigationMenuItemsArgs = {
  where: PublicationNavigationMenuItems_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationNavigationMenuItems_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationNavigationMenuStoriesArgs = {
  where: PublicationNavigationMenuStories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationNavigationMenuStories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationSetupPdfStylesArgs = {
  where: PublicationSetupPdfStyles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationSetupPdfStyles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationStoryPdfSettingsArgs = {
  where: PublicationStoryPdfSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationStoryPdfSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationTocSettingsArgs = {
  where: PublicationTocSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicationTocSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PublicationsArgs = {
  where: Publications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Publications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpreadsheetNamedRangesArgs = {
  where: SpreadsheetNamedRanges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpreadsheetNamedRanges_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpreadsheetSplitTablesArgs = {
  where: SpreadsheetSplitTables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpreadsheetSplitTables_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpreadsheetsArgs = {
  where: Spreadsheets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpreadsheetsProcessingStatusArgs = {
  where: SpreadsheetsProcessingStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpreadsheetsProcessingStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Spreadsheets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoriesArgs = {
  where: Stories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoriesCopyProcessesArgs = {
  where: StoriesCopyProcesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoriesCopyProcesses_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Stories_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryBudgetProposalsArgs = {
  where: StoryBudgetProposals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryBudgetProposals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryContentBlockTypesArgs = {
  where: StoryContentBlockTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryContentBlockTypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryContentBlocksArgs = {
  where: StoryContentBlocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryContentBlocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryContentColorTargetsArgs = {
  where: StoryContentColorTargets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryContentColorTargets_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryContentSpreadsheetReferencesArgs = {
  where: StoryContentSpreadsheetReferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryContentSpreadsheetReferences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryContentTypesArgs = {
  where: StoryContentTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryContentTypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryContentsArgs = {
  where: StoryContents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryContents_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryCopyProcessesArgs = {
  where: StoryCopyProcesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryCopyProcesses_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryCustomColorsArgs = {
  where: StoryCustomColors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryCustomColors_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  storyId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryEmbedsArgs = {
  where: StoryEmbeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryEmbeds_By_PkArgs = {
  embedId: Scalars['uuid']['input'];
  storyId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryFolderActionSetsArgs = {
  where: StoryFolderActionSets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryFolderActionSets_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryFolderGrantsArgs = {
  where: StoryFolderGrants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryFolderGrants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryFoldersArgs = {
  where: StoryFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryFoldersCopyProcessesArgs = {
  where: StoryFoldersCopyProcesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryFoldersCopyProcesses_By_PkArgs = {
  destinationFolderId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryStatesArgs = {
  where: StoryStates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryStates_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplateContentBlocksArgs = {
  where: StoryTemplateContentBlocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplateContentBlocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplateContentsArgs = {
  where: StoryTemplateContents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplateContents_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplateCustomColorsArgs = {
  where: StoryTemplateCustomColors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplateCustomColors_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  templateId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplatesArgs = {
  where: StoryTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryTemplates_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryUsersArgs = {
  where: StoryUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryUsers_By_PkArgs = {
  _id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StoryVisibilitiesArgs = {
  where: StoryVisibilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StoryVisibilities_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SubjectPublicationClaimsArgs = {
  where: SubjectPublicationClaims_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SubjectPublicationClaims_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SubjectStoryClaimsArgs = {
  where: SubjectStoryClaims_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SubjectStoryClaims_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserPublicationViewsArgs = {
  where: UserPublicationViews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserPublicationViews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AsyncJobsArgs = {
  objects: Array<AsyncJobs_Insert_Input>;
  on_conflict?: InputMaybe<AsyncJobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AsyncJobs_OneArgs = {
  object: AsyncJobs_Insert_Input;
  on_conflict?: InputMaybe<AsyncJobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ChartsConfigArgs = {
  objects: Array<ChartsConfig_Insert_Input>;
  on_conflict?: InputMaybe<ChartsConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ChartsConfig_OneArgs = {
  object: ChartsConfig_Insert_Input;
  on_conflict?: InputMaybe<ChartsConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CopyProcessStatusesArgs = {
  objects: Array<CopyProcessStatuses_Insert_Input>;
  on_conflict?: InputMaybe<CopyProcessStatuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CopyProcessStatuses_OneArgs = {
  object: CopyProcessStatuses_Insert_Input;
  on_conflict?: InputMaybe<CopyProcessStatuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityProgressTrackerSettingsArgs = {
  objects: Array<EntityProgressTrackerSettings_Insert_Input>;
  on_conflict?: InputMaybe<EntityProgressTrackerSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityProgressTrackerSettings_OneArgs = {
  object: EntityProgressTrackerSettings_Insert_Input;
  on_conflict?: InputMaybe<EntityProgressTrackerSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityStoryColorSettingsArgs = {
  objects: Array<EntityStoryColorSettings_Insert_Input>;
  on_conflict?: InputMaybe<EntityStoryColorSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityStoryColorSettings_OneArgs = {
  object: EntityStoryColorSettings_Insert_Input;
  on_conflict?: InputMaybe<EntityStoryColorSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityStorySettingsArgs = {
  objects: Array<EntityStorySettings_Insert_Input>;
  on_conflict?: InputMaybe<EntityStorySettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityStorySettings_OneArgs = {
  object: EntityStorySettings_Insert_Input;
  on_conflict?: InputMaybe<EntityStorySettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExportFolderPdfRequestsArgs = {
  objects: Array<ExportFolderPdfRequests_Insert_Input>;
  on_conflict?: InputMaybe<ExportFolderPdfRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExportFolderPdfRequests_OneArgs = {
  object: ExportFolderPdfRequests_Insert_Input;
  on_conflict?: InputMaybe<ExportFolderPdfRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExportStoriesChunksArgs = {
  objects: Array<ExportStoriesChunks_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_ExportStoriesChunks_OneArgs = {
  object: ExportStoriesChunks_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_InternalPublishedStoryArgs = {
  objects: Array<InternalPublishedStory_Insert_Input>;
  on_conflict?: InputMaybe<InternalPublishedStory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InternalPublishedStory_OneArgs = {
  object: InternalPublishedStory_Insert_Input;
  on_conflict?: InputMaybe<InternalPublishedStory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PortalStoryArgs = {
  objects: Array<PortalStory_Insert_Input>;
  on_conflict?: InputMaybe<PortalStory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PortalStory_OneArgs = {
  object: PortalStory_Insert_Input;
  on_conflict?: InputMaybe<PortalStory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationBrandingsArgs = {
  objects: Array<PublicationBrandings_Insert_Input>;
  on_conflict?: InputMaybe<PublicationBrandings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationBrandings_OneArgs = {
  object: PublicationBrandings_Insert_Input;
  on_conflict?: InputMaybe<PublicationBrandings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationExportPdfRequestArgs = {
  objects: Array<PublicationExportPdfRequest_Insert_Input>;
  on_conflict?: InputMaybe<PublicationExportPdfRequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationExportPdfRequest_OneArgs = {
  object: PublicationExportPdfRequest_Insert_Input;
  on_conflict?: InputMaybe<PublicationExportPdfRequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationFoldersArgs = {
  objects: Array<PublicationFolders_Insert_Input>;
  on_conflict?: InputMaybe<PublicationFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationFolders_OneArgs = {
  object: PublicationFolders_Insert_Input;
  on_conflict?: InputMaybe<PublicationFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationFooterSettingsArgs = {
  objects: Array<PublicationFooterSettings_Insert_Input>;
  on_conflict?: InputMaybe<PublicationFooterSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationFooterSettings_OneArgs = {
  object: PublicationFooterSettings_Insert_Input;
  on_conflict?: InputMaybe<PublicationFooterSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationNavigationMenuItemsArgs = {
  objects: Array<PublicationNavigationMenuItems_Insert_Input>;
  on_conflict?: InputMaybe<PublicationNavigationMenuItems_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationNavigationMenuItems_OneArgs = {
  object: PublicationNavigationMenuItems_Insert_Input;
  on_conflict?: InputMaybe<PublicationNavigationMenuItems_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationNavigationMenuStoriesArgs = {
  objects: Array<PublicationNavigationMenuStories_Insert_Input>;
  on_conflict?: InputMaybe<PublicationNavigationMenuStories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationNavigationMenuStories_OneArgs = {
  object: PublicationNavigationMenuStories_Insert_Input;
  on_conflict?: InputMaybe<PublicationNavigationMenuStories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationSetupPdfStylesArgs = {
  objects: Array<PublicationSetupPdfStyles_Insert_Input>;
  on_conflict?: InputMaybe<PublicationSetupPdfStyles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationSetupPdfStyles_OneArgs = {
  object: PublicationSetupPdfStyles_Insert_Input;
  on_conflict?: InputMaybe<PublicationSetupPdfStyles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationStoryPdfSettingsArgs = {
  objects: Array<PublicationStoryPdfSettings_Insert_Input>;
  on_conflict?: InputMaybe<PublicationStoryPdfSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationStoryPdfSettings_OneArgs = {
  object: PublicationStoryPdfSettings_Insert_Input;
  on_conflict?: InputMaybe<PublicationStoryPdfSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationTocSettingsArgs = {
  objects: Array<PublicationTocSettings_Insert_Input>;
  on_conflict?: InputMaybe<PublicationTocSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationTocSettings_OneArgs = {
  object: PublicationTocSettings_Insert_Input;
  on_conflict?: InputMaybe<PublicationTocSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicationsArgs = {
  objects: Array<Publications_Insert_Input>;
  on_conflict?: InputMaybe<Publications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Publications_OneArgs = {
  object: Publications_Insert_Input;
  on_conflict?: InputMaybe<Publications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpreadsheetNamedRangesArgs = {
  objects: Array<SpreadsheetNamedRanges_Insert_Input>;
  on_conflict?: InputMaybe<SpreadsheetNamedRanges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpreadsheetNamedRanges_OneArgs = {
  object: SpreadsheetNamedRanges_Insert_Input;
  on_conflict?: InputMaybe<SpreadsheetNamedRanges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpreadsheetSplitTablesArgs = {
  objects: Array<SpreadsheetSplitTables_Insert_Input>;
  on_conflict?: InputMaybe<SpreadsheetSplitTables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpreadsheetSplitTables_OneArgs = {
  object: SpreadsheetSplitTables_Insert_Input;
  on_conflict?: InputMaybe<SpreadsheetSplitTables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpreadsheetsArgs = {
  objects: Array<Spreadsheets_Insert_Input>;
  on_conflict?: InputMaybe<Spreadsheets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpreadsheetsProcessingStatusArgs = {
  objects: Array<SpreadsheetsProcessingStatus_Insert_Input>;
  on_conflict?: InputMaybe<SpreadsheetsProcessingStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpreadsheetsProcessingStatus_OneArgs = {
  object: SpreadsheetsProcessingStatus_Insert_Input;
  on_conflict?: InputMaybe<SpreadsheetsProcessingStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spreadsheets_OneArgs = {
  object: Spreadsheets_Insert_Input;
  on_conflict?: InputMaybe<Spreadsheets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoriesArgs = {
  objects: Array<Stories_Insert_Input>;
  on_conflict?: InputMaybe<Stories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoriesCopyProcessesArgs = {
  objects: Array<StoriesCopyProcesses_Insert_Input>;
  on_conflict?: InputMaybe<StoriesCopyProcesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoriesCopyProcesses_OneArgs = {
  object: StoriesCopyProcesses_Insert_Input;
  on_conflict?: InputMaybe<StoriesCopyProcesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stories_OneArgs = {
  object: Stories_Insert_Input;
  on_conflict?: InputMaybe<Stories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryBudgetProposalsArgs = {
  objects: Array<StoryBudgetProposals_Insert_Input>;
  on_conflict?: InputMaybe<StoryBudgetProposals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryBudgetProposals_OneArgs = {
  object: StoryBudgetProposals_Insert_Input;
  on_conflict?: InputMaybe<StoryBudgetProposals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentBlockTypesArgs = {
  objects: Array<StoryContentBlockTypes_Insert_Input>;
  on_conflict?: InputMaybe<StoryContentBlockTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentBlockTypes_OneArgs = {
  object: StoryContentBlockTypes_Insert_Input;
  on_conflict?: InputMaybe<StoryContentBlockTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentBlocksArgs = {
  objects: Array<StoryContentBlocks_Insert_Input>;
  on_conflict?: InputMaybe<StoryContentBlocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentBlocks_OneArgs = {
  object: StoryContentBlocks_Insert_Input;
  on_conflict?: InputMaybe<StoryContentBlocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentColorTargetsArgs = {
  objects: Array<StoryContentColorTargets_Insert_Input>;
  on_conflict?: InputMaybe<StoryContentColorTargets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentColorTargets_OneArgs = {
  object: StoryContentColorTargets_Insert_Input;
  on_conflict?: InputMaybe<StoryContentColorTargets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentSpreadsheetReferencesArgs = {
  objects: Array<StoryContentSpreadsheetReferences_Insert_Input>;
  on_conflict?: InputMaybe<StoryContentSpreadsheetReferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentSpreadsheetReferences_OneArgs = {
  object: StoryContentSpreadsheetReferences_Insert_Input;
  on_conflict?: InputMaybe<StoryContentSpreadsheetReferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentTypesArgs = {
  objects: Array<StoryContentTypes_Insert_Input>;
  on_conflict?: InputMaybe<StoryContentTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentTypes_OneArgs = {
  object: StoryContentTypes_Insert_Input;
  on_conflict?: InputMaybe<StoryContentTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContentsArgs = {
  objects: Array<StoryContents_Insert_Input>;
  on_conflict?: InputMaybe<StoryContents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryContents_OneArgs = {
  object: StoryContents_Insert_Input;
  on_conflict?: InputMaybe<StoryContents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryCopyProcessesArgs = {
  objects: Array<StoryCopyProcesses_Insert_Input>;
  on_conflict?: InputMaybe<StoryCopyProcesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryCopyProcesses_OneArgs = {
  object: StoryCopyProcesses_Insert_Input;
  on_conflict?: InputMaybe<StoryCopyProcesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryCustomColorsArgs = {
  objects: Array<StoryCustomColors_Insert_Input>;
  on_conflict?: InputMaybe<StoryCustomColors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryCustomColors_OneArgs = {
  object: StoryCustomColors_Insert_Input;
  on_conflict?: InputMaybe<StoryCustomColors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryEmbedsArgs = {
  objects: Array<StoryEmbeds_Insert_Input>;
  on_conflict?: InputMaybe<StoryEmbeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryEmbeds_OneArgs = {
  object: StoryEmbeds_Insert_Input;
  on_conflict?: InputMaybe<StoryEmbeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFolderActionSetsArgs = {
  objects: Array<StoryFolderActionSets_Insert_Input>;
  on_conflict?: InputMaybe<StoryFolderActionSets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFolderActionSets_OneArgs = {
  object: StoryFolderActionSets_Insert_Input;
  on_conflict?: InputMaybe<StoryFolderActionSets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFolderGrantsArgs = {
  objects: Array<StoryFolderGrants_Insert_Input>;
  on_conflict?: InputMaybe<StoryFolderGrants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFolderGrants_OneArgs = {
  object: StoryFolderGrants_Insert_Input;
  on_conflict?: InputMaybe<StoryFolderGrants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFoldersArgs = {
  objects: Array<StoryFolders_Insert_Input>;
  on_conflict?: InputMaybe<StoryFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFoldersCopyProcessesArgs = {
  objects: Array<StoryFoldersCopyProcesses_Insert_Input>;
  on_conflict?: InputMaybe<StoryFoldersCopyProcesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFoldersCopyProcesses_OneArgs = {
  object: StoryFoldersCopyProcesses_Insert_Input;
  on_conflict?: InputMaybe<StoryFoldersCopyProcesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryFolders_OneArgs = {
  object: StoryFolders_Insert_Input;
  on_conflict?: InputMaybe<StoryFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryStatesArgs = {
  objects: Array<StoryStates_Insert_Input>;
  on_conflict?: InputMaybe<StoryStates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryStates_OneArgs = {
  object: StoryStates_Insert_Input;
  on_conflict?: InputMaybe<StoryStates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplateContentBlocksArgs = {
  objects: Array<StoryTemplateContentBlocks_Insert_Input>;
  on_conflict?: InputMaybe<StoryTemplateContentBlocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplateContentBlocks_OneArgs = {
  object: StoryTemplateContentBlocks_Insert_Input;
  on_conflict?: InputMaybe<StoryTemplateContentBlocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplateContentsArgs = {
  objects: Array<StoryTemplateContents_Insert_Input>;
  on_conflict?: InputMaybe<StoryTemplateContents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplateContents_OneArgs = {
  object: StoryTemplateContents_Insert_Input;
  on_conflict?: InputMaybe<StoryTemplateContents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplateCustomColorsArgs = {
  objects: Array<StoryTemplateCustomColors_Insert_Input>;
  on_conflict?: InputMaybe<StoryTemplateCustomColors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplateCustomColors_OneArgs = {
  object: StoryTemplateCustomColors_Insert_Input;
  on_conflict?: InputMaybe<StoryTemplateCustomColors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplatesArgs = {
  objects: Array<StoryTemplates_Insert_Input>;
  on_conflict?: InputMaybe<StoryTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryTemplates_OneArgs = {
  object: StoryTemplates_Insert_Input;
  on_conflict?: InputMaybe<StoryTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryUsersArgs = {
  objects: Array<StoryUsers_Insert_Input>;
  on_conflict?: InputMaybe<StoryUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryUsers_OneArgs = {
  object: StoryUsers_Insert_Input;
  on_conflict?: InputMaybe<StoryUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryVisibilitiesArgs = {
  objects: Array<StoryVisibilities_Insert_Input>;
  on_conflict?: InputMaybe<StoryVisibilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StoryVisibilities_OneArgs = {
  object: StoryVisibilities_Insert_Input;
  on_conflict?: InputMaybe<StoryVisibilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubjectPublicationClaimsArgs = {
  objects: Array<SubjectPublicationClaims_Insert_Input>;
  on_conflict?: InputMaybe<SubjectPublicationClaims_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubjectPublicationClaims_OneArgs = {
  object: SubjectPublicationClaims_Insert_Input;
  on_conflict?: InputMaybe<SubjectPublicationClaims_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubjectStoryClaimsArgs = {
  objects: Array<SubjectStoryClaims_Insert_Input>;
  on_conflict?: InputMaybe<SubjectStoryClaims_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubjectStoryClaims_OneArgs = {
  object: SubjectStoryClaims_Insert_Input;
  on_conflict?: InputMaybe<SubjectStoryClaims_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserPublicationViewsArgs = {
  objects: Array<UserPublicationViews_Insert_Input>;
  on_conflict?: InputMaybe<UserPublicationViews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserPublicationViews_OneArgs = {
  object: UserPublicationViews_Insert_Input;
  on_conflict?: InputMaybe<UserPublicationViews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AsyncJobsArgs = {
  _set?: InputMaybe<AsyncJobs_Set_Input>;
  where: AsyncJobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AsyncJobs_By_PkArgs = {
  _set?: InputMaybe<AsyncJobs_Set_Input>;
  pk_columns: AsyncJobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AsyncJobs_ManyArgs = {
  updates: Array<AsyncJobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ChartsConfigArgs = {
  _append?: InputMaybe<ChartsConfig_Append_Input>;
  _delete_at_path?: InputMaybe<ChartsConfig_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ChartsConfig_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ChartsConfig_Delete_Key_Input>;
  _inc?: InputMaybe<ChartsConfig_Inc_Input>;
  _prepend?: InputMaybe<ChartsConfig_Prepend_Input>;
  _set?: InputMaybe<ChartsConfig_Set_Input>;
  where: ChartsConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ChartsConfig_By_PkArgs = {
  _append?: InputMaybe<ChartsConfig_Append_Input>;
  _delete_at_path?: InputMaybe<ChartsConfig_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ChartsConfig_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ChartsConfig_Delete_Key_Input>;
  _inc?: InputMaybe<ChartsConfig_Inc_Input>;
  _prepend?: InputMaybe<ChartsConfig_Prepend_Input>;
  _set?: InputMaybe<ChartsConfig_Set_Input>;
  pk_columns: ChartsConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ChartsConfig_ManyArgs = {
  updates: Array<ChartsConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CopyProcessStatusesArgs = {
  _set?: InputMaybe<CopyProcessStatuses_Set_Input>;
  where: CopyProcessStatuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CopyProcessStatuses_By_PkArgs = {
  _set?: InputMaybe<CopyProcessStatuses_Set_Input>;
  pk_columns: CopyProcessStatuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CopyProcessStatuses_ManyArgs = {
  updates: Array<CopyProcessStatuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityProgressTrackerSettingsArgs = {
  _inc?: InputMaybe<EntityProgressTrackerSettings_Inc_Input>;
  _set?: InputMaybe<EntityProgressTrackerSettings_Set_Input>;
  where: EntityProgressTrackerSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EntityProgressTrackerSettings_By_PkArgs = {
  _inc?: InputMaybe<EntityProgressTrackerSettings_Inc_Input>;
  _set?: InputMaybe<EntityProgressTrackerSettings_Set_Input>;
  pk_columns: EntityProgressTrackerSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EntityProgressTrackerSettings_ManyArgs = {
  updates: Array<EntityProgressTrackerSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityStoryColorSettingsArgs = {
  _append?: InputMaybe<EntityStoryColorSettings_Append_Input>;
  _delete_at_path?: InputMaybe<EntityStoryColorSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<EntityStoryColorSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<EntityStoryColorSettings_Delete_Key_Input>;
  _inc?: InputMaybe<EntityStoryColorSettings_Inc_Input>;
  _prepend?: InputMaybe<EntityStoryColorSettings_Prepend_Input>;
  _set?: InputMaybe<EntityStoryColorSettings_Set_Input>;
  where: EntityStoryColorSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EntityStoryColorSettings_By_PkArgs = {
  _append?: InputMaybe<EntityStoryColorSettings_Append_Input>;
  _delete_at_path?: InputMaybe<EntityStoryColorSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<EntityStoryColorSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<EntityStoryColorSettings_Delete_Key_Input>;
  _inc?: InputMaybe<EntityStoryColorSettings_Inc_Input>;
  _prepend?: InputMaybe<EntityStoryColorSettings_Prepend_Input>;
  _set?: InputMaybe<EntityStoryColorSettings_Set_Input>;
  pk_columns: EntityStoryColorSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EntityStoryColorSettings_ManyArgs = {
  updates: Array<EntityStoryColorSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityStorySettingsArgs = {
  _inc?: InputMaybe<EntityStorySettings_Inc_Input>;
  _set?: InputMaybe<EntityStorySettings_Set_Input>;
  where: EntityStorySettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EntityStorySettings_By_PkArgs = {
  _inc?: InputMaybe<EntityStorySettings_Inc_Input>;
  _set?: InputMaybe<EntityStorySettings_Set_Input>;
  pk_columns: EntityStorySettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EntityStorySettings_ManyArgs = {
  updates: Array<EntityStorySettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExportFolderPdfRequestsArgs = {
  _inc?: InputMaybe<ExportFolderPdfRequests_Inc_Input>;
  _set?: InputMaybe<ExportFolderPdfRequests_Set_Input>;
  where: ExportFolderPdfRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ExportFolderPdfRequests_By_PkArgs = {
  _inc?: InputMaybe<ExportFolderPdfRequests_Inc_Input>;
  _set?: InputMaybe<ExportFolderPdfRequests_Set_Input>;
  pk_columns: ExportFolderPdfRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ExportFolderPdfRequests_ManyArgs = {
  updates: Array<ExportFolderPdfRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExportStoriesChunksArgs = {
  _inc?: InputMaybe<ExportStoriesChunks_Inc_Input>;
  _set?: InputMaybe<ExportStoriesChunks_Set_Input>;
  where: ExportStoriesChunks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ExportStoriesChunks_ManyArgs = {
  updates: Array<ExportStoriesChunks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InternalPublishedStoryArgs = {
  _set?: InputMaybe<InternalPublishedStory_Set_Input>;
  where: InternalPublishedStory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_InternalPublishedStory_By_PkArgs = {
  _set?: InputMaybe<InternalPublishedStory_Set_Input>;
  pk_columns: InternalPublishedStory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_InternalPublishedStory_ManyArgs = {
  updates: Array<InternalPublishedStory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PortalStoryArgs = {
  _inc?: InputMaybe<PortalStory_Inc_Input>;
  _set?: InputMaybe<PortalStory_Set_Input>;
  where: PortalStory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PortalStory_By_PkArgs = {
  _inc?: InputMaybe<PortalStory_Inc_Input>;
  _set?: InputMaybe<PortalStory_Set_Input>;
  pk_columns: PortalStory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PortalStory_ManyArgs = {
  updates: Array<PortalStory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationBrandingsArgs = {
  _append?: InputMaybe<PublicationBrandings_Append_Input>;
  _delete_at_path?: InputMaybe<PublicationBrandings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PublicationBrandings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PublicationBrandings_Delete_Key_Input>;
  _prepend?: InputMaybe<PublicationBrandings_Prepend_Input>;
  _set?: InputMaybe<PublicationBrandings_Set_Input>;
  where: PublicationBrandings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationBrandings_By_PkArgs = {
  _append?: InputMaybe<PublicationBrandings_Append_Input>;
  _delete_at_path?: InputMaybe<PublicationBrandings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PublicationBrandings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PublicationBrandings_Delete_Key_Input>;
  _prepend?: InputMaybe<PublicationBrandings_Prepend_Input>;
  _set?: InputMaybe<PublicationBrandings_Set_Input>;
  pk_columns: PublicationBrandings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationBrandings_ManyArgs = {
  updates: Array<PublicationBrandings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationExportPdfRequestArgs = {
  _inc?: InputMaybe<PublicationExportPdfRequest_Inc_Input>;
  _set?: InputMaybe<PublicationExportPdfRequest_Set_Input>;
  where: PublicationExportPdfRequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationExportPdfRequest_By_PkArgs = {
  _inc?: InputMaybe<PublicationExportPdfRequest_Inc_Input>;
  _set?: InputMaybe<PublicationExportPdfRequest_Set_Input>;
  pk_columns: PublicationExportPdfRequest_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationExportPdfRequest_ManyArgs = {
  updates: Array<PublicationExportPdfRequest_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationFoldersArgs = {
  _set?: InputMaybe<PublicationFolders_Set_Input>;
  where: PublicationFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationFolders_By_PkArgs = {
  _set?: InputMaybe<PublicationFolders_Set_Input>;
  pk_columns: PublicationFolders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationFolders_ManyArgs = {
  updates: Array<PublicationFolders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationFooterSettingsArgs = {
  _append?: InputMaybe<PublicationFooterSettings_Append_Input>;
  _delete_at_path?: InputMaybe<PublicationFooterSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PublicationFooterSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PublicationFooterSettings_Delete_Key_Input>;
  _prepend?: InputMaybe<PublicationFooterSettings_Prepend_Input>;
  _set?: InputMaybe<PublicationFooterSettings_Set_Input>;
  where: PublicationFooterSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationFooterSettings_By_PkArgs = {
  _append?: InputMaybe<PublicationFooterSettings_Append_Input>;
  _delete_at_path?: InputMaybe<PublicationFooterSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PublicationFooterSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PublicationFooterSettings_Delete_Key_Input>;
  _prepend?: InputMaybe<PublicationFooterSettings_Prepend_Input>;
  _set?: InputMaybe<PublicationFooterSettings_Set_Input>;
  pk_columns: PublicationFooterSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationFooterSettings_ManyArgs = {
  updates: Array<PublicationFooterSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationNavigationMenuItemsArgs = {
  _inc?: InputMaybe<PublicationNavigationMenuItems_Inc_Input>;
  _set?: InputMaybe<PublicationNavigationMenuItems_Set_Input>;
  where: PublicationNavigationMenuItems_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationNavigationMenuItems_By_PkArgs = {
  _inc?: InputMaybe<PublicationNavigationMenuItems_Inc_Input>;
  _set?: InputMaybe<PublicationNavigationMenuItems_Set_Input>;
  pk_columns: PublicationNavigationMenuItems_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationNavigationMenuItems_ManyArgs = {
  updates: Array<PublicationNavigationMenuItems_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationNavigationMenuStoriesArgs = {
  _inc?: InputMaybe<PublicationNavigationMenuStories_Inc_Input>;
  _set?: InputMaybe<PublicationNavigationMenuStories_Set_Input>;
  where: PublicationNavigationMenuStories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationNavigationMenuStories_By_PkArgs = {
  _inc?: InputMaybe<PublicationNavigationMenuStories_Inc_Input>;
  _set?: InputMaybe<PublicationNavigationMenuStories_Set_Input>;
  pk_columns: PublicationNavigationMenuStories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationNavigationMenuStories_ManyArgs = {
  updates: Array<PublicationNavigationMenuStories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationSetupPdfStylesArgs = {
  _append?: InputMaybe<PublicationSetupPdfStyles_Append_Input>;
  _delete_at_path?: InputMaybe<PublicationSetupPdfStyles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PublicationSetupPdfStyles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PublicationSetupPdfStyles_Delete_Key_Input>;
  _prepend?: InputMaybe<PublicationSetupPdfStyles_Prepend_Input>;
  _set?: InputMaybe<PublicationSetupPdfStyles_Set_Input>;
  where: PublicationSetupPdfStyles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationSetupPdfStyles_By_PkArgs = {
  _append?: InputMaybe<PublicationSetupPdfStyles_Append_Input>;
  _delete_at_path?: InputMaybe<PublicationSetupPdfStyles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PublicationSetupPdfStyles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PublicationSetupPdfStyles_Delete_Key_Input>;
  _prepend?: InputMaybe<PublicationSetupPdfStyles_Prepend_Input>;
  _set?: InputMaybe<PublicationSetupPdfStyles_Set_Input>;
  pk_columns: PublicationSetupPdfStyles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationSetupPdfStyles_ManyArgs = {
  updates: Array<PublicationSetupPdfStyles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationStoryPdfSettingsArgs = {
  _set?: InputMaybe<PublicationStoryPdfSettings_Set_Input>;
  where: PublicationStoryPdfSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationStoryPdfSettings_By_PkArgs = {
  _set?: InputMaybe<PublicationStoryPdfSettings_Set_Input>;
  pk_columns: PublicationStoryPdfSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationStoryPdfSettings_ManyArgs = {
  updates: Array<PublicationStoryPdfSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationTocSettingsArgs = {
  _inc?: InputMaybe<PublicationTocSettings_Inc_Input>;
  _set?: InputMaybe<PublicationTocSettings_Set_Input>;
  where: PublicationTocSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationTocSettings_By_PkArgs = {
  _inc?: InputMaybe<PublicationTocSettings_Inc_Input>;
  _set?: InputMaybe<PublicationTocSettings_Set_Input>;
  pk_columns: PublicationTocSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationTocSettings_ManyArgs = {
  updates: Array<PublicationTocSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicationsArgs = {
  _inc?: InputMaybe<Publications_Inc_Input>;
  _set?: InputMaybe<Publications_Set_Input>;
  where: Publications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Publications_By_PkArgs = {
  _inc?: InputMaybe<Publications_Inc_Input>;
  _set?: InputMaybe<Publications_Set_Input>;
  pk_columns: Publications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Publications_ManyArgs = {
  updates: Array<Publications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetNamedRangesArgs = {
  _set?: InputMaybe<SpreadsheetNamedRanges_Set_Input>;
  where: SpreadsheetNamedRanges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetNamedRanges_By_PkArgs = {
  _set?: InputMaybe<SpreadsheetNamedRanges_Set_Input>;
  pk_columns: SpreadsheetNamedRanges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetNamedRanges_ManyArgs = {
  updates: Array<SpreadsheetNamedRanges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetSplitTablesArgs = {
  _inc?: InputMaybe<SpreadsheetSplitTables_Inc_Input>;
  _set?: InputMaybe<SpreadsheetSplitTables_Set_Input>;
  where: SpreadsheetSplitTables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetSplitTables_By_PkArgs = {
  _inc?: InputMaybe<SpreadsheetSplitTables_Inc_Input>;
  _set?: InputMaybe<SpreadsheetSplitTables_Set_Input>;
  pk_columns: SpreadsheetSplitTables_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetSplitTables_ManyArgs = {
  updates: Array<SpreadsheetSplitTables_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetsArgs = {
  _inc?: InputMaybe<Spreadsheets_Inc_Input>;
  _set?: InputMaybe<Spreadsheets_Set_Input>;
  where: Spreadsheets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetsProcessingStatusArgs = {
  _set?: InputMaybe<SpreadsheetsProcessingStatus_Set_Input>;
  where: SpreadsheetsProcessingStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetsProcessingStatus_By_PkArgs = {
  _set?: InputMaybe<SpreadsheetsProcessingStatus_Set_Input>;
  pk_columns: SpreadsheetsProcessingStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpreadsheetsProcessingStatus_ManyArgs = {
  updates: Array<SpreadsheetsProcessingStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spreadsheets_By_PkArgs = {
  _inc?: InputMaybe<Spreadsheets_Inc_Input>;
  _set?: InputMaybe<Spreadsheets_Set_Input>;
  pk_columns: Spreadsheets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spreadsheets_ManyArgs = {
  updates: Array<Spreadsheets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoriesArgs = {
  _inc?: InputMaybe<Stories_Inc_Input>;
  _set?: InputMaybe<Stories_Set_Input>;
  where: Stories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoriesCopyProcessesArgs = {
  _set?: InputMaybe<StoriesCopyProcesses_Set_Input>;
  where: StoriesCopyProcesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoriesCopyProcesses_By_PkArgs = {
  _set?: InputMaybe<StoriesCopyProcesses_Set_Input>;
  pk_columns: StoriesCopyProcesses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoriesCopyProcesses_ManyArgs = {
  updates: Array<StoriesCopyProcesses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stories_By_PkArgs = {
  _inc?: InputMaybe<Stories_Inc_Input>;
  _set?: InputMaybe<Stories_Set_Input>;
  pk_columns: Stories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stories_ManyArgs = {
  updates: Array<Stories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryBudgetProposalsArgs = {
  _inc?: InputMaybe<StoryBudgetProposals_Inc_Input>;
  _set?: InputMaybe<StoryBudgetProposals_Set_Input>;
  where: StoryBudgetProposals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryBudgetProposals_By_PkArgs = {
  _inc?: InputMaybe<StoryBudgetProposals_Inc_Input>;
  _set?: InputMaybe<StoryBudgetProposals_Set_Input>;
  pk_columns: StoryBudgetProposals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryBudgetProposals_ManyArgs = {
  updates: Array<StoryBudgetProposals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentBlockTypesArgs = {
  _set?: InputMaybe<StoryContentBlockTypes_Set_Input>;
  where: StoryContentBlockTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentBlockTypes_By_PkArgs = {
  _set?: InputMaybe<StoryContentBlockTypes_Set_Input>;
  pk_columns: StoryContentBlockTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentBlockTypes_ManyArgs = {
  updates: Array<StoryContentBlockTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentBlocksArgs = {
  _append?: InputMaybe<StoryContentBlocks_Append_Input>;
  _delete_at_path?: InputMaybe<StoryContentBlocks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryContentBlocks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryContentBlocks_Delete_Key_Input>;
  _inc?: InputMaybe<StoryContentBlocks_Inc_Input>;
  _prepend?: InputMaybe<StoryContentBlocks_Prepend_Input>;
  _set?: InputMaybe<StoryContentBlocks_Set_Input>;
  where: StoryContentBlocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentBlocks_By_PkArgs = {
  _append?: InputMaybe<StoryContentBlocks_Append_Input>;
  _delete_at_path?: InputMaybe<StoryContentBlocks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryContentBlocks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryContentBlocks_Delete_Key_Input>;
  _inc?: InputMaybe<StoryContentBlocks_Inc_Input>;
  _prepend?: InputMaybe<StoryContentBlocks_Prepend_Input>;
  _set?: InputMaybe<StoryContentBlocks_Set_Input>;
  pk_columns: StoryContentBlocks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentBlocks_ManyArgs = {
  updates: Array<StoryContentBlocks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentColorTargetsArgs = {
  _set?: InputMaybe<StoryContentColorTargets_Set_Input>;
  where: StoryContentColorTargets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentColorTargets_By_PkArgs = {
  _set?: InputMaybe<StoryContentColorTargets_Set_Input>;
  pk_columns: StoryContentColorTargets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentColorTargets_ManyArgs = {
  updates: Array<StoryContentColorTargets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentSpreadsheetReferencesArgs = {
  _set?: InputMaybe<StoryContentSpreadsheetReferences_Set_Input>;
  where: StoryContentSpreadsheetReferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentSpreadsheetReferences_By_PkArgs = {
  _set?: InputMaybe<StoryContentSpreadsheetReferences_Set_Input>;
  pk_columns: StoryContentSpreadsheetReferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentSpreadsheetReferences_ManyArgs = {
  updates: Array<StoryContentSpreadsheetReferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentTypesArgs = {
  _set?: InputMaybe<StoryContentTypes_Set_Input>;
  where: StoryContentTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentTypes_By_PkArgs = {
  _set?: InputMaybe<StoryContentTypes_Set_Input>;
  pk_columns: StoryContentTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentTypes_ManyArgs = {
  updates: Array<StoryContentTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContentsArgs = {
  _inc?: InputMaybe<StoryContents_Inc_Input>;
  _set?: InputMaybe<StoryContents_Set_Input>;
  where: StoryContents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContents_By_PkArgs = {
  _inc?: InputMaybe<StoryContents_Inc_Input>;
  _set?: InputMaybe<StoryContents_Set_Input>;
  pk_columns: StoryContents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryContents_ManyArgs = {
  updates: Array<StoryContents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryCopyProcessesArgs = {
  _set?: InputMaybe<StoryCopyProcesses_Set_Input>;
  where: StoryCopyProcesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryCopyProcesses_By_PkArgs = {
  _set?: InputMaybe<StoryCopyProcesses_Set_Input>;
  pk_columns: StoryCopyProcesses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryCopyProcesses_ManyArgs = {
  updates: Array<StoryCopyProcesses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryCustomColorsArgs = {
  _append?: InputMaybe<StoryCustomColors_Append_Input>;
  _delete_at_path?: InputMaybe<StoryCustomColors_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryCustomColors_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryCustomColors_Delete_Key_Input>;
  _prepend?: InputMaybe<StoryCustomColors_Prepend_Input>;
  _set?: InputMaybe<StoryCustomColors_Set_Input>;
  where: StoryCustomColors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryCustomColors_By_PkArgs = {
  _append?: InputMaybe<StoryCustomColors_Append_Input>;
  _delete_at_path?: InputMaybe<StoryCustomColors_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryCustomColors_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryCustomColors_Delete_Key_Input>;
  _prepend?: InputMaybe<StoryCustomColors_Prepend_Input>;
  _set?: InputMaybe<StoryCustomColors_Set_Input>;
  pk_columns: StoryCustomColors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryCustomColors_ManyArgs = {
  updates: Array<StoryCustomColors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryEmbedsArgs = {
  _set?: InputMaybe<StoryEmbeds_Set_Input>;
  where: StoryEmbeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryEmbeds_By_PkArgs = {
  _set?: InputMaybe<StoryEmbeds_Set_Input>;
  pk_columns: StoryEmbeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryEmbeds_ManyArgs = {
  updates: Array<StoryEmbeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolderActionSetsArgs = {
  _set?: InputMaybe<StoryFolderActionSets_Set_Input>;
  where: StoryFolderActionSets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolderActionSets_By_PkArgs = {
  _set?: InputMaybe<StoryFolderActionSets_Set_Input>;
  pk_columns: StoryFolderActionSets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolderActionSets_ManyArgs = {
  updates: Array<StoryFolderActionSets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolderGrantsArgs = {
  _set?: InputMaybe<StoryFolderGrants_Set_Input>;
  where: StoryFolderGrants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolderGrants_By_PkArgs = {
  _set?: InputMaybe<StoryFolderGrants_Set_Input>;
  pk_columns: StoryFolderGrants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolderGrants_ManyArgs = {
  updates: Array<StoryFolderGrants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFoldersArgs = {
  _inc?: InputMaybe<StoryFolders_Inc_Input>;
  _set?: InputMaybe<StoryFolders_Set_Input>;
  where: StoryFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFoldersCopyProcessesArgs = {
  _set?: InputMaybe<StoryFoldersCopyProcesses_Set_Input>;
  where: StoryFoldersCopyProcesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFoldersCopyProcesses_By_PkArgs = {
  _set?: InputMaybe<StoryFoldersCopyProcesses_Set_Input>;
  pk_columns: StoryFoldersCopyProcesses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFoldersCopyProcesses_ManyArgs = {
  updates: Array<StoryFoldersCopyProcesses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolders_By_PkArgs = {
  _inc?: InputMaybe<StoryFolders_Inc_Input>;
  _set?: InputMaybe<StoryFolders_Set_Input>;
  pk_columns: StoryFolders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryFolders_ManyArgs = {
  updates: Array<StoryFolders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryStatesArgs = {
  _set?: InputMaybe<StoryStates_Set_Input>;
  where: StoryStates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryStates_By_PkArgs = {
  _set?: InputMaybe<StoryStates_Set_Input>;
  pk_columns: StoryStates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryStates_ManyArgs = {
  updates: Array<StoryStates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateContentBlocksArgs = {
  _append?: InputMaybe<StoryTemplateContentBlocks_Append_Input>;
  _delete_at_path?: InputMaybe<StoryTemplateContentBlocks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryTemplateContentBlocks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryTemplateContentBlocks_Delete_Key_Input>;
  _inc?: InputMaybe<StoryTemplateContentBlocks_Inc_Input>;
  _prepend?: InputMaybe<StoryTemplateContentBlocks_Prepend_Input>;
  _set?: InputMaybe<StoryTemplateContentBlocks_Set_Input>;
  where: StoryTemplateContentBlocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateContentBlocks_By_PkArgs = {
  _append?: InputMaybe<StoryTemplateContentBlocks_Append_Input>;
  _delete_at_path?: InputMaybe<StoryTemplateContentBlocks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryTemplateContentBlocks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryTemplateContentBlocks_Delete_Key_Input>;
  _inc?: InputMaybe<StoryTemplateContentBlocks_Inc_Input>;
  _prepend?: InputMaybe<StoryTemplateContentBlocks_Prepend_Input>;
  _set?: InputMaybe<StoryTemplateContentBlocks_Set_Input>;
  pk_columns: StoryTemplateContentBlocks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateContentBlocks_ManyArgs = {
  updates: Array<StoryTemplateContentBlocks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateContentsArgs = {
  _inc?: InputMaybe<StoryTemplateContents_Inc_Input>;
  _set?: InputMaybe<StoryTemplateContents_Set_Input>;
  where: StoryTemplateContents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateContents_By_PkArgs = {
  _inc?: InputMaybe<StoryTemplateContents_Inc_Input>;
  _set?: InputMaybe<StoryTemplateContents_Set_Input>;
  pk_columns: StoryTemplateContents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateContents_ManyArgs = {
  updates: Array<StoryTemplateContents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateCustomColorsArgs = {
  _append?: InputMaybe<StoryTemplateCustomColors_Append_Input>;
  _delete_at_path?: InputMaybe<StoryTemplateCustomColors_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryTemplateCustomColors_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryTemplateCustomColors_Delete_Key_Input>;
  _prepend?: InputMaybe<StoryTemplateCustomColors_Prepend_Input>;
  _set?: InputMaybe<StoryTemplateCustomColors_Set_Input>;
  where: StoryTemplateCustomColors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateCustomColors_By_PkArgs = {
  _append?: InputMaybe<StoryTemplateCustomColors_Append_Input>;
  _delete_at_path?: InputMaybe<StoryTemplateCustomColors_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<StoryTemplateCustomColors_Delete_Elem_Input>;
  _delete_key?: InputMaybe<StoryTemplateCustomColors_Delete_Key_Input>;
  _prepend?: InputMaybe<StoryTemplateCustomColors_Prepend_Input>;
  _set?: InputMaybe<StoryTemplateCustomColors_Set_Input>;
  pk_columns: StoryTemplateCustomColors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplateCustomColors_ManyArgs = {
  updates: Array<StoryTemplateCustomColors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplatesArgs = {
  _inc?: InputMaybe<StoryTemplates_Inc_Input>;
  _set?: InputMaybe<StoryTemplates_Set_Input>;
  where: StoryTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplates_By_PkArgs = {
  _inc?: InputMaybe<StoryTemplates_Inc_Input>;
  _set?: InputMaybe<StoryTemplates_Set_Input>;
  pk_columns: StoryTemplates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryTemplates_ManyArgs = {
  updates: Array<StoryTemplates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryUsersArgs = {
  _inc?: InputMaybe<StoryUsers_Inc_Input>;
  _set?: InputMaybe<StoryUsers_Set_Input>;
  where: StoryUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryUsers_By_PkArgs = {
  _inc?: InputMaybe<StoryUsers_Inc_Input>;
  _set?: InputMaybe<StoryUsers_Set_Input>;
  pk_columns: StoryUsers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryUsers_ManyArgs = {
  updates: Array<StoryUsers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoryVisibilitiesArgs = {
  _set?: InputMaybe<StoryVisibilities_Set_Input>;
  where: StoryVisibilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StoryVisibilities_By_PkArgs = {
  _set?: InputMaybe<StoryVisibilities_Set_Input>;
  pk_columns: StoryVisibilities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StoryVisibilities_ManyArgs = {
  updates: Array<StoryVisibilities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubjectPublicationClaimsArgs = {
  _append?: InputMaybe<SubjectPublicationClaims_Append_Input>;
  _delete_at_path?: InputMaybe<SubjectPublicationClaims_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SubjectPublicationClaims_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SubjectPublicationClaims_Delete_Key_Input>;
  _prepend?: InputMaybe<SubjectPublicationClaims_Prepend_Input>;
  _set?: InputMaybe<SubjectPublicationClaims_Set_Input>;
  where: SubjectPublicationClaims_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SubjectPublicationClaims_By_PkArgs = {
  _append?: InputMaybe<SubjectPublicationClaims_Append_Input>;
  _delete_at_path?: InputMaybe<SubjectPublicationClaims_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SubjectPublicationClaims_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SubjectPublicationClaims_Delete_Key_Input>;
  _prepend?: InputMaybe<SubjectPublicationClaims_Prepend_Input>;
  _set?: InputMaybe<SubjectPublicationClaims_Set_Input>;
  pk_columns: SubjectPublicationClaims_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SubjectPublicationClaims_ManyArgs = {
  updates: Array<SubjectPublicationClaims_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubjectStoryClaimsArgs = {
  _append?: InputMaybe<SubjectStoryClaims_Append_Input>;
  _delete_at_path?: InputMaybe<SubjectStoryClaims_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SubjectStoryClaims_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SubjectStoryClaims_Delete_Key_Input>;
  _prepend?: InputMaybe<SubjectStoryClaims_Prepend_Input>;
  _set?: InputMaybe<SubjectStoryClaims_Set_Input>;
  where: SubjectStoryClaims_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SubjectStoryClaims_By_PkArgs = {
  _append?: InputMaybe<SubjectStoryClaims_Append_Input>;
  _delete_at_path?: InputMaybe<SubjectStoryClaims_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SubjectStoryClaims_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SubjectStoryClaims_Delete_Key_Input>;
  _prepend?: InputMaybe<SubjectStoryClaims_Prepend_Input>;
  _set?: InputMaybe<SubjectStoryClaims_Set_Input>;
  pk_columns: SubjectStoryClaims_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SubjectStoryClaims_ManyArgs = {
  updates: Array<SubjectStoryClaims_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserPublicationViewsArgs = {
  _inc?: InputMaybe<UserPublicationViews_Inc_Input>;
  _set?: InputMaybe<UserPublicationViews_Set_Input>;
  where: UserPublicationViews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserPublicationViews_By_PkArgs = {
  _inc?: InputMaybe<UserPublicationViews_Inc_Input>;
  _set?: InputMaybe<UserPublicationViews_Set_Input>;
  pk_columns: UserPublicationViews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserPublicationViews_ManyArgs = {
  updates: Array<UserPublicationViews_Updates>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "portalStory" */
export type PortalStory = {
  __typename?: 'portalStory';
  _id: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  story: Stories;
  storyId: Scalars['String']['output'];
};

/** aggregated selection of "portalStory" */
export type PortalStory_Aggregate = {
  __typename?: 'portalStory_aggregate';
  aggregate?: Maybe<PortalStory_Aggregate_Fields>;
  nodes: Array<PortalStory>;
};

/** aggregate fields of "portalStory" */
export type PortalStory_Aggregate_Fields = {
  __typename?: 'portalStory_aggregate_fields';
  avg?: Maybe<PortalStory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PortalStory_Max_Fields>;
  min?: Maybe<PortalStory_Min_Fields>;
  stddev?: Maybe<PortalStory_Stddev_Fields>;
  stddev_pop?: Maybe<PortalStory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PortalStory_Stddev_Samp_Fields>;
  sum?: Maybe<PortalStory_Sum_Fields>;
  var_pop?: Maybe<PortalStory_Var_Pop_Fields>;
  var_samp?: Maybe<PortalStory_Var_Samp_Fields>;
  variance?: Maybe<PortalStory_Variance_Fields>;
};


/** aggregate fields of "portalStory" */
export type PortalStory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PortalStory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type PortalStory_Avg_Fields = {
  __typename?: 'portalStory_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "portalStory". All fields are combined with a logical 'AND'. */
export type PortalStory_Bool_Exp = {
  _and?: InputMaybe<Array<PortalStory_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<PortalStory_Bool_Exp>;
  _or?: InputMaybe<Array<PortalStory_Bool_Exp>>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "portalStory" */
export enum PortalStory_Constraint {
  /** unique or primary key constraint on columns "_id" */
  PortalStoryPkey = 'portalStory_pkey',
  /** unique or primary key constraint on columns "storyId" */
  PortalStoryStoryIdKey = 'portalStory_storyId_key'
}

/** input type for incrementing numeric columns in table "portalStory" */
export type PortalStory_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "portalStory" */
export type PortalStory_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PortalStory_Max_Fields = {
  __typename?: 'portalStory_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PortalStory_Min_Fields = {
  __typename?: 'portalStory_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "portalStory" */
export type PortalStory_Mutation_Response = {
  __typename?: 'portalStory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PortalStory>;
};

/** input type for inserting object relation for remote table "portalStory" */
export type PortalStory_Obj_Rel_Insert_Input = {
  data: PortalStory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PortalStory_On_Conflict>;
};

/** on_conflict condition type for table "portalStory" */
export type PortalStory_On_Conflict = {
  constraint: PortalStory_Constraint;
  update_columns?: Array<PortalStory_Update_Column>;
  where?: InputMaybe<PortalStory_Bool_Exp>;
};

/** Ordering options when selecting data from "portalStory". */
export type PortalStory_Order_By = {
  _id?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: portalStory */
export type PortalStory_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "portalStory" */
export enum PortalStory_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Order = 'order',
  /** column name */
  StoryId = 'storyId'
}

/** input type for updating data in table "portalStory" */
export type PortalStory_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type PortalStory_Stddev_Fields = {
  __typename?: 'portalStory_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type PortalStory_Stddev_Pop_Fields = {
  __typename?: 'portalStory_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type PortalStory_Stddev_Samp_Fields = {
  __typename?: 'portalStory_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "portalStory" */
export type PortalStory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PortalStory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PortalStory_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type PortalStory_Sum_Fields = {
  __typename?: 'portalStory_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "portalStory" */
export enum PortalStory_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Order = 'order',
  /** column name */
  StoryId = 'storyId'
}

export type PortalStory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PortalStory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PortalStory_Set_Input>;
  where: PortalStory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PortalStory_Var_Pop_Fields = {
  __typename?: 'portalStory_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type PortalStory_Var_Samp_Fields = {
  __typename?: 'portalStory_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type PortalStory_Variance_Fields = {
  __typename?: 'portalStory_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "publicationBrandings" */
export type PublicationBrandings = {
  __typename?: 'publicationBrandings';
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor: Scalars['jsonb']['output'];
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  enableGoogleTranslate: Scalars['Boolean']['output'];
  enableLogoNavigation: Scalars['Boolean']['output'];
  fontStyle: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor: Scalars['jsonb']['output'];
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor: Scalars['jsonb']['output'];
  isNavigationMenuSticky: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  showLogoOnFooter: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "publicationBrandings" */
export type PublicationBrandingsActiveBackgroundColorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "publicationBrandings" */
export type PublicationBrandingsActiveFontColorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "publicationBrandings" */
export type PublicationBrandingsIdleBackgroundColorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "publicationBrandings" */
export type PublicationBrandingsIdleFontColorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "publicationBrandings" */
export type PublicationBrandings_Aggregate = {
  __typename?: 'publicationBrandings_aggregate';
  aggregate?: Maybe<PublicationBrandings_Aggregate_Fields>;
  nodes: Array<PublicationBrandings>;
};

/** aggregate fields of "publicationBrandings" */
export type PublicationBrandings_Aggregate_Fields = {
  __typename?: 'publicationBrandings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationBrandings_Max_Fields>;
  min?: Maybe<PublicationBrandings_Min_Fields>;
};


/** aggregate fields of "publicationBrandings" */
export type PublicationBrandings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationBrandings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PublicationBrandings_Append_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "publicationBrandings". All fields are combined with a logical 'AND'. */
export type PublicationBrandings_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationBrandings_Bool_Exp>>;
  _not?: InputMaybe<PublicationBrandings_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationBrandings_Bool_Exp>>;
  activeBackgroundColor?: InputMaybe<Jsonb_Comparison_Exp>;
  activeFontColor?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  enableGoogleTranslate?: InputMaybe<Boolean_Comparison_Exp>;
  enableLogoNavigation?: InputMaybe<Boolean_Comparison_Exp>;
  fontStyle?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idleBackgroundColor?: InputMaybe<Jsonb_Comparison_Exp>;
  idleFontColor?: InputMaybe<Jsonb_Comparison_Exp>;
  isNavigationMenuSticky?: InputMaybe<Boolean_Comparison_Exp>;
  logoUrl?: InputMaybe<String_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  showLogoOnFooter?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationBrandings" */
export enum PublicationBrandings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationBrandingsPkey = 'publicationBrandings_pkey',
  /** unique or primary key constraint on columns "publicationId" */
  PublicationBrandingsPublicationIdKey = 'publicationBrandings_publicationId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PublicationBrandings_Delete_At_Path_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PublicationBrandings_Delete_Elem_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Scalars['Int']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Scalars['Int']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Scalars['Int']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PublicationBrandings_Delete_Key_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "publicationBrandings" */
export type PublicationBrandings_Insert_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  enableGoogleTranslate?: InputMaybe<Scalars['Boolean']['input']>;
  enableLogoNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  isNavigationMenuSticky?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  showLogoOnFooter?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublicationBrandings_Max_Fields = {
  __typename?: 'publicationBrandings_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fontStyle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PublicationBrandings_Min_Fields = {
  __typename?: 'publicationBrandings_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fontStyle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "publicationBrandings" */
export type PublicationBrandings_Mutation_Response = {
  __typename?: 'publicationBrandings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationBrandings>;
};

/** input type for inserting object relation for remote table "publicationBrandings" */
export type PublicationBrandings_Obj_Rel_Insert_Input = {
  data: PublicationBrandings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicationBrandings_On_Conflict>;
};

/** on_conflict condition type for table "publicationBrandings" */
export type PublicationBrandings_On_Conflict = {
  constraint: PublicationBrandings_Constraint;
  update_columns?: Array<PublicationBrandings_Update_Column>;
  where?: InputMaybe<PublicationBrandings_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationBrandings". */
export type PublicationBrandings_Order_By = {
  activeBackgroundColor?: InputMaybe<Order_By>;
  activeFontColor?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  enableGoogleTranslate?: InputMaybe<Order_By>;
  enableLogoNavigation?: InputMaybe<Order_By>;
  fontStyle?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idleBackgroundColor?: InputMaybe<Order_By>;
  idleFontColor?: InputMaybe<Order_By>;
  isNavigationMenuSticky?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  showLogoOnFooter?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationBrandings */
export type PublicationBrandings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PublicationBrandings_Prepend_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "publicationBrandings" */
export enum PublicationBrandings_Select_Column {
  /** column name */
  ActiveBackgroundColor = 'activeBackgroundColor',
  /** column name */
  ActiveFontColor = 'activeFontColor',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnableGoogleTranslate = 'enableGoogleTranslate',
  /** column name */
  EnableLogoNavigation = 'enableLogoNavigation',
  /** column name */
  FontStyle = 'fontStyle',
  /** column name */
  Id = 'id',
  /** column name */
  IdleBackgroundColor = 'idleBackgroundColor',
  /** column name */
  IdleFontColor = 'idleFontColor',
  /** column name */
  IsNavigationMenuSticky = 'isNavigationMenuSticky',
  /** column name */
  LogoUrl = 'logoUrl',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  ShowLogoOnFooter = 'showLogoOnFooter',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "publicationBrandings" */
export type PublicationBrandings_Set_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  enableGoogleTranslate?: InputMaybe<Scalars['Boolean']['input']>;
  enableLogoNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  isNavigationMenuSticky?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  showLogoOnFooter?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "publicationBrandings" */
export type PublicationBrandings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationBrandings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationBrandings_Stream_Cursor_Value_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  activeFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  enableGoogleTranslate?: InputMaybe<Scalars['Boolean']['input']>;
  enableLogoNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleBackgroundColor?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  idleFontColor?: InputMaybe<Scalars['jsonb']['input']>;
  isNavigationMenuSticky?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  showLogoOnFooter?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "publicationBrandings" */
export enum PublicationBrandings_Update_Column {
  /** column name */
  ActiveBackgroundColor = 'activeBackgroundColor',
  /** column name */
  ActiveFontColor = 'activeFontColor',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnableGoogleTranslate = 'enableGoogleTranslate',
  /** column name */
  EnableLogoNavigation = 'enableLogoNavigation',
  /** column name */
  FontStyle = 'fontStyle',
  /** column name */
  Id = 'id',
  /** column name */
  IdleBackgroundColor = 'idleBackgroundColor',
  /** column name */
  IdleFontColor = 'idleFontColor',
  /** column name */
  IsNavigationMenuSticky = 'isNavigationMenuSticky',
  /** column name */
  LogoUrl = 'logoUrl',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  ShowLogoOnFooter = 'showLogoOnFooter',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PublicationBrandings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PublicationBrandings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PublicationBrandings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PublicationBrandings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PublicationBrandings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PublicationBrandings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationBrandings_Set_Input>;
  where: PublicationBrandings_Bool_Exp;
};

/** columns and relationships of "publicationExportPdfRequest" */
export type PublicationExportPdfRequest = {
  __typename?: 'publicationExportPdfRequest';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  pdfOptions: Scalars['String']['output'];
  publicationId: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  suppressDisplayBanner: Scalars['Boolean']['output'];
};

/** aggregated selection of "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Aggregate = {
  __typename?: 'publicationExportPdfRequest_aggregate';
  aggregate?: Maybe<PublicationExportPdfRequest_Aggregate_Fields>;
  nodes: Array<PublicationExportPdfRequest>;
};

/** aggregate fields of "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Aggregate_Fields = {
  __typename?: 'publicationExportPdfRequest_aggregate_fields';
  avg?: Maybe<PublicationExportPdfRequest_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationExportPdfRequest_Max_Fields>;
  min?: Maybe<PublicationExportPdfRequest_Min_Fields>;
  stddev?: Maybe<PublicationExportPdfRequest_Stddev_Fields>;
  stddev_pop?: Maybe<PublicationExportPdfRequest_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PublicationExportPdfRequest_Stddev_Samp_Fields>;
  sum?: Maybe<PublicationExportPdfRequest_Sum_Fields>;
  var_pop?: Maybe<PublicationExportPdfRequest_Var_Pop_Fields>;
  var_samp?: Maybe<PublicationExportPdfRequest_Var_Samp_Fields>;
  variance?: Maybe<PublicationExportPdfRequest_Variance_Fields>;
};


/** aggregate fields of "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationExportPdfRequest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type PublicationExportPdfRequest_Avg_Fields = {
  __typename?: 'publicationExportPdfRequest_avg_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "publicationExportPdfRequest". All fields are combined with a logical 'AND'. */
export type PublicationExportPdfRequest_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationExportPdfRequest_Bool_Exp>>;
  _not?: InputMaybe<PublicationExportPdfRequest_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationExportPdfRequest_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Int_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  fileUrl?: InputMaybe<String_Comparison_Exp>;
  finishedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pdfOptions?: InputMaybe<String_Comparison_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  suppressDisplayBanner?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationExportPdfRequest" */
export enum PublicationExportPdfRequest_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationExportPdfRequestPkey = 'publicationExportPdfRequest_pkey'
}

/** input type for incrementing numeric columns in table "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Inc_Input = {
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfOptions?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type PublicationExportPdfRequest_Max_Fields = {
  __typename?: 'publicationExportPdfRequest_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfOptions?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PublicationExportPdfRequest_Min_Fields = {
  __typename?: 'publicationExportPdfRequest_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfOptions?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Mutation_Response = {
  __typename?: 'publicationExportPdfRequest_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationExportPdfRequest>;
};

/** on_conflict condition type for table "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_On_Conflict = {
  constraint: PublicationExportPdfRequest_Constraint;
  update_columns?: Array<PublicationExportPdfRequest_Update_Column>;
  where?: InputMaybe<PublicationExportPdfRequest_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationExportPdfRequest". */
export type PublicationExportPdfRequest_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  fileUrl?: InputMaybe<Order_By>;
  finishedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pdfOptions?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  suppressDisplayBanner?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationExportPdfRequest */
export type PublicationExportPdfRequest_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publicationExportPdfRequest" */
export enum PublicationExportPdfRequest_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FileUrl = 'fileUrl',
  /** column name */
  FinishedAt = 'finishedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PdfOptions = 'pdfOptions',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner'
}

/** input type for updating data in table "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfOptions?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type PublicationExportPdfRequest_Stddev_Fields = {
  __typename?: 'publicationExportPdfRequest_stddev_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type PublicationExportPdfRequest_Stddev_Pop_Fields = {
  __typename?: 'publicationExportPdfRequest_stddev_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type PublicationExportPdfRequest_Stddev_Samp_Fields = {
  __typename?: 'publicationExportPdfRequest_stddev_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "publicationExportPdfRequest" */
export type PublicationExportPdfRequest_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationExportPdfRequest_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationExportPdfRequest_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfOptions?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type PublicationExportPdfRequest_Sum_Fields = {
  __typename?: 'publicationExportPdfRequest_sum_fields';
  createdBy?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "publicationExportPdfRequest" */
export enum PublicationExportPdfRequest_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FileUrl = 'fileUrl',
  /** column name */
  FinishedAt = 'finishedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PdfOptions = 'pdfOptions',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner'
}

export type PublicationExportPdfRequest_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PublicationExportPdfRequest_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationExportPdfRequest_Set_Input>;
  where: PublicationExportPdfRequest_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PublicationExportPdfRequest_Var_Pop_Fields = {
  __typename?: 'publicationExportPdfRequest_var_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type PublicationExportPdfRequest_Var_Samp_Fields = {
  __typename?: 'publicationExportPdfRequest_var_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type PublicationExportPdfRequest_Variance_Fields = {
  __typename?: 'publicationExportPdfRequest_variance_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "publicationFolders" */
export type PublicationFolders = {
  __typename?: 'publicationFolders';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Scalars['String']['output'];
  folderId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  /** An object relationship */
  storyFolder: StoryFolders;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "publicationFolders" */
export type PublicationFolders_Aggregate = {
  __typename?: 'publicationFolders_aggregate';
  aggregate?: Maybe<PublicationFolders_Aggregate_Fields>;
  nodes: Array<PublicationFolders>;
};

export type PublicationFolders_Aggregate_Bool_Exp = {
  count?: InputMaybe<PublicationFolders_Aggregate_Bool_Exp_Count>;
};

export type PublicationFolders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PublicationFolders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "publicationFolders" */
export type PublicationFolders_Aggregate_Fields = {
  __typename?: 'publicationFolders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationFolders_Max_Fields>;
  min?: Maybe<PublicationFolders_Min_Fields>;
};


/** aggregate fields of "publicationFolders" */
export type PublicationFolders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "publicationFolders" */
export type PublicationFolders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PublicationFolders_Max_Order_By>;
  min?: InputMaybe<PublicationFolders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "publicationFolders" */
export type PublicationFolders_Arr_Rel_Insert_Input = {
  data: Array<PublicationFolders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicationFolders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "publicationFolders". All fields are combined with a logical 'AND'. */
export type PublicationFolders_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationFolders_Bool_Exp>>;
  _not?: InputMaybe<PublicationFolders_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationFolders_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  folderId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  storyFolder?: InputMaybe<StoryFolders_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationFolders" */
export enum PublicationFolders_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationFoldersPkey = 'publicationFolders_pkey',
  /** unique or primary key constraint on columns "folderId", "publicationId" */
  PublicationFoldersPublicationIdFolderIdKey = 'publicationFolders_publicationId_folderId_key'
}

/** input type for inserting data into table "publicationFolders" */
export type PublicationFolders_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyFolder?: InputMaybe<StoryFolders_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublicationFolders_Max_Fields = {
  __typename?: 'publicationFolders_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "publicationFolders" */
export type PublicationFolders_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  folderId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PublicationFolders_Min_Fields = {
  __typename?: 'publicationFolders_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "publicationFolders" */
export type PublicationFolders_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  folderId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "publicationFolders" */
export type PublicationFolders_Mutation_Response = {
  __typename?: 'publicationFolders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationFolders>;
};

/** on_conflict condition type for table "publicationFolders" */
export type PublicationFolders_On_Conflict = {
  constraint: PublicationFolders_Constraint;
  update_columns?: Array<PublicationFolders_Update_Column>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationFolders". */
export type PublicationFolders_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  folderId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  storyFolder?: InputMaybe<StoryFolders_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationFolders */
export type PublicationFolders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publicationFolders" */
export enum PublicationFolders_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FolderId = 'folderId',
  /** column name */
  Id = 'id',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "publicationFolders" */
export type PublicationFolders_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "publicationFolders" */
export type PublicationFolders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationFolders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationFolders_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "publicationFolders" */
export enum PublicationFolders_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FolderId = 'folderId',
  /** column name */
  Id = 'id',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PublicationFolders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationFolders_Set_Input>;
  where: PublicationFolders_Bool_Exp;
};

/** columns and relationships of "publicationFooterSettings" */
export type PublicationFooterSettings = {
  __typename?: 'publicationFooterSettings';
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['String']['output'];
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks: Scalars['jsonb']['output'];
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "publicationFooterSettings" */
export type PublicationFooterSettingsBackgroundColorsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "publicationFooterSettings" */
export type PublicationFooterSettingsFontColorsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "publicationFooterSettings" */
export type PublicationFooterSettingsMediaLinksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "publicationFooterSettings" */
export type PublicationFooterSettings_Aggregate = {
  __typename?: 'publicationFooterSettings_aggregate';
  aggregate?: Maybe<PublicationFooterSettings_Aggregate_Fields>;
  nodes: Array<PublicationFooterSettings>;
};

/** aggregate fields of "publicationFooterSettings" */
export type PublicationFooterSettings_Aggregate_Fields = {
  __typename?: 'publicationFooterSettings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationFooterSettings_Max_Fields>;
  min?: Maybe<PublicationFooterSettings_Min_Fields>;
};


/** aggregate fields of "publicationFooterSettings" */
export type PublicationFooterSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationFooterSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PublicationFooterSettings_Append_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "publicationFooterSettings". All fields are combined with a logical 'AND'. */
export type PublicationFooterSettings_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationFooterSettings_Bool_Exp>>;
  _not?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationFooterSettings_Bool_Exp>>;
  backgroundColors?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  fontColors?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mediaLinks?: InputMaybe<Jsonb_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationFooterSettings" */
export enum PublicationFooterSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationFooterSettingsPkey = 'publicationFooterSettings_pkey',
  /** unique or primary key constraint on columns "publicationId" */
  PublicationFooterSettingsPublicationIdKey = 'publicationFooterSettings_publicationId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PublicationFooterSettings_Delete_At_Path_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PublicationFooterSettings_Delete_Elem_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Scalars['Int']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Scalars['Int']['input']>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PublicationFooterSettings_Delete_Key_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "publicationFooterSettings" */
export type PublicationFooterSettings_Insert_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Scalars['jsonb']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublicationFooterSettings_Max_Fields = {
  __typename?: 'publicationFooterSettings_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PublicationFooterSettings_Min_Fields = {
  __typename?: 'publicationFooterSettings_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "publicationFooterSettings" */
export type PublicationFooterSettings_Mutation_Response = {
  __typename?: 'publicationFooterSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationFooterSettings>;
};

/** input type for inserting object relation for remote table "publicationFooterSettings" */
export type PublicationFooterSettings_Obj_Rel_Insert_Input = {
  data: PublicationFooterSettings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicationFooterSettings_On_Conflict>;
};

/** on_conflict condition type for table "publicationFooterSettings" */
export type PublicationFooterSettings_On_Conflict = {
  constraint: PublicationFooterSettings_Constraint;
  update_columns?: Array<PublicationFooterSettings_Update_Column>;
  where?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationFooterSettings". */
export type PublicationFooterSettings_Order_By = {
  backgroundColors?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  fontColors?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mediaLinks?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationFooterSettings */
export type PublicationFooterSettings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PublicationFooterSettings_Prepend_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Scalars['jsonb']['input']>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "publicationFooterSettings" */
export enum PublicationFooterSettings_Select_Column {
  /** column name */
  BackgroundColors = 'backgroundColors',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FontColors = 'fontColors',
  /** column name */
  Id = 'id',
  /** column name */
  MediaLinks = 'mediaLinks',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "publicationFooterSettings" */
export type PublicationFooterSettings_Set_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Scalars['jsonb']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "publicationFooterSettings" */
export type PublicationFooterSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationFooterSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationFooterSettings_Stream_Cursor_Value_Input = {
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  backgroundColors?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** An array of color options e.g. {colorCode: string, selected: bool} */
  fontColors?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** An array of color options e.g. {link: string, type: string, title:string} */
  mediaLinks?: InputMaybe<Scalars['jsonb']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "publicationFooterSettings" */
export enum PublicationFooterSettings_Update_Column {
  /** column name */
  BackgroundColors = 'backgroundColors',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FontColors = 'fontColors',
  /** column name */
  Id = 'id',
  /** column name */
  MediaLinks = 'mediaLinks',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PublicationFooterSettings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PublicationFooterSettings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PublicationFooterSettings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PublicationFooterSettings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PublicationFooterSettings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PublicationFooterSettings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationFooterSettings_Set_Input>;
  where: PublicationFooterSettings_Bool_Exp;
};

/** columns and relationships of "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems = {
  __typename?: 'publicationNavigationMenuItems';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  /** An array relationship */
  publicationNavigationMenuStories: Array<PublicationNavigationMenuStories>;
  /** An aggregate relationship */
  publicationNavigationMenuStories_aggregate: PublicationNavigationMenuStories_Aggregate;
  /** An object relationship */
  storyUser: StoryUsers;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItemsPublicationNavigationMenuStoriesArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuStories_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};


/** columns and relationships of "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItemsPublicationNavigationMenuStories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuStories_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};

/** aggregated selection of "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Aggregate = {
  __typename?: 'publicationNavigationMenuItems_aggregate';
  aggregate?: Maybe<PublicationNavigationMenuItems_Aggregate_Fields>;
  nodes: Array<PublicationNavigationMenuItems>;
};

export type PublicationNavigationMenuItems_Aggregate_Bool_Exp = {
  count?: InputMaybe<PublicationNavigationMenuItems_Aggregate_Bool_Exp_Count>;
};

export type PublicationNavigationMenuItems_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Aggregate_Fields = {
  __typename?: 'publicationNavigationMenuItems_aggregate_fields';
  avg?: Maybe<PublicationNavigationMenuItems_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationNavigationMenuItems_Max_Fields>;
  min?: Maybe<PublicationNavigationMenuItems_Min_Fields>;
  stddev?: Maybe<PublicationNavigationMenuItems_Stddev_Fields>;
  stddev_pop?: Maybe<PublicationNavigationMenuItems_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PublicationNavigationMenuItems_Stddev_Samp_Fields>;
  sum?: Maybe<PublicationNavigationMenuItems_Sum_Fields>;
  var_pop?: Maybe<PublicationNavigationMenuItems_Var_Pop_Fields>;
  var_samp?: Maybe<PublicationNavigationMenuItems_Var_Samp_Fields>;
  variance?: Maybe<PublicationNavigationMenuItems_Variance_Fields>;
};


/** aggregate fields of "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Aggregate_Order_By = {
  avg?: InputMaybe<PublicationNavigationMenuItems_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PublicationNavigationMenuItems_Max_Order_By>;
  min?: InputMaybe<PublicationNavigationMenuItems_Min_Order_By>;
  stddev?: InputMaybe<PublicationNavigationMenuItems_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PublicationNavigationMenuItems_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PublicationNavigationMenuItems_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PublicationNavigationMenuItems_Sum_Order_By>;
  var_pop?: InputMaybe<PublicationNavigationMenuItems_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PublicationNavigationMenuItems_Var_Samp_Order_By>;
  variance?: InputMaybe<PublicationNavigationMenuItems_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Arr_Rel_Insert_Input = {
  data: Array<PublicationNavigationMenuItems_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicationNavigationMenuItems_On_Conflict>;
};

/** aggregate avg on columns */
export type PublicationNavigationMenuItems_Avg_Fields = {
  __typename?: 'publicationNavigationMenuItems_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "publicationNavigationMenuItems". All fields are combined with a logical 'AND'. */
export type PublicationNavigationMenuItems_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationNavigationMenuItems_Bool_Exp>>;
  _not?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationNavigationMenuItems_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  publicationNavigationMenuStories?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
  publicationNavigationMenuStories_aggregate?: InputMaybe<PublicationNavigationMenuStories_Aggregate_Bool_Exp>;
  storyUser?: InputMaybe<StoryUsers_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationNavigationMenuItems" */
export enum PublicationNavigationMenuItems_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationNavigationMenuItemsPkey = 'publicationNavigationMenuItems_pkey',
  /** unique or primary key constraint on columns "title", "publicationId" */
  PublicationNavigationMenuItemsPublicationIdTitleKey = 'publicationNavigationMenuItems_publicationId_title_key'
}

/** input type for incrementing numeric columns in table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  publicationNavigationMenuStories?: InputMaybe<PublicationNavigationMenuStories_Arr_Rel_Insert_Input>;
  storyUser?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublicationNavigationMenuItems_Max_Fields = {
  __typename?: 'publicationNavigationMenuItems_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PublicationNavigationMenuItems_Min_Fields = {
  __typename?: 'publicationNavigationMenuItems_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Mutation_Response = {
  __typename?: 'publicationNavigationMenuItems_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationNavigationMenuItems>;
};

/** input type for inserting object relation for remote table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Obj_Rel_Insert_Input = {
  data: PublicationNavigationMenuItems_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicationNavigationMenuItems_On_Conflict>;
};

/** on_conflict condition type for table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_On_Conflict = {
  constraint: PublicationNavigationMenuItems_Constraint;
  update_columns?: Array<PublicationNavigationMenuItems_Update_Column>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationNavigationMenuItems". */
export type PublicationNavigationMenuItems_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  publicationNavigationMenuStories_aggregate?: InputMaybe<PublicationNavigationMenuStories_Aggregate_Order_By>;
  storyUser?: InputMaybe<StoryUsers_Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationNavigationMenuItems */
export type PublicationNavigationMenuItems_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publicationNavigationMenuItems" */
export enum PublicationNavigationMenuItems_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type PublicationNavigationMenuItems_Stddev_Fields = {
  __typename?: 'publicationNavigationMenuItems_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PublicationNavigationMenuItems_Stddev_Pop_Fields = {
  __typename?: 'publicationNavigationMenuItems_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PublicationNavigationMenuItems_Stddev_Samp_Fields = {
  __typename?: 'publicationNavigationMenuItems_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationNavigationMenuItems_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationNavigationMenuItems_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type PublicationNavigationMenuItems_Sum_Fields = {
  __typename?: 'publicationNavigationMenuItems_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "publicationNavigationMenuItems" */
export enum PublicationNavigationMenuItems_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PublicationNavigationMenuItems_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PublicationNavigationMenuItems_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationNavigationMenuItems_Set_Input>;
  where: PublicationNavigationMenuItems_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PublicationNavigationMenuItems_Var_Pop_Fields = {
  __typename?: 'publicationNavigationMenuItems_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PublicationNavigationMenuItems_Var_Samp_Fields = {
  __typename?: 'publicationNavigationMenuItems_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PublicationNavigationMenuItems_Variance_Fields = {
  __typename?: 'publicationNavigationMenuItems_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "publicationNavigationMenuItems" */
export type PublicationNavigationMenuItems_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories = {
  __typename?: 'publicationNavigationMenuStories';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  menuId: Scalars['uuid']['output'];
  /** An object relationship */
  menuItem: PublicationNavigationMenuItems;
  order: Scalars['Int']['output'];
  /** An object relationship */
  story: Stories;
  storyId: Scalars['String']['output'];
  /** An object relationship */
  storyUser: StoryUsers;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Aggregate = {
  __typename?: 'publicationNavigationMenuStories_aggregate';
  aggregate?: Maybe<PublicationNavigationMenuStories_Aggregate_Fields>;
  nodes: Array<PublicationNavigationMenuStories>;
};

export type PublicationNavigationMenuStories_Aggregate_Bool_Exp = {
  count?: InputMaybe<PublicationNavigationMenuStories_Aggregate_Bool_Exp_Count>;
};

export type PublicationNavigationMenuStories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Aggregate_Fields = {
  __typename?: 'publicationNavigationMenuStories_aggregate_fields';
  avg?: Maybe<PublicationNavigationMenuStories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationNavigationMenuStories_Max_Fields>;
  min?: Maybe<PublicationNavigationMenuStories_Min_Fields>;
  stddev?: Maybe<PublicationNavigationMenuStories_Stddev_Fields>;
  stddev_pop?: Maybe<PublicationNavigationMenuStories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PublicationNavigationMenuStories_Stddev_Samp_Fields>;
  sum?: Maybe<PublicationNavigationMenuStories_Sum_Fields>;
  var_pop?: Maybe<PublicationNavigationMenuStories_Var_Pop_Fields>;
  var_samp?: Maybe<PublicationNavigationMenuStories_Var_Samp_Fields>;
  variance?: Maybe<PublicationNavigationMenuStories_Variance_Fields>;
};


/** aggregate fields of "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Aggregate_Order_By = {
  avg?: InputMaybe<PublicationNavigationMenuStories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PublicationNavigationMenuStories_Max_Order_By>;
  min?: InputMaybe<PublicationNavigationMenuStories_Min_Order_By>;
  stddev?: InputMaybe<PublicationNavigationMenuStories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PublicationNavigationMenuStories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PublicationNavigationMenuStories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PublicationNavigationMenuStories_Sum_Order_By>;
  var_pop?: InputMaybe<PublicationNavigationMenuStories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PublicationNavigationMenuStories_Var_Samp_Order_By>;
  variance?: InputMaybe<PublicationNavigationMenuStories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Arr_Rel_Insert_Input = {
  data: Array<PublicationNavigationMenuStories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicationNavigationMenuStories_On_Conflict>;
};

/** aggregate avg on columns */
export type PublicationNavigationMenuStories_Avg_Fields = {
  __typename?: 'publicationNavigationMenuStories_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "publicationNavigationMenuStories". All fields are combined with a logical 'AND'. */
export type PublicationNavigationMenuStories_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationNavigationMenuStories_Bool_Exp>>;
  _not?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationNavigationMenuStories_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  menuId?: InputMaybe<Uuid_Comparison_Exp>;
  menuItem?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
  storyUser?: InputMaybe<StoryUsers_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationNavigationMenuStories" */
export enum PublicationNavigationMenuStories_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationNavigationMenuStoriesPkey = 'publicationNavigationMenuStories_pkey'
}

/** input type for incrementing numeric columns in table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menuId?: InputMaybe<Scalars['uuid']['input']>;
  menuItem?: InputMaybe<PublicationNavigationMenuItems_Obj_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['Int']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  storyUser?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublicationNavigationMenuStories_Max_Fields = {
  __typename?: 'publicationNavigationMenuStories_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  menuId?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  menuId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PublicationNavigationMenuStories_Min_Fields = {
  __typename?: 'publicationNavigationMenuStories_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  menuId?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  menuId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Mutation_Response = {
  __typename?: 'publicationNavigationMenuStories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationNavigationMenuStories>;
};

/** on_conflict condition type for table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_On_Conflict = {
  constraint: PublicationNavigationMenuStories_Constraint;
  update_columns?: Array<PublicationNavigationMenuStories_Update_Column>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationNavigationMenuStories". */
export type PublicationNavigationMenuStories_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  menuId?: InputMaybe<Order_By>;
  menuItem?: InputMaybe<PublicationNavigationMenuItems_Order_By>;
  order?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyId?: InputMaybe<Order_By>;
  storyUser?: InputMaybe<StoryUsers_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationNavigationMenuStories */
export type PublicationNavigationMenuStories_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publicationNavigationMenuStories" */
export enum PublicationNavigationMenuStories_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  MenuId = 'menuId',
  /** column name */
  Order = 'order',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menuId?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type PublicationNavigationMenuStories_Stddev_Fields = {
  __typename?: 'publicationNavigationMenuStories_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PublicationNavigationMenuStories_Stddev_Pop_Fields = {
  __typename?: 'publicationNavigationMenuStories_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PublicationNavigationMenuStories_Stddev_Samp_Fields = {
  __typename?: 'publicationNavigationMenuStories_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationNavigationMenuStories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationNavigationMenuStories_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menuId?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type PublicationNavigationMenuStories_Sum_Fields = {
  __typename?: 'publicationNavigationMenuStories_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "publicationNavigationMenuStories" */
export enum PublicationNavigationMenuStories_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  MenuId = 'menuId',
  /** column name */
  Order = 'order',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PublicationNavigationMenuStories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PublicationNavigationMenuStories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationNavigationMenuStories_Set_Input>;
  where: PublicationNavigationMenuStories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PublicationNavigationMenuStories_Var_Pop_Fields = {
  __typename?: 'publicationNavigationMenuStories_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PublicationNavigationMenuStories_Var_Samp_Fields = {
  __typename?: 'publicationNavigationMenuStories_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PublicationNavigationMenuStories_Variance_Fields = {
  __typename?: 'publicationNavigationMenuStories_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "publicationNavigationMenuStories" */
export type PublicationNavigationMenuStories_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles = {
  __typename?: 'publicationSetupPdfStyles';
  coverStoryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['String']['output'];
  /** An object relationship */
  createdByUser: StoryUsers;
  footerControls: Scalars['jsonb']['output'];
  headerControls: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  pageMargins?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  storyStates?: Maybe<Scalars['String']['output']>;
  tocData: Scalars['String']['output'];
  tocStyles: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  watermark?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "publicationSetupPdfStyles" */
export type PublicationSetupPdfStylesFooterControlsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "publicationSetupPdfStyles" */
export type PublicationSetupPdfStylesHeaderControlsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "publicationSetupPdfStyles" */
export type PublicationSetupPdfStylesPageMarginsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_Aggregate = {
  __typename?: 'publicationSetupPdfStyles_aggregate';
  aggregate?: Maybe<PublicationSetupPdfStyles_Aggregate_Fields>;
  nodes: Array<PublicationSetupPdfStyles>;
};

/** aggregate fields of "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_Aggregate_Fields = {
  __typename?: 'publicationSetupPdfStyles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationSetupPdfStyles_Max_Fields>;
  min?: Maybe<PublicationSetupPdfStyles_Min_Fields>;
};


/** aggregate fields of "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationSetupPdfStyles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PublicationSetupPdfStyles_Append_Input = {
  footerControls?: InputMaybe<Scalars['jsonb']['input']>;
  headerControls?: InputMaybe<Scalars['jsonb']['input']>;
  pageMargins?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "publicationSetupPdfStyles". All fields are combined with a logical 'AND'. */
export type PublicationSetupPdfStyles_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationSetupPdfStyles_Bool_Exp>>;
  _not?: InputMaybe<PublicationSetupPdfStyles_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationSetupPdfStyles_Bool_Exp>>;
  coverStoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  createdByUser?: InputMaybe<StoryUsers_Bool_Exp>;
  footerControls?: InputMaybe<Jsonb_Comparison_Exp>;
  headerControls?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pageMargins?: InputMaybe<Jsonb_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  storyStates?: InputMaybe<String_Comparison_Exp>;
  tocData?: InputMaybe<String_Comparison_Exp>;
  tocStyles?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  watermark?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationSetupPdfStyles" */
export enum PublicationSetupPdfStyles_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationSetupPdfStylesPkey = 'publicationSetupPdfStyles_pkey',
  /** unique or primary key constraint on columns "publicationId" */
  PublicationSetupPdfStylesPublicationIdKey = 'publicationSetupPdfStyles_publicationId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PublicationSetupPdfStyles_Delete_At_Path_Input = {
  footerControls?: InputMaybe<Array<Scalars['String']['input']>>;
  headerControls?: InputMaybe<Array<Scalars['String']['input']>>;
  pageMargins?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PublicationSetupPdfStyles_Delete_Elem_Input = {
  footerControls?: InputMaybe<Scalars['Int']['input']>;
  headerControls?: InputMaybe<Scalars['Int']['input']>;
  pageMargins?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PublicationSetupPdfStyles_Delete_Key_Input = {
  footerControls?: InputMaybe<Scalars['String']['input']>;
  headerControls?: InputMaybe<Scalars['String']['input']>;
  pageMargins?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_Insert_Input = {
  coverStoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  footerControls?: InputMaybe<Scalars['jsonb']['input']>;
  headerControls?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pageMargins?: InputMaybe<Scalars['jsonb']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyStates?: InputMaybe<Scalars['String']['input']>;
  tocData?: InputMaybe<Scalars['String']['input']>;
  tocStyles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  watermark?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PublicationSetupPdfStyles_Max_Fields = {
  __typename?: 'publicationSetupPdfStyles_max_fields';
  coverStoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  storyStates?: Maybe<Scalars['String']['output']>;
  tocData?: Maybe<Scalars['String']['output']>;
  tocStyles?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  watermark?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PublicationSetupPdfStyles_Min_Fields = {
  __typename?: 'publicationSetupPdfStyles_min_fields';
  coverStoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  storyStates?: Maybe<Scalars['String']['output']>;
  tocData?: Maybe<Scalars['String']['output']>;
  tocStyles?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  watermark?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_Mutation_Response = {
  __typename?: 'publicationSetupPdfStyles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationSetupPdfStyles>;
};

/** on_conflict condition type for table "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_On_Conflict = {
  constraint: PublicationSetupPdfStyles_Constraint;
  update_columns?: Array<PublicationSetupPdfStyles_Update_Column>;
  where?: InputMaybe<PublicationSetupPdfStyles_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationSetupPdfStyles". */
export type PublicationSetupPdfStyles_Order_By = {
  coverStoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<StoryUsers_Order_By>;
  footerControls?: InputMaybe<Order_By>;
  headerControls?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pageMargins?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  storyStates?: InputMaybe<Order_By>;
  tocData?: InputMaybe<Order_By>;
  tocStyles?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  watermark?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationSetupPdfStyles */
export type PublicationSetupPdfStyles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PublicationSetupPdfStyles_Prepend_Input = {
  footerControls?: InputMaybe<Scalars['jsonb']['input']>;
  headerControls?: InputMaybe<Scalars['jsonb']['input']>;
  pageMargins?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "publicationSetupPdfStyles" */
export enum PublicationSetupPdfStyles_Select_Column {
  /** column name */
  CoverStoryId = 'coverStoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FooterControls = 'footerControls',
  /** column name */
  HeaderControls = 'headerControls',
  /** column name */
  Id = 'id',
  /** column name */
  PageMargins = 'pageMargins',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  StoryStates = 'storyStates',
  /** column name */
  TocData = 'tocData',
  /** column name */
  TocStyles = 'tocStyles',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Watermark = 'watermark'
}

/** input type for updating data in table "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_Set_Input = {
  coverStoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  footerControls?: InputMaybe<Scalars['jsonb']['input']>;
  headerControls?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pageMargins?: InputMaybe<Scalars['jsonb']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyStates?: InputMaybe<Scalars['String']['input']>;
  tocData?: InputMaybe<Scalars['String']['input']>;
  tocStyles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  watermark?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "publicationSetupPdfStyles" */
export type PublicationSetupPdfStyles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationSetupPdfStyles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationSetupPdfStyles_Stream_Cursor_Value_Input = {
  coverStoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  footerControls?: InputMaybe<Scalars['jsonb']['input']>;
  headerControls?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pageMargins?: InputMaybe<Scalars['jsonb']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyStates?: InputMaybe<Scalars['String']['input']>;
  tocData?: InputMaybe<Scalars['String']['input']>;
  tocStyles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  watermark?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "publicationSetupPdfStyles" */
export enum PublicationSetupPdfStyles_Update_Column {
  /** column name */
  CoverStoryId = 'coverStoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FooterControls = 'footerControls',
  /** column name */
  HeaderControls = 'headerControls',
  /** column name */
  Id = 'id',
  /** column name */
  PageMargins = 'pageMargins',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  StoryStates = 'storyStates',
  /** column name */
  TocData = 'tocData',
  /** column name */
  TocStyles = 'tocStyles',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Watermark = 'watermark'
}

export type PublicationSetupPdfStyles_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PublicationSetupPdfStyles_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PublicationSetupPdfStyles_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PublicationSetupPdfStyles_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PublicationSetupPdfStyles_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PublicationSetupPdfStyles_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationSetupPdfStyles_Set_Input>;
  where: PublicationSetupPdfStyles_Bool_Exp;
};

/** columns and relationships of "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings = {
  __typename?: 'publicationStoryPdfSettings';
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  storyContentsHtml: Scalars['String']['output'];
  storyId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_Aggregate = {
  __typename?: 'publicationStoryPdfSettings_aggregate';
  aggregate?: Maybe<PublicationStoryPdfSettings_Aggregate_Fields>;
  nodes: Array<PublicationStoryPdfSettings>;
};

/** aggregate fields of "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_Aggregate_Fields = {
  __typename?: 'publicationStoryPdfSettings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationStoryPdfSettings_Max_Fields>;
  min?: Maybe<PublicationStoryPdfSettings_Min_Fields>;
};


/** aggregate fields of "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationStoryPdfSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "publicationStoryPdfSettings". All fields are combined with a logical 'AND'. */
export type PublicationStoryPdfSettings_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationStoryPdfSettings_Bool_Exp>>;
  _not?: InputMaybe<PublicationStoryPdfSettings_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationStoryPdfSettings_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  storyContentsHtml?: InputMaybe<String_Comparison_Exp>;
  storyId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationStoryPdfSettings" */
export enum PublicationStoryPdfSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationStoryPdfSettingsPkey = 'publicationStoryPdfSettings_pkey',
  /** unique or primary key constraint on columns "publicationId" */
  PublicationStoryPdfSettingsPublicationIdKey = 'publicationStoryPdfSettings_publicationId_key'
}

/** input type for inserting data into table "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyContentsHtml?: InputMaybe<Scalars['String']['input']>;
  storyId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublicationStoryPdfSettings_Max_Fields = {
  __typename?: 'publicationStoryPdfSettings_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  storyContentsHtml?: Maybe<Scalars['String']['output']>;
  storyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PublicationStoryPdfSettings_Min_Fields = {
  __typename?: 'publicationStoryPdfSettings_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  storyContentsHtml?: Maybe<Scalars['String']['output']>;
  storyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_Mutation_Response = {
  __typename?: 'publicationStoryPdfSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationStoryPdfSettings>;
};

/** on_conflict condition type for table "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_On_Conflict = {
  constraint: PublicationStoryPdfSettings_Constraint;
  update_columns?: Array<PublicationStoryPdfSettings_Update_Column>;
  where?: InputMaybe<PublicationStoryPdfSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationStoryPdfSettings". */
export type PublicationStoryPdfSettings_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  storyContentsHtml?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationStoryPdfSettings */
export type PublicationStoryPdfSettings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publicationStoryPdfSettings" */
export enum PublicationStoryPdfSettings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  StoryContentsHtml = 'storyContentsHtml',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyContentsHtml?: InputMaybe<Scalars['String']['input']>;
  storyId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "publicationStoryPdfSettings" */
export type PublicationStoryPdfSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationStoryPdfSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationStoryPdfSettings_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyContentsHtml?: InputMaybe<Scalars['String']['input']>;
  storyId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "publicationStoryPdfSettings" */
export enum PublicationStoryPdfSettings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  StoryContentsHtml = 'storyContentsHtml',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PublicationStoryPdfSettings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationStoryPdfSettings_Set_Input>;
  where: PublicationStoryPdfSettings_Bool_Exp;
};

/** columns and relationships of "publicationTOCSettings" */
export type PublicationTocSettings = {
  __typename?: 'publicationTOCSettings';
  columnLayoutNumber: Scalars['Int']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasUserToggledToc: Scalars['Boolean']['output'];
  headerHeightSize?: Maybe<Scalars['String']['output']>;
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  showTableOfContents: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "publicationTOCSettings" */
export type PublicationTocSettings_Aggregate = {
  __typename?: 'publicationTOCSettings_aggregate';
  aggregate?: Maybe<PublicationTocSettings_Aggregate_Fields>;
  nodes: Array<PublicationTocSettings>;
};

/** aggregate fields of "publicationTOCSettings" */
export type PublicationTocSettings_Aggregate_Fields = {
  __typename?: 'publicationTOCSettings_aggregate_fields';
  avg?: Maybe<PublicationTocSettings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PublicationTocSettings_Max_Fields>;
  min?: Maybe<PublicationTocSettings_Min_Fields>;
  stddev?: Maybe<PublicationTocSettings_Stddev_Fields>;
  stddev_pop?: Maybe<PublicationTocSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PublicationTocSettings_Stddev_Samp_Fields>;
  sum?: Maybe<PublicationTocSettings_Sum_Fields>;
  var_pop?: Maybe<PublicationTocSettings_Var_Pop_Fields>;
  var_samp?: Maybe<PublicationTocSettings_Var_Samp_Fields>;
  variance?: Maybe<PublicationTocSettings_Variance_Fields>;
};


/** aggregate fields of "publicationTOCSettings" */
export type PublicationTocSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicationTocSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type PublicationTocSettings_Avg_Fields = {
  __typename?: 'publicationTOCSettings_avg_fields';
  columnLayoutNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "publicationTOCSettings". All fields are combined with a logical 'AND'. */
export type PublicationTocSettings_Bool_Exp = {
  _and?: InputMaybe<Array<PublicationTocSettings_Bool_Exp>>;
  _not?: InputMaybe<PublicationTocSettings_Bool_Exp>;
  _or?: InputMaybe<Array<PublicationTocSettings_Bool_Exp>>;
  columnLayoutNumber?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hasUserToggledToc?: InputMaybe<Boolean_Comparison_Exp>;
  headerHeightSize?: InputMaybe<String_Comparison_Exp>;
  headerImageUrl?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  menuTitle?: InputMaybe<String_Comparison_Exp>;
  pageTitle?: InputMaybe<String_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  showTableOfContents?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "publicationTOCSettings" */
export enum PublicationTocSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationTocSettingsPkey = 'publicationTOCSettings_pkey',
  /** unique or primary key constraint on columns "publicationId" */
  PublicationTocSettingsPublicationIdKey = 'publicationTOCSettings_publicationId_key'
}

/** input type for incrementing numeric columns in table "publicationTOCSettings" */
export type PublicationTocSettings_Inc_Input = {
  columnLayoutNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "publicationTOCSettings" */
export type PublicationTocSettings_Insert_Input = {
  columnLayoutNumber?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasUserToggledToc?: InputMaybe<Scalars['Boolean']['input']>;
  headerHeightSize?: InputMaybe<Scalars['String']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublicationTocSettings_Max_Fields = {
  __typename?: 'publicationTOCSettings_max_fields';
  columnLayoutNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headerHeightSize?: Maybe<Scalars['String']['output']>;
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PublicationTocSettings_Min_Fields = {
  __typename?: 'publicationTOCSettings_min_fields';
  columnLayoutNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headerHeightSize?: Maybe<Scalars['String']['output']>;
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "publicationTOCSettings" */
export type PublicationTocSettings_Mutation_Response = {
  __typename?: 'publicationTOCSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicationTocSettings>;
};

/** input type for inserting object relation for remote table "publicationTOCSettings" */
export type PublicationTocSettings_Obj_Rel_Insert_Input = {
  data: PublicationTocSettings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicationTocSettings_On_Conflict>;
};

/** on_conflict condition type for table "publicationTOCSettings" */
export type PublicationTocSettings_On_Conflict = {
  constraint: PublicationTocSettings_Constraint;
  update_columns?: Array<PublicationTocSettings_Update_Column>;
  where?: InputMaybe<PublicationTocSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "publicationTOCSettings". */
export type PublicationTocSettings_Order_By = {
  columnLayoutNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hasUserToggledToc?: InputMaybe<Order_By>;
  headerHeightSize?: InputMaybe<Order_By>;
  headerImageUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  menuTitle?: InputMaybe<Order_By>;
  pageTitle?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  showTableOfContents?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publicationTOCSettings */
export type PublicationTocSettings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publicationTOCSettings" */
export enum PublicationTocSettings_Select_Column {
  /** column name */
  ColumnLayoutNumber = 'columnLayoutNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  HasUserToggledToc = 'hasUserToggledToc',
  /** column name */
  HeaderHeightSize = 'headerHeightSize',
  /** column name */
  HeaderImageUrl = 'headerImageUrl',
  /** column name */
  Id = 'id',
  /** column name */
  MenuTitle = 'menuTitle',
  /** column name */
  PageTitle = 'pageTitle',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  ShowTableOfContents = 'showTableOfContents',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "publicationTOCSettings" */
export type PublicationTocSettings_Set_Input = {
  columnLayoutNumber?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasUserToggledToc?: InputMaybe<Scalars['Boolean']['input']>;
  headerHeightSize?: InputMaybe<Scalars['String']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type PublicationTocSettings_Stddev_Fields = {
  __typename?: 'publicationTOCSettings_stddev_fields';
  columnLayoutNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type PublicationTocSettings_Stddev_Pop_Fields = {
  __typename?: 'publicationTOCSettings_stddev_pop_fields';
  columnLayoutNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type PublicationTocSettings_Stddev_Samp_Fields = {
  __typename?: 'publicationTOCSettings_stddev_samp_fields';
  columnLayoutNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "publicationTOCSettings" */
export type PublicationTocSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicationTocSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicationTocSettings_Stream_Cursor_Value_Input = {
  columnLayoutNumber?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasUserToggledToc?: InputMaybe<Scalars['Boolean']['input']>;
  headerHeightSize?: InputMaybe<Scalars['String']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type PublicationTocSettings_Sum_Fields = {
  __typename?: 'publicationTOCSettings_sum_fields';
  columnLayoutNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "publicationTOCSettings" */
export enum PublicationTocSettings_Update_Column {
  /** column name */
  ColumnLayoutNumber = 'columnLayoutNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  HasUserToggledToc = 'hasUserToggledToc',
  /** column name */
  HeaderHeightSize = 'headerHeightSize',
  /** column name */
  HeaderImageUrl = 'headerImageUrl',
  /** column name */
  Id = 'id',
  /** column name */
  MenuTitle = 'menuTitle',
  /** column name */
  PageTitle = 'pageTitle',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  ShowTableOfContents = 'showTableOfContents',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PublicationTocSettings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PublicationTocSettings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicationTocSettings_Set_Input>;
  where: PublicationTocSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PublicationTocSettings_Var_Pop_Fields = {
  __typename?: 'publicationTOCSettings_var_pop_fields';
  columnLayoutNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type PublicationTocSettings_Var_Samp_Fields = {
  __typename?: 'publicationTOCSettings_var_samp_fields';
  columnLayoutNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type PublicationTocSettings_Variance_Fields = {
  __typename?: 'publicationTOCSettings_variance_fields';
  columnLayoutNumber?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "publications" */
export type Publications = {
  __typename?: 'publications';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Scalars['String']['output'];
  /** An object relationship */
  createdByUser: StoryUsers;
  customCssCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  publicationBranding?: Maybe<PublicationBrandings>;
  /** An array relationship */
  publicationFolders: Array<PublicationFolders>;
  /** An aggregate relationship */
  publicationFolders_aggregate: PublicationFolders_Aggregate;
  /** An object relationship */
  publicationFooterSettings?: Maybe<PublicationFooterSettings>;
  /** An array relationship */
  publicationNavigationMenuItems: Array<PublicationNavigationMenuItems>;
  /** An aggregate relationship */
  publicationNavigationMenuItems_aggregate: PublicationNavigationMenuItems_Aggregate;
  /** An object relationship */
  publicationTOCSettings?: Maybe<PublicationTocSettings>;
  publishedAt?: Maybe<Scalars['timestamptz']['output']>;
  publishedBy: Scalars['String']['output'];
  setTocAsLandingPage: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  /** An array relationship */
  storyFolders: Array<StoryFolders>;
  /** An aggregate relationship */
  storyFolders_aggregate: StoryFolders_Aggregate;
  /** An array relationship */
  subjectPublicationClaims: Array<SubjectPublicationClaims>;
  /** An aggregate relationship */
  subjectPublicationClaims_aggregate: SubjectPublicationClaims_Aggregate;
  thumbnailPath: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy: Scalars['String']['output'];
};


/** columns and relationships of "publications" */
export type PublicationsPublicationFoldersArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


/** columns and relationships of "publications" */
export type PublicationsPublicationFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


/** columns and relationships of "publications" */
export type PublicationsPublicationNavigationMenuItemsArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuItems_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};


/** columns and relationships of "publications" */
export type PublicationsPublicationNavigationMenuItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuItems_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};


/** columns and relationships of "publications" */
export type PublicationsStoryFoldersArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


/** columns and relationships of "publications" */
export type PublicationsStoryFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


/** columns and relationships of "publications" */
export type PublicationsSubjectPublicationClaimsArgs = {
  distinct_on?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectPublicationClaims_Order_By>>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};


/** columns and relationships of "publications" */
export type PublicationsSubjectPublicationClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectPublicationClaims_Order_By>>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};

/** aggregated selection of "publications" */
export type Publications_Aggregate = {
  __typename?: 'publications_aggregate';
  aggregate?: Maybe<Publications_Aggregate_Fields>;
  nodes: Array<Publications>;
};

/** aggregate fields of "publications" */
export type Publications_Aggregate_Fields = {
  __typename?: 'publications_aggregate_fields';
  avg?: Maybe<Publications_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Publications_Max_Fields>;
  min?: Maybe<Publications_Min_Fields>;
  stddev?: Maybe<Publications_Stddev_Fields>;
  stddev_pop?: Maybe<Publications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Publications_Stddev_Samp_Fields>;
  sum?: Maybe<Publications_Sum_Fields>;
  var_pop?: Maybe<Publications_Var_Pop_Fields>;
  var_samp?: Maybe<Publications_Var_Samp_Fields>;
  variance?: Maybe<Publications_Variance_Fields>;
};


/** aggregate fields of "publications" */
export type Publications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Publications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Publications_Avg_Fields = {
  __typename?: 'publications_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "publications". All fields are combined with a logical 'AND'. */
export type Publications_Bool_Exp = {
  _and?: InputMaybe<Array<Publications_Bool_Exp>>;
  _not?: InputMaybe<Publications_Bool_Exp>;
  _or?: InputMaybe<Array<Publications_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  createdByUser?: InputMaybe<StoryUsers_Bool_Exp>;
  customCssCode?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  publicUrl?: InputMaybe<String_Comparison_Exp>;
  publicationBranding?: InputMaybe<PublicationBrandings_Bool_Exp>;
  publicationFolders?: InputMaybe<PublicationFolders_Bool_Exp>;
  publicationFolders_aggregate?: InputMaybe<PublicationFolders_Aggregate_Bool_Exp>;
  publicationFooterSettings?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
  publicationNavigationMenuItems?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
  publicationNavigationMenuItems_aggregate?: InputMaybe<PublicationNavigationMenuItems_Aggregate_Bool_Exp>;
  publicationTOCSettings?: InputMaybe<PublicationTocSettings_Bool_Exp>;
  publishedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  publishedBy?: InputMaybe<String_Comparison_Exp>;
  setTocAsLandingPage?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  storyFolders?: InputMaybe<StoryFolders_Bool_Exp>;
  storyFolders_aggregate?: InputMaybe<StoryFolders_Aggregate_Bool_Exp>;
  subjectPublicationClaims?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
  subjectPublicationClaims_aggregate?: InputMaybe<SubjectPublicationClaims_Aggregate_Bool_Exp>;
  thumbnailPath?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "publications" */
export enum Publications_Constraint {
  /** unique or primary key constraint on columns "id" */
  PublicationsPkey = 'publications_pkey',
  /** unique or primary key constraint on columns "entityId", "title" */
  PublicationsPublicationTitleUniqueKey = 'publications_publication_title_unique_key'
}

/** input type for incrementing numeric columns in table "publications" */
export type Publications_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "publications" */
export type Publications_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  publicationBranding?: InputMaybe<PublicationBrandings_Obj_Rel_Insert_Input>;
  publicationFolders?: InputMaybe<PublicationFolders_Arr_Rel_Insert_Input>;
  publicationFooterSettings?: InputMaybe<PublicationFooterSettings_Obj_Rel_Insert_Input>;
  publicationNavigationMenuItems?: InputMaybe<PublicationNavigationMenuItems_Arr_Rel_Insert_Input>;
  publicationTOCSettings?: InputMaybe<PublicationTocSettings_Obj_Rel_Insert_Input>;
  publishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  setTocAsLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storyFolders?: InputMaybe<StoryFolders_Arr_Rel_Insert_Input>;
  subjectPublicationClaims?: InputMaybe<SubjectPublicationClaims_Arr_Rel_Insert_Input>;
  thumbnailPath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Publications_Max_Fields = {
  __typename?: 'publications_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customCssCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['timestamptz']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Publications_Min_Fields = {
  __typename?: 'publications_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customCssCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['timestamptz']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "publications" */
export type Publications_Mutation_Response = {
  __typename?: 'publications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Publications>;
};

/** input type for inserting object relation for remote table "publications" */
export type Publications_Obj_Rel_Insert_Input = {
  data: Publications_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Publications_On_Conflict>;
};

/** on_conflict condition type for table "publications" */
export type Publications_On_Conflict = {
  constraint: Publications_Constraint;
  update_columns?: Array<Publications_Update_Column>;
  where?: InputMaybe<Publications_Bool_Exp>;
};

/** Ordering options when selecting data from "publications". */
export type Publications_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<StoryUsers_Order_By>;
  customCssCode?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicUrl?: InputMaybe<Order_By>;
  publicationBranding?: InputMaybe<PublicationBrandings_Order_By>;
  publicationFolders_aggregate?: InputMaybe<PublicationFolders_Aggregate_Order_By>;
  publicationFooterSettings?: InputMaybe<PublicationFooterSettings_Order_By>;
  publicationNavigationMenuItems_aggregate?: InputMaybe<PublicationNavigationMenuItems_Aggregate_Order_By>;
  publicationTOCSettings?: InputMaybe<PublicationTocSettings_Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  publishedBy?: InputMaybe<Order_By>;
  setTocAsLandingPage?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  storyFolders_aggregate?: InputMaybe<StoryFolders_Aggregate_Order_By>;
  subjectPublicationClaims_aggregate?: InputMaybe<SubjectPublicationClaims_Aggregate_Order_By>;
  thumbnailPath?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: publications */
export type Publications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publications" */
export enum Publications_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomCssCode = 'customCssCode',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  PublicUrl = 'publicUrl',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  PublishedBy = 'publishedBy',
  /** column name */
  SetTocAsLandingPage = 'setTocAsLandingPage',
  /** column name */
  Status = 'status',
  /** column name */
  ThumbnailPath = 'thumbnailPath',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "publications" */
export type Publications_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  setTocAsLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  thumbnailPath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Publications_Stddev_Fields = {
  __typename?: 'publications_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Publications_Stddev_Pop_Fields = {
  __typename?: 'publications_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Publications_Stddev_Samp_Fields = {
  __typename?: 'publications_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "publications" */
export type Publications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Publications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Publications_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  setTocAsLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  thumbnailPath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Publications_Sum_Fields = {
  __typename?: 'publications_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "publications" */
export enum Publications_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomCssCode = 'customCssCode',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  PublicUrl = 'publicUrl',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  PublishedBy = 'publishedBy',
  /** column name */
  SetTocAsLandingPage = 'setTocAsLandingPage',
  /** column name */
  Status = 'status',
  /** column name */
  ThumbnailPath = 'thumbnailPath',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Publications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Publications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Publications_Set_Input>;
  where: Publications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Publications_Var_Pop_Fields = {
  __typename?: 'publications_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Publications_Var_Samp_Fields = {
  __typename?: 'publications_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Publications_Variance_Fields = {
  __typename?: 'publications_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "asyncJobs" */
  asyncJobs: Array<AsyncJobs>;
  /** fetch aggregated fields from the table: "asyncJobs" */
  asyncJobs_aggregate: AsyncJobs_Aggregate;
  /** fetch data from the table: "asyncJobs" using primary key columns */
  asyncJobs_by_pk?: Maybe<AsyncJobs>;
  /** fetch data from the table: "chartsConfig" */
  chartsConfig: Array<ChartsConfig>;
  /** fetch aggregated fields from the table: "chartsConfig" */
  chartsConfig_aggregate: ChartsConfig_Aggregate;
  /** fetch data from the table: "chartsConfig" using primary key columns */
  chartsConfig_by_pk?: Maybe<ChartsConfig>;
  /** fetch data from the table: "copyProcessStatuses" */
  copyProcessStatuses: Array<CopyProcessStatuses>;
  /** fetch aggregated fields from the table: "copyProcessStatuses" */
  copyProcessStatuses_aggregate: CopyProcessStatuses_Aggregate;
  /** fetch data from the table: "copyProcessStatuses" using primary key columns */
  copyProcessStatuses_by_pk?: Maybe<CopyProcessStatuses>;
  /** fetch data from the table: "entityProgressTrackerSettings" */
  entityProgressTrackerSettings: Array<EntityProgressTrackerSettings>;
  /** fetch aggregated fields from the table: "entityProgressTrackerSettings" */
  entityProgressTrackerSettings_aggregate: EntityProgressTrackerSettings_Aggregate;
  /** fetch data from the table: "entityProgressTrackerSettings" using primary key columns */
  entityProgressTrackerSettings_by_pk?: Maybe<EntityProgressTrackerSettings>;
  /** fetch data from the table: "entityStoryColorSettings" */
  entityStoryColorSettings: Array<EntityStoryColorSettings>;
  /** fetch aggregated fields from the table: "entityStoryColorSettings" */
  entityStoryColorSettings_aggregate: EntityStoryColorSettings_Aggregate;
  /** fetch data from the table: "entityStoryColorSettings" using primary key columns */
  entityStoryColorSettings_by_pk?: Maybe<EntityStoryColorSettings>;
  /** fetch data from the table: "entityStorySettings" */
  entityStorySettings: Array<EntityStorySettings>;
  /** fetch aggregated fields from the table: "entityStorySettings" */
  entityStorySettings_aggregate: EntityStorySettings_Aggregate;
  /** fetch data from the table: "entityStorySettings" using primary key columns */
  entityStorySettings_by_pk?: Maybe<EntityStorySettings>;
  /** fetch data from the table: "exportFolderPdfRequests" */
  exportFolderPdfRequests: Array<ExportFolderPdfRequests>;
  /** fetch aggregated fields from the table: "exportFolderPdfRequests" */
  exportFolderPdfRequests_aggregate: ExportFolderPdfRequests_Aggregate;
  /** fetch data from the table: "exportFolderPdfRequests" using primary key columns */
  exportFolderPdfRequests_by_pk?: Maybe<ExportFolderPdfRequests>;
  /** fetch data from the table: "exportStoriesChunks" */
  exportStoriesChunks: Array<ExportStoriesChunks>;
  /** fetch aggregated fields from the table: "exportStoriesChunks" */
  exportStoriesChunks_aggregate: ExportStoriesChunks_Aggregate;
  /** fetch data from the table: "internalPublishedStory" */
  internalPublishedStory: Array<InternalPublishedStory>;
  /** fetch aggregated fields from the table: "internalPublishedStory" */
  internalPublishedStory_aggregate: InternalPublishedStory_Aggregate;
  /** fetch data from the table: "internalPublishedStory" using primary key columns */
  internalPublishedStory_by_pk?: Maybe<InternalPublishedStory>;
  /** fetch data from the table: "portalStory" */
  portalStory: Array<PortalStory>;
  /** fetch aggregated fields from the table: "portalStory" */
  portalStory_aggregate: PortalStory_Aggregate;
  /** fetch data from the table: "portalStory" using primary key columns */
  portalStory_by_pk?: Maybe<PortalStory>;
  /** fetch data from the table: "publicationBrandings" */
  publicationBrandings: Array<PublicationBrandings>;
  /** fetch aggregated fields from the table: "publicationBrandings" */
  publicationBrandings_aggregate: PublicationBrandings_Aggregate;
  /** fetch data from the table: "publicationBrandings" using primary key columns */
  publicationBrandings_by_pk?: Maybe<PublicationBrandings>;
  /** fetch data from the table: "publicationExportPdfRequest" */
  publicationExportPdfRequest: Array<PublicationExportPdfRequest>;
  /** fetch aggregated fields from the table: "publicationExportPdfRequest" */
  publicationExportPdfRequest_aggregate: PublicationExportPdfRequest_Aggregate;
  /** fetch data from the table: "publicationExportPdfRequest" using primary key columns */
  publicationExportPdfRequest_by_pk?: Maybe<PublicationExportPdfRequest>;
  /** An array relationship */
  publicationFolders: Array<PublicationFolders>;
  /** An aggregate relationship */
  publicationFolders_aggregate: PublicationFolders_Aggregate;
  /** fetch data from the table: "publicationFolders" using primary key columns */
  publicationFolders_by_pk?: Maybe<PublicationFolders>;
  /** fetch data from the table: "publicationFooterSettings" */
  publicationFooterSettings: Array<PublicationFooterSettings>;
  /** fetch aggregated fields from the table: "publicationFooterSettings" */
  publicationFooterSettings_aggregate: PublicationFooterSettings_Aggregate;
  /** fetch data from the table: "publicationFooterSettings" using primary key columns */
  publicationFooterSettings_by_pk?: Maybe<PublicationFooterSettings>;
  /** An array relationship */
  publicationNavigationMenuItems: Array<PublicationNavigationMenuItems>;
  /** An aggregate relationship */
  publicationNavigationMenuItems_aggregate: PublicationNavigationMenuItems_Aggregate;
  /** fetch data from the table: "publicationNavigationMenuItems" using primary key columns */
  publicationNavigationMenuItems_by_pk?: Maybe<PublicationNavigationMenuItems>;
  /** An array relationship */
  publicationNavigationMenuStories: Array<PublicationNavigationMenuStories>;
  /** An aggregate relationship */
  publicationNavigationMenuStories_aggregate: PublicationNavigationMenuStories_Aggregate;
  /** fetch data from the table: "publicationNavigationMenuStories" using primary key columns */
  publicationNavigationMenuStories_by_pk?: Maybe<PublicationNavigationMenuStories>;
  /** fetch data from the table: "publicationSetupPdfStyles" */
  publicationSetupPdfStyles: Array<PublicationSetupPdfStyles>;
  /** fetch aggregated fields from the table: "publicationSetupPdfStyles" */
  publicationSetupPdfStyles_aggregate: PublicationSetupPdfStyles_Aggregate;
  /** fetch data from the table: "publicationSetupPdfStyles" using primary key columns */
  publicationSetupPdfStyles_by_pk?: Maybe<PublicationSetupPdfStyles>;
  /** fetch data from the table: "publicationStoryPdfSettings" */
  publicationStoryPdfSettings: Array<PublicationStoryPdfSettings>;
  /** fetch aggregated fields from the table: "publicationStoryPdfSettings" */
  publicationStoryPdfSettings_aggregate: PublicationStoryPdfSettings_Aggregate;
  /** fetch data from the table: "publicationStoryPdfSettings" using primary key columns */
  publicationStoryPdfSettings_by_pk?: Maybe<PublicationStoryPdfSettings>;
  /** fetch data from the table: "publicationTOCSettings" */
  publicationTOCSettings: Array<PublicationTocSettings>;
  /** fetch aggregated fields from the table: "publicationTOCSettings" */
  publicationTOCSettings_aggregate: PublicationTocSettings_Aggregate;
  /** fetch data from the table: "publicationTOCSettings" using primary key columns */
  publicationTOCSettings_by_pk?: Maybe<PublicationTocSettings>;
  /** fetch data from the table: "publications" */
  publications: Array<Publications>;
  /** fetch aggregated fields from the table: "publications" */
  publications_aggregate: Publications_Aggregate;
  /** fetch data from the table: "publications" using primary key columns */
  publications_by_pk?: Maybe<Publications>;
  /** An array relationship */
  spreadsheetNamedRanges: Array<SpreadsheetNamedRanges>;
  /** An aggregate relationship */
  spreadsheetNamedRanges_aggregate: SpreadsheetNamedRanges_Aggregate;
  /** fetch data from the table: "spreadsheetNamedRanges" using primary key columns */
  spreadsheetNamedRanges_by_pk?: Maybe<SpreadsheetNamedRanges>;
  /** fetch data from the table: "spreadsheetSplitTables" */
  spreadsheetSplitTables: Array<SpreadsheetSplitTables>;
  /** fetch aggregated fields from the table: "spreadsheetSplitTables" */
  spreadsheetSplitTables_aggregate: SpreadsheetSplitTables_Aggregate;
  /** fetch data from the table: "spreadsheetSplitTables" using primary key columns */
  spreadsheetSplitTables_by_pk?: Maybe<SpreadsheetSplitTables>;
  /** fetch data from the table: "spreadsheetStoryCounts" */
  spreadsheetStoryCounts: Array<SpreadsheetStoryCounts>;
  /** fetch aggregated fields from the table: "spreadsheetStoryCounts" */
  spreadsheetStoryCounts_aggregate: SpreadsheetStoryCounts_Aggregate;
  /** fetch data from the table: "spreadsheets" */
  spreadsheets: Array<Spreadsheets>;
  /** fetch data from the table: "spreadsheetsProcessingStatus" */
  spreadsheetsProcessingStatus: Array<SpreadsheetsProcessingStatus>;
  /** fetch aggregated fields from the table: "spreadsheetsProcessingStatus" */
  spreadsheetsProcessingStatus_aggregate: SpreadsheetsProcessingStatus_Aggregate;
  /** fetch data from the table: "spreadsheetsProcessingStatus" using primary key columns */
  spreadsheetsProcessingStatus_by_pk?: Maybe<SpreadsheetsProcessingStatus>;
  /** fetch aggregated fields from the table: "spreadsheets" */
  spreadsheets_aggregate: Spreadsheets_Aggregate;
  /** fetch data from the table: "spreadsheets" using primary key columns */
  spreadsheets_by_pk?: Maybe<Spreadsheets>;
  /** An array relationship */
  stories: Array<Stories>;
  /** An array relationship */
  storiesCopyProcesses: Array<StoriesCopyProcesses>;
  /** An aggregate relationship */
  storiesCopyProcesses_aggregate: StoriesCopyProcesses_Aggregate;
  /** fetch data from the table: "storiesCopyProcesses" using primary key columns */
  storiesCopyProcesses_by_pk?: Maybe<StoriesCopyProcesses>;
  /** An aggregate relationship */
  stories_aggregate: Stories_Aggregate;
  /** fetch data from the table: "stories" using primary key columns */
  stories_by_pk?: Maybe<Stories>;
  /** fetch data from the table: "storyBudgetProposals" */
  storyBudgetProposals: Array<StoryBudgetProposals>;
  /** fetch aggregated fields from the table: "storyBudgetProposals" */
  storyBudgetProposals_aggregate: StoryBudgetProposals_Aggregate;
  /** fetch data from the table: "storyBudgetProposals" using primary key columns */
  storyBudgetProposals_by_pk?: Maybe<StoryBudgetProposals>;
  /** fetch data from the table: "storyContentBlockTypes" */
  storyContentBlockTypes: Array<StoryContentBlockTypes>;
  /** fetch aggregated fields from the table: "storyContentBlockTypes" */
  storyContentBlockTypes_aggregate: StoryContentBlockTypes_Aggregate;
  /** fetch data from the table: "storyContentBlockTypes" using primary key columns */
  storyContentBlockTypes_by_pk?: Maybe<StoryContentBlockTypes>;
  /** fetch data from the table: "storyContentBlocks" */
  storyContentBlocks: Array<StoryContentBlocks>;
  /** fetch aggregated fields from the table: "storyContentBlocks" */
  storyContentBlocks_aggregate: StoryContentBlocks_Aggregate;
  /** fetch data from the table: "storyContentBlocks" using primary key columns */
  storyContentBlocks_by_pk?: Maybe<StoryContentBlocks>;
  /** fetch data from the table: "storyContentColorTargets" */
  storyContentColorTargets: Array<StoryContentColorTargets>;
  /** fetch aggregated fields from the table: "storyContentColorTargets" */
  storyContentColorTargets_aggregate: StoryContentColorTargets_Aggregate;
  /** fetch data from the table: "storyContentColorTargets" using primary key columns */
  storyContentColorTargets_by_pk?: Maybe<StoryContentColorTargets>;
  /** An array relationship */
  storyContentSpreadsheetReferences: Array<StoryContentSpreadsheetReferences>;
  /** An aggregate relationship */
  storyContentSpreadsheetReferences_aggregate: StoryContentSpreadsheetReferences_Aggregate;
  /** fetch data from the table: "storyContentSpreadsheetReferences" using primary key columns */
  storyContentSpreadsheetReferences_by_pk?: Maybe<StoryContentSpreadsheetReferences>;
  /** fetch data from the table: "storyContentTypes" */
  storyContentTypes: Array<StoryContentTypes>;
  /** fetch aggregated fields from the table: "storyContentTypes" */
  storyContentTypes_aggregate: StoryContentTypes_Aggregate;
  /** fetch data from the table: "storyContentTypes" using primary key columns */
  storyContentTypes_by_pk?: Maybe<StoryContentTypes>;
  /** fetch data from the table: "storyContents" */
  storyContents: Array<StoryContents>;
  /** fetch aggregated fields from the table: "storyContents" */
  storyContents_aggregate: StoryContents_Aggregate;
  /** fetch data from the table: "storyContents" using primary key columns */
  storyContents_by_pk?: Maybe<StoryContents>;
  /** An array relationship */
  storyCopyProcesses: Array<StoryCopyProcesses>;
  /** An aggregate relationship */
  storyCopyProcesses_aggregate: StoryCopyProcesses_Aggregate;
  /** fetch data from the table: "storyCopyProcesses" using primary key columns */
  storyCopyProcesses_by_pk?: Maybe<StoryCopyProcesses>;
  /** fetch data from the table: "storyCustomColors" */
  storyCustomColors: Array<StoryCustomColors>;
  /** fetch aggregated fields from the table: "storyCustomColors" */
  storyCustomColors_aggregate: StoryCustomColors_Aggregate;
  /** fetch data from the table: "storyCustomColors" using primary key columns */
  storyCustomColors_by_pk?: Maybe<StoryCustomColors>;
  /** fetch data from the table: "storyEmbeds" */
  storyEmbeds: Array<StoryEmbeds>;
  /** fetch aggregated fields from the table: "storyEmbeds" */
  storyEmbeds_aggregate: StoryEmbeds_Aggregate;
  /** fetch data from the table: "storyEmbeds" using primary key columns */
  storyEmbeds_by_pk?: Maybe<StoryEmbeds>;
  /** fetch data from the table: "storyFolderActionSets" */
  storyFolderActionSets: Array<StoryFolderActionSets>;
  /** fetch aggregated fields from the table: "storyFolderActionSets" */
  storyFolderActionSets_aggregate: StoryFolderActionSets_Aggregate;
  /** fetch data from the table: "storyFolderActionSets" using primary key columns */
  storyFolderActionSets_by_pk?: Maybe<StoryFolderActionSets>;
  /** An array relationship */
  storyFolderGrants: Array<StoryFolderGrants>;
  /** An aggregate relationship */
  storyFolderGrants_aggregate: StoryFolderGrants_Aggregate;
  /** fetch data from the table: "storyFolderGrants" using primary key columns */
  storyFolderGrants_by_pk?: Maybe<StoryFolderGrants>;
  /** An array relationship */
  storyFolders: Array<StoryFolders>;
  /** fetch data from the table: "storyFoldersCopyProcesses" */
  storyFoldersCopyProcesses: Array<StoryFoldersCopyProcesses>;
  /** fetch aggregated fields from the table: "storyFoldersCopyProcesses" */
  storyFoldersCopyProcesses_aggregate: StoryFoldersCopyProcesses_Aggregate;
  /** fetch data from the table: "storyFoldersCopyProcesses" using primary key columns */
  storyFoldersCopyProcesses_by_pk?: Maybe<StoryFoldersCopyProcesses>;
  /** fetch data from the table: "storyFoldersGrantsFlat" */
  storyFoldersGrantsFlat: Array<StoryFoldersGrantsFlat>;
  /** fetch aggregated fields from the table: "storyFoldersGrantsFlat" */
  storyFoldersGrantsFlat_aggregate: StoryFoldersGrantsFlat_Aggregate;
  /** An aggregate relationship */
  storyFolders_aggregate: StoryFolders_Aggregate;
  /** fetch data from the table: "storyFolders" using primary key columns */
  storyFolders_by_pk?: Maybe<StoryFolders>;
  /** fetch data from the table: "storyStates" */
  storyStates: Array<StoryStates>;
  /** fetch aggregated fields from the table: "storyStates" */
  storyStates_aggregate: StoryStates_Aggregate;
  /** fetch data from the table: "storyStates" using primary key columns */
  storyStates_by_pk?: Maybe<StoryStates>;
  /** fetch data from the table: "storyTemplateContentBlocks" */
  storyTemplateContentBlocks: Array<StoryTemplateContentBlocks>;
  /** fetch aggregated fields from the table: "storyTemplateContentBlocks" */
  storyTemplateContentBlocks_aggregate: StoryTemplateContentBlocks_Aggregate;
  /** fetch data from the table: "storyTemplateContentBlocks" using primary key columns */
  storyTemplateContentBlocks_by_pk?: Maybe<StoryTemplateContentBlocks>;
  /** fetch data from the table: "storyTemplateContents" */
  storyTemplateContents: Array<StoryTemplateContents>;
  /** fetch aggregated fields from the table: "storyTemplateContents" */
  storyTemplateContents_aggregate: StoryTemplateContents_Aggregate;
  /** fetch data from the table: "storyTemplateContents" using primary key columns */
  storyTemplateContents_by_pk?: Maybe<StoryTemplateContents>;
  /** fetch data from the table: "storyTemplateCustomColors" */
  storyTemplateCustomColors: Array<StoryTemplateCustomColors>;
  /** fetch aggregated fields from the table: "storyTemplateCustomColors" */
  storyTemplateCustomColors_aggregate: StoryTemplateCustomColors_Aggregate;
  /** fetch data from the table: "storyTemplateCustomColors" using primary key columns */
  storyTemplateCustomColors_by_pk?: Maybe<StoryTemplateCustomColors>;
  /** fetch data from the table: "storyTemplates" */
  storyTemplates: Array<StoryTemplates>;
  /** fetch aggregated fields from the table: "storyTemplates" */
  storyTemplates_aggregate: StoryTemplates_Aggregate;
  /** fetch data from the table: "storyTemplates" using primary key columns */
  storyTemplates_by_pk?: Maybe<StoryTemplates>;
  /** fetch data from the table: "storyUsers" */
  storyUsers: Array<StoryUsers>;
  /** fetch aggregated fields from the table: "storyUsers" */
  storyUsers_aggregate: StoryUsers_Aggregate;
  /** fetch data from the table: "storyUsers" using primary key columns */
  storyUsers_by_pk?: Maybe<StoryUsers>;
  /** fetch data from the table: "storyVisibilities" */
  storyVisibilities: Array<StoryVisibilities>;
  /** fetch aggregated fields from the table: "storyVisibilities" */
  storyVisibilities_aggregate: StoryVisibilities_Aggregate;
  /** fetch data from the table: "storyVisibilities" using primary key columns */
  storyVisibilities_by_pk?: Maybe<StoryVisibilities>;
  /** An array relationship */
  subjectPublicationClaims: Array<SubjectPublicationClaims>;
  /** An aggregate relationship */
  subjectPublicationClaims_aggregate: SubjectPublicationClaims_Aggregate;
  /** fetch data from the table: "subjectPublicationClaims" using primary key columns */
  subjectPublicationClaims_by_pk?: Maybe<SubjectPublicationClaims>;
  /** An array relationship */
  subjectStoryClaims: Array<SubjectStoryClaims>;
  /** An aggregate relationship */
  subjectStoryClaims_aggregate: SubjectStoryClaims_Aggregate;
  /** fetch data from the table: "subjectStoryClaims" using primary key columns */
  subjectStoryClaims_by_pk?: Maybe<SubjectStoryClaims>;
  /** fetch data from the table: "userPublicationViews" */
  userPublicationViews: Array<UserPublicationViews>;
  /** fetch aggregated fields from the table: "userPublicationViews" */
  userPublicationViews_aggregate: UserPublicationViews_Aggregate;
  /** fetch data from the table: "userPublicationViews" using primary key columns */
  userPublicationViews_by_pk?: Maybe<UserPublicationViews>;
};


export type Query_RootAsyncJobsArgs = {
  distinct_on?: InputMaybe<Array<AsyncJobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AsyncJobs_Order_By>>;
  where?: InputMaybe<AsyncJobs_Bool_Exp>;
};


export type Query_RootAsyncJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AsyncJobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AsyncJobs_Order_By>>;
  where?: InputMaybe<AsyncJobs_Bool_Exp>;
};


export type Query_RootAsyncJobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChartsConfigArgs = {
  distinct_on?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChartsConfig_Order_By>>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};


export type Query_RootChartsConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChartsConfig_Order_By>>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};


export type Query_RootChartsConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCopyProcessStatusesArgs = {
  distinct_on?: InputMaybe<Array<CopyProcessStatuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CopyProcessStatuses_Order_By>>;
  where?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
};


export type Query_RootCopyProcessStatuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CopyProcessStatuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CopyProcessStatuses_Order_By>>;
  where?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
};


export type Query_RootCopyProcessStatuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEntityProgressTrackerSettingsArgs = {
  distinct_on?: InputMaybe<Array<EntityProgressTrackerSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityProgressTrackerSettings_Order_By>>;
  where?: InputMaybe<EntityProgressTrackerSettings_Bool_Exp>;
};


export type Query_RootEntityProgressTrackerSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityProgressTrackerSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityProgressTrackerSettings_Order_By>>;
  where?: InputMaybe<EntityProgressTrackerSettings_Bool_Exp>;
};


export type Query_RootEntityProgressTrackerSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEntityStoryColorSettingsArgs = {
  distinct_on?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStoryColorSettings_Order_By>>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};


export type Query_RootEntityStoryColorSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStoryColorSettings_Order_By>>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};


export type Query_RootEntityStoryColorSettings_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  entityId: Scalars['Int']['input'];
};


export type Query_RootEntityStorySettingsArgs = {
  distinct_on?: InputMaybe<Array<EntityStorySettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStorySettings_Order_By>>;
  where?: InputMaybe<EntityStorySettings_Bool_Exp>;
};


export type Query_RootEntityStorySettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityStorySettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStorySettings_Order_By>>;
  where?: InputMaybe<EntityStorySettings_Bool_Exp>;
};


export type Query_RootEntityStorySettings_By_PkArgs = {
  entityId: Scalars['Int']['input'];
};


export type Query_RootExportFolderPdfRequestsArgs = {
  distinct_on?: InputMaybe<Array<ExportFolderPdfRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportFolderPdfRequests_Order_By>>;
  where?: InputMaybe<ExportFolderPdfRequests_Bool_Exp>;
};


export type Query_RootExportFolderPdfRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExportFolderPdfRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportFolderPdfRequests_Order_By>>;
  where?: InputMaybe<ExportFolderPdfRequests_Bool_Exp>;
};


export type Query_RootExportFolderPdfRequests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootExportStoriesChunksArgs = {
  distinct_on?: InputMaybe<Array<ExportStoriesChunks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportStoriesChunks_Order_By>>;
  where?: InputMaybe<ExportStoriesChunks_Bool_Exp>;
};


export type Query_RootExportStoriesChunks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExportStoriesChunks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportStoriesChunks_Order_By>>;
  where?: InputMaybe<ExportStoriesChunks_Bool_Exp>;
};


export type Query_RootInternalPublishedStoryArgs = {
  distinct_on?: InputMaybe<Array<InternalPublishedStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InternalPublishedStory_Order_By>>;
  where?: InputMaybe<InternalPublishedStory_Bool_Exp>;
};


export type Query_RootInternalPublishedStory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InternalPublishedStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InternalPublishedStory_Order_By>>;
  where?: InputMaybe<InternalPublishedStory_Bool_Exp>;
};


export type Query_RootInternalPublishedStory_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootPortalStoryArgs = {
  distinct_on?: InputMaybe<Array<PortalStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortalStory_Order_By>>;
  where?: InputMaybe<PortalStory_Bool_Exp>;
};


export type Query_RootPortalStory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PortalStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortalStory_Order_By>>;
  where?: InputMaybe<PortalStory_Bool_Exp>;
};


export type Query_RootPortalStory_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootPublicationBrandingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationBrandings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationBrandings_Order_By>>;
  where?: InputMaybe<PublicationBrandings_Bool_Exp>;
};


export type Query_RootPublicationBrandings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationBrandings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationBrandings_Order_By>>;
  where?: InputMaybe<PublicationBrandings_Bool_Exp>;
};


export type Query_RootPublicationBrandings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationExportPdfRequestArgs = {
  distinct_on?: InputMaybe<Array<PublicationExportPdfRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationExportPdfRequest_Order_By>>;
  where?: InputMaybe<PublicationExportPdfRequest_Bool_Exp>;
};


export type Query_RootPublicationExportPdfRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationExportPdfRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationExportPdfRequest_Order_By>>;
  where?: InputMaybe<PublicationExportPdfRequest_Bool_Exp>;
};


export type Query_RootPublicationExportPdfRequest_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationFoldersArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


export type Query_RootPublicationFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


export type Query_RootPublicationFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationFooterSettingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationFooterSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFooterSettings_Order_By>>;
  where?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
};


export type Query_RootPublicationFooterSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationFooterSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFooterSettings_Order_By>>;
  where?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
};


export type Query_RootPublicationFooterSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationNavigationMenuItemsArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuItems_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};


export type Query_RootPublicationNavigationMenuItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuItems_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};


export type Query_RootPublicationNavigationMenuItems_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationNavigationMenuStoriesArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuStories_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};


export type Query_RootPublicationNavigationMenuStories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuStories_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};


export type Query_RootPublicationNavigationMenuStories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationSetupPdfStylesArgs = {
  distinct_on?: InputMaybe<Array<PublicationSetupPdfStyles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationSetupPdfStyles_Order_By>>;
  where?: InputMaybe<PublicationSetupPdfStyles_Bool_Exp>;
};


export type Query_RootPublicationSetupPdfStyles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationSetupPdfStyles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationSetupPdfStyles_Order_By>>;
  where?: InputMaybe<PublicationSetupPdfStyles_Bool_Exp>;
};


export type Query_RootPublicationSetupPdfStyles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationStoryPdfSettingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationStoryPdfSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationStoryPdfSettings_Order_By>>;
  where?: InputMaybe<PublicationStoryPdfSettings_Bool_Exp>;
};


export type Query_RootPublicationStoryPdfSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationStoryPdfSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationStoryPdfSettings_Order_By>>;
  where?: InputMaybe<PublicationStoryPdfSettings_Bool_Exp>;
};


export type Query_RootPublicationStoryPdfSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationTocSettingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationTocSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationTocSettings_Order_By>>;
  where?: InputMaybe<PublicationTocSettings_Bool_Exp>;
};


export type Query_RootPublicationTocSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationTocSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationTocSettings_Order_By>>;
  where?: InputMaybe<PublicationTocSettings_Bool_Exp>;
};


export type Query_RootPublicationTocSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPublicationsArgs = {
  distinct_on?: InputMaybe<Array<Publications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Publications_Order_By>>;
  where?: InputMaybe<Publications_Bool_Exp>;
};


export type Query_RootPublications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Publications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Publications_Order_By>>;
  where?: InputMaybe<Publications_Bool_Exp>;
};


export type Query_RootPublications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpreadsheetNamedRangesArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetNamedRanges_Order_By>>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};


export type Query_RootSpreadsheetNamedRanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetNamedRanges_Order_By>>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};


export type Query_RootSpreadsheetNamedRanges_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpreadsheetSplitTablesArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetSplitTables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetSplitTables_Order_By>>;
  where?: InputMaybe<SpreadsheetSplitTables_Bool_Exp>;
};


export type Query_RootSpreadsheetSplitTables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetSplitTables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetSplitTables_Order_By>>;
  where?: InputMaybe<SpreadsheetSplitTables_Bool_Exp>;
};


export type Query_RootSpreadsheetSplitTables_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpreadsheetStoryCountsArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetStoryCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetStoryCounts_Order_By>>;
  where?: InputMaybe<SpreadsheetStoryCounts_Bool_Exp>;
};


export type Query_RootSpreadsheetStoryCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetStoryCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetStoryCounts_Order_By>>;
  where?: InputMaybe<SpreadsheetStoryCounts_Bool_Exp>;
};


export type Query_RootSpreadsheetsArgs = {
  distinct_on?: InputMaybe<Array<Spreadsheets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spreadsheets_Order_By>>;
  where?: InputMaybe<Spreadsheets_Bool_Exp>;
};


export type Query_RootSpreadsheetsProcessingStatusArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetsProcessingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetsProcessingStatus_Order_By>>;
  where?: InputMaybe<SpreadsheetsProcessingStatus_Bool_Exp>;
};


export type Query_RootSpreadsheetsProcessingStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetsProcessingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetsProcessingStatus_Order_By>>;
  where?: InputMaybe<SpreadsheetsProcessingStatus_Bool_Exp>;
};


export type Query_RootSpreadsheetsProcessingStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSpreadsheets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spreadsheets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spreadsheets_Order_By>>;
  where?: InputMaybe<Spreadsheets_Bool_Exp>;
};


export type Query_RootSpreadsheets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStoriesArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


export type Query_RootStoriesCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoriesCopyProcesses_Order_By>>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};


export type Query_RootStoriesCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoriesCopyProcesses_Order_By>>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};


export type Query_RootStoriesCopyProcesses_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootStories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


export type Query_RootStories_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootStoryBudgetProposalsArgs = {
  distinct_on?: InputMaybe<Array<StoryBudgetProposals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryBudgetProposals_Order_By>>;
  where?: InputMaybe<StoryBudgetProposals_Bool_Exp>;
};


export type Query_RootStoryBudgetProposals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryBudgetProposals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryBudgetProposals_Order_By>>;
  where?: InputMaybe<StoryBudgetProposals_Bool_Exp>;
};


export type Query_RootStoryBudgetProposals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStoryContentBlockTypesArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlockTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlockTypes_Order_By>>;
  where?: InputMaybe<StoryContentBlockTypes_Bool_Exp>;
};


export type Query_RootStoryContentBlockTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlockTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlockTypes_Order_By>>;
  where?: InputMaybe<StoryContentBlockTypes_Bool_Exp>;
};


export type Query_RootStoryContentBlockTypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStoryContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlocks_Order_By>>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};


export type Query_RootStoryContentBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlocks_Order_By>>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};


export type Query_RootStoryContentBlocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStoryContentColorTargetsArgs = {
  distinct_on?: InputMaybe<Array<StoryContentColorTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentColorTargets_Order_By>>;
  where?: InputMaybe<StoryContentColorTargets_Bool_Exp>;
};


export type Query_RootStoryContentColorTargets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentColorTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentColorTargets_Order_By>>;
  where?: InputMaybe<StoryContentColorTargets_Bool_Exp>;
};


export type Query_RootStoryContentColorTargets_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStoryContentSpreadsheetReferencesArgs = {
  distinct_on?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentSpreadsheetReferences_Order_By>>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};


export type Query_RootStoryContentSpreadsheetReferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentSpreadsheetReferences_Order_By>>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};


export type Query_RootStoryContentSpreadsheetReferences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStoryContentTypesArgs = {
  distinct_on?: InputMaybe<Array<StoryContentTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentTypes_Order_By>>;
  where?: InputMaybe<StoryContentTypes_Bool_Exp>;
};


export type Query_RootStoryContentTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentTypes_Order_By>>;
  where?: InputMaybe<StoryContentTypes_Bool_Exp>;
};


export type Query_RootStoryContentTypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStoryContentsArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


export type Query_RootStoryContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


export type Query_RootStoryContents_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootStoryCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};


export type Query_RootStoryCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};


export type Query_RootStoryCopyProcesses_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootStoryCustomColorsArgs = {
  distinct_on?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCustomColors_Order_By>>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};


export type Query_RootStoryCustomColors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCustomColors_Order_By>>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};


export type Query_RootStoryCustomColors_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  storyId: Scalars['String']['input'];
};


export type Query_RootStoryEmbedsArgs = {
  distinct_on?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryEmbeds_Order_By>>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};


export type Query_RootStoryEmbeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryEmbeds_Order_By>>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};


export type Query_RootStoryEmbeds_By_PkArgs = {
  embedId: Scalars['uuid']['input'];
  storyId: Scalars['String']['input'];
};


export type Query_RootStoryFolderActionSetsArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderActionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderActionSets_Order_By>>;
  where?: InputMaybe<StoryFolderActionSets_Bool_Exp>;
};


export type Query_RootStoryFolderActionSets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderActionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderActionSets_Order_By>>;
  where?: InputMaybe<StoryFolderActionSets_Bool_Exp>;
};


export type Query_RootStoryFolderActionSets_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStoryFolderGrantsArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderGrants_Order_By>>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};


export type Query_RootStoryFolderGrants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderGrants_Order_By>>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};


export type Query_RootStoryFolderGrants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStoryFoldersArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


export type Query_RootStoryFoldersCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
};


export type Query_RootStoryFoldersCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
};


export type Query_RootStoryFoldersCopyProcesses_By_PkArgs = {
  destinationFolderId: Scalars['uuid']['input'];
};


export type Query_RootStoryFoldersGrantsFlatArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersGrantsFlat_Order_By>>;
  where?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
};


export type Query_RootStoryFoldersGrantsFlat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersGrantsFlat_Order_By>>;
  where?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
};


export type Query_RootStoryFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


export type Query_RootStoryFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStoryStatesArgs = {
  distinct_on?: InputMaybe<Array<StoryStates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryStates_Order_By>>;
  where?: InputMaybe<StoryStates_Bool_Exp>;
};


export type Query_RootStoryStates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryStates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryStates_Order_By>>;
  where?: InputMaybe<StoryStates_Bool_Exp>;
};


export type Query_RootStoryStates_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStoryTemplateContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContentBlocks_Order_By>>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};


export type Query_RootStoryTemplateContentBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContentBlocks_Order_By>>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};


export type Query_RootStoryTemplateContentBlocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStoryTemplateContentsArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContents_Order_By>>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};


export type Query_RootStoryTemplateContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContents_Order_By>>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};


export type Query_RootStoryTemplateContents_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootStoryTemplateCustomColorsArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateCustomColors_Order_By>>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};


export type Query_RootStoryTemplateCustomColors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateCustomColors_Order_By>>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};


export type Query_RootStoryTemplateCustomColors_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  templateId: Scalars['String']['input'];
};


export type Query_RootStoryTemplatesArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplates_Order_By>>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};


export type Query_RootStoryTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplates_Order_By>>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};


export type Query_RootStoryTemplates_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootStoryUsersArgs = {
  distinct_on?: InputMaybe<Array<StoryUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryUsers_Order_By>>;
  where?: InputMaybe<StoryUsers_Bool_Exp>;
};


export type Query_RootStoryUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryUsers_Order_By>>;
  where?: InputMaybe<StoryUsers_Bool_Exp>;
};


export type Query_RootStoryUsers_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Query_RootStoryVisibilitiesArgs = {
  distinct_on?: InputMaybe<Array<StoryVisibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryVisibilities_Order_By>>;
  where?: InputMaybe<StoryVisibilities_Bool_Exp>;
};


export type Query_RootStoryVisibilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryVisibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryVisibilities_Order_By>>;
  where?: InputMaybe<StoryVisibilities_Bool_Exp>;
};


export type Query_RootStoryVisibilities_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSubjectPublicationClaimsArgs = {
  distinct_on?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectPublicationClaims_Order_By>>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};


export type Query_RootSubjectPublicationClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectPublicationClaims_Order_By>>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};


export type Query_RootSubjectPublicationClaims_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubjectStoryClaimsArgs = {
  distinct_on?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectStoryClaims_Order_By>>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};


export type Query_RootSubjectStoryClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectStoryClaims_Order_By>>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};


export type Query_RootSubjectStoryClaims_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserPublicationViewsArgs = {
  distinct_on?: InputMaybe<Array<UserPublicationViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPublicationViews_Order_By>>;
  where?: InputMaybe<UserPublicationViews_Bool_Exp>;
};


export type Query_RootUserPublicationViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPublicationViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPublicationViews_Order_By>>;
  where?: InputMaybe<UserPublicationViews_Bool_Exp>;
};


export type Query_RootUserPublicationViews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges = {
  __typename?: 'spreadsheetNamedRanges';
  createdAt: Scalars['timestamptz']['output'];
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  needsSplitting: Scalars['Boolean']['output'];
  s3Key: Scalars['String']['output'];
  /** An object relationship */
  spreadsheet: Spreadsheets;
  spreadsheetId: Scalars['uuid']['output'];
  /** An array relationship */
  storyContentSpreadsheetReferences: Array<StoryContentSpreadsheetReferences>;
  /** An aggregate relationship */
  storyContentSpreadsheetReferences_aggregate: StoryContentSpreadsheetReferences_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "spreadsheetNamedRanges" */
export type SpreadsheetNamedRangesStoryContentSpreadsheetReferencesArgs = {
  distinct_on?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentSpreadsheetReferences_Order_By>>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};


/** columns and relationships of "spreadsheetNamedRanges" */
export type SpreadsheetNamedRangesStoryContentSpreadsheetReferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentSpreadsheetReferences_Order_By>>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};

/** aggregated selection of "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Aggregate = {
  __typename?: 'spreadsheetNamedRanges_aggregate';
  aggregate?: Maybe<SpreadsheetNamedRanges_Aggregate_Fields>;
  nodes: Array<SpreadsheetNamedRanges>;
};

export type SpreadsheetNamedRanges_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<SpreadsheetNamedRanges_Aggregate_Bool_Exp_Count>;
};

export type SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_And = {
  arguments: SpreadsheetNamedRanges_Select_Column_SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_Or = {
  arguments: SpreadsheetNamedRanges_Select_Column_SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type SpreadsheetNamedRanges_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Aggregate_Fields = {
  __typename?: 'spreadsheetNamedRanges_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SpreadsheetNamedRanges_Max_Fields>;
  min?: Maybe<SpreadsheetNamedRanges_Min_Fields>;
};


/** aggregate fields of "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SpreadsheetNamedRanges_Max_Order_By>;
  min?: InputMaybe<SpreadsheetNamedRanges_Min_Order_By>;
};

/** input type for inserting array relation for remote table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Arr_Rel_Insert_Input = {
  data: Array<SpreadsheetNamedRanges_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SpreadsheetNamedRanges_On_Conflict>;
};

/** Boolean expression to filter rows from the table "spreadsheetNamedRanges". All fields are combined with a logical 'AND'. */
export type SpreadsheetNamedRanges_Bool_Exp = {
  _and?: InputMaybe<Array<SpreadsheetNamedRanges_Bool_Exp>>;
  _not?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
  _or?: InputMaybe<Array<SpreadsheetNamedRanges_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  htmlContent?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  needsSplitting?: InputMaybe<Boolean_Comparison_Exp>;
  s3Key?: InputMaybe<String_Comparison_Exp>;
  spreadsheet?: InputMaybe<Spreadsheets_Bool_Exp>;
  spreadsheetId?: InputMaybe<Uuid_Comparison_Exp>;
  storyContentSpreadsheetReferences?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
  storyContentSpreadsheetReferences_aggregate?: InputMaybe<StoryContentSpreadsheetReferences_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "spreadsheetNamedRanges" */
export enum SpreadsheetNamedRanges_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpreadsheetNamedRangesPkey = 'spreadsheetNamedRanges_pkey',
  /** unique or primary key constraint on columns "id", "spreadsheetId" */
  SpreadsheetNamedRangesSpreadsheetIdIdKey = 'spreadsheetNamedRanges_spreadsheetId_id_key'
}

/** input type for inserting data into table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsSplitting?: InputMaybe<Scalars['Boolean']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  spreadsheet?: InputMaybe<Spreadsheets_Obj_Rel_Insert_Input>;
  spreadsheetId?: InputMaybe<Scalars['uuid']['input']>;
  storyContentSpreadsheetReferences?: InputMaybe<StoryContentSpreadsheetReferences_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type SpreadsheetNamedRanges_Max_Fields = {
  __typename?: 'spreadsheetNamedRanges_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  spreadsheetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  htmlContent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  s3Key?: InputMaybe<Order_By>;
  spreadsheetId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SpreadsheetNamedRanges_Min_Fields = {
  __typename?: 'spreadsheetNamedRanges_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  spreadsheetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  htmlContent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  s3Key?: InputMaybe<Order_By>;
  spreadsheetId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Mutation_Response = {
  __typename?: 'spreadsheetNamedRanges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpreadsheetNamedRanges>;
};

/** input type for inserting object relation for remote table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Obj_Rel_Insert_Input = {
  data: SpreadsheetNamedRanges_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SpreadsheetNamedRanges_On_Conflict>;
};

/** on_conflict condition type for table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_On_Conflict = {
  constraint: SpreadsheetNamedRanges_Constraint;
  update_columns?: Array<SpreadsheetNamedRanges_Update_Column>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};

/** Ordering options when selecting data from "spreadsheetNamedRanges". */
export type SpreadsheetNamedRanges_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  htmlContent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  needsSplitting?: InputMaybe<Order_By>;
  s3Key?: InputMaybe<Order_By>;
  spreadsheet?: InputMaybe<Spreadsheets_Order_By>;
  spreadsheetId?: InputMaybe<Order_By>;
  storyContentSpreadsheetReferences_aggregate?: InputMaybe<StoryContentSpreadsheetReferences_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spreadsheetNamedRanges */
export type SpreadsheetNamedRanges_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "spreadsheetNamedRanges" */
export enum SpreadsheetNamedRanges_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HtmlContent = 'htmlContent',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsSplitting = 'needsSplitting',
  /** column name */
  S3Key = 's3Key',
  /** column name */
  SpreadsheetId = 'spreadsheetId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "spreadsheetNamedRanges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spreadsheetNamedRanges" */
export enum SpreadsheetNamedRanges_Select_Column_SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NeedsSplitting = 'needsSplitting'
}

/** select "spreadsheetNamedRanges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spreadsheetNamedRanges" */
export enum SpreadsheetNamedRanges_Select_Column_SpreadsheetNamedRanges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NeedsSplitting = 'needsSplitting'
}

/** input type for updating data in table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsSplitting?: InputMaybe<Scalars['Boolean']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  spreadsheetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "spreadsheetNamedRanges" */
export type SpreadsheetNamedRanges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpreadsheetNamedRanges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpreadsheetNamedRanges_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsSplitting?: InputMaybe<Scalars['Boolean']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  spreadsheetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "spreadsheetNamedRanges" */
export enum SpreadsheetNamedRanges_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HtmlContent = 'htmlContent',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsSplitting = 'needsSplitting',
  /** column name */
  S3Key = 's3Key',
  /** column name */
  SpreadsheetId = 'spreadsheetId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SpreadsheetNamedRanges_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpreadsheetNamedRanges_Set_Input>;
  where: SpreadsheetNamedRanges_Bool_Exp;
};

/** columns and relationships of "spreadsheetSplitTables" */
export type SpreadsheetSplitTables = {
  __typename?: 'spreadsheetSplitTables';
  createdAt: Scalars['timestamptz']['output'];
  htmlContent: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  namedRangeId: Scalars['uuid']['output'];
  sequenceNumber: Scalars['Int']['output'];
  /** An object relationship */
  spreadsheetNamedRange: SpreadsheetNamedRanges;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Aggregate = {
  __typename?: 'spreadsheetSplitTables_aggregate';
  aggregate?: Maybe<SpreadsheetSplitTables_Aggregate_Fields>;
  nodes: Array<SpreadsheetSplitTables>;
};

/** aggregate fields of "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Aggregate_Fields = {
  __typename?: 'spreadsheetSplitTables_aggregate_fields';
  avg?: Maybe<SpreadsheetSplitTables_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<SpreadsheetSplitTables_Max_Fields>;
  min?: Maybe<SpreadsheetSplitTables_Min_Fields>;
  stddev?: Maybe<SpreadsheetSplitTables_Stddev_Fields>;
  stddev_pop?: Maybe<SpreadsheetSplitTables_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SpreadsheetSplitTables_Stddev_Samp_Fields>;
  sum?: Maybe<SpreadsheetSplitTables_Sum_Fields>;
  var_pop?: Maybe<SpreadsheetSplitTables_Var_Pop_Fields>;
  var_samp?: Maybe<SpreadsheetSplitTables_Var_Samp_Fields>;
  variance?: Maybe<SpreadsheetSplitTables_Variance_Fields>;
};


/** aggregate fields of "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpreadsheetSplitTables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type SpreadsheetSplitTables_Avg_Fields = {
  __typename?: 'spreadsheetSplitTables_avg_fields';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "spreadsheetSplitTables". All fields are combined with a logical 'AND'. */
export type SpreadsheetSplitTables_Bool_Exp = {
  _and?: InputMaybe<Array<SpreadsheetSplitTables_Bool_Exp>>;
  _not?: InputMaybe<SpreadsheetSplitTables_Bool_Exp>;
  _or?: InputMaybe<Array<SpreadsheetSplitTables_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  htmlContent?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  namedRangeId?: InputMaybe<Uuid_Comparison_Exp>;
  sequenceNumber?: InputMaybe<Int_Comparison_Exp>;
  spreadsheetNamedRange?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "spreadsheetSplitTables" */
export enum SpreadsheetSplitTables_Constraint {
  /** unique or primary key constraint on columns "namedRangeId", "sequenceNumber" */
  SpreadsheetSplitTablesNamedRangeIdSequenceNumberKey = 'spreadsheetSplitTables_namedRangeId_sequenceNumber_key',
  /** unique or primary key constraint on columns "id" */
  SpreadsheetSplitTablesPkey = 'spreadsheetSplitTables_pkey'
}

/** input type for incrementing numeric columns in table "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Inc_Input = {
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  namedRangeId?: InputMaybe<Scalars['uuid']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  spreadsheetNamedRange?: InputMaybe<SpreadsheetNamedRanges_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type SpreadsheetSplitTables_Max_Fields = {
  __typename?: 'spreadsheetSplitTables_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  namedRangeId?: Maybe<Scalars['uuid']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type SpreadsheetSplitTables_Min_Fields = {
  __typename?: 'spreadsheetSplitTables_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  namedRangeId?: Maybe<Scalars['uuid']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Mutation_Response = {
  __typename?: 'spreadsheetSplitTables_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpreadsheetSplitTables>;
};

/** on_conflict condition type for table "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_On_Conflict = {
  constraint: SpreadsheetSplitTables_Constraint;
  update_columns?: Array<SpreadsheetSplitTables_Update_Column>;
  where?: InputMaybe<SpreadsheetSplitTables_Bool_Exp>;
};

/** Ordering options when selecting data from "spreadsheetSplitTables". */
export type SpreadsheetSplitTables_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  htmlContent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  namedRangeId?: InputMaybe<Order_By>;
  sequenceNumber?: InputMaybe<Order_By>;
  spreadsheetNamedRange?: InputMaybe<SpreadsheetNamedRanges_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spreadsheetSplitTables */
export type SpreadsheetSplitTables_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "spreadsheetSplitTables" */
export enum SpreadsheetSplitTables_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HtmlContent = 'htmlContent',
  /** column name */
  Id = 'id',
  /** column name */
  NamedRangeId = 'namedRangeId',
  /** column name */
  SequenceNumber = 'sequenceNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  namedRangeId?: InputMaybe<Scalars['uuid']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type SpreadsheetSplitTables_Stddev_Fields = {
  __typename?: 'spreadsheetSplitTables_stddev_fields';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type SpreadsheetSplitTables_Stddev_Pop_Fields = {
  __typename?: 'spreadsheetSplitTables_stddev_pop_fields';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type SpreadsheetSplitTables_Stddev_Samp_Fields = {
  __typename?: 'spreadsheetSplitTables_stddev_samp_fields';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "spreadsheetSplitTables" */
export type SpreadsheetSplitTables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpreadsheetSplitTables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpreadsheetSplitTables_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  namedRangeId?: InputMaybe<Scalars['uuid']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type SpreadsheetSplitTables_Sum_Fields = {
  __typename?: 'spreadsheetSplitTables_sum_fields';
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "spreadsheetSplitTables" */
export enum SpreadsheetSplitTables_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HtmlContent = 'htmlContent',
  /** column name */
  Id = 'id',
  /** column name */
  NamedRangeId = 'namedRangeId',
  /** column name */
  SequenceNumber = 'sequenceNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SpreadsheetSplitTables_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SpreadsheetSplitTables_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpreadsheetSplitTables_Set_Input>;
  where: SpreadsheetSplitTables_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SpreadsheetSplitTables_Var_Pop_Fields = {
  __typename?: 'spreadsheetSplitTables_var_pop_fields';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type SpreadsheetSplitTables_Var_Samp_Fields = {
  __typename?: 'spreadsheetSplitTables_var_samp_fields';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type SpreadsheetSplitTables_Variance_Fields = {
  __typename?: 'spreadsheetSplitTables_variance_fields';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "spreadsheetStoryCounts" */
export type SpreadsheetStoryCounts = {
  __typename?: 'spreadsheetStoryCounts';
  countOfUniqueStories?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  spreadsheetId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "spreadsheetStoryCounts" */
export type SpreadsheetStoryCounts_Aggregate = {
  __typename?: 'spreadsheetStoryCounts_aggregate';
  aggregate?: Maybe<SpreadsheetStoryCounts_Aggregate_Fields>;
  nodes: Array<SpreadsheetStoryCounts>;
};

/** aggregate fields of "spreadsheetStoryCounts" */
export type SpreadsheetStoryCounts_Aggregate_Fields = {
  __typename?: 'spreadsheetStoryCounts_aggregate_fields';
  avg?: Maybe<SpreadsheetStoryCounts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<SpreadsheetStoryCounts_Max_Fields>;
  min?: Maybe<SpreadsheetStoryCounts_Min_Fields>;
  stddev?: Maybe<SpreadsheetStoryCounts_Stddev_Fields>;
  stddev_pop?: Maybe<SpreadsheetStoryCounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SpreadsheetStoryCounts_Stddev_Samp_Fields>;
  sum?: Maybe<SpreadsheetStoryCounts_Sum_Fields>;
  var_pop?: Maybe<SpreadsheetStoryCounts_Var_Pop_Fields>;
  var_samp?: Maybe<SpreadsheetStoryCounts_Var_Samp_Fields>;
  variance?: Maybe<SpreadsheetStoryCounts_Variance_Fields>;
};


/** aggregate fields of "spreadsheetStoryCounts" */
export type SpreadsheetStoryCounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpreadsheetStoryCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type SpreadsheetStoryCounts_Avg_Fields = {
  __typename?: 'spreadsheetStoryCounts_avg_fields';
  countOfUniqueStories?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "spreadsheetStoryCounts". All fields are combined with a logical 'AND'. */
export type SpreadsheetStoryCounts_Bool_Exp = {
  _and?: InputMaybe<Array<SpreadsheetStoryCounts_Bool_Exp>>;
  _not?: InputMaybe<SpreadsheetStoryCounts_Bool_Exp>;
  _or?: InputMaybe<Array<SpreadsheetStoryCounts_Bool_Exp>>;
  countOfUniqueStories?: InputMaybe<Int_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  spreadsheetId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type SpreadsheetStoryCounts_Max_Fields = {
  __typename?: 'spreadsheetStoryCounts_max_fields';
  countOfUniqueStories?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  spreadsheetId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type SpreadsheetStoryCounts_Min_Fields = {
  __typename?: 'spreadsheetStoryCounts_min_fields';
  countOfUniqueStories?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  spreadsheetId?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "spreadsheetStoryCounts". */
export type SpreadsheetStoryCounts_Order_By = {
  countOfUniqueStories?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  spreadsheetId?: InputMaybe<Order_By>;
};

/** select columns of table "spreadsheetStoryCounts" */
export enum SpreadsheetStoryCounts_Select_Column {
  /** column name */
  CountOfUniqueStories = 'countOfUniqueStories',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  SpreadsheetId = 'spreadsheetId'
}

/** aggregate stddev on columns */
export type SpreadsheetStoryCounts_Stddev_Fields = {
  __typename?: 'spreadsheetStoryCounts_stddev_fields';
  countOfUniqueStories?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type SpreadsheetStoryCounts_Stddev_Pop_Fields = {
  __typename?: 'spreadsheetStoryCounts_stddev_pop_fields';
  countOfUniqueStories?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type SpreadsheetStoryCounts_Stddev_Samp_Fields = {
  __typename?: 'spreadsheetStoryCounts_stddev_samp_fields';
  countOfUniqueStories?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "spreadsheetStoryCounts" */
export type SpreadsheetStoryCounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpreadsheetStoryCounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpreadsheetStoryCounts_Stream_Cursor_Value_Input = {
  countOfUniqueStories?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  spreadsheetId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type SpreadsheetStoryCounts_Sum_Fields = {
  __typename?: 'spreadsheetStoryCounts_sum_fields';
  countOfUniqueStories?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type SpreadsheetStoryCounts_Var_Pop_Fields = {
  __typename?: 'spreadsheetStoryCounts_var_pop_fields';
  countOfUniqueStories?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type SpreadsheetStoryCounts_Var_Samp_Fields = {
  __typename?: 'spreadsheetStoryCounts_var_samp_fields';
  countOfUniqueStories?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type SpreadsheetStoryCounts_Variance_Fields = {
  __typename?: 'spreadsheetStoryCounts_variance_fields';
  countOfUniqueStories?: Maybe<Scalars['Float']['output']>;
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "spreadsheets" */
export type Spreadsheets = {
  __typename?: 'spreadsheets';
  createdAt: Scalars['timestamptz']['output'];
  entityId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['timestamptz']['output']>;
  processingErrors?: Maybe<Scalars['_text']['output']>;
  processingStatus: SpreadsheetsProcessingStatus_Enum;
  publicationId: Scalars['uuid']['output'];
  s3Key?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  spreadsheetNamedRanges: Array<SpreadsheetNamedRanges>;
  /** An aggregate relationship */
  spreadsheetNamedRanges_aggregate: SpreadsheetNamedRanges_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "spreadsheets" */
export type SpreadsheetsSpreadsheetNamedRangesArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetNamedRanges_Order_By>>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};


/** columns and relationships of "spreadsheets" */
export type SpreadsheetsSpreadsheetNamedRanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetNamedRanges_Order_By>>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};

/** columns and relationships of "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus = {
  __typename?: 'spreadsheetsProcessingStatus';
  value: Scalars['String']['output'];
};

/** aggregated selection of "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_Aggregate = {
  __typename?: 'spreadsheetsProcessingStatus_aggregate';
  aggregate?: Maybe<SpreadsheetsProcessingStatus_Aggregate_Fields>;
  nodes: Array<SpreadsheetsProcessingStatus>;
};

/** aggregate fields of "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_Aggregate_Fields = {
  __typename?: 'spreadsheetsProcessingStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SpreadsheetsProcessingStatus_Max_Fields>;
  min?: Maybe<SpreadsheetsProcessingStatus_Min_Fields>;
};


/** aggregate fields of "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpreadsheetsProcessingStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "spreadsheetsProcessingStatus". All fields are combined with a logical 'AND'. */
export type SpreadsheetsProcessingStatus_Bool_Exp = {
  _and?: InputMaybe<Array<SpreadsheetsProcessingStatus_Bool_Exp>>;
  _not?: InputMaybe<SpreadsheetsProcessingStatus_Bool_Exp>;
  _or?: InputMaybe<Array<SpreadsheetsProcessingStatus_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spreadsheetsProcessingStatus" */
export enum SpreadsheetsProcessingStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  SpreadsheetsProcessingStatusPkey = 'spreadsheetsProcessingStatus_pkey'
}

export enum SpreadsheetsProcessingStatus_Enum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Uploaded = 'UPLOADED'
}

/** Boolean expression to compare columns of type "spreadsheetsProcessingStatus_enum". All fields are combined with logical 'AND'. */
export type SpreadsheetsProcessingStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<SpreadsheetsProcessingStatus_Enum>;
  _in?: InputMaybe<Array<SpreadsheetsProcessingStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<SpreadsheetsProcessingStatus_Enum>;
  _nin?: InputMaybe<Array<SpreadsheetsProcessingStatus_Enum>>;
};

/** input type for inserting data into table "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type SpreadsheetsProcessingStatus_Max_Fields = {
  __typename?: 'spreadsheetsProcessingStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type SpreadsheetsProcessingStatus_Min_Fields = {
  __typename?: 'spreadsheetsProcessingStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_Mutation_Response = {
  __typename?: 'spreadsheetsProcessingStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpreadsheetsProcessingStatus>;
};

/** on_conflict condition type for table "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_On_Conflict = {
  constraint: SpreadsheetsProcessingStatus_Constraint;
  update_columns?: Array<SpreadsheetsProcessingStatus_Update_Column>;
  where?: InputMaybe<SpreadsheetsProcessingStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "spreadsheetsProcessingStatus". */
export type SpreadsheetsProcessingStatus_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spreadsheetsProcessingStatus */
export type SpreadsheetsProcessingStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "spreadsheetsProcessingStatus" */
export enum SpreadsheetsProcessingStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "spreadsheetsProcessingStatus" */
export type SpreadsheetsProcessingStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpreadsheetsProcessingStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpreadsheetsProcessingStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "spreadsheetsProcessingStatus" */
export enum SpreadsheetsProcessingStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type SpreadsheetsProcessingStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpreadsheetsProcessingStatus_Set_Input>;
  where: SpreadsheetsProcessingStatus_Bool_Exp;
};

/** aggregated selection of "spreadsheets" */
export type Spreadsheets_Aggregate = {
  __typename?: 'spreadsheets_aggregate';
  aggregate?: Maybe<Spreadsheets_Aggregate_Fields>;
  nodes: Array<Spreadsheets>;
};

/** aggregate fields of "spreadsheets" */
export type Spreadsheets_Aggregate_Fields = {
  __typename?: 'spreadsheets_aggregate_fields';
  avg?: Maybe<Spreadsheets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spreadsheets_Max_Fields>;
  min?: Maybe<Spreadsheets_Min_Fields>;
  stddev?: Maybe<Spreadsheets_Stddev_Fields>;
  stddev_pop?: Maybe<Spreadsheets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spreadsheets_Stddev_Samp_Fields>;
  sum?: Maybe<Spreadsheets_Sum_Fields>;
  var_pop?: Maybe<Spreadsheets_Var_Pop_Fields>;
  var_samp?: Maybe<Spreadsheets_Var_Samp_Fields>;
  variance?: Maybe<Spreadsheets_Variance_Fields>;
};


/** aggregate fields of "spreadsheets" */
export type Spreadsheets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spreadsheets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Spreadsheets_Avg_Fields = {
  __typename?: 'spreadsheets_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "spreadsheets". All fields are combined with a logical 'AND'. */
export type Spreadsheets_Bool_Exp = {
  _and?: InputMaybe<Array<Spreadsheets_Bool_Exp>>;
  _not?: InputMaybe<Spreadsheets_Bool_Exp>;
  _or?: InputMaybe<Array<Spreadsheets_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  processedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  processingErrors?: InputMaybe<_Text_Comparison_Exp>;
  processingStatus?: InputMaybe<SpreadsheetsProcessingStatus_Enum_Comparison_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  s3Key?: InputMaybe<String_Comparison_Exp>;
  spreadsheetNamedRanges?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
  spreadsheetNamedRanges_aggregate?: InputMaybe<SpreadsheetNamedRanges_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  uploadedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "spreadsheets" */
export enum Spreadsheets_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpreadsheetsPkey = 'spreadsheets_pkey'
}

/** input type for incrementing numeric columns in table "spreadsheets" */
export type Spreadsheets_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spreadsheets" */
export type Spreadsheets_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  processingErrors?: InputMaybe<Scalars['_text']['input']>;
  processingStatus?: InputMaybe<SpreadsheetsProcessingStatus_Enum>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  spreadsheetNamedRanges?: InputMaybe<SpreadsheetNamedRanges_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Spreadsheets_Max_Fields = {
  __typename?: 'spreadsheets_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['timestamptz']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Spreadsheets_Min_Fields = {
  __typename?: 'spreadsheets_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['timestamptz']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "spreadsheets" */
export type Spreadsheets_Mutation_Response = {
  __typename?: 'spreadsheets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spreadsheets>;
};

/** input type for inserting object relation for remote table "spreadsheets" */
export type Spreadsheets_Obj_Rel_Insert_Input = {
  data: Spreadsheets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spreadsheets_On_Conflict>;
};

/** on_conflict condition type for table "spreadsheets" */
export type Spreadsheets_On_Conflict = {
  constraint: Spreadsheets_Constraint;
  update_columns?: Array<Spreadsheets_Update_Column>;
  where?: InputMaybe<Spreadsheets_Bool_Exp>;
};

/** Ordering options when selecting data from "spreadsheets". */
export type Spreadsheets_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  processedAt?: InputMaybe<Order_By>;
  processingErrors?: InputMaybe<Order_By>;
  processingStatus?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  s3Key?: InputMaybe<Order_By>;
  spreadsheetNamedRanges_aggregate?: InputMaybe<SpreadsheetNamedRanges_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  uploadedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spreadsheets */
export type Spreadsheets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "spreadsheets" */
export enum Spreadsheets_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProcessedAt = 'processedAt',
  /** column name */
  ProcessingErrors = 'processingErrors',
  /** column name */
  ProcessingStatus = 'processingStatus',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  S3Key = 's3Key',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UploadedAt = 'uploadedAt'
}

/** input type for updating data in table "spreadsheets" */
export type Spreadsheets_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  processingErrors?: InputMaybe<Scalars['_text']['input']>;
  processingStatus?: InputMaybe<SpreadsheetsProcessingStatus_Enum>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Spreadsheets_Stddev_Fields = {
  __typename?: 'spreadsheets_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Spreadsheets_Stddev_Pop_Fields = {
  __typename?: 'spreadsheets_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Spreadsheets_Stddev_Samp_Fields = {
  __typename?: 'spreadsheets_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "spreadsheets" */
export type Spreadsheets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spreadsheets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spreadsheets_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  processingErrors?: InputMaybe<Scalars['_text']['input']>;
  processingStatus?: InputMaybe<SpreadsheetsProcessingStatus_Enum>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Spreadsheets_Sum_Fields = {
  __typename?: 'spreadsheets_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "spreadsheets" */
export enum Spreadsheets_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProcessedAt = 'processedAt',
  /** column name */
  ProcessingErrors = 'processingErrors',
  /** column name */
  ProcessingStatus = 'processingStatus',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  S3Key = 's3Key',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UploadedAt = 'uploadedAt'
}

export type Spreadsheets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spreadsheets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spreadsheets_Set_Input>;
  where: Spreadsheets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spreadsheets_Var_Pop_Fields = {
  __typename?: 'spreadsheets_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Spreadsheets_Var_Samp_Fields = {
  __typename?: 'spreadsheets_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Spreadsheets_Variance_Fields = {
  __typename?: 'spreadsheets_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "stories" */
export type Stories = {
  __typename?: 'stories';
  _id: Scalars['String']['output'];
  /** An object relationship */
  author?: Maybe<StoryUsers>;
  authorId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  contents: Array<StoryContents>;
  /** An aggregate relationship */
  contents_aggregate: StoryContents_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customColors: Array<StoryCustomColors>;
  /** An aggregate relationship */
  customColors_aggregate: StoryCustomColors_Aggregate;
  customCssCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  embeds: Array<StoryEmbeds>;
  /** An aggregate relationship */
  embeds_aggregate: StoryEmbeds_Aggregate;
  entityId: Scalars['Int']['output'];
  /** An object relationship */
  folder?: Maybe<StoryFolders>;
  folderId?: Maybe<Scalars['uuid']['output']>;
  isFollowable: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  portalStory?: Maybe<PortalStory>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['timestamp']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  settings: EntityStorySettings;
  state: StoryStates_Enum;
  storyKey: Scalars['String']['output'];
  /** An array relationship */
  subjectStoryClaims: Array<SubjectStoryClaims>;
  /** An aggregate relationship */
  subjectStoryClaims_aggregate: SubjectStoryClaims_Aggregate;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailRelativePath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  visibility: StoryVisibilities_Enum;
};


/** columns and relationships of "stories" */
export type StoriesContentsArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


/** columns and relationships of "stories" */
export type StoriesContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


/** columns and relationships of "stories" */
export type StoriesCustomColorsArgs = {
  distinct_on?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCustomColors_Order_By>>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};


/** columns and relationships of "stories" */
export type StoriesCustomColors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCustomColors_Order_By>>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};


/** columns and relationships of "stories" */
export type StoriesEmbedsArgs = {
  distinct_on?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryEmbeds_Order_By>>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};


/** columns and relationships of "stories" */
export type StoriesEmbeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryEmbeds_Order_By>>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};


/** columns and relationships of "stories" */
export type StoriesSubjectStoryClaimsArgs = {
  distinct_on?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectStoryClaims_Order_By>>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};


/** columns and relationships of "stories" */
export type StoriesSubjectStoryClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectStoryClaims_Order_By>>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};

/** columns and relationships of "storiesCopyProcesses" */
export type StoriesCopyProcesses = {
  __typename?: 'storiesCopyProcesses';
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['time']['output']>;
  destinationFolderId: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: CopyProcessStatuses_Enum;
  /** An array relationship */
  storyCopyProcesses: Array<StoryCopyProcesses>;
  /** An aggregate relationship */
  storyCopyProcesses_aggregate: StoryCopyProcesses_Aggregate;
  suppressDisplayBanner: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['time']['output']>;
};


/** columns and relationships of "storiesCopyProcesses" */
export type StoriesCopyProcessesStoryCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};


/** columns and relationships of "storiesCopyProcesses" */
export type StoriesCopyProcessesStoryCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};

/** aggregated selection of "storiesCopyProcesses" */
export type StoriesCopyProcesses_Aggregate = {
  __typename?: 'storiesCopyProcesses_aggregate';
  aggregate?: Maybe<StoriesCopyProcesses_Aggregate_Fields>;
  nodes: Array<StoriesCopyProcesses>;
};

export type StoriesCopyProcesses_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<StoriesCopyProcesses_Aggregate_Bool_Exp_Count>;
};

export type StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_And = {
  arguments: StoriesCopyProcesses_Select_Column_StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_Or = {
  arguments: StoriesCopyProcesses_Select_Column_StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoriesCopyProcesses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storiesCopyProcesses" */
export type StoriesCopyProcesses_Aggregate_Fields = {
  __typename?: 'storiesCopyProcesses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoriesCopyProcesses_Max_Fields>;
  min?: Maybe<StoriesCopyProcesses_Min_Fields>;
};


/** aggregate fields of "storiesCopyProcesses" */
export type StoriesCopyProcesses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoriesCopyProcesses_Max_Order_By>;
  min?: InputMaybe<StoriesCopyProcesses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Arr_Rel_Insert_Input = {
  data: Array<StoriesCopyProcesses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoriesCopyProcesses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storiesCopyProcesses". All fields are combined with a logical 'AND'. */
export type StoriesCopyProcesses_Bool_Exp = {
  _and?: InputMaybe<Array<StoriesCopyProcesses_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
  _or?: InputMaybe<Array<StoriesCopyProcesses_Bool_Exp>>;
  createdAt?: InputMaybe<Time_Comparison_Exp>;
  destinationFolderId?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<CopyProcessStatuses_Enum_Comparison_Exp>;
  storyCopyProcesses?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
  storyCopyProcesses_aggregate?: InputMaybe<StoryCopyProcesses_Aggregate_Bool_Exp>;
  suppressDisplayBanner?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Time_Comparison_Exp>;
};

/** unique or primary key constraints on table "storiesCopyProcesses" */
export enum StoriesCopyProcesses_Constraint {
  /** unique or primary key constraint on columns "_id" */
  StoriesCopyProcessesIdKey = 'storiesCopyProcesses__id_key',
  /** unique or primary key constraint on columns "_id" */
  StoriesCopyProcessesPkey = 'storiesCopyProcesses_pkey'
}

/** input type for inserting data into table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['time']['input']>;
  destinationFolderId?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CopyProcessStatuses_Enum>;
  storyCopyProcesses?: InputMaybe<StoryCopyProcesses_Arr_Rel_Insert_Input>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate max on columns */
export type StoriesCopyProcesses_Max_Fields = {
  __typename?: 'storiesCopyProcesses_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  destinationFolderId?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Max_Order_By = {
  _id?: InputMaybe<Order_By>;
  destinationFolderId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoriesCopyProcesses_Min_Fields = {
  __typename?: 'storiesCopyProcesses_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  destinationFolderId?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Min_Order_By = {
  _id?: InputMaybe<Order_By>;
  destinationFolderId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Mutation_Response = {
  __typename?: 'storiesCopyProcesses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoriesCopyProcesses>;
};

/** input type for inserting object relation for remote table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Obj_Rel_Insert_Input = {
  data: StoriesCopyProcesses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StoriesCopyProcesses_On_Conflict>;
};

/** on_conflict condition type for table "storiesCopyProcesses" */
export type StoriesCopyProcesses_On_Conflict = {
  constraint: StoriesCopyProcesses_Constraint;
  update_columns?: Array<StoriesCopyProcesses_Update_Column>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};

/** Ordering options when selecting data from "storiesCopyProcesses". */
export type StoriesCopyProcesses_Order_By = {
  _id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  destinationFolderId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  storyCopyProcesses_aggregate?: InputMaybe<StoryCopyProcesses_Aggregate_Order_By>;
  suppressDisplayBanner?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storiesCopyProcesses */
export type StoriesCopyProcesses_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "storiesCopyProcesses" */
export enum StoriesCopyProcesses_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DestinationFolderId = 'destinationFolderId',
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "storiesCopyProcesses_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storiesCopyProcesses" */
export enum StoriesCopyProcesses_Select_Column_StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner'
}

/** select "storiesCopyProcesses_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storiesCopyProcesses" */
export enum StoriesCopyProcesses_Select_Column_StoriesCopyProcesses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner'
}

/** input type for updating data in table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['time']['input']>;
  destinationFolderId?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CopyProcessStatuses_Enum>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['time']['input']>;
};

/** Streaming cursor of the table "storiesCopyProcesses" */
export type StoriesCopyProcesses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoriesCopyProcesses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoriesCopyProcesses_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['time']['input']>;
  destinationFolderId?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CopyProcessStatuses_Enum>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['time']['input']>;
};

/** update columns of table "storiesCopyProcesses" */
export enum StoriesCopyProcesses_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DestinationFolderId = 'destinationFolderId',
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StoriesCopyProcesses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoriesCopyProcesses_Set_Input>;
  where: StoriesCopyProcesses_Bool_Exp;
};

/** aggregated selection of "stories" */
export type Stories_Aggregate = {
  __typename?: 'stories_aggregate';
  aggregate?: Maybe<Stories_Aggregate_Fields>;
  nodes: Array<Stories>;
};

export type Stories_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Stories_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Stories_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Stories_Aggregate_Bool_Exp_Count>;
};

export type Stories_Aggregate_Bool_Exp_Bool_And = {
  arguments: Stories_Select_Column_Stories_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stories_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Stories_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Stories_Select_Column_Stories_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stories_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Stories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Stories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "stories" */
export type Stories_Aggregate_Fields = {
  __typename?: 'stories_aggregate_fields';
  avg?: Maybe<Stories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Stories_Max_Fields>;
  min?: Maybe<Stories_Min_Fields>;
  stddev?: Maybe<Stories_Stddev_Fields>;
  stddev_pop?: Maybe<Stories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stories_Stddev_Samp_Fields>;
  sum?: Maybe<Stories_Sum_Fields>;
  var_pop?: Maybe<Stories_Var_Pop_Fields>;
  var_samp?: Maybe<Stories_Var_Samp_Fields>;
  variance?: Maybe<Stories_Variance_Fields>;
};


/** aggregate fields of "stories" */
export type Stories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "stories" */
export type Stories_Aggregate_Order_By = {
  avg?: InputMaybe<Stories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stories_Max_Order_By>;
  min?: InputMaybe<Stories_Min_Order_By>;
  stddev?: InputMaybe<Stories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stories_Sum_Order_By>;
  var_pop?: InputMaybe<Stories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stories_Var_Samp_Order_By>;
  variance?: InputMaybe<Stories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stories" */
export type Stories_Arr_Rel_Insert_Input = {
  data: Array<Stories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stories_On_Conflict>;
};

/** aggregate avg on columns */
export type Stories_Avg_Fields = {
  __typename?: 'stories_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "stories" */
export type Stories_Avg_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stories". All fields are combined with a logical 'AND'. */
export type Stories_Bool_Exp = {
  _and?: InputMaybe<Array<Stories_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Stories_Bool_Exp>;
  _or?: InputMaybe<Array<Stories_Bool_Exp>>;
  author?: InputMaybe<StoryUsers_Bool_Exp>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  contents?: InputMaybe<StoryContents_Bool_Exp>;
  contents_aggregate?: InputMaybe<StoryContents_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  customColors?: InputMaybe<StoryCustomColors_Bool_Exp>;
  customColors_aggregate?: InputMaybe<StoryCustomColors_Aggregate_Bool_Exp>;
  customCssCode?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  embeds?: InputMaybe<StoryEmbeds_Bool_Exp>;
  embeds_aggregate?: InputMaybe<StoryEmbeds_Aggregate_Bool_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  folder?: InputMaybe<StoryFolders_Bool_Exp>;
  folderId?: InputMaybe<Uuid_Comparison_Exp>;
  isFollowable?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  paddingBottom?: InputMaybe<Int_Comparison_Exp>;
  paddingTop?: InputMaybe<Int_Comparison_Exp>;
  portalStory?: InputMaybe<PortalStory_Bool_Exp>;
  publicUrl?: InputMaybe<String_Comparison_Exp>;
  publishedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  publishedBy?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<EntityStorySettings_Bool_Exp>;
  state?: InputMaybe<StoryStates_Enum_Comparison_Exp>;
  storyKey?: InputMaybe<String_Comparison_Exp>;
  subjectStoryClaims?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
  subjectStoryClaims_aggregate?: InputMaybe<SubjectStoryClaims_Aggregate_Bool_Exp>;
  thumbnail?: InputMaybe<String_Comparison_Exp>;
  thumbnailRelativePath?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  visibility?: InputMaybe<StoryVisibilities_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "stories" */
export enum Stories_Constraint {
  /** unique or primary key constraint on columns "_id" */
  StoriesPkey = 'stories_pkey'
}

/** input type for incrementing numeric columns in table "stories" */
export type Stories_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "stories" */
export type Stories_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<StoryContents_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<StoryCustomColors_Arr_Rel_Insert_Input>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeds?: InputMaybe<StoryEmbeds_Arr_Rel_Insert_Input>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<StoryFolders_Obj_Rel_Insert_Input>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  isFollowable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
  portalStory?: InputMaybe<PortalStory_Obj_Rel_Insert_Input>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamp']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<EntityStorySettings_Obj_Rel_Insert_Input>;
  state?: InputMaybe<StoryStates_Enum>;
  storyKey?: InputMaybe<Scalars['String']['input']>;
  subjectStoryClaims?: InputMaybe<SubjectStoryClaims_Arr_Rel_Insert_Input>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnailRelativePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<StoryVisibilities_Enum>;
};

/** aggregate max on columns */
export type Stories_Max_Fields = {
  __typename?: 'stories_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customCssCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  folderId?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['timestamp']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  storyKey?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailRelativePath?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "stories" */
export type Stories_Max_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customCssCode?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  folderId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
  publicUrl?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  publishedBy?: InputMaybe<Order_By>;
  storyKey?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  thumbnailRelativePath?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stories_Min_Fields = {
  __typename?: 'stories_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customCssCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  folderId?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['timestamp']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  storyKey?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailRelativePath?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "stories" */
export type Stories_Min_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customCssCode?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  folderId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
  publicUrl?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  publishedBy?: InputMaybe<Order_By>;
  storyKey?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  thumbnailRelativePath?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stories" */
export type Stories_Mutation_Response = {
  __typename?: 'stories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Stories>;
};

/** input type for inserting object relation for remote table "stories" */
export type Stories_Obj_Rel_Insert_Input = {
  data: Stories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stories_On_Conflict>;
};

/** on_conflict condition type for table "stories" */
export type Stories_On_Conflict = {
  constraint: Stories_Constraint;
  update_columns?: Array<Stories_Update_Column>;
  where?: InputMaybe<Stories_Bool_Exp>;
};

/** Ordering options when selecting data from "stories". */
export type Stories_Order_By = {
  _id?: InputMaybe<Order_By>;
  author?: InputMaybe<StoryUsers_Order_By>;
  authorId?: InputMaybe<Order_By>;
  contents_aggregate?: InputMaybe<StoryContents_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customColors_aggregate?: InputMaybe<StoryCustomColors_Aggregate_Order_By>;
  customCssCode?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  embeds_aggregate?: InputMaybe<StoryEmbeds_Aggregate_Order_By>;
  entityId?: InputMaybe<Order_By>;
  folder?: InputMaybe<StoryFolders_Order_By>;
  folderId?: InputMaybe<Order_By>;
  isFollowable?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
  portalStory?: InputMaybe<PortalStory_Order_By>;
  publicUrl?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  publishedBy?: InputMaybe<Order_By>;
  settings?: InputMaybe<EntityStorySettings_Order_By>;
  state?: InputMaybe<Order_By>;
  storyKey?: InputMaybe<Order_By>;
  subjectStoryClaims_aggregate?: InputMaybe<SubjectStoryClaims_Aggregate_Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  thumbnailRelativePath?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stories */
export type Stories_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "stories" */
export enum Stories_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomCssCode = 'customCssCode',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FolderId = 'folderId',
  /** column name */
  IsFollowable = 'isFollowable',
  /** column name */
  Order = 'order',
  /** column name */
  PaddingBottom = 'paddingBottom',
  /** column name */
  PaddingTop = 'paddingTop',
  /** column name */
  PublicUrl = 'publicUrl',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  PublishedBy = 'publishedBy',
  /** column name */
  State = 'state',
  /** column name */
  StoryKey = 'storyKey',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  ThumbnailRelativePath = 'thumbnailRelativePath',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Visibility = 'visibility'
}

/** select "stories_aggregate_bool_exp_bool_and_arguments_columns" columns of table "stories" */
export enum Stories_Select_Column_Stories_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsFollowable = 'isFollowable'
}

/** select "stories_aggregate_bool_exp_bool_or_arguments_columns" columns of table "stories" */
export enum Stories_Select_Column_Stories_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsFollowable = 'isFollowable'
}

/** input type for updating data in table "stories" */
export type Stories_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  isFollowable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamp']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StoryStates_Enum>;
  storyKey?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnailRelativePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<StoryVisibilities_Enum>;
};

/** aggregate stddev on columns */
export type Stories_Stddev_Fields = {
  __typename?: 'stories_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "stories" */
export type Stories_Stddev_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stories_Stddev_Pop_Fields = {
  __typename?: 'stories_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "stories" */
export type Stories_Stddev_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stories_Stddev_Samp_Fields = {
  __typename?: 'stories_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "stories" */
export type Stories_Stddev_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stories" */
export type Stories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stories_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['uuid']['input']>;
  isFollowable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamp']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StoryStates_Enum>;
  storyKey?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnailRelativePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<StoryVisibilities_Enum>;
};

/** aggregate sum on columns */
export type Stories_Sum_Fields = {
  __typename?: 'stories_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "stories" */
export type Stories_Sum_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** update columns of table "stories" */
export enum Stories_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomCssCode = 'customCssCode',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FolderId = 'folderId',
  /** column name */
  IsFollowable = 'isFollowable',
  /** column name */
  Order = 'order',
  /** column name */
  PaddingBottom = 'paddingBottom',
  /** column name */
  PaddingTop = 'paddingTop',
  /** column name */
  PublicUrl = 'publicUrl',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  PublishedBy = 'publishedBy',
  /** column name */
  State = 'state',
  /** column name */
  StoryKey = 'storyKey',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  ThumbnailRelativePath = 'thumbnailRelativePath',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Visibility = 'visibility'
}

export type Stories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stories_Set_Input>;
  where: Stories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stories_Var_Pop_Fields = {
  __typename?: 'stories_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "stories" */
export type Stories_Var_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stories_Var_Samp_Fields = {
  __typename?: 'stories_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "stories" */
export type Stories_Var_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stories_Variance_Fields = {
  __typename?: 'stories_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "stories" */
export type Stories_Variance_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** columns and relationships of "storyBudgetProposals" */
export type StoryBudgetProposals = {
  __typename?: 'storyBudgetProposals';
  budgetId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  proposalId: Scalars['Int']['output'];
  /** An object relationship */
  story: Stories;
  storyId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "storyBudgetProposals" */
export type StoryBudgetProposals_Aggregate = {
  __typename?: 'storyBudgetProposals_aggregate';
  aggregate?: Maybe<StoryBudgetProposals_Aggregate_Fields>;
  nodes: Array<StoryBudgetProposals>;
};

/** aggregate fields of "storyBudgetProposals" */
export type StoryBudgetProposals_Aggregate_Fields = {
  __typename?: 'storyBudgetProposals_aggregate_fields';
  avg?: Maybe<StoryBudgetProposals_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryBudgetProposals_Max_Fields>;
  min?: Maybe<StoryBudgetProposals_Min_Fields>;
  stddev?: Maybe<StoryBudgetProposals_Stddev_Fields>;
  stddev_pop?: Maybe<StoryBudgetProposals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryBudgetProposals_Stddev_Samp_Fields>;
  sum?: Maybe<StoryBudgetProposals_Sum_Fields>;
  var_pop?: Maybe<StoryBudgetProposals_Var_Pop_Fields>;
  var_samp?: Maybe<StoryBudgetProposals_Var_Samp_Fields>;
  variance?: Maybe<StoryBudgetProposals_Variance_Fields>;
};


/** aggregate fields of "storyBudgetProposals" */
export type StoryBudgetProposals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryBudgetProposals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type StoryBudgetProposals_Avg_Fields = {
  __typename?: 'storyBudgetProposals_avg_fields';
  budgetId?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storyBudgetProposals". All fields are combined with a logical 'AND'. */
export type StoryBudgetProposals_Bool_Exp = {
  _and?: InputMaybe<Array<StoryBudgetProposals_Bool_Exp>>;
  _not?: InputMaybe<StoryBudgetProposals_Bool_Exp>;
  _or?: InputMaybe<Array<StoryBudgetProposals_Bool_Exp>>;
  budgetId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  proposalId?: InputMaybe<Int_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyBudgetProposals" */
export enum StoryBudgetProposals_Constraint {
  /** unique or primary key constraint on columns "id" */
  StoryBudgetProposalsPkey = 'storyBudgetProposals_pkey'
}

/** input type for incrementing numeric columns in table "storyBudgetProposals" */
export type StoryBudgetProposals_Inc_Input = {
  budgetId?: InputMaybe<Scalars['Int']['input']>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyBudgetProposals" */
export type StoryBudgetProposals_Insert_Input = {
  budgetId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type StoryBudgetProposals_Max_Fields = {
  __typename?: 'storyBudgetProposals_max_fields';
  budgetId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type StoryBudgetProposals_Min_Fields = {
  __typename?: 'storyBudgetProposals_min_fields';
  budgetId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storyBudgetProposals" */
export type StoryBudgetProposals_Mutation_Response = {
  __typename?: 'storyBudgetProposals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryBudgetProposals>;
};

/** on_conflict condition type for table "storyBudgetProposals" */
export type StoryBudgetProposals_On_Conflict = {
  constraint: StoryBudgetProposals_Constraint;
  update_columns?: Array<StoryBudgetProposals_Update_Column>;
  where?: InputMaybe<StoryBudgetProposals_Bool_Exp>;
};

/** Ordering options when selecting data from "storyBudgetProposals". */
export type StoryBudgetProposals_Order_By = {
  budgetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  proposalId?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyBudgetProposals */
export type StoryBudgetProposals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "storyBudgetProposals" */
export enum StoryBudgetProposals_Select_Column {
  /** column name */
  BudgetId = 'budgetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProposalId = 'proposalId',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storyBudgetProposals" */
export type StoryBudgetProposals_Set_Input = {
  budgetId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type StoryBudgetProposals_Stddev_Fields = {
  __typename?: 'storyBudgetProposals_stddev_fields';
  budgetId?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type StoryBudgetProposals_Stddev_Pop_Fields = {
  __typename?: 'storyBudgetProposals_stddev_pop_fields';
  budgetId?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type StoryBudgetProposals_Stddev_Samp_Fields = {
  __typename?: 'storyBudgetProposals_stddev_samp_fields';
  budgetId?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "storyBudgetProposals" */
export type StoryBudgetProposals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryBudgetProposals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryBudgetProposals_Stream_Cursor_Value_Input = {
  budgetId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type StoryBudgetProposals_Sum_Fields = {
  __typename?: 'storyBudgetProposals_sum_fields';
  budgetId?: Maybe<Scalars['Int']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storyBudgetProposals" */
export enum StoryBudgetProposals_Update_Column {
  /** column name */
  BudgetId = 'budgetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProposalId = 'proposalId',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StoryBudgetProposals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryBudgetProposals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryBudgetProposals_Set_Input>;
  where: StoryBudgetProposals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryBudgetProposals_Var_Pop_Fields = {
  __typename?: 'storyBudgetProposals_var_pop_fields';
  budgetId?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type StoryBudgetProposals_Var_Samp_Fields = {
  __typename?: 'storyBudgetProposals_var_samp_fields';
  budgetId?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type StoryBudgetProposals_Variance_Fields = {
  __typename?: 'storyBudgetProposals_variance_fields';
  budgetId?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "storyContentBlockTypes" */
export type StoryContentBlockTypes = {
  __typename?: 'storyContentBlockTypes';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "storyContentBlockTypes" */
export type StoryContentBlockTypes_Aggregate = {
  __typename?: 'storyContentBlockTypes_aggregate';
  aggregate?: Maybe<StoryContentBlockTypes_Aggregate_Fields>;
  nodes: Array<StoryContentBlockTypes>;
};

/** aggregate fields of "storyContentBlockTypes" */
export type StoryContentBlockTypes_Aggregate_Fields = {
  __typename?: 'storyContentBlockTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryContentBlockTypes_Max_Fields>;
  min?: Maybe<StoryContentBlockTypes_Min_Fields>;
};


/** aggregate fields of "storyContentBlockTypes" */
export type StoryContentBlockTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryContentBlockTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "storyContentBlockTypes". All fields are combined with a logical 'AND'. */
export type StoryContentBlockTypes_Bool_Exp = {
  _and?: InputMaybe<Array<StoryContentBlockTypes_Bool_Exp>>;
  _not?: InputMaybe<StoryContentBlockTypes_Bool_Exp>;
  _or?: InputMaybe<Array<StoryContentBlockTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyContentBlockTypes" */
export enum StoryContentBlockTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  StoryContentBlockTypesPkey = 'storyContentBlockTypes_pkey'
}

export enum StoryContentBlockTypes_Enum {
  /** OpenGov Embeds */
  Embed = 'embed',
  /** Images */
  Image = 'image',
  /** Text */
  Text = 'text',
  /** Video */
  Video = 'video'
}

/** Boolean expression to compare columns of type "storyContentBlockTypes_enum". All fields are combined with logical 'AND'. */
export type StoryContentBlockTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<StoryContentBlockTypes_Enum>;
  _in?: InputMaybe<Array<StoryContentBlockTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<StoryContentBlockTypes_Enum>;
  _nin?: InputMaybe<Array<StoryContentBlockTypes_Enum>>;
};

/** input type for inserting data into table "storyContentBlockTypes" */
export type StoryContentBlockTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryContentBlockTypes_Max_Fields = {
  __typename?: 'storyContentBlockTypes_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type StoryContentBlockTypes_Min_Fields = {
  __typename?: 'storyContentBlockTypes_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storyContentBlockTypes" */
export type StoryContentBlockTypes_Mutation_Response = {
  __typename?: 'storyContentBlockTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryContentBlockTypes>;
};

/** on_conflict condition type for table "storyContentBlockTypes" */
export type StoryContentBlockTypes_On_Conflict = {
  constraint: StoryContentBlockTypes_Constraint;
  update_columns?: Array<StoryContentBlockTypes_Update_Column>;
  where?: InputMaybe<StoryContentBlockTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "storyContentBlockTypes". */
export type StoryContentBlockTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyContentBlockTypes */
export type StoryContentBlockTypes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "storyContentBlockTypes" */
export enum StoryContentBlockTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "storyContentBlockTypes" */
export type StoryContentBlockTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyContentBlockTypes" */
export type StoryContentBlockTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryContentBlockTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryContentBlockTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyContentBlockTypes" */
export enum StoryContentBlockTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type StoryContentBlockTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryContentBlockTypes_Set_Input>;
  where: StoryContentBlockTypes_Bool_Exp;
};

/** columns and relationships of "storyContentBlocks" */
export type StoryContentBlocks = {
  __typename?: 'storyContentBlocks';
  alt?: Maybe<Scalars['String']['output']>;
  creationParameters?: Maybe<Scalars['jsonb']['output']>;
  dataProviderId?: Maybe<Scalars['uuid']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  storyContent: StoryContents;
  storyContentId: Scalars['String']['output'];
  text_content?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StoryContentBlockTypes_Enum>;
  width?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "storyContentBlocks" */
export type StoryContentBlocksCreationParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storyContentBlocks" */
export type StoryContentBlocks_Aggregate = {
  __typename?: 'storyContentBlocks_aggregate';
  aggregate?: Maybe<StoryContentBlocks_Aggregate_Fields>;
  nodes: Array<StoryContentBlocks>;
};

export type StoryContentBlocks_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<StoryContentBlocks_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<StoryContentBlocks_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<StoryContentBlocks_Aggregate_Bool_Exp_Count>;
};

export type StoryContentBlocks_Aggregate_Bool_Exp_Bool_And = {
  arguments: StoryContentBlocks_Select_Column_StoryContentBlocks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryContentBlocks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryContentBlocks_Aggregate_Bool_Exp_Bool_Or = {
  arguments: StoryContentBlocks_Select_Column_StoryContentBlocks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryContentBlocks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryContentBlocks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryContentBlocks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyContentBlocks" */
export type StoryContentBlocks_Aggregate_Fields = {
  __typename?: 'storyContentBlocks_aggregate_fields';
  avg?: Maybe<StoryContentBlocks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryContentBlocks_Max_Fields>;
  min?: Maybe<StoryContentBlocks_Min_Fields>;
  stddev?: Maybe<StoryContentBlocks_Stddev_Fields>;
  stddev_pop?: Maybe<StoryContentBlocks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryContentBlocks_Stddev_Samp_Fields>;
  sum?: Maybe<StoryContentBlocks_Sum_Fields>;
  var_pop?: Maybe<StoryContentBlocks_Var_Pop_Fields>;
  var_samp?: Maybe<StoryContentBlocks_Var_Samp_Fields>;
  variance?: Maybe<StoryContentBlocks_Variance_Fields>;
};


/** aggregate fields of "storyContentBlocks" */
export type StoryContentBlocks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyContentBlocks" */
export type StoryContentBlocks_Aggregate_Order_By = {
  avg?: InputMaybe<StoryContentBlocks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryContentBlocks_Max_Order_By>;
  min?: InputMaybe<StoryContentBlocks_Min_Order_By>;
  stddev?: InputMaybe<StoryContentBlocks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<StoryContentBlocks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<StoryContentBlocks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<StoryContentBlocks_Sum_Order_By>;
  var_pop?: InputMaybe<StoryContentBlocks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<StoryContentBlocks_Var_Samp_Order_By>;
  variance?: InputMaybe<StoryContentBlocks_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type StoryContentBlocks_Append_Input = {
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storyContentBlocks" */
export type StoryContentBlocks_Arr_Rel_Insert_Input = {
  data: Array<StoryContentBlocks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryContentBlocks_On_Conflict>;
};

/** aggregate avg on columns */
export type StoryContentBlocks_Avg_Fields = {
  __typename?: 'storyContentBlocks_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storyContentBlocks". All fields are combined with a logical 'AND'. */
export type StoryContentBlocks_Bool_Exp = {
  _and?: InputMaybe<Array<StoryContentBlocks_Bool_Exp>>;
  _not?: InputMaybe<StoryContentBlocks_Bool_Exp>;
  _or?: InputMaybe<Array<StoryContentBlocks_Bool_Exp>>;
  alt?: InputMaybe<String_Comparison_Exp>;
  creationParameters?: InputMaybe<Jsonb_Comparison_Exp>;
  dataProviderId?: InputMaybe<Uuid_Comparison_Exp>;
  editable?: InputMaybe<Boolean_Comparison_Exp>;
  height?: InputMaybe<String_Comparison_Exp>;
  hyperlink?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  src?: InputMaybe<String_Comparison_Exp>;
  storyContent?: InputMaybe<StoryContents_Bool_Exp>;
  storyContentId?: InputMaybe<String_Comparison_Exp>;
  text_content?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<StoryContentBlockTypes_Enum_Comparison_Exp>;
  width?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyContentBlocks" */
export enum StoryContentBlocks_Constraint {
  /** unique or primary key constraint on columns "id" */
  StoryContentBlocksPkey = 'storyContentBlocks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type StoryContentBlocks_Delete_At_Path_Input = {
  creationParameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type StoryContentBlocks_Delete_Elem_Input = {
  creationParameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type StoryContentBlocks_Delete_Key_Input = {
  creationParameters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storyContentBlocks" */
export type StoryContentBlocks_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyContentBlocks" */
export type StoryContentBlocks_Insert_Input = {
  alt?: InputMaybe<Scalars['String']['input']>;
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
  dataProviderId?: InputMaybe<Scalars['uuid']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  storyContent?: InputMaybe<StoryContents_Obj_Rel_Insert_Input>;
  storyContentId?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentBlockTypes_Enum>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryContentBlocks_Max_Fields = {
  __typename?: 'storyContentBlocks_max_fields';
  alt?: Maybe<Scalars['String']['output']>;
  dataProviderId?: Maybe<Scalars['uuid']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  storyContentId?: Maybe<Scalars['String']['output']>;
  text_content?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Max_Order_By = {
  alt?: InputMaybe<Order_By>;
  dataProviderId?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hyperlink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  src?: InputMaybe<Order_By>;
  storyContentId?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryContentBlocks_Min_Fields = {
  __typename?: 'storyContentBlocks_min_fields';
  alt?: Maybe<Scalars['String']['output']>;
  dataProviderId?: Maybe<Scalars['uuid']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  storyContentId?: Maybe<Scalars['String']['output']>;
  text_content?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Min_Order_By = {
  alt?: InputMaybe<Order_By>;
  dataProviderId?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hyperlink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  src?: InputMaybe<Order_By>;
  storyContentId?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyContentBlocks" */
export type StoryContentBlocks_Mutation_Response = {
  __typename?: 'storyContentBlocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryContentBlocks>;
};

/** on_conflict condition type for table "storyContentBlocks" */
export type StoryContentBlocks_On_Conflict = {
  constraint: StoryContentBlocks_Constraint;
  update_columns?: Array<StoryContentBlocks_Update_Column>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};

/** Ordering options when selecting data from "storyContentBlocks". */
export type StoryContentBlocks_Order_By = {
  alt?: InputMaybe<Order_By>;
  creationParameters?: InputMaybe<Order_By>;
  dataProviderId?: InputMaybe<Order_By>;
  editable?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hyperlink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  src?: InputMaybe<Order_By>;
  storyContent?: InputMaybe<StoryContents_Order_By>;
  storyContentId?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyContentBlocks */
export type StoryContentBlocks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type StoryContentBlocks_Prepend_Input = {
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storyContentBlocks" */
export enum StoryContentBlocks_Select_Column {
  /** column name */
  Alt = 'alt',
  /** column name */
  CreationParameters = 'creationParameters',
  /** column name */
  DataProviderId = 'dataProviderId',
  /** column name */
  Editable = 'editable',
  /** column name */
  Height = 'height',
  /** column name */
  Hyperlink = 'hyperlink',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Src = 'src',
  /** column name */
  StoryContentId = 'storyContentId',
  /** column name */
  TextContent = 'text_content',
  /** column name */
  Type = 'type',
  /** column name */
  Width = 'width'
}

/** select "storyContentBlocks_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storyContentBlocks" */
export enum StoryContentBlocks_Select_Column_StoryContentBlocks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Editable = 'editable'
}

/** select "storyContentBlocks_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storyContentBlocks" */
export enum StoryContentBlocks_Select_Column_StoryContentBlocks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Editable = 'editable'
}

/** input type for updating data in table "storyContentBlocks" */
export type StoryContentBlocks_Set_Input = {
  alt?: InputMaybe<Scalars['String']['input']>;
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
  dataProviderId?: InputMaybe<Scalars['uuid']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  storyContentId?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentBlockTypes_Enum>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type StoryContentBlocks_Stddev_Fields = {
  __typename?: 'storyContentBlocks_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type StoryContentBlocks_Stddev_Pop_Fields = {
  __typename?: 'storyContentBlocks_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type StoryContentBlocks_Stddev_Samp_Fields = {
  __typename?: 'storyContentBlocks_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storyContentBlocks" */
export type StoryContentBlocks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryContentBlocks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryContentBlocks_Stream_Cursor_Value_Input = {
  alt?: InputMaybe<Scalars['String']['input']>;
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
  dataProviderId?: InputMaybe<Scalars['uuid']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  storyContentId?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentBlockTypes_Enum>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type StoryContentBlocks_Sum_Fields = {
  __typename?: 'storyContentBlocks_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "storyContentBlocks" */
export enum StoryContentBlocks_Update_Column {
  /** column name */
  Alt = 'alt',
  /** column name */
  CreationParameters = 'creationParameters',
  /** column name */
  DataProviderId = 'dataProviderId',
  /** column name */
  Editable = 'editable',
  /** column name */
  Height = 'height',
  /** column name */
  Hyperlink = 'hyperlink',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Src = 'src',
  /** column name */
  StoryContentId = 'storyContentId',
  /** column name */
  TextContent = 'text_content',
  /** column name */
  Type = 'type',
  /** column name */
  Width = 'width'
}

export type StoryContentBlocks_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<StoryContentBlocks_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<StoryContentBlocks_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<StoryContentBlocks_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<StoryContentBlocks_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryContentBlocks_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<StoryContentBlocks_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryContentBlocks_Set_Input>;
  where: StoryContentBlocks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryContentBlocks_Var_Pop_Fields = {
  __typename?: 'storyContentBlocks_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type StoryContentBlocks_Var_Samp_Fields = {
  __typename?: 'storyContentBlocks_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type StoryContentBlocks_Variance_Fields = {
  __typename?: 'storyContentBlocks_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storyContentBlocks" */
export type StoryContentBlocks_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Story Content Color Targets, such as background or font */
export type StoryContentColorTargets = {
  __typename?: 'storyContentColorTargets';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "storyContentColorTargets" */
export type StoryContentColorTargets_Aggregate = {
  __typename?: 'storyContentColorTargets_aggregate';
  aggregate?: Maybe<StoryContentColorTargets_Aggregate_Fields>;
  nodes: Array<StoryContentColorTargets>;
};

/** aggregate fields of "storyContentColorTargets" */
export type StoryContentColorTargets_Aggregate_Fields = {
  __typename?: 'storyContentColorTargets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryContentColorTargets_Max_Fields>;
  min?: Maybe<StoryContentColorTargets_Min_Fields>;
};


/** aggregate fields of "storyContentColorTargets" */
export type StoryContentColorTargets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryContentColorTargets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "storyContentColorTargets". All fields are combined with a logical 'AND'. */
export type StoryContentColorTargets_Bool_Exp = {
  _and?: InputMaybe<Array<StoryContentColorTargets_Bool_Exp>>;
  _not?: InputMaybe<StoryContentColorTargets_Bool_Exp>;
  _or?: InputMaybe<Array<StoryContentColorTargets_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyContentColorTargets" */
export enum StoryContentColorTargets_Constraint {
  /** unique or primary key constraint on columns "value" */
  EntityStoryContentSubElementTypesPkey = 'entityStoryContentSubElementTypes_pkey'
}

export enum StoryContentColorTargets_Enum {
  /** The Background */
  Background = 'background',
  /** The Font */
  Font = 'font'
}

/** Boolean expression to compare columns of type "storyContentColorTargets_enum". All fields are combined with logical 'AND'. */
export type StoryContentColorTargets_Enum_Comparison_Exp = {
  _eq?: InputMaybe<StoryContentColorTargets_Enum>;
  _in?: InputMaybe<Array<StoryContentColorTargets_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<StoryContentColorTargets_Enum>;
  _nin?: InputMaybe<Array<StoryContentColorTargets_Enum>>;
};

/** input type for inserting data into table "storyContentColorTargets" */
export type StoryContentColorTargets_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryContentColorTargets_Max_Fields = {
  __typename?: 'storyContentColorTargets_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type StoryContentColorTargets_Min_Fields = {
  __typename?: 'storyContentColorTargets_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storyContentColorTargets" */
export type StoryContentColorTargets_Mutation_Response = {
  __typename?: 'storyContentColorTargets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryContentColorTargets>;
};

/** on_conflict condition type for table "storyContentColorTargets" */
export type StoryContentColorTargets_On_Conflict = {
  constraint: StoryContentColorTargets_Constraint;
  update_columns?: Array<StoryContentColorTargets_Update_Column>;
  where?: InputMaybe<StoryContentColorTargets_Bool_Exp>;
};

/** Ordering options when selecting data from "storyContentColorTargets". */
export type StoryContentColorTargets_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyContentColorTargets */
export type StoryContentColorTargets_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "storyContentColorTargets" */
export enum StoryContentColorTargets_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "storyContentColorTargets" */
export type StoryContentColorTargets_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyContentColorTargets" */
export type StoryContentColorTargets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryContentColorTargets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryContentColorTargets_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyContentColorTargets" */
export enum StoryContentColorTargets_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type StoryContentColorTargets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryContentColorTargets_Set_Input>;
  where: StoryContentColorTargets_Bool_Exp;
};

/** columns and relationships of "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences = {
  __typename?: 'storyContentSpreadsheetReferences';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  namedRangeId: Scalars['uuid']['output'];
  spreadsheetId: Scalars['uuid']['output'];
  /** An object relationship */
  spreadsheetNamedRange?: Maybe<SpreadsheetNamedRanges>;
  /** An object relationship */
  storyContent: StoryContents;
  storyContentId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Aggregate = {
  __typename?: 'storyContentSpreadsheetReferences_aggregate';
  aggregate?: Maybe<StoryContentSpreadsheetReferences_Aggregate_Fields>;
  nodes: Array<StoryContentSpreadsheetReferences>;
};

export type StoryContentSpreadsheetReferences_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryContentSpreadsheetReferences_Aggregate_Bool_Exp_Count>;
};

export type StoryContentSpreadsheetReferences_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Aggregate_Fields = {
  __typename?: 'storyContentSpreadsheetReferences_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryContentSpreadsheetReferences_Max_Fields>;
  min?: Maybe<StoryContentSpreadsheetReferences_Min_Fields>;
};


/** aggregate fields of "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryContentSpreadsheetReferences_Max_Order_By>;
  min?: InputMaybe<StoryContentSpreadsheetReferences_Min_Order_By>;
};

/** input type for inserting array relation for remote table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Arr_Rel_Insert_Input = {
  data: Array<StoryContentSpreadsheetReferences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryContentSpreadsheetReferences_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storyContentSpreadsheetReferences". All fields are combined with a logical 'AND'. */
export type StoryContentSpreadsheetReferences_Bool_Exp = {
  _and?: InputMaybe<Array<StoryContentSpreadsheetReferences_Bool_Exp>>;
  _not?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
  _or?: InputMaybe<Array<StoryContentSpreadsheetReferences_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  namedRangeId?: InputMaybe<Uuid_Comparison_Exp>;
  spreadsheetId?: InputMaybe<Uuid_Comparison_Exp>;
  spreadsheetNamedRange?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
  storyContent?: InputMaybe<StoryContents_Bool_Exp>;
  storyContentId?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyContentSpreadsheetReferences" */
export enum StoryContentSpreadsheetReferences_Constraint {
  /** unique or primary key constraint on columns "id" */
  StoryContentSpreadsheetReferencesPkey = 'storyContentSpreadsheetReferences_pkey'
}

/** input type for inserting data into table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  namedRangeId?: InputMaybe<Scalars['uuid']['input']>;
  spreadsheetId?: InputMaybe<Scalars['uuid']['input']>;
  spreadsheetNamedRange?: InputMaybe<SpreadsheetNamedRanges_Obj_Rel_Insert_Input>;
  storyContent?: InputMaybe<StoryContents_Obj_Rel_Insert_Input>;
  storyContentId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type StoryContentSpreadsheetReferences_Max_Fields = {
  __typename?: 'storyContentSpreadsheetReferences_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  namedRangeId?: Maybe<Scalars['uuid']['output']>;
  spreadsheetId?: Maybe<Scalars['uuid']['output']>;
  storyContentId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  namedRangeId?: InputMaybe<Order_By>;
  spreadsheetId?: InputMaybe<Order_By>;
  storyContentId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryContentSpreadsheetReferences_Min_Fields = {
  __typename?: 'storyContentSpreadsheetReferences_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  namedRangeId?: Maybe<Scalars['uuid']['output']>;
  spreadsheetId?: Maybe<Scalars['uuid']['output']>;
  storyContentId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  namedRangeId?: InputMaybe<Order_By>;
  spreadsheetId?: InputMaybe<Order_By>;
  storyContentId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Mutation_Response = {
  __typename?: 'storyContentSpreadsheetReferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryContentSpreadsheetReferences>;
};

/** on_conflict condition type for table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_On_Conflict = {
  constraint: StoryContentSpreadsheetReferences_Constraint;
  update_columns?: Array<StoryContentSpreadsheetReferences_Update_Column>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};

/** Ordering options when selecting data from "storyContentSpreadsheetReferences". */
export type StoryContentSpreadsheetReferences_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  namedRangeId?: InputMaybe<Order_By>;
  spreadsheetId?: InputMaybe<Order_By>;
  spreadsheetNamedRange?: InputMaybe<SpreadsheetNamedRanges_Order_By>;
  storyContent?: InputMaybe<StoryContents_Order_By>;
  storyContentId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyContentSpreadsheetReferences */
export type StoryContentSpreadsheetReferences_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "storyContentSpreadsheetReferences" */
export enum StoryContentSpreadsheetReferences_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NamedRangeId = 'namedRangeId',
  /** column name */
  SpreadsheetId = 'spreadsheetId',
  /** column name */
  StoryContentId = 'storyContentId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  namedRangeId?: InputMaybe<Scalars['uuid']['input']>;
  spreadsheetId?: InputMaybe<Scalars['uuid']['input']>;
  storyContentId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "storyContentSpreadsheetReferences" */
export type StoryContentSpreadsheetReferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryContentSpreadsheetReferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryContentSpreadsheetReferences_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  namedRangeId?: InputMaybe<Scalars['uuid']['input']>;
  spreadsheetId?: InputMaybe<Scalars['uuid']['input']>;
  storyContentId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "storyContentSpreadsheetReferences" */
export enum StoryContentSpreadsheetReferences_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NamedRangeId = 'namedRangeId',
  /** column name */
  SpreadsheetId = 'spreadsheetId',
  /** column name */
  StoryContentId = 'storyContentId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StoryContentSpreadsheetReferences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryContentSpreadsheetReferences_Set_Input>;
  where: StoryContentSpreadsheetReferences_Bool_Exp;
};

/** Story Content Types, such as header and footer */
export type StoryContentTypes = {
  __typename?: 'storyContentTypes';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "storyContentTypes" */
export type StoryContentTypes_Aggregate = {
  __typename?: 'storyContentTypes_aggregate';
  aggregate?: Maybe<StoryContentTypes_Aggregate_Fields>;
  nodes: Array<StoryContentTypes>;
};

/** aggregate fields of "storyContentTypes" */
export type StoryContentTypes_Aggregate_Fields = {
  __typename?: 'storyContentTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryContentTypes_Max_Fields>;
  min?: Maybe<StoryContentTypes_Min_Fields>;
};


/** aggregate fields of "storyContentTypes" */
export type StoryContentTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryContentTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "storyContentTypes". All fields are combined with a logical 'AND'. */
export type StoryContentTypes_Bool_Exp = {
  _and?: InputMaybe<Array<StoryContentTypes_Bool_Exp>>;
  _not?: InputMaybe<StoryContentTypes_Bool_Exp>;
  _or?: InputMaybe<Array<StoryContentTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyContentTypes" */
export enum StoryContentTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  StoryContentBlockTypessPkey = 'storyContentBlockTypess_pkey'
}

export enum StoryContentTypes_Enum {
  /** A Story Body Section */
  BodyContent = 'body_content',
  /** A Story Footer */
  Footer = 'footer',
  /** A Story Header Section */
  Header = 'header'
}

/** Boolean expression to compare columns of type "storyContentTypes_enum". All fields are combined with logical 'AND'. */
export type StoryContentTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<StoryContentTypes_Enum>;
  _in?: InputMaybe<Array<StoryContentTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<StoryContentTypes_Enum>;
  _nin?: InputMaybe<Array<StoryContentTypes_Enum>>;
};

/** input type for inserting data into table "storyContentTypes" */
export type StoryContentTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryContentTypes_Max_Fields = {
  __typename?: 'storyContentTypes_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type StoryContentTypes_Min_Fields = {
  __typename?: 'storyContentTypes_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storyContentTypes" */
export type StoryContentTypes_Mutation_Response = {
  __typename?: 'storyContentTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryContentTypes>;
};

/** on_conflict condition type for table "storyContentTypes" */
export type StoryContentTypes_On_Conflict = {
  constraint: StoryContentTypes_Constraint;
  update_columns?: Array<StoryContentTypes_Update_Column>;
  where?: InputMaybe<StoryContentTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "storyContentTypes". */
export type StoryContentTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyContentTypes */
export type StoryContentTypes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "storyContentTypes" */
export enum StoryContentTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "storyContentTypes" */
export type StoryContentTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyContentTypes" */
export type StoryContentTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryContentTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryContentTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyContentTypes" */
export enum StoryContentTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type StoryContentTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryContentTypes_Set_Input>;
  where: StoryContentTypes_Bool_Exp;
};

/** columns and relationships of "storyContents" */
export type StoryContents = {
  __typename?: 'storyContents';
  _id: Scalars['String']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  author: StoryUsers;
  authorId: Scalars['String']['output'];
  /** An array relationship */
  blocks: Array<StoryContentBlocks>;
  /** An aggregate relationship */
  blocks_aggregate: StoryContentBlocks_Aggregate;
  content: Scalars['String']['output'];
  /** An array relationship */
  contentChartConfig: Array<ChartsConfig>;
  /** An aggregate relationship */
  contentChartConfig_aggregate: ChartsConfig_Aggregate;
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  format?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  /** An object relationship */
  story: Stories;
  storyId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: StoryContentTypes_Enum;
  updatedAt: Scalars['timestamp']['output'];
};


/** columns and relationships of "storyContents" */
export type StoryContentsBlocksArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlocks_Order_By>>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};


/** columns and relationships of "storyContents" */
export type StoryContentsBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlocks_Order_By>>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};


/** columns and relationships of "storyContents" */
export type StoryContentsContentChartConfigArgs = {
  distinct_on?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChartsConfig_Order_By>>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};


/** columns and relationships of "storyContents" */
export type StoryContentsContentChartConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChartsConfig_Order_By>>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};

/** aggregated selection of "storyContents" */
export type StoryContents_Aggregate = {
  __typename?: 'storyContents_aggregate';
  aggregate?: Maybe<StoryContents_Aggregate_Fields>;
  nodes: Array<StoryContents>;
};

export type StoryContents_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<StoryContents_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<StoryContents_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<StoryContents_Aggregate_Bool_Exp_Count>;
};

export type StoryContents_Aggregate_Bool_Exp_Bool_And = {
  arguments: StoryContents_Select_Column_StoryContents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryContents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryContents_Aggregate_Bool_Exp_Bool_Or = {
  arguments: StoryContents_Select_Column_StoryContents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryContents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryContents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryContents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryContents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyContents" */
export type StoryContents_Aggregate_Fields = {
  __typename?: 'storyContents_aggregate_fields';
  avg?: Maybe<StoryContents_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryContents_Max_Fields>;
  min?: Maybe<StoryContents_Min_Fields>;
  stddev?: Maybe<StoryContents_Stddev_Fields>;
  stddev_pop?: Maybe<StoryContents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryContents_Stddev_Samp_Fields>;
  sum?: Maybe<StoryContents_Sum_Fields>;
  var_pop?: Maybe<StoryContents_Var_Pop_Fields>;
  var_samp?: Maybe<StoryContents_Var_Samp_Fields>;
  variance?: Maybe<StoryContents_Variance_Fields>;
};


/** aggregate fields of "storyContents" */
export type StoryContents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryContents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyContents" */
export type StoryContents_Aggregate_Order_By = {
  avg?: InputMaybe<StoryContents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryContents_Max_Order_By>;
  min?: InputMaybe<StoryContents_Min_Order_By>;
  stddev?: InputMaybe<StoryContents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<StoryContents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<StoryContents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<StoryContents_Sum_Order_By>;
  var_pop?: InputMaybe<StoryContents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<StoryContents_Var_Samp_Order_By>;
  variance?: InputMaybe<StoryContents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "storyContents" */
export type StoryContents_Arr_Rel_Insert_Input = {
  data: Array<StoryContents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryContents_On_Conflict>;
};

/** aggregate avg on columns */
export type StoryContents_Avg_Fields = {
  __typename?: 'storyContents_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storyContents" */
export type StoryContents_Avg_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storyContents". All fields are combined with a logical 'AND'. */
export type StoryContents_Bool_Exp = {
  _and?: InputMaybe<Array<StoryContents_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<StoryContents_Bool_Exp>;
  _or?: InputMaybe<Array<StoryContents_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  author?: InputMaybe<StoryUsers_Bool_Exp>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  blocks?: InputMaybe<StoryContentBlocks_Bool_Exp>;
  blocks_aggregate?: InputMaybe<StoryContentBlocks_Aggregate_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  contentChartConfig?: InputMaybe<ChartsConfig_Bool_Exp>;
  contentChartConfig_aggregate?: InputMaybe<ChartsConfig_Aggregate_Bool_Exp>;
  contentHtml?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  format?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  layout?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<StoryContentTypes_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyContents" */
export enum StoryContents_Constraint {
  /** unique or primary key constraint on columns "_id" */
  StoryContentsPkey = 'storyContents_pkey'
}

/** input type for incrementing numeric columns in table "storyContents" */
export type StoryContents_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyContents" */
export type StoryContents_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  blocks?: InputMaybe<StoryContentBlocks_Arr_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentChartConfig?: InputMaybe<ChartsConfig_Arr_Rel_Insert_Input>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentTypes_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type StoryContents_Max_Fields = {
  __typename?: 'storyContents_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "storyContents" */
export type StoryContents_Max_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  contentHtml?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  layout?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryContents_Min_Fields = {
  __typename?: 'storyContents_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "storyContents" */
export type StoryContents_Min_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  contentHtml?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  layout?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyContents" */
export type StoryContents_Mutation_Response = {
  __typename?: 'storyContents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryContents>;
};

/** input type for inserting object relation for remote table "storyContents" */
export type StoryContents_Obj_Rel_Insert_Input = {
  data: StoryContents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryContents_On_Conflict>;
};

/** on_conflict condition type for table "storyContents" */
export type StoryContents_On_Conflict = {
  constraint: StoryContents_Constraint;
  update_columns?: Array<StoryContents_Update_Column>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};

/** Ordering options when selecting data from "storyContents". */
export type StoryContents_Order_By = {
  _id?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  author?: InputMaybe<StoryUsers_Order_By>;
  authorId?: InputMaybe<Order_By>;
  blocks_aggregate?: InputMaybe<StoryContentBlocks_Aggregate_Order_By>;
  content?: InputMaybe<Order_By>;
  contentChartConfig_aggregate?: InputMaybe<ChartsConfig_Aggregate_Order_By>;
  contentHtml?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  layout?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyContents */
export type StoryContents_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "storyContents" */
export enum StoryContents_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  Active = 'active',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Content = 'content',
  /** column name */
  ContentHtml = 'contentHtml',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Format = 'format',
  /** column name */
  Group = 'group',
  /** column name */
  Layout = 'layout',
  /** column name */
  Order = 'order',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "storyContents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storyContents" */
export enum StoryContents_Select_Column_StoryContents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "storyContents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storyContents" */
export enum StoryContents_Select_Column_StoryContents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "storyContents" */
export type StoryContents_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentTypes_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type StoryContents_Stddev_Fields = {
  __typename?: 'storyContents_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storyContents" */
export type StoryContents_Stddev_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type StoryContents_Stddev_Pop_Fields = {
  __typename?: 'storyContents_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storyContents" */
export type StoryContents_Stddev_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type StoryContents_Stddev_Samp_Fields = {
  __typename?: 'storyContents_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storyContents" */
export type StoryContents_Stddev_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storyContents" */
export type StoryContents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryContents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryContents_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentTypes_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type StoryContents_Sum_Fields = {
  __typename?: 'storyContents_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storyContents" */
export type StoryContents_Sum_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "storyContents" */
export enum StoryContents_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  Active = 'active',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Content = 'content',
  /** column name */
  ContentHtml = 'contentHtml',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Format = 'format',
  /** column name */
  Group = 'group',
  /** column name */
  Layout = 'layout',
  /** column name */
  Order = 'order',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StoryContents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryContents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryContents_Set_Input>;
  where: StoryContents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryContents_Var_Pop_Fields = {
  __typename?: 'storyContents_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storyContents" */
export type StoryContents_Var_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type StoryContents_Var_Samp_Fields = {
  __typename?: 'storyContents_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storyContents" */
export type StoryContents_Var_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type StoryContents_Variance_Fields = {
  __typename?: 'storyContents_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storyContents" */
export type StoryContents_Variance_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "storyCopyProcesses" */
export type StoryCopyProcesses = {
  __typename?: 'storyCopyProcesses';
  _id: Scalars['String']['output'];
  /** An object relationship */
  copyProcess?: Maybe<StoriesCopyProcesses>;
  copyProcessId: Scalars['String']['output'];
  /** An object relationship */
  storyCopy?: Maybe<Stories>;
  storyCopyId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  storySource?: Maybe<Stories>;
  storySourceId: Scalars['String']['output'];
};

/** aggregated selection of "storyCopyProcesses" */
export type StoryCopyProcesses_Aggregate = {
  __typename?: 'storyCopyProcesses_aggregate';
  aggregate?: Maybe<StoryCopyProcesses_Aggregate_Fields>;
  nodes: Array<StoryCopyProcesses>;
};

export type StoryCopyProcesses_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryCopyProcesses_Aggregate_Bool_Exp_Count>;
};

export type StoryCopyProcesses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyCopyProcesses" */
export type StoryCopyProcesses_Aggregate_Fields = {
  __typename?: 'storyCopyProcesses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryCopyProcesses_Max_Fields>;
  min?: Maybe<StoryCopyProcesses_Min_Fields>;
};


/** aggregate fields of "storyCopyProcesses" */
export type StoryCopyProcesses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyCopyProcesses" */
export type StoryCopyProcesses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryCopyProcesses_Max_Order_By>;
  min?: InputMaybe<StoryCopyProcesses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "storyCopyProcesses" */
export type StoryCopyProcesses_Arr_Rel_Insert_Input = {
  data: Array<StoryCopyProcesses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryCopyProcesses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storyCopyProcesses". All fields are combined with a logical 'AND'. */
export type StoryCopyProcesses_Bool_Exp = {
  _and?: InputMaybe<Array<StoryCopyProcesses_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
  _or?: InputMaybe<Array<StoryCopyProcesses_Bool_Exp>>;
  copyProcess?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
  copyProcessId?: InputMaybe<String_Comparison_Exp>;
  storyCopy?: InputMaybe<Stories_Bool_Exp>;
  storyCopyId?: InputMaybe<String_Comparison_Exp>;
  storySource?: InputMaybe<Stories_Bool_Exp>;
  storySourceId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyCopyProcesses" */
export enum StoryCopyProcesses_Constraint {
  /** unique or primary key constraint on columns "_id" */
  StoryCopyProcessesPkey = 'storyCopyProcesses_pkey',
  /** unique or primary key constraint on columns "storyCopyId" */
  StoryCopyProcessesStoryCopyIdKey = 'storyCopyProcesses_storyCopyId_key'
}

/** input type for inserting data into table "storyCopyProcesses" */
export type StoryCopyProcesses_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  copyProcess?: InputMaybe<StoriesCopyProcesses_Obj_Rel_Insert_Input>;
  copyProcessId?: InputMaybe<Scalars['String']['input']>;
  storyCopy?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyCopyId?: InputMaybe<Scalars['String']['input']>;
  storySource?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storySourceId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryCopyProcesses_Max_Fields = {
  __typename?: 'storyCopyProcesses_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  copyProcessId?: Maybe<Scalars['String']['output']>;
  storyCopyId?: Maybe<Scalars['String']['output']>;
  storySourceId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyCopyProcesses" */
export type StoryCopyProcesses_Max_Order_By = {
  _id?: InputMaybe<Order_By>;
  copyProcessId?: InputMaybe<Order_By>;
  storyCopyId?: InputMaybe<Order_By>;
  storySourceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryCopyProcesses_Min_Fields = {
  __typename?: 'storyCopyProcesses_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  copyProcessId?: Maybe<Scalars['String']['output']>;
  storyCopyId?: Maybe<Scalars['String']['output']>;
  storySourceId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyCopyProcesses" */
export type StoryCopyProcesses_Min_Order_By = {
  _id?: InputMaybe<Order_By>;
  copyProcessId?: InputMaybe<Order_By>;
  storyCopyId?: InputMaybe<Order_By>;
  storySourceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyCopyProcesses" */
export type StoryCopyProcesses_Mutation_Response = {
  __typename?: 'storyCopyProcesses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryCopyProcesses>;
};

/** on_conflict condition type for table "storyCopyProcesses" */
export type StoryCopyProcesses_On_Conflict = {
  constraint: StoryCopyProcesses_Constraint;
  update_columns?: Array<StoryCopyProcesses_Update_Column>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};

/** Ordering options when selecting data from "storyCopyProcesses". */
export type StoryCopyProcesses_Order_By = {
  _id?: InputMaybe<Order_By>;
  copyProcess?: InputMaybe<StoriesCopyProcesses_Order_By>;
  copyProcessId?: InputMaybe<Order_By>;
  storyCopy?: InputMaybe<Stories_Order_By>;
  storyCopyId?: InputMaybe<Order_By>;
  storySource?: InputMaybe<Stories_Order_By>;
  storySourceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyCopyProcesses */
export type StoryCopyProcesses_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "storyCopyProcesses" */
export enum StoryCopyProcesses_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  CopyProcessId = 'copyProcessId',
  /** column name */
  StoryCopyId = 'storyCopyId',
  /** column name */
  StorySourceId = 'storySourceId'
}

/** input type for updating data in table "storyCopyProcesses" */
export type StoryCopyProcesses_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  copyProcessId?: InputMaybe<Scalars['String']['input']>;
  storyCopyId?: InputMaybe<Scalars['String']['input']>;
  storySourceId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyCopyProcesses" */
export type StoryCopyProcesses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryCopyProcesses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryCopyProcesses_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  copyProcessId?: InputMaybe<Scalars['String']['input']>;
  storyCopyId?: InputMaybe<Scalars['String']['input']>;
  storySourceId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyCopyProcesses" */
export enum StoryCopyProcesses_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  CopyProcessId = 'copyProcessId',
  /** column name */
  StoryCopyId = 'storyCopyId',
  /** column name */
  StorySourceId = 'storySourceId'
}

export type StoryCopyProcesses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryCopyProcesses_Set_Input>;
  where: StoryCopyProcesses_Bool_Exp;
};

/** columns and relationships of "storyCustomColors" */
export type StoryCustomColors = {
  __typename?: 'storyCustomColors';
  colorTarget: StoryContentColorTargets_Enum;
  /** An array of hex color strings e.g. #143a90 */
  colors: Scalars['jsonb']['output'];
  contentType: StoryContentTypes_Enum;
  /** An object relationship */
  story: Stories;
  storyId: Scalars['String']['output'];
};


/** columns and relationships of "storyCustomColors" */
export type StoryCustomColorsColorsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storyCustomColors" */
export type StoryCustomColors_Aggregate = {
  __typename?: 'storyCustomColors_aggregate';
  aggregate?: Maybe<StoryCustomColors_Aggregate_Fields>;
  nodes: Array<StoryCustomColors>;
};

export type StoryCustomColors_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryCustomColors_Aggregate_Bool_Exp_Count>;
};

export type StoryCustomColors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryCustomColors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyCustomColors" */
export type StoryCustomColors_Aggregate_Fields = {
  __typename?: 'storyCustomColors_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryCustomColors_Max_Fields>;
  min?: Maybe<StoryCustomColors_Min_Fields>;
};


/** aggregate fields of "storyCustomColors" */
export type StoryCustomColors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyCustomColors" */
export type StoryCustomColors_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryCustomColors_Max_Order_By>;
  min?: InputMaybe<StoryCustomColors_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type StoryCustomColors_Append_Input = {
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storyCustomColors" */
export type StoryCustomColors_Arr_Rel_Insert_Input = {
  data: Array<StoryCustomColors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryCustomColors_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storyCustomColors". All fields are combined with a logical 'AND'. */
export type StoryCustomColors_Bool_Exp = {
  _and?: InputMaybe<Array<StoryCustomColors_Bool_Exp>>;
  _not?: InputMaybe<StoryCustomColors_Bool_Exp>;
  _or?: InputMaybe<Array<StoryCustomColors_Bool_Exp>>;
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum_Comparison_Exp>;
  colors?: InputMaybe<Jsonb_Comparison_Exp>;
  contentType?: InputMaybe<StoryContentTypes_Enum_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyCustomColors" */
export enum StoryCustomColors_Constraint {
  /** unique or primary key constraint on columns "colorTarget", "storyId", "contentType" */
  StoryCustomColorsPkey = 'storyCustomColors_pkey',
  /** unique or primary key constraint on columns "colorTarget", "storyId", "contentType" */
  StoryCustomColorsStoryIdContentTypeElementTypeKey = 'storyCustomColors_storyId_contentType_elementType_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type StoryCustomColors_Delete_At_Path_Input = {
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type StoryCustomColors_Delete_Elem_Input = {
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type StoryCustomColors_Delete_Key_Input = {
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storyCustomColors" */
export type StoryCustomColors_Insert_Input = {
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Scalars['jsonb']['input']>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryCustomColors_Max_Fields = {
  __typename?: 'storyCustomColors_max_fields';
  storyId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyCustomColors" */
export type StoryCustomColors_Max_Order_By = {
  storyId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryCustomColors_Min_Fields = {
  __typename?: 'storyCustomColors_min_fields';
  storyId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyCustomColors" */
export type StoryCustomColors_Min_Order_By = {
  storyId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyCustomColors" */
export type StoryCustomColors_Mutation_Response = {
  __typename?: 'storyCustomColors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryCustomColors>;
};

/** on_conflict condition type for table "storyCustomColors" */
export type StoryCustomColors_On_Conflict = {
  constraint: StoryCustomColors_Constraint;
  update_columns?: Array<StoryCustomColors_Update_Column>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};

/** Ordering options when selecting data from "storyCustomColors". */
export type StoryCustomColors_Order_By = {
  colorTarget?: InputMaybe<Order_By>;
  colors?: InputMaybe<Order_By>;
  contentType?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyCustomColors */
export type StoryCustomColors_Pk_Columns_Input = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  storyId: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type StoryCustomColors_Prepend_Input = {
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storyCustomColors" */
export enum StoryCustomColors_Select_Column {
  /** column name */
  ColorTarget = 'colorTarget',
  /** column name */
  Colors = 'colors',
  /** column name */
  ContentType = 'contentType',
  /** column name */
  StoryId = 'storyId'
}

/** input type for updating data in table "storyCustomColors" */
export type StoryCustomColors_Set_Input = {
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Scalars['jsonb']['input']>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyCustomColors" */
export type StoryCustomColors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryCustomColors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryCustomColors_Stream_Cursor_Value_Input = {
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  /** An array of hex color strings e.g. #143a90 */
  colors?: InputMaybe<Scalars['jsonb']['input']>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  storyId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyCustomColors" */
export enum StoryCustomColors_Update_Column {
  /** column name */
  ColorTarget = 'colorTarget',
  /** column name */
  Colors = 'colors',
  /** column name */
  ContentType = 'contentType',
  /** column name */
  StoryId = 'storyId'
}

export type StoryCustomColors_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<StoryCustomColors_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<StoryCustomColors_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<StoryCustomColors_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<StoryCustomColors_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<StoryCustomColors_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryCustomColors_Set_Input>;
  where: StoryCustomColors_Bool_Exp;
};

/** columns and relationships of "storyEmbeds" */
export type StoryEmbeds = {
  __typename?: 'storyEmbeds';
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  embedId: Scalars['uuid']['output'];
  frequency?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  savedViewId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  story: Stories;
  storyId: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "storyEmbeds" */
export type StoryEmbeds_Aggregate = {
  __typename?: 'storyEmbeds_aggregate';
  aggregate?: Maybe<StoryEmbeds_Aggregate_Fields>;
  nodes: Array<StoryEmbeds>;
};

export type StoryEmbeds_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryEmbeds_Aggregate_Bool_Exp_Count>;
};

export type StoryEmbeds_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryEmbeds_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyEmbeds" */
export type StoryEmbeds_Aggregate_Fields = {
  __typename?: 'storyEmbeds_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryEmbeds_Max_Fields>;
  min?: Maybe<StoryEmbeds_Min_Fields>;
};


/** aggregate fields of "storyEmbeds" */
export type StoryEmbeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyEmbeds" */
export type StoryEmbeds_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryEmbeds_Max_Order_By>;
  min?: InputMaybe<StoryEmbeds_Min_Order_By>;
};

/** input type for inserting array relation for remote table "storyEmbeds" */
export type StoryEmbeds_Arr_Rel_Insert_Input = {
  data: Array<StoryEmbeds_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryEmbeds_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storyEmbeds". All fields are combined with a logical 'AND'. */
export type StoryEmbeds_Bool_Exp = {
  _and?: InputMaybe<Array<StoryEmbeds_Bool_Exp>>;
  _not?: InputMaybe<StoryEmbeds_Bool_Exp>;
  _or?: InputMaybe<Array<StoryEmbeds_Bool_Exp>>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedId?: InputMaybe<Uuid_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  reportId?: InputMaybe<Uuid_Comparison_Exp>;
  savedViewId?: InputMaybe<Uuid_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyEmbeds" */
export enum StoryEmbeds_Constraint {
  /** unique or primary key constraint on columns "embedId", "storyId" */
  StoryEmbedsPkey = 'storyEmbeds_pkey'
}

/** input type for inserting data into table "storyEmbeds" */
export type StoryEmbeds_Insert_Input = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  embedId?: InputMaybe<Scalars['uuid']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  savedViewId?: InputMaybe<Scalars['uuid']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type StoryEmbeds_Max_Fields = {
  __typename?: 'storyEmbeds_max_fields';
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  embedId?: Maybe<Scalars['uuid']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  savedViewId?: Maybe<Scalars['uuid']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "storyEmbeds" */
export type StoryEmbeds_Max_Order_By = {
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  embedId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  reportId?: InputMaybe<Order_By>;
  savedViewId?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryEmbeds_Min_Fields = {
  __typename?: 'storyEmbeds_min_fields';
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  embedId?: Maybe<Scalars['uuid']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  savedViewId?: Maybe<Scalars['uuid']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "storyEmbeds" */
export type StoryEmbeds_Min_Order_By = {
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  embedId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  reportId?: InputMaybe<Order_By>;
  savedViewId?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyEmbeds" */
export type StoryEmbeds_Mutation_Response = {
  __typename?: 'storyEmbeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryEmbeds>;
};

/** on_conflict condition type for table "storyEmbeds" */
export type StoryEmbeds_On_Conflict = {
  constraint: StoryEmbeds_Constraint;
  update_columns?: Array<StoryEmbeds_Update_Column>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};

/** Ordering options when selecting data from "storyEmbeds". */
export type StoryEmbeds_Order_By = {
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  embedId?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  reportId?: InputMaybe<Order_By>;
  savedViewId?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyEmbeds */
export type StoryEmbeds_Pk_Columns_Input = {
  embedId: Scalars['uuid']['input'];
  storyId: Scalars['String']['input'];
};

/** select columns of table "storyEmbeds" */
export enum StoryEmbeds_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EmbedId = 'embedId',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  ReportId = 'reportId',
  /** column name */
  SavedViewId = 'savedViewId',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storyEmbeds" */
export type StoryEmbeds_Set_Input = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  embedId?: InputMaybe<Scalars['uuid']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  savedViewId?: InputMaybe<Scalars['uuid']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "storyEmbeds" */
export type StoryEmbeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryEmbeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryEmbeds_Stream_Cursor_Value_Input = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  embedId?: InputMaybe<Scalars['uuid']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  savedViewId?: InputMaybe<Scalars['uuid']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "storyEmbeds" */
export enum StoryEmbeds_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EmbedId = 'embedId',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  ReportId = 'reportId',
  /** column name */
  SavedViewId = 'savedViewId',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StoryEmbeds_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryEmbeds_Set_Input>;
  where: StoryEmbeds_Bool_Exp;
};

/** columns and relationships of "storyFolderActionSets" */
export type StoryFolderActionSets = {
  __typename?: 'storyFolderActionSets';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "storyFolderActionSets" */
export type StoryFolderActionSets_Aggregate = {
  __typename?: 'storyFolderActionSets_aggregate';
  aggregate?: Maybe<StoryFolderActionSets_Aggregate_Fields>;
  nodes: Array<StoryFolderActionSets>;
};

/** aggregate fields of "storyFolderActionSets" */
export type StoryFolderActionSets_Aggregate_Fields = {
  __typename?: 'storyFolderActionSets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryFolderActionSets_Max_Fields>;
  min?: Maybe<StoryFolderActionSets_Min_Fields>;
};


/** aggregate fields of "storyFolderActionSets" */
export type StoryFolderActionSets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryFolderActionSets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "storyFolderActionSets". All fields are combined with a logical 'AND'. */
export type StoryFolderActionSets_Bool_Exp = {
  _and?: InputMaybe<Array<StoryFolderActionSets_Bool_Exp>>;
  _not?: InputMaybe<StoryFolderActionSets_Bool_Exp>;
  _or?: InputMaybe<Array<StoryFolderActionSets_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyFolderActionSets" */
export enum StoryFolderActionSets_Constraint {
  /** unique or primary key constraint on columns "value" */
  StoryFolderActionSetsPkey = 'storyFolderActionSets_pkey'
}

export enum StoryFolderActionSets_Enum {
  /** StoryFolderOwner */
  StoryFolderOwner = 'StoryFolderOwner',
  /** StoryFolderViewer */
  StoryFolderViewer = 'StoryFolderViewer'
}

/** Boolean expression to compare columns of type "storyFolderActionSets_enum". All fields are combined with logical 'AND'. */
export type StoryFolderActionSets_Enum_Comparison_Exp = {
  _eq?: InputMaybe<StoryFolderActionSets_Enum>;
  _in?: InputMaybe<Array<StoryFolderActionSets_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<StoryFolderActionSets_Enum>;
  _nin?: InputMaybe<Array<StoryFolderActionSets_Enum>>;
};

/** input type for inserting data into table "storyFolderActionSets" */
export type StoryFolderActionSets_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryFolderActionSets_Max_Fields = {
  __typename?: 'storyFolderActionSets_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type StoryFolderActionSets_Min_Fields = {
  __typename?: 'storyFolderActionSets_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storyFolderActionSets" */
export type StoryFolderActionSets_Mutation_Response = {
  __typename?: 'storyFolderActionSets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryFolderActionSets>;
};

/** on_conflict condition type for table "storyFolderActionSets" */
export type StoryFolderActionSets_On_Conflict = {
  constraint: StoryFolderActionSets_Constraint;
  update_columns?: Array<StoryFolderActionSets_Update_Column>;
  where?: InputMaybe<StoryFolderActionSets_Bool_Exp>;
};

/** Ordering options when selecting data from "storyFolderActionSets". */
export type StoryFolderActionSets_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyFolderActionSets */
export type StoryFolderActionSets_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "storyFolderActionSets" */
export enum StoryFolderActionSets_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "storyFolderActionSets" */
export type StoryFolderActionSets_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyFolderActionSets" */
export type StoryFolderActionSets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryFolderActionSets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryFolderActionSets_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyFolderActionSets" */
export enum StoryFolderActionSets_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type StoryFolderActionSets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryFolderActionSets_Set_Input>;
  where: StoryFolderActionSets_Bool_Exp;
};

/** columns and relationships of "storyFolderGrants" */
export type StoryFolderGrants = {
  __typename?: 'storyFolderGrants';
  actionSet: StoryFolderActionSets_Enum;
  createdAt: Scalars['timestamp']['output'];
  createdBy?: Maybe<Scalars['uuid']['output']>;
  granteeId: Scalars['String']['output'];
  granteeType: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  storyFolderId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "storyFolderGrants" */
export type StoryFolderGrants_Aggregate = {
  __typename?: 'storyFolderGrants_aggregate';
  aggregate?: Maybe<StoryFolderGrants_Aggregate_Fields>;
  nodes: Array<StoryFolderGrants>;
};

export type StoryFolderGrants_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryFolderGrants_Aggregate_Bool_Exp_Count>;
};

export type StoryFolderGrants_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryFolderGrants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyFolderGrants" */
export type StoryFolderGrants_Aggregate_Fields = {
  __typename?: 'storyFolderGrants_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryFolderGrants_Max_Fields>;
  min?: Maybe<StoryFolderGrants_Min_Fields>;
};


/** aggregate fields of "storyFolderGrants" */
export type StoryFolderGrants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyFolderGrants" */
export type StoryFolderGrants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryFolderGrants_Max_Order_By>;
  min?: InputMaybe<StoryFolderGrants_Min_Order_By>;
};

/** input type for inserting array relation for remote table "storyFolderGrants" */
export type StoryFolderGrants_Arr_Rel_Insert_Input = {
  data: Array<StoryFolderGrants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryFolderGrants_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storyFolderGrants". All fields are combined with a logical 'AND'. */
export type StoryFolderGrants_Bool_Exp = {
  _and?: InputMaybe<Array<StoryFolderGrants_Bool_Exp>>;
  _not?: InputMaybe<StoryFolderGrants_Bool_Exp>;
  _or?: InputMaybe<Array<StoryFolderGrants_Bool_Exp>>;
  actionSet?: InputMaybe<StoryFolderActionSets_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  granteeId?: InputMaybe<String_Comparison_Exp>;
  granteeType?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  storyFolderId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyFolderGrants" */
export enum StoryFolderGrants_Constraint {
  /** unique or primary key constraint on columns "id" */
  StoryFolderGrantsPkey = 'storyFolderGrants_pkey'
}

/** input type for inserting data into table "storyFolderGrants" */
export type StoryFolderGrants_Insert_Input = {
  actionSet?: InputMaybe<StoryFolderActionSets_Enum>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  granteeId?: InputMaybe<Scalars['String']['input']>;
  granteeType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  storyFolderId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type StoryFolderGrants_Max_Fields = {
  __typename?: 'storyFolderGrants_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  granteeId?: Maybe<Scalars['String']['output']>;
  granteeType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  storyFolderId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storyFolderGrants" */
export type StoryFolderGrants_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  granteeType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  storyFolderId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryFolderGrants_Min_Fields = {
  __typename?: 'storyFolderGrants_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  granteeId?: Maybe<Scalars['String']['output']>;
  granteeType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  storyFolderId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storyFolderGrants" */
export type StoryFolderGrants_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  granteeType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  storyFolderId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyFolderGrants" */
export type StoryFolderGrants_Mutation_Response = {
  __typename?: 'storyFolderGrants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryFolderGrants>;
};

/** on_conflict condition type for table "storyFolderGrants" */
export type StoryFolderGrants_On_Conflict = {
  constraint: StoryFolderGrants_Constraint;
  update_columns?: Array<StoryFolderGrants_Update_Column>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};

/** Ordering options when selecting data from "storyFolderGrants". */
export type StoryFolderGrants_Order_By = {
  actionSet?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  granteeType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  storyFolderId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyFolderGrants */
export type StoryFolderGrants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "storyFolderGrants" */
export enum StoryFolderGrants_Select_Column {
  /** column name */
  ActionSet = 'actionSet',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  GranteeId = 'granteeId',
  /** column name */
  GranteeType = 'granteeType',
  /** column name */
  Id = 'id',
  /** column name */
  StoryFolderId = 'storyFolderId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "storyFolderGrants" */
export type StoryFolderGrants_Set_Input = {
  actionSet?: InputMaybe<StoryFolderActionSets_Enum>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  granteeId?: InputMaybe<Scalars['String']['input']>;
  granteeType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  storyFolderId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "storyFolderGrants" */
export type StoryFolderGrants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryFolderGrants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryFolderGrants_Stream_Cursor_Value_Input = {
  actionSet?: InputMaybe<StoryFolderActionSets_Enum>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  granteeId?: InputMaybe<Scalars['String']['input']>;
  granteeType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  storyFolderId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "storyFolderGrants" */
export enum StoryFolderGrants_Update_Column {
  /** column name */
  ActionSet = 'actionSet',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  GranteeId = 'granteeId',
  /** column name */
  GranteeType = 'granteeType',
  /** column name */
  Id = 'id',
  /** column name */
  StoryFolderId = 'storyFolderId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type StoryFolderGrants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryFolderGrants_Set_Input>;
  where: StoryFolderGrants_Bool_Exp;
};

/** columns and relationships of "storyFolders" */
export type StoryFolders = {
  __typename?: 'storyFolders';
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId: Scalars['Int']['output'];
  /** An object relationship */
  folderCopyProcess?: Maybe<StoryFoldersCopyProcesses>;
  id: Scalars['uuid']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  parentFolder?: Maybe<StoryFolders>;
  parentFolderId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  publication?: Maybe<Publications>;
  /** An array relationship */
  publicationFolders: Array<PublicationFolders>;
  /** An aggregate relationship */
  publicationFolders_aggregate: PublicationFolders_Aggregate;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  stories: Array<Stories>;
  /** An array relationship */
  storiesCopyProcesses: Array<StoriesCopyProcesses>;
  /** An aggregate relationship */
  storiesCopyProcesses_aggregate: StoriesCopyProcesses_Aggregate;
  /** An aggregate relationship */
  stories_aggregate: Stories_Aggregate;
  /** An array relationship */
  storyFolderGrants: Array<StoryFolderGrants>;
  /** An array relationship */
  storyFolderGrantsFlat: Array<StoryFoldersGrantsFlat>;
  /** An aggregate relationship */
  storyFolderGrantsFlat_aggregate: StoryFoldersGrantsFlat_Aggregate;
  /** An aggregate relationship */
  storyFolderGrants_aggregate: StoryFolderGrants_Aggregate;
  /** An array relationship */
  subFolders: Array<StoryFolders>;
  /** An aggregate relationship */
  subFolders_aggregate: StoryFolders_Aggregate;
  title: Scalars['String']['output'];
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersPublicationFoldersArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersPublicationFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStoriesArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStoriesCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoriesCopyProcesses_Order_By>>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStoriesCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoriesCopyProcesses_Order_By>>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStoryFolderGrantsArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderGrants_Order_By>>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStoryFolderGrantsFlatArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersGrantsFlat_Order_By>>;
  where?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStoryFolderGrantsFlat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersGrantsFlat_Order_By>>;
  where?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersStoryFolderGrants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderGrants_Order_By>>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersSubFoldersArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


/** columns and relationships of "storyFolders" */
export type StoryFoldersSubFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};

/** columns and relationships of "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses = {
  __typename?: 'storyFoldersCopyProcesses';
  /** An object relationship */
  copyProcessStatus: CopyProcessStatuses;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  destinationFolderId: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  sourceFolderId: Scalars['uuid']['output'];
  status: CopyProcessStatuses_Enum;
  suppressDisplayBanner: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Aggregate = {
  __typename?: 'storyFoldersCopyProcesses_aggregate';
  aggregate?: Maybe<StoryFoldersCopyProcesses_Aggregate_Fields>;
  nodes: Array<StoryFoldersCopyProcesses>;
};

/** aggregate fields of "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Aggregate_Fields = {
  __typename?: 'storyFoldersCopyProcesses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryFoldersCopyProcesses_Max_Fields>;
  min?: Maybe<StoryFoldersCopyProcesses_Min_Fields>;
};


/** aggregate fields of "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryFoldersCopyProcesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "storyFoldersCopyProcesses". All fields are combined with a logical 'AND'. */
export type StoryFoldersCopyProcesses_Bool_Exp = {
  _and?: InputMaybe<Array<StoryFoldersCopyProcesses_Bool_Exp>>;
  _not?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
  _or?: InputMaybe<Array<StoryFoldersCopyProcesses_Bool_Exp>>;
  copyProcessStatus?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  destinationFolderId?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  sourceFolderId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<CopyProcessStatuses_Enum_Comparison_Exp>;
  suppressDisplayBanner?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyFoldersCopyProcesses" */
export enum StoryFoldersCopyProcesses_Constraint {
  /** unique or primary key constraint on columns "destinationFolderId" */
  StoryFoldersCopyProcessesPkey = 'storyFoldersCopyProcesses_pkey'
}

/** input type for inserting data into table "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Insert_Input = {
  copyProcessStatus?: InputMaybe<CopyProcessStatuses_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  destinationFolderId?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sourceFolderId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<CopyProcessStatuses_Enum>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type StoryFoldersCopyProcesses_Max_Fields = {
  __typename?: 'storyFoldersCopyProcesses_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  destinationFolderId?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sourceFolderId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type StoryFoldersCopyProcesses_Min_Fields = {
  __typename?: 'storyFoldersCopyProcesses_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  destinationFolderId?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sourceFolderId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Mutation_Response = {
  __typename?: 'storyFoldersCopyProcesses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryFoldersCopyProcesses>;
};

/** input type for inserting object relation for remote table "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Obj_Rel_Insert_Input = {
  data: StoryFoldersCopyProcesses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryFoldersCopyProcesses_On_Conflict>;
};

/** on_conflict condition type for table "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_On_Conflict = {
  constraint: StoryFoldersCopyProcesses_Constraint;
  update_columns?: Array<StoryFoldersCopyProcesses_Update_Column>;
  where?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
};

/** Ordering options when selecting data from "storyFoldersCopyProcesses". */
export type StoryFoldersCopyProcesses_Order_By = {
  copyProcessStatus?: InputMaybe<CopyProcessStatuses_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  destinationFolderId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  sourceFolderId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  suppressDisplayBanner?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyFoldersCopyProcesses */
export type StoryFoldersCopyProcesses_Pk_Columns_Input = {
  destinationFolderId: Scalars['uuid']['input'];
};

/** select columns of table "storyFoldersCopyProcesses" */
export enum StoryFoldersCopyProcesses_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DestinationFolderId = 'destinationFolderId',
  /** column name */
  Message = 'message',
  /** column name */
  SourceFolderId = 'sourceFolderId',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  destinationFolderId?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sourceFolderId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<CopyProcessStatuses_Enum>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "storyFoldersCopyProcesses" */
export type StoryFoldersCopyProcesses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryFoldersCopyProcesses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryFoldersCopyProcesses_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  destinationFolderId?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sourceFolderId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<CopyProcessStatuses_Enum>;
  suppressDisplayBanner?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "storyFoldersCopyProcesses" */
export enum StoryFoldersCopyProcesses_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DestinationFolderId = 'destinationFolderId',
  /** column name */
  Message = 'message',
  /** column name */
  SourceFolderId = 'sourceFolderId',
  /** column name */
  Status = 'status',
  /** column name */
  SuppressDisplayBanner = 'suppressDisplayBanner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StoryFoldersCopyProcesses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryFoldersCopyProcesses_Set_Input>;
  where: StoryFoldersCopyProcesses_Bool_Exp;
};

/** columns and relationships of "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat = {
  __typename?: 'storyFoldersGrantsFlat';
  actionSet?: Maybe<Scalars['String']['output']>;
  granteeId?: Maybe<Scalars['String']['output']>;
  granteeType?: Maybe<Scalars['String']['output']>;
  storyFolderId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Aggregate = {
  __typename?: 'storyFoldersGrantsFlat_aggregate';
  aggregate?: Maybe<StoryFoldersGrantsFlat_Aggregate_Fields>;
  nodes: Array<StoryFoldersGrantsFlat>;
};

export type StoryFoldersGrantsFlat_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryFoldersGrantsFlat_Aggregate_Bool_Exp_Count>;
};

export type StoryFoldersGrantsFlat_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Aggregate_Fields = {
  __typename?: 'storyFoldersGrantsFlat_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryFoldersGrantsFlat_Max_Fields>;
  min?: Maybe<StoryFoldersGrantsFlat_Min_Fields>;
};


/** aggregate fields of "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryFoldersGrantsFlat_Max_Order_By>;
  min?: InputMaybe<StoryFoldersGrantsFlat_Min_Order_By>;
};

/** input type for inserting array relation for remote table "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Arr_Rel_Insert_Input = {
  data: Array<StoryFoldersGrantsFlat_Insert_Input>;
};

/** Boolean expression to filter rows from the table "storyFoldersGrantsFlat". All fields are combined with a logical 'AND'. */
export type StoryFoldersGrantsFlat_Bool_Exp = {
  _and?: InputMaybe<Array<StoryFoldersGrantsFlat_Bool_Exp>>;
  _not?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
  _or?: InputMaybe<Array<StoryFoldersGrantsFlat_Bool_Exp>>;
  actionSet?: InputMaybe<String_Comparison_Exp>;
  granteeId?: InputMaybe<String_Comparison_Exp>;
  granteeType?: InputMaybe<String_Comparison_Exp>;
  storyFolderId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Insert_Input = {
  actionSet?: InputMaybe<Scalars['String']['input']>;
  granteeId?: InputMaybe<Scalars['String']['input']>;
  granteeType?: InputMaybe<Scalars['String']['input']>;
  storyFolderId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type StoryFoldersGrantsFlat_Max_Fields = {
  __typename?: 'storyFoldersGrantsFlat_max_fields';
  actionSet?: Maybe<Scalars['String']['output']>;
  granteeId?: Maybe<Scalars['String']['output']>;
  granteeType?: Maybe<Scalars['String']['output']>;
  storyFolderId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Max_Order_By = {
  actionSet?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  granteeType?: InputMaybe<Order_By>;
  storyFolderId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryFoldersGrantsFlat_Min_Fields = {
  __typename?: 'storyFoldersGrantsFlat_min_fields';
  actionSet?: Maybe<Scalars['String']['output']>;
  granteeId?: Maybe<Scalars['String']['output']>;
  granteeType?: Maybe<Scalars['String']['output']>;
  storyFolderId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Min_Order_By = {
  actionSet?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  granteeType?: InputMaybe<Order_By>;
  storyFolderId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "storyFoldersGrantsFlat". */
export type StoryFoldersGrantsFlat_Order_By = {
  actionSet?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  granteeType?: InputMaybe<Order_By>;
  storyFolderId?: InputMaybe<Order_By>;
};

/** select columns of table "storyFoldersGrantsFlat" */
export enum StoryFoldersGrantsFlat_Select_Column {
  /** column name */
  ActionSet = 'actionSet',
  /** column name */
  GranteeId = 'granteeId',
  /** column name */
  GranteeType = 'granteeType',
  /** column name */
  StoryFolderId = 'storyFolderId'
}

/** Streaming cursor of the table "storyFoldersGrantsFlat" */
export type StoryFoldersGrantsFlat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryFoldersGrantsFlat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryFoldersGrantsFlat_Stream_Cursor_Value_Input = {
  actionSet?: InputMaybe<Scalars['String']['input']>;
  granteeId?: InputMaybe<Scalars['String']['input']>;
  granteeType?: InputMaybe<Scalars['String']['input']>;
  storyFolderId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregated selection of "storyFolders" */
export type StoryFolders_Aggregate = {
  __typename?: 'storyFolders_aggregate';
  aggregate?: Maybe<StoryFolders_Aggregate_Fields>;
  nodes: Array<StoryFolders>;
};

export type StoryFolders_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryFolders_Aggregate_Bool_Exp_Count>;
};

export type StoryFolders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryFolders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryFolders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyFolders" */
export type StoryFolders_Aggregate_Fields = {
  __typename?: 'storyFolders_aggregate_fields';
  avg?: Maybe<StoryFolders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryFolders_Max_Fields>;
  min?: Maybe<StoryFolders_Min_Fields>;
  stddev?: Maybe<StoryFolders_Stddev_Fields>;
  stddev_pop?: Maybe<StoryFolders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryFolders_Stddev_Samp_Fields>;
  sum?: Maybe<StoryFolders_Sum_Fields>;
  var_pop?: Maybe<StoryFolders_Var_Pop_Fields>;
  var_samp?: Maybe<StoryFolders_Var_Samp_Fields>;
  variance?: Maybe<StoryFolders_Variance_Fields>;
};


/** aggregate fields of "storyFolders" */
export type StoryFolders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryFolders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyFolders" */
export type StoryFolders_Aggregate_Order_By = {
  avg?: InputMaybe<StoryFolders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryFolders_Max_Order_By>;
  min?: InputMaybe<StoryFolders_Min_Order_By>;
  stddev?: InputMaybe<StoryFolders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<StoryFolders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<StoryFolders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<StoryFolders_Sum_Order_By>;
  var_pop?: InputMaybe<StoryFolders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<StoryFolders_Var_Samp_Order_By>;
  variance?: InputMaybe<StoryFolders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "storyFolders" */
export type StoryFolders_Arr_Rel_Insert_Input = {
  data: Array<StoryFolders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryFolders_On_Conflict>;
};

/** aggregate avg on columns */
export type StoryFolders_Avg_Fields = {
  __typename?: 'storyFolders_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storyFolders" */
export type StoryFolders_Avg_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storyFolders". All fields are combined with a logical 'AND'. */
export type StoryFolders_Bool_Exp = {
  _and?: InputMaybe<Array<StoryFolders_Bool_Exp>>;
  _not?: InputMaybe<StoryFolders_Bool_Exp>;
  _or?: InputMaybe<Array<StoryFolders_Bool_Exp>>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  folderCopyProcess?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parentFolder?: InputMaybe<StoryFolders_Bool_Exp>;
  parentFolderId?: InputMaybe<Uuid_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationFolders?: InputMaybe<PublicationFolders_Bool_Exp>;
  publicationFolders_aggregate?: InputMaybe<PublicationFolders_Aggregate_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  stories?: InputMaybe<Stories_Bool_Exp>;
  storiesCopyProcesses?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
  storiesCopyProcesses_aggregate?: InputMaybe<StoriesCopyProcesses_Aggregate_Bool_Exp>;
  stories_aggregate?: InputMaybe<Stories_Aggregate_Bool_Exp>;
  storyFolderGrants?: InputMaybe<StoryFolderGrants_Bool_Exp>;
  storyFolderGrantsFlat?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
  storyFolderGrantsFlat_aggregate?: InputMaybe<StoryFoldersGrantsFlat_Aggregate_Bool_Exp>;
  storyFolderGrants_aggregate?: InputMaybe<StoryFolderGrants_Aggregate_Bool_Exp>;
  subFolders?: InputMaybe<StoryFolders_Bool_Exp>;
  subFolders_aggregate?: InputMaybe<StoryFolders_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyFolders" */
export enum StoryFolders_Constraint {
  /** unique or primary key constraint on columns "entityId" */
  IOnlyOneRootPerEntityStoryFolders = 'i_only_one_root_per_entity_storyFolders',
  /** unique or primary key constraint on columns "entityId", "parentFolderId", "title" */
  StoriesFoldersEntityIdParentFolderIdTitleKey = 'storiesFolders_entityId_parentFolderId_title_key',
  /** unique or primary key constraint on columns "id" */
  StoriesFoldersPkey = 'storiesFolders_pkey'
}

/** input type for incrementing numeric columns in table "storyFolders" */
export type StoryFolders_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyFolders" */
export type StoryFolders_Insert_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  folderCopyProcess?: InputMaybe<StoryFoldersCopyProcesses_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentFolder?: InputMaybe<StoryFolders_Obj_Rel_Insert_Input>;
  parentFolderId?: InputMaybe<Scalars['uuid']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationFolders?: InputMaybe<PublicationFolders_Arr_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  stories?: InputMaybe<Stories_Arr_Rel_Insert_Input>;
  storiesCopyProcesses?: InputMaybe<StoriesCopyProcesses_Arr_Rel_Insert_Input>;
  storyFolderGrants?: InputMaybe<StoryFolderGrants_Arr_Rel_Insert_Input>;
  storyFolderGrantsFlat?: InputMaybe<StoryFoldersGrantsFlat_Arr_Rel_Insert_Input>;
  subFolders?: InputMaybe<StoryFolders_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryFolders_Max_Fields = {
  __typename?: 'storyFolders_max_fields';
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentFolderId?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyFolders" */
export type StoryFolders_Max_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentFolderId?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryFolders_Min_Fields = {
  __typename?: 'storyFolders_min_fields';
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentFolderId?: Maybe<Scalars['uuid']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyFolders" */
export type StoryFolders_Min_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentFolderId?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyFolders" */
export type StoryFolders_Mutation_Response = {
  __typename?: 'storyFolders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryFolders>;
};

/** input type for inserting object relation for remote table "storyFolders" */
export type StoryFolders_Obj_Rel_Insert_Input = {
  data: StoryFolders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryFolders_On_Conflict>;
};

/** on_conflict condition type for table "storyFolders" */
export type StoryFolders_On_Conflict = {
  constraint: StoryFolders_Constraint;
  update_columns?: Array<StoryFolders_Update_Column>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};

/** Ordering options when selecting data from "storyFolders". */
export type StoryFolders_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  folderCopyProcess?: InputMaybe<StoryFoldersCopyProcesses_Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentFolder?: InputMaybe<StoryFolders_Order_By>;
  parentFolderId?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationFolders_aggregate?: InputMaybe<PublicationFolders_Aggregate_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  storiesCopyProcesses_aggregate?: InputMaybe<StoriesCopyProcesses_Aggregate_Order_By>;
  stories_aggregate?: InputMaybe<Stories_Aggregate_Order_By>;
  storyFolderGrantsFlat_aggregate?: InputMaybe<StoryFoldersGrantsFlat_Aggregate_Order_By>;
  storyFolderGrants_aggregate?: InputMaybe<StoryFolderGrants_Aggregate_Order_By>;
  subFolders_aggregate?: InputMaybe<StoryFolders_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyFolders */
export type StoryFolders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "storyFolders" */
export enum StoryFolders_Select_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  ParentFolderId = 'parentFolderId',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "storyFolders" */
export type StoryFolders_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentFolderId?: InputMaybe<Scalars['uuid']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type StoryFolders_Stddev_Fields = {
  __typename?: 'storyFolders_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storyFolders" */
export type StoryFolders_Stddev_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type StoryFolders_Stddev_Pop_Fields = {
  __typename?: 'storyFolders_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storyFolders" */
export type StoryFolders_Stddev_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type StoryFolders_Stddev_Samp_Fields = {
  __typename?: 'storyFolders_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storyFolders" */
export type StoryFolders_Stddev_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storyFolders" */
export type StoryFolders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryFolders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryFolders_Stream_Cursor_Value_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentFolderId?: InputMaybe<Scalars['uuid']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type StoryFolders_Sum_Fields = {
  __typename?: 'storyFolders_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storyFolders" */
export type StoryFolders_Sum_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "storyFolders" */
export enum StoryFolders_Update_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  ParentFolderId = 'parentFolderId',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  Title = 'title'
}

export type StoryFolders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryFolders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryFolders_Set_Input>;
  where: StoryFolders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryFolders_Var_Pop_Fields = {
  __typename?: 'storyFolders_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storyFolders" */
export type StoryFolders_Var_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type StoryFolders_Var_Samp_Fields = {
  __typename?: 'storyFolders_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storyFolders" */
export type StoryFolders_Var_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type StoryFolders_Variance_Fields = {
  __typename?: 'storyFolders_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storyFolders" */
export type StoryFolders_Variance_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "storyStates" */
export type StoryStates = {
  __typename?: 'storyStates';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "storyStates" */
export type StoryStates_Aggregate = {
  __typename?: 'storyStates_aggregate';
  aggregate?: Maybe<StoryStates_Aggregate_Fields>;
  nodes: Array<StoryStates>;
};

/** aggregate fields of "storyStates" */
export type StoryStates_Aggregate_Fields = {
  __typename?: 'storyStates_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryStates_Max_Fields>;
  min?: Maybe<StoryStates_Min_Fields>;
};


/** aggregate fields of "storyStates" */
export type StoryStates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryStates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "storyStates". All fields are combined with a logical 'AND'. */
export type StoryStates_Bool_Exp = {
  _and?: InputMaybe<Array<StoryStates_Bool_Exp>>;
  _not?: InputMaybe<StoryStates_Bool_Exp>;
  _or?: InputMaybe<Array<StoryStates_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyStates" */
export enum StoryStates_Constraint {
  /** unique or primary key constraint on columns "value" */
  StoryStatesPkey = 'storyStates_pkey'
}

export enum StoryStates_Enum {
  /** Archived */
  Archived = 'archived',
  /** Draft */
  Draft = 'draft',
  /** Published Internally */
  InternalPublished = 'internalPublished',
  /** Published */
  Published = 'published',
  /** Un Published */
  UnPublished = 'unPublished'
}

/** Boolean expression to compare columns of type "storyStates_enum". All fields are combined with logical 'AND'. */
export type StoryStates_Enum_Comparison_Exp = {
  _eq?: InputMaybe<StoryStates_Enum>;
  _in?: InputMaybe<Array<StoryStates_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<StoryStates_Enum>;
  _nin?: InputMaybe<Array<StoryStates_Enum>>;
};

/** input type for inserting data into table "storyStates" */
export type StoryStates_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryStates_Max_Fields = {
  __typename?: 'storyStates_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type StoryStates_Min_Fields = {
  __typename?: 'storyStates_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storyStates" */
export type StoryStates_Mutation_Response = {
  __typename?: 'storyStates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryStates>;
};

/** on_conflict condition type for table "storyStates" */
export type StoryStates_On_Conflict = {
  constraint: StoryStates_Constraint;
  update_columns?: Array<StoryStates_Update_Column>;
  where?: InputMaybe<StoryStates_Bool_Exp>;
};

/** Ordering options when selecting data from "storyStates". */
export type StoryStates_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyStates */
export type StoryStates_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "storyStates" */
export enum StoryStates_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "storyStates" */
export type StoryStates_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyStates" */
export type StoryStates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryStates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryStates_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyStates" */
export enum StoryStates_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type StoryStates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryStates_Set_Input>;
  where: StoryStates_Bool_Exp;
};

/** columns and relationships of "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks = {
  __typename?: 'storyTemplateContentBlocks';
  alt?: Maybe<Scalars['String']['output']>;
  creationParameters?: Maybe<Scalars['jsonb']['output']>;
  dataProviderId?: Maybe<Scalars['uuid']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  storyTemplateContentId: Scalars['String']['output'];
  text_content?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StoryContentBlockTypes_Enum>;
  width?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocksCreationParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Aggregate = {
  __typename?: 'storyTemplateContentBlocks_aggregate';
  aggregate?: Maybe<StoryTemplateContentBlocks_Aggregate_Fields>;
  nodes: Array<StoryTemplateContentBlocks>;
};

export type StoryTemplateContentBlocks_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<StoryTemplateContentBlocks_Aggregate_Bool_Exp_Count>;
};

export type StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_And = {
  arguments: StoryTemplateContentBlocks_Select_Column_StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_Or = {
  arguments: StoryTemplateContentBlocks_Select_Column_StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryTemplateContentBlocks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Aggregate_Fields = {
  __typename?: 'storyTemplateContentBlocks_aggregate_fields';
  avg?: Maybe<StoryTemplateContentBlocks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryTemplateContentBlocks_Max_Fields>;
  min?: Maybe<StoryTemplateContentBlocks_Min_Fields>;
  stddev?: Maybe<StoryTemplateContentBlocks_Stddev_Fields>;
  stddev_pop?: Maybe<StoryTemplateContentBlocks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryTemplateContentBlocks_Stddev_Samp_Fields>;
  sum?: Maybe<StoryTemplateContentBlocks_Sum_Fields>;
  var_pop?: Maybe<StoryTemplateContentBlocks_Var_Pop_Fields>;
  var_samp?: Maybe<StoryTemplateContentBlocks_Var_Samp_Fields>;
  variance?: Maybe<StoryTemplateContentBlocks_Variance_Fields>;
};


/** aggregate fields of "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Aggregate_Order_By = {
  avg?: InputMaybe<StoryTemplateContentBlocks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryTemplateContentBlocks_Max_Order_By>;
  min?: InputMaybe<StoryTemplateContentBlocks_Min_Order_By>;
  stddev?: InputMaybe<StoryTemplateContentBlocks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<StoryTemplateContentBlocks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<StoryTemplateContentBlocks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<StoryTemplateContentBlocks_Sum_Order_By>;
  var_pop?: InputMaybe<StoryTemplateContentBlocks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<StoryTemplateContentBlocks_Var_Samp_Order_By>;
  variance?: InputMaybe<StoryTemplateContentBlocks_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type StoryTemplateContentBlocks_Append_Input = {
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Arr_Rel_Insert_Input = {
  data: Array<StoryTemplateContentBlocks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryTemplateContentBlocks_On_Conflict>;
};

/** aggregate avg on columns */
export type StoryTemplateContentBlocks_Avg_Fields = {
  __typename?: 'storyTemplateContentBlocks_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storyTemplateContentBlocks". All fields are combined with a logical 'AND'. */
export type StoryTemplateContentBlocks_Bool_Exp = {
  _and?: InputMaybe<Array<StoryTemplateContentBlocks_Bool_Exp>>;
  _not?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
  _or?: InputMaybe<Array<StoryTemplateContentBlocks_Bool_Exp>>;
  alt?: InputMaybe<String_Comparison_Exp>;
  creationParameters?: InputMaybe<Jsonb_Comparison_Exp>;
  dataProviderId?: InputMaybe<Uuid_Comparison_Exp>;
  editable?: InputMaybe<Boolean_Comparison_Exp>;
  height?: InputMaybe<String_Comparison_Exp>;
  hyperlink?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  src?: InputMaybe<String_Comparison_Exp>;
  storyTemplateContentId?: InputMaybe<String_Comparison_Exp>;
  text_content?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<StoryContentBlockTypes_Enum_Comparison_Exp>;
  width?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyTemplateContentBlocks" */
export enum StoryTemplateContentBlocks_Constraint {
  /** unique or primary key constraint on columns "id" */
  StoryTemplateContentBlocksPkey = 'storyTemplateContentBlocks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type StoryTemplateContentBlocks_Delete_At_Path_Input = {
  creationParameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type StoryTemplateContentBlocks_Delete_Elem_Input = {
  creationParameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type StoryTemplateContentBlocks_Delete_Key_Input = {
  creationParameters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Insert_Input = {
  alt?: InputMaybe<Scalars['String']['input']>;
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
  dataProviderId?: InputMaybe<Scalars['uuid']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  storyTemplateContentId?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentBlockTypes_Enum>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryTemplateContentBlocks_Max_Fields = {
  __typename?: 'storyTemplateContentBlocks_max_fields';
  alt?: Maybe<Scalars['String']['output']>;
  dataProviderId?: Maybe<Scalars['uuid']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  storyTemplateContentId?: Maybe<Scalars['String']['output']>;
  text_content?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Max_Order_By = {
  alt?: InputMaybe<Order_By>;
  dataProviderId?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hyperlink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  src?: InputMaybe<Order_By>;
  storyTemplateContentId?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryTemplateContentBlocks_Min_Fields = {
  __typename?: 'storyTemplateContentBlocks_min_fields';
  alt?: Maybe<Scalars['String']['output']>;
  dataProviderId?: Maybe<Scalars['uuid']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  storyTemplateContentId?: Maybe<Scalars['String']['output']>;
  text_content?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Min_Order_By = {
  alt?: InputMaybe<Order_By>;
  dataProviderId?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hyperlink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  src?: InputMaybe<Order_By>;
  storyTemplateContentId?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Mutation_Response = {
  __typename?: 'storyTemplateContentBlocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryTemplateContentBlocks>;
};

/** on_conflict condition type for table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_On_Conflict = {
  constraint: StoryTemplateContentBlocks_Constraint;
  update_columns?: Array<StoryTemplateContentBlocks_Update_Column>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};

/** Ordering options when selecting data from "storyTemplateContentBlocks". */
export type StoryTemplateContentBlocks_Order_By = {
  alt?: InputMaybe<Order_By>;
  creationParameters?: InputMaybe<Order_By>;
  dataProviderId?: InputMaybe<Order_By>;
  editable?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hyperlink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  src?: InputMaybe<Order_By>;
  storyTemplateContentId?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyTemplateContentBlocks */
export type StoryTemplateContentBlocks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type StoryTemplateContentBlocks_Prepend_Input = {
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storyTemplateContentBlocks" */
export enum StoryTemplateContentBlocks_Select_Column {
  /** column name */
  Alt = 'alt',
  /** column name */
  CreationParameters = 'creationParameters',
  /** column name */
  DataProviderId = 'dataProviderId',
  /** column name */
  Editable = 'editable',
  /** column name */
  Height = 'height',
  /** column name */
  Hyperlink = 'hyperlink',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Src = 'src',
  /** column name */
  StoryTemplateContentId = 'storyTemplateContentId',
  /** column name */
  TextContent = 'text_content',
  /** column name */
  Type = 'type',
  /** column name */
  Width = 'width'
}

/** select "storyTemplateContentBlocks_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storyTemplateContentBlocks" */
export enum StoryTemplateContentBlocks_Select_Column_StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Editable = 'editable'
}

/** select "storyTemplateContentBlocks_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storyTemplateContentBlocks" */
export enum StoryTemplateContentBlocks_Select_Column_StoryTemplateContentBlocks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Editable = 'editable'
}

/** input type for updating data in table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Set_Input = {
  alt?: InputMaybe<Scalars['String']['input']>;
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
  dataProviderId?: InputMaybe<Scalars['uuid']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  storyTemplateContentId?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentBlockTypes_Enum>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type StoryTemplateContentBlocks_Stddev_Fields = {
  __typename?: 'storyTemplateContentBlocks_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type StoryTemplateContentBlocks_Stddev_Pop_Fields = {
  __typename?: 'storyTemplateContentBlocks_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type StoryTemplateContentBlocks_Stddev_Samp_Fields = {
  __typename?: 'storyTemplateContentBlocks_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryTemplateContentBlocks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryTemplateContentBlocks_Stream_Cursor_Value_Input = {
  alt?: InputMaybe<Scalars['String']['input']>;
  creationParameters?: InputMaybe<Scalars['jsonb']['input']>;
  dataProviderId?: InputMaybe<Scalars['uuid']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  storyTemplateContentId?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentBlockTypes_Enum>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type StoryTemplateContentBlocks_Sum_Fields = {
  __typename?: 'storyTemplateContentBlocks_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "storyTemplateContentBlocks" */
export enum StoryTemplateContentBlocks_Update_Column {
  /** column name */
  Alt = 'alt',
  /** column name */
  CreationParameters = 'creationParameters',
  /** column name */
  DataProviderId = 'dataProviderId',
  /** column name */
  Editable = 'editable',
  /** column name */
  Height = 'height',
  /** column name */
  Hyperlink = 'hyperlink',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Src = 'src',
  /** column name */
  StoryTemplateContentId = 'storyTemplateContentId',
  /** column name */
  TextContent = 'text_content',
  /** column name */
  Type = 'type',
  /** column name */
  Width = 'width'
}

export type StoryTemplateContentBlocks_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<StoryTemplateContentBlocks_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<StoryTemplateContentBlocks_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<StoryTemplateContentBlocks_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<StoryTemplateContentBlocks_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryTemplateContentBlocks_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<StoryTemplateContentBlocks_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryTemplateContentBlocks_Set_Input>;
  where: StoryTemplateContentBlocks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryTemplateContentBlocks_Var_Pop_Fields = {
  __typename?: 'storyTemplateContentBlocks_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type StoryTemplateContentBlocks_Var_Samp_Fields = {
  __typename?: 'storyTemplateContentBlocks_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type StoryTemplateContentBlocks_Variance_Fields = {
  __typename?: 'storyTemplateContentBlocks_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storyTemplateContentBlocks" */
export type StoryTemplateContentBlocks_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** columns and relationships of "storyTemplateContents" */
export type StoryTemplateContents = {
  __typename?: 'storyTemplateContents';
  _id: Scalars['String']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  author?: Maybe<StoryUsers>;
  authorId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  blocks: Array<StoryTemplateContentBlocks>;
  /** An aggregate relationship */
  blocks_aggregate: StoryTemplateContentBlocks_Aggregate;
  content: Scalars['String']['output'];
  contentHtml: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  format?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  storyTemplateId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StoryContentTypes_Enum>;
};


/** columns and relationships of "storyTemplateContents" */
export type StoryTemplateContentsBlocksArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContentBlocks_Order_By>>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};


/** columns and relationships of "storyTemplateContents" */
export type StoryTemplateContentsBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContentBlocks_Order_By>>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};

/** aggregated selection of "storyTemplateContents" */
export type StoryTemplateContents_Aggregate = {
  __typename?: 'storyTemplateContents_aggregate';
  aggregate?: Maybe<StoryTemplateContents_Aggregate_Fields>;
  nodes: Array<StoryTemplateContents>;
};

export type StoryTemplateContents_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<StoryTemplateContents_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<StoryTemplateContents_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<StoryTemplateContents_Aggregate_Bool_Exp_Count>;
};

export type StoryTemplateContents_Aggregate_Bool_Exp_Bool_And = {
  arguments: StoryTemplateContents_Select_Column_StoryTemplateContents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplateContents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryTemplateContents_Aggregate_Bool_Exp_Bool_Or = {
  arguments: StoryTemplateContents_Select_Column_StoryTemplateContents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplateContents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type StoryTemplateContents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplateContents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyTemplateContents" */
export type StoryTemplateContents_Aggregate_Fields = {
  __typename?: 'storyTemplateContents_aggregate_fields';
  avg?: Maybe<StoryTemplateContents_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryTemplateContents_Max_Fields>;
  min?: Maybe<StoryTemplateContents_Min_Fields>;
  stddev?: Maybe<StoryTemplateContents_Stddev_Fields>;
  stddev_pop?: Maybe<StoryTemplateContents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryTemplateContents_Stddev_Samp_Fields>;
  sum?: Maybe<StoryTemplateContents_Sum_Fields>;
  var_pop?: Maybe<StoryTemplateContents_Var_Pop_Fields>;
  var_samp?: Maybe<StoryTemplateContents_Var_Samp_Fields>;
  variance?: Maybe<StoryTemplateContents_Variance_Fields>;
};


/** aggregate fields of "storyTemplateContents" */
export type StoryTemplateContents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyTemplateContents" */
export type StoryTemplateContents_Aggregate_Order_By = {
  avg?: InputMaybe<StoryTemplateContents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryTemplateContents_Max_Order_By>;
  min?: InputMaybe<StoryTemplateContents_Min_Order_By>;
  stddev?: InputMaybe<StoryTemplateContents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<StoryTemplateContents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<StoryTemplateContents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<StoryTemplateContents_Sum_Order_By>;
  var_pop?: InputMaybe<StoryTemplateContents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<StoryTemplateContents_Var_Samp_Order_By>;
  variance?: InputMaybe<StoryTemplateContents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "storyTemplateContents" */
export type StoryTemplateContents_Arr_Rel_Insert_Input = {
  data: Array<StoryTemplateContents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryTemplateContents_On_Conflict>;
};

/** aggregate avg on columns */
export type StoryTemplateContents_Avg_Fields = {
  __typename?: 'storyTemplateContents_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Avg_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storyTemplateContents". All fields are combined with a logical 'AND'. */
export type StoryTemplateContents_Bool_Exp = {
  _and?: InputMaybe<Array<StoryTemplateContents_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<StoryTemplateContents_Bool_Exp>;
  _or?: InputMaybe<Array<StoryTemplateContents_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  author?: InputMaybe<StoryUsers_Bool_Exp>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  blocks?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
  blocks_aggregate?: InputMaybe<StoryTemplateContentBlocks_Aggregate_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  contentHtml?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  format?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  layout?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  storyTemplateId?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<StoryContentTypes_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyTemplateContents" */
export enum StoryTemplateContents_Constraint {
  /** unique or primary key constraint on columns "_id" */
  StoryTemplateContentsPkey = 'storyTemplateContents_pkey'
}

/** input type for incrementing numeric columns in table "storyTemplateContents" */
export type StoryTemplateContents_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyTemplateContents" */
export type StoryTemplateContents_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  blocks?: InputMaybe<StoryTemplateContentBlocks_Arr_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyTemplateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentTypes_Enum>;
};

/** aggregate max on columns */
export type StoryTemplateContents_Max_Fields = {
  __typename?: 'storyTemplateContents_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyTemplateId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Max_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  contentHtml?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  layout?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  storyTemplateId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryTemplateContents_Min_Fields = {
  __typename?: 'storyTemplateContents_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  storyTemplateId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Min_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  contentHtml?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  layout?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  storyTemplateId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyTemplateContents" */
export type StoryTemplateContents_Mutation_Response = {
  __typename?: 'storyTemplateContents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryTemplateContents>;
};

/** on_conflict condition type for table "storyTemplateContents" */
export type StoryTemplateContents_On_Conflict = {
  constraint: StoryTemplateContents_Constraint;
  update_columns?: Array<StoryTemplateContents_Update_Column>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};

/** Ordering options when selecting data from "storyTemplateContents". */
export type StoryTemplateContents_Order_By = {
  _id?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  author?: InputMaybe<StoryUsers_Order_By>;
  authorId?: InputMaybe<Order_By>;
  blocks_aggregate?: InputMaybe<StoryTemplateContentBlocks_Aggregate_Order_By>;
  content?: InputMaybe<Order_By>;
  contentHtml?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  layout?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  storyTemplateId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyTemplateContents */
export type StoryTemplateContents_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "storyTemplateContents" */
export enum StoryTemplateContents_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  Active = 'active',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Content = 'content',
  /** column name */
  ContentHtml = 'contentHtml',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Format = 'format',
  /** column name */
  Group = 'group',
  /** column name */
  Layout = 'layout',
  /** column name */
  Order = 'order',
  /** column name */
  StoryTemplateId = 'storyTemplateId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

/** select "storyTemplateContents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storyTemplateContents" */
export enum StoryTemplateContents_Select_Column_StoryTemplateContents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "storyTemplateContents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storyTemplateContents" */
export enum StoryTemplateContents_Select_Column_StoryTemplateContents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "storyTemplateContents" */
export type StoryTemplateContents_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyTemplateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentTypes_Enum>;
};

/** aggregate stddev on columns */
export type StoryTemplateContents_Stddev_Fields = {
  __typename?: 'storyTemplateContents_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Stddev_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type StoryTemplateContents_Stddev_Pop_Fields = {
  __typename?: 'storyTemplateContents_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Stddev_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type StoryTemplateContents_Stddev_Samp_Fields = {
  __typename?: 'storyTemplateContents_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Stddev_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storyTemplateContents" */
export type StoryTemplateContents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryTemplateContents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryTemplateContents_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  storyTemplateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoryContentTypes_Enum>;
};

/** aggregate sum on columns */
export type StoryTemplateContents_Sum_Fields = {
  __typename?: 'storyTemplateContents_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Sum_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "storyTemplateContents" */
export enum StoryTemplateContents_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  Active = 'active',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Content = 'content',
  /** column name */
  ContentHtml = 'contentHtml',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Format = 'format',
  /** column name */
  Group = 'group',
  /** column name */
  Layout = 'layout',
  /** column name */
  Order = 'order',
  /** column name */
  StoryTemplateId = 'storyTemplateId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

export type StoryTemplateContents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryTemplateContents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryTemplateContents_Set_Input>;
  where: StoryTemplateContents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryTemplateContents_Var_Pop_Fields = {
  __typename?: 'storyTemplateContents_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Var_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type StoryTemplateContents_Var_Samp_Fields = {
  __typename?: 'storyTemplateContents_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Var_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type StoryTemplateContents_Variance_Fields = {
  __typename?: 'storyTemplateContents_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storyTemplateContents" */
export type StoryTemplateContents_Variance_Order_By = {
  entityId?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "storyTemplateCustomColors" */
export type StoryTemplateCustomColors = {
  __typename?: 'storyTemplateCustomColors';
  colorTarget: StoryContentColorTargets_Enum;
  colors: Scalars['jsonb']['output'];
  contentType: StoryContentTypes_Enum;
  /** An object relationship */
  template?: Maybe<StoryTemplates>;
  templateId: Scalars['String']['output'];
};


/** columns and relationships of "storyTemplateCustomColors" */
export type StoryTemplateCustomColorsColorsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Aggregate = {
  __typename?: 'storyTemplateCustomColors_aggregate';
  aggregate?: Maybe<StoryTemplateCustomColors_Aggregate_Fields>;
  nodes: Array<StoryTemplateCustomColors>;
};

export type StoryTemplateCustomColors_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryTemplateCustomColors_Aggregate_Bool_Exp_Count>;
};

export type StoryTemplateCustomColors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Aggregate_Fields = {
  __typename?: 'storyTemplateCustomColors_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryTemplateCustomColors_Max_Fields>;
  min?: Maybe<StoryTemplateCustomColors_Min_Fields>;
};


/** aggregate fields of "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryTemplateCustomColors_Max_Order_By>;
  min?: InputMaybe<StoryTemplateCustomColors_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type StoryTemplateCustomColors_Append_Input = {
  colors?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Arr_Rel_Insert_Input = {
  data: Array<StoryTemplateCustomColors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryTemplateCustomColors_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storyTemplateCustomColors". All fields are combined with a logical 'AND'. */
export type StoryTemplateCustomColors_Bool_Exp = {
  _and?: InputMaybe<Array<StoryTemplateCustomColors_Bool_Exp>>;
  _not?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
  _or?: InputMaybe<Array<StoryTemplateCustomColors_Bool_Exp>>;
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum_Comparison_Exp>;
  colors?: InputMaybe<Jsonb_Comparison_Exp>;
  contentType?: InputMaybe<StoryContentTypes_Enum_Comparison_Exp>;
  template?: InputMaybe<StoryTemplates_Bool_Exp>;
  templateId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyTemplateCustomColors" */
export enum StoryTemplateCustomColors_Constraint {
  /** unique or primary key constraint on columns "colorTarget", "templateId", "contentType" */
  TemplateCustomColorsPkey = 'templateCustomColors_pkey',
  /** unique or primary key constraint on columns "colorTarget", "templateId", "contentType" */
  TemplateCustomColorsTemplateIdContentTypeColorTargetKey = 'templateCustomColors_templateId_contentType_colorTarget_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type StoryTemplateCustomColors_Delete_At_Path_Input = {
  colors?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type StoryTemplateCustomColors_Delete_Elem_Input = {
  colors?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type StoryTemplateCustomColors_Delete_Key_Input = {
  colors?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Insert_Input = {
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  colors?: InputMaybe<Scalars['jsonb']['input']>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  template?: InputMaybe<StoryTemplates_Obj_Rel_Insert_Input>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryTemplateCustomColors_Max_Fields = {
  __typename?: 'storyTemplateCustomColors_max_fields';
  templateId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Max_Order_By = {
  templateId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryTemplateCustomColors_Min_Fields = {
  __typename?: 'storyTemplateCustomColors_min_fields';
  templateId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Min_Order_By = {
  templateId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Mutation_Response = {
  __typename?: 'storyTemplateCustomColors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryTemplateCustomColors>;
};

/** on_conflict condition type for table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_On_Conflict = {
  constraint: StoryTemplateCustomColors_Constraint;
  update_columns?: Array<StoryTemplateCustomColors_Update_Column>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};

/** Ordering options when selecting data from "storyTemplateCustomColors". */
export type StoryTemplateCustomColors_Order_By = {
  colorTarget?: InputMaybe<Order_By>;
  colors?: InputMaybe<Order_By>;
  contentType?: InputMaybe<Order_By>;
  template?: InputMaybe<StoryTemplates_Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyTemplateCustomColors */
export type StoryTemplateCustomColors_Pk_Columns_Input = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  templateId: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type StoryTemplateCustomColors_Prepend_Input = {
  colors?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storyTemplateCustomColors" */
export enum StoryTemplateCustomColors_Select_Column {
  /** column name */
  ColorTarget = 'colorTarget',
  /** column name */
  Colors = 'colors',
  /** column name */
  ContentType = 'contentType',
  /** column name */
  TemplateId = 'templateId'
}

/** input type for updating data in table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Set_Input = {
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  colors?: InputMaybe<Scalars['jsonb']['input']>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyTemplateCustomColors" */
export type StoryTemplateCustomColors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryTemplateCustomColors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryTemplateCustomColors_Stream_Cursor_Value_Input = {
  colorTarget?: InputMaybe<StoryContentColorTargets_Enum>;
  colors?: InputMaybe<Scalars['jsonb']['input']>;
  contentType?: InputMaybe<StoryContentTypes_Enum>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyTemplateCustomColors" */
export enum StoryTemplateCustomColors_Update_Column {
  /** column name */
  ColorTarget = 'colorTarget',
  /** column name */
  Colors = 'colors',
  /** column name */
  ContentType = 'contentType',
  /** column name */
  TemplateId = 'templateId'
}

export type StoryTemplateCustomColors_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<StoryTemplateCustomColors_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<StoryTemplateCustomColors_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<StoryTemplateCustomColors_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<StoryTemplateCustomColors_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<StoryTemplateCustomColors_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryTemplateCustomColors_Set_Input>;
  where: StoryTemplateCustomColors_Bool_Exp;
};

/** columns and relationships of "storyTemplates" */
export type StoryTemplates = {
  __typename?: 'storyTemplates';
  _id: Scalars['String']['output'];
  /** An object relationship */
  author: StoryUsers;
  authorId: Scalars['String']['output'];
  /** An array relationship */
  contents: Array<StoryTemplateContents>;
  /** An aggregate relationship */
  contents_aggregate: StoryTemplateContents_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customColors: Array<StoryTemplateCustomColors>;
  /** An aggregate relationship */
  customColors_aggregate: StoryTemplateCustomColors_Aggregate;
  customCssCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['timestamp']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  state: StoryStates_Enum;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailRelativePath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  visibility: StoryVisibilities_Enum;
};


/** columns and relationships of "storyTemplates" */
export type StoryTemplatesContentsArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContents_Order_By>>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};


/** columns and relationships of "storyTemplates" */
export type StoryTemplatesContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContents_Order_By>>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};


/** columns and relationships of "storyTemplates" */
export type StoryTemplatesCustomColorsArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateCustomColors_Order_By>>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};


/** columns and relationships of "storyTemplates" */
export type StoryTemplatesCustomColors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateCustomColors_Order_By>>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};

/** aggregated selection of "storyTemplates" */
export type StoryTemplates_Aggregate = {
  __typename?: 'storyTemplates_aggregate';
  aggregate?: Maybe<StoryTemplates_Aggregate_Fields>;
  nodes: Array<StoryTemplates>;
};

export type StoryTemplates_Aggregate_Bool_Exp = {
  count?: InputMaybe<StoryTemplates_Aggregate_Bool_Exp_Count>;
};

export type StoryTemplates_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<StoryTemplates_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storyTemplates" */
export type StoryTemplates_Aggregate_Fields = {
  __typename?: 'storyTemplates_aggregate_fields';
  avg?: Maybe<StoryTemplates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryTemplates_Max_Fields>;
  min?: Maybe<StoryTemplates_Min_Fields>;
  stddev?: Maybe<StoryTemplates_Stddev_Fields>;
  stddev_pop?: Maybe<StoryTemplates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryTemplates_Stddev_Samp_Fields>;
  sum?: Maybe<StoryTemplates_Sum_Fields>;
  var_pop?: Maybe<StoryTemplates_Var_Pop_Fields>;
  var_samp?: Maybe<StoryTemplates_Var_Samp_Fields>;
  variance?: Maybe<StoryTemplates_Variance_Fields>;
};


/** aggregate fields of "storyTemplates" */
export type StoryTemplates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storyTemplates" */
export type StoryTemplates_Aggregate_Order_By = {
  avg?: InputMaybe<StoryTemplates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StoryTemplates_Max_Order_By>;
  min?: InputMaybe<StoryTemplates_Min_Order_By>;
  stddev?: InputMaybe<StoryTemplates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<StoryTemplates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<StoryTemplates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<StoryTemplates_Sum_Order_By>;
  var_pop?: InputMaybe<StoryTemplates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<StoryTemplates_Var_Samp_Order_By>;
  variance?: InputMaybe<StoryTemplates_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "storyTemplates" */
export type StoryTemplates_Arr_Rel_Insert_Input = {
  data: Array<StoryTemplates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryTemplates_On_Conflict>;
};

/** aggregate avg on columns */
export type StoryTemplates_Avg_Fields = {
  __typename?: 'storyTemplates_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storyTemplates" */
export type StoryTemplates_Avg_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storyTemplates". All fields are combined with a logical 'AND'. */
export type StoryTemplates_Bool_Exp = {
  _and?: InputMaybe<Array<StoryTemplates_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<StoryTemplates_Bool_Exp>;
  _or?: InputMaybe<Array<StoryTemplates_Bool_Exp>>;
  author?: InputMaybe<StoryUsers_Bool_Exp>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  contents?: InputMaybe<StoryTemplateContents_Bool_Exp>;
  contents_aggregate?: InputMaybe<StoryTemplateContents_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  customColors?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
  customColors_aggregate?: InputMaybe<StoryTemplateCustomColors_Aggregate_Bool_Exp>;
  customCssCode?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  paddingBottom?: InputMaybe<Int_Comparison_Exp>;
  paddingTop?: InputMaybe<Int_Comparison_Exp>;
  publishedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  publishedBy?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<StoryStates_Enum_Comparison_Exp>;
  thumbnail?: InputMaybe<String_Comparison_Exp>;
  thumbnailRelativePath?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  visibility?: InputMaybe<StoryVisibilities_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyTemplates" */
export enum StoryTemplates_Constraint {
  /** unique or primary key constraint on columns "_id" */
  StoryTemplatePkey = 'storyTemplate_pkey'
}

/** input type for incrementing numeric columns in table "storyTemplates" */
export type StoryTemplates_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyTemplates" */
export type StoryTemplates_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<StoryTemplateContents_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<StoryTemplateCustomColors_Arr_Rel_Insert_Input>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamp']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StoryStates_Enum>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnailRelativePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<StoryVisibilities_Enum>;
};

/** aggregate max on columns */
export type StoryTemplates_Max_Fields = {
  __typename?: 'storyTemplates_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customCssCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['timestamp']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailRelativePath?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "storyTemplates" */
export type StoryTemplates_Max_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customCssCode?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  publishedBy?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  thumbnailRelativePath?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StoryTemplates_Min_Fields = {
  __typename?: 'storyTemplates_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customCssCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['timestamp']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailRelativePath?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "storyTemplates" */
export type StoryTemplates_Min_Order_By = {
  _id?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customCssCode?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  publishedBy?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  thumbnailRelativePath?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storyTemplates" */
export type StoryTemplates_Mutation_Response = {
  __typename?: 'storyTemplates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryTemplates>;
};

/** input type for inserting object relation for remote table "storyTemplates" */
export type StoryTemplates_Obj_Rel_Insert_Input = {
  data: StoryTemplates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryTemplates_On_Conflict>;
};

/** on_conflict condition type for table "storyTemplates" */
export type StoryTemplates_On_Conflict = {
  constraint: StoryTemplates_Constraint;
  update_columns?: Array<StoryTemplates_Update_Column>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};

/** Ordering options when selecting data from "storyTemplates". */
export type StoryTemplates_Order_By = {
  _id?: InputMaybe<Order_By>;
  author?: InputMaybe<StoryUsers_Order_By>;
  authorId?: InputMaybe<Order_By>;
  contents_aggregate?: InputMaybe<StoryTemplateContents_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customColors_aggregate?: InputMaybe<StoryTemplateCustomColors_Aggregate_Order_By>;
  customCssCode?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  publishedBy?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  thumbnailRelativePath?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyTemplates */
export type StoryTemplates_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "storyTemplates" */
export enum StoryTemplates_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomCssCode = 'customCssCode',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  PaddingBottom = 'paddingBottom',
  /** column name */
  PaddingTop = 'paddingTop',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  PublishedBy = 'publishedBy',
  /** column name */
  State = 'state',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  ThumbnailRelativePath = 'thumbnailRelativePath',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Visibility = 'visibility'
}

/** input type for updating data in table "storyTemplates" */
export type StoryTemplates_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamp']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StoryStates_Enum>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnailRelativePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<StoryVisibilities_Enum>;
};

/** aggregate stddev on columns */
export type StoryTemplates_Stddev_Fields = {
  __typename?: 'storyTemplates_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storyTemplates" */
export type StoryTemplates_Stddev_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type StoryTemplates_Stddev_Pop_Fields = {
  __typename?: 'storyTemplates_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storyTemplates" */
export type StoryTemplates_Stddev_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type StoryTemplates_Stddev_Samp_Fields = {
  __typename?: 'storyTemplates_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storyTemplates" */
export type StoryTemplates_Stddev_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storyTemplates" */
export type StoryTemplates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryTemplates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryTemplates_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customCssCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  paddingBottom?: InputMaybe<Scalars['Int']['input']>;
  paddingTop?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['timestamp']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StoryStates_Enum>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnailRelativePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<StoryVisibilities_Enum>;
};

/** aggregate sum on columns */
export type StoryTemplates_Sum_Fields = {
  __typename?: 'storyTemplates_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storyTemplates" */
export type StoryTemplates_Sum_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** update columns of table "storyTemplates" */
export enum StoryTemplates_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomCssCode = 'customCssCode',
  /** column name */
  Description = 'description',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  PaddingBottom = 'paddingBottom',
  /** column name */
  PaddingTop = 'paddingTop',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  PublishedBy = 'publishedBy',
  /** column name */
  State = 'state',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  ThumbnailRelativePath = 'thumbnailRelativePath',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Visibility = 'visibility'
}

export type StoryTemplates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryTemplates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryTemplates_Set_Input>;
  where: StoryTemplates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryTemplates_Var_Pop_Fields = {
  __typename?: 'storyTemplates_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storyTemplates" */
export type StoryTemplates_Var_Pop_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type StoryTemplates_Var_Samp_Fields = {
  __typename?: 'storyTemplates_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storyTemplates" */
export type StoryTemplates_Var_Samp_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type StoryTemplates_Variance_Fields = {
  __typename?: 'storyTemplates_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  paddingBottom?: Maybe<Scalars['Float']['output']>;
  paddingTop?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storyTemplates" */
export type StoryTemplates_Variance_Order_By = {
  entityId?: InputMaybe<Order_By>;
  paddingBottom?: InputMaybe<Order_By>;
  paddingTop?: InputMaybe<Order_By>;
};

/** columns and relationships of "storyUsers" */
export type StoryUsers = {
  __typename?: 'storyUsers';
  _id: Scalars['String']['output'];
  /** An array relationship */
  authoredStories: Array<Stories>;
  /** An aggregate relationship */
  authoredStories_aggregate: Stories_Aggregate;
  /** An array relationship */
  authoredTemplates: Array<StoryTemplates>;
  /** An aggregate relationship */
  authoredTemplates_aggregate: StoryTemplates_Aggregate;
  /** An array relationship */
  authoriedStoryContents: Array<StoryContents>;
  /** An aggregate relationship */
  authoriedStoryContents_aggregate: StoryContents_Aggregate;
  email: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  opengovId: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "storyUsers" */
export type StoryUsersAuthoredStoriesArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


/** columns and relationships of "storyUsers" */
export type StoryUsersAuthoredStories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


/** columns and relationships of "storyUsers" */
export type StoryUsersAuthoredTemplatesArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplates_Order_By>>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};


/** columns and relationships of "storyUsers" */
export type StoryUsersAuthoredTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplates_Order_By>>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};


/** columns and relationships of "storyUsers" */
export type StoryUsersAuthoriedStoryContentsArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


/** columns and relationships of "storyUsers" */
export type StoryUsersAuthoriedStoryContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};

/** aggregated selection of "storyUsers" */
export type StoryUsers_Aggregate = {
  __typename?: 'storyUsers_aggregate';
  aggregate?: Maybe<StoryUsers_Aggregate_Fields>;
  nodes: Array<StoryUsers>;
};

/** aggregate fields of "storyUsers" */
export type StoryUsers_Aggregate_Fields = {
  __typename?: 'storyUsers_aggregate_fields';
  avg?: Maybe<StoryUsers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StoryUsers_Max_Fields>;
  min?: Maybe<StoryUsers_Min_Fields>;
  stddev?: Maybe<StoryUsers_Stddev_Fields>;
  stddev_pop?: Maybe<StoryUsers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoryUsers_Stddev_Samp_Fields>;
  sum?: Maybe<StoryUsers_Sum_Fields>;
  var_pop?: Maybe<StoryUsers_Var_Pop_Fields>;
  var_samp?: Maybe<StoryUsers_Var_Samp_Fields>;
  variance?: Maybe<StoryUsers_Variance_Fields>;
};


/** aggregate fields of "storyUsers" */
export type StoryUsers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type StoryUsers_Avg_Fields = {
  __typename?: 'storyUsers_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  opengovId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storyUsers". All fields are combined with a logical 'AND'. */
export type StoryUsers_Bool_Exp = {
  _and?: InputMaybe<Array<StoryUsers_Bool_Exp>>;
  _id?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<StoryUsers_Bool_Exp>;
  _or?: InputMaybe<Array<StoryUsers_Bool_Exp>>;
  authoredStories?: InputMaybe<Stories_Bool_Exp>;
  authoredStories_aggregate?: InputMaybe<Stories_Aggregate_Bool_Exp>;
  authoredTemplates?: InputMaybe<StoryTemplates_Bool_Exp>;
  authoredTemplates_aggregate?: InputMaybe<StoryTemplates_Aggregate_Bool_Exp>;
  authoriedStoryContents?: InputMaybe<StoryContents_Bool_Exp>;
  authoriedStoryContents_aggregate?: InputMaybe<StoryContents_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  opengovId?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyUsers" */
export enum StoryUsers_Constraint {
  /** unique or primary key constraint on columns "_id" */
  StoryUsersIdKey = 'storyUsers__id_key',
  /** unique or primary key constraint on columns "email" */
  StoryUsersEmailKey = 'storyUsers_email_key',
  /** unique or primary key constraint on columns "opengovId" */
  StoryUsersOgIdKey = 'storyUsers_og_id_key',
  /** unique or primary key constraint on columns "_id" */
  StoryUsersPkey = 'storyUsers_pkey'
}

/** input type for incrementing numeric columns in table "storyUsers" */
export type StoryUsers_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  opengovId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storyUsers" */
export type StoryUsers_Insert_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  authoredStories?: InputMaybe<Stories_Arr_Rel_Insert_Input>;
  authoredTemplates?: InputMaybe<StoryTemplates_Arr_Rel_Insert_Input>;
  authoriedStoryContents?: InputMaybe<StoryContents_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  opengovId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryUsers_Max_Fields = {
  __typename?: 'storyUsers_max_fields';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  opengovId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type StoryUsers_Min_Fields = {
  __typename?: 'storyUsers_min_fields';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  opengovId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storyUsers" */
export type StoryUsers_Mutation_Response = {
  __typename?: 'storyUsers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryUsers>;
};

/** input type for inserting object relation for remote table "storyUsers" */
export type StoryUsers_Obj_Rel_Insert_Input = {
  data: StoryUsers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StoryUsers_On_Conflict>;
};

/** on_conflict condition type for table "storyUsers" */
export type StoryUsers_On_Conflict = {
  constraint: StoryUsers_Constraint;
  update_columns?: Array<StoryUsers_Update_Column>;
  where?: InputMaybe<StoryUsers_Bool_Exp>;
};

/** Ordering options when selecting data from "storyUsers". */
export type StoryUsers_Order_By = {
  _id?: InputMaybe<Order_By>;
  authoredStories_aggregate?: InputMaybe<Stories_Aggregate_Order_By>;
  authoredTemplates_aggregate?: InputMaybe<StoryTemplates_Aggregate_Order_By>;
  authoriedStoryContents_aggregate?: InputMaybe<StoryContents_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  opengovId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyUsers */
export type StoryUsers_Pk_Columns_Input = {
  _id: Scalars['String']['input'];
};

/** select columns of table "storyUsers" */
export enum StoryUsers_Select_Column {
  /** column name */
  Id = '_id',
  /** column name */
  Email = 'email',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OpengovId = 'opengovId',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "storyUsers" */
export type StoryUsers_Set_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  opengovId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type StoryUsers_Stddev_Fields = {
  __typename?: 'storyUsers_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  opengovId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type StoryUsers_Stddev_Pop_Fields = {
  __typename?: 'storyUsers_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  opengovId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type StoryUsers_Stddev_Samp_Fields = {
  __typename?: 'storyUsers_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  opengovId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "storyUsers" */
export type StoryUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryUsers_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  opengovId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type StoryUsers_Sum_Fields = {
  __typename?: 'storyUsers_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
  opengovId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storyUsers" */
export enum StoryUsers_Update_Column {
  /** column name */
  Id = '_id',
  /** column name */
  Email = 'email',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OpengovId = 'opengovId',
  /** column name */
  Title = 'title'
}

export type StoryUsers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoryUsers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryUsers_Set_Input>;
  where: StoryUsers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoryUsers_Var_Pop_Fields = {
  __typename?: 'storyUsers_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  opengovId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type StoryUsers_Var_Samp_Fields = {
  __typename?: 'storyUsers_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  opengovId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type StoryUsers_Variance_Fields = {
  __typename?: 'storyUsers_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
  opengovId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "storyVisibilities" */
export type StoryVisibilities = {
  __typename?: 'storyVisibilities';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "storyVisibilities" */
export type StoryVisibilities_Aggregate = {
  __typename?: 'storyVisibilities_aggregate';
  aggregate?: Maybe<StoryVisibilities_Aggregate_Fields>;
  nodes: Array<StoryVisibilities>;
};

/** aggregate fields of "storyVisibilities" */
export type StoryVisibilities_Aggregate_Fields = {
  __typename?: 'storyVisibilities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<StoryVisibilities_Max_Fields>;
  min?: Maybe<StoryVisibilities_Min_Fields>;
};


/** aggregate fields of "storyVisibilities" */
export type StoryVisibilities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoryVisibilities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "storyVisibilities". All fields are combined with a logical 'AND'. */
export type StoryVisibilities_Bool_Exp = {
  _and?: InputMaybe<Array<StoryVisibilities_Bool_Exp>>;
  _not?: InputMaybe<StoryVisibilities_Bool_Exp>;
  _or?: InputMaybe<Array<StoryVisibilities_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storyVisibilities" */
export enum StoryVisibilities_Constraint {
  /** unique or primary key constraint on columns "value" */
  StoryVisibilitiesPkey = 'storyVisibilities_pkey'
}

export enum StoryVisibilities_Enum {
  /** Network */
  Network = 'network',
  /** Organization */
  Organization = 'organization',
  /** Private */
  Private = 'private'
}

/** Boolean expression to compare columns of type "storyVisibilities_enum". All fields are combined with logical 'AND'. */
export type StoryVisibilities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<StoryVisibilities_Enum>;
  _in?: InputMaybe<Array<StoryVisibilities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<StoryVisibilities_Enum>;
  _nin?: InputMaybe<Array<StoryVisibilities_Enum>>;
};

/** input type for inserting data into table "storyVisibilities" */
export type StoryVisibilities_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type StoryVisibilities_Max_Fields = {
  __typename?: 'storyVisibilities_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type StoryVisibilities_Min_Fields = {
  __typename?: 'storyVisibilities_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storyVisibilities" */
export type StoryVisibilities_Mutation_Response = {
  __typename?: 'storyVisibilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StoryVisibilities>;
};

/** on_conflict condition type for table "storyVisibilities" */
export type StoryVisibilities_On_Conflict = {
  constraint: StoryVisibilities_Constraint;
  update_columns?: Array<StoryVisibilities_Update_Column>;
  where?: InputMaybe<StoryVisibilities_Bool_Exp>;
};

/** Ordering options when selecting data from "storyVisibilities". */
export type StoryVisibilities_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storyVisibilities */
export type StoryVisibilities_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "storyVisibilities" */
export enum StoryVisibilities_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "storyVisibilities" */
export type StoryVisibilities_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "storyVisibilities" */
export type StoryVisibilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoryVisibilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoryVisibilities_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storyVisibilities" */
export enum StoryVisibilities_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type StoryVisibilities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoryVisibilities_Set_Input>;
  where: StoryVisibilities_Bool_Exp;
};

/** columns and relationships of "subjectPublicationClaims" */
export type SubjectPublicationClaims = {
  __typename?: 'subjectPublicationClaims';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  publication: Publications;
  publicationClaim: Scalars['String']['output'];
  publicationId: Scalars['uuid']['output'];
  sectionIds: Scalars['jsonb']['output'];
  subjectId: Scalars['uuid']['output'];
  subjectType: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "subjectPublicationClaims" */
export type SubjectPublicationClaimsSectionIdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "subjectPublicationClaims" */
export type SubjectPublicationClaims_Aggregate = {
  __typename?: 'subjectPublicationClaims_aggregate';
  aggregate?: Maybe<SubjectPublicationClaims_Aggregate_Fields>;
  nodes: Array<SubjectPublicationClaims>;
};

export type SubjectPublicationClaims_Aggregate_Bool_Exp = {
  count?: InputMaybe<SubjectPublicationClaims_Aggregate_Bool_Exp_Count>;
};

export type SubjectPublicationClaims_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subjectPublicationClaims" */
export type SubjectPublicationClaims_Aggregate_Fields = {
  __typename?: 'subjectPublicationClaims_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SubjectPublicationClaims_Max_Fields>;
  min?: Maybe<SubjectPublicationClaims_Min_Fields>;
};


/** aggregate fields of "subjectPublicationClaims" */
export type SubjectPublicationClaims_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SubjectPublicationClaims_Max_Order_By>;
  min?: InputMaybe<SubjectPublicationClaims_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SubjectPublicationClaims_Append_Input = {
  sectionIds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Arr_Rel_Insert_Input = {
  data: Array<SubjectPublicationClaims_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SubjectPublicationClaims_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subjectPublicationClaims". All fields are combined with a logical 'AND'. */
export type SubjectPublicationClaims_Bool_Exp = {
  _and?: InputMaybe<Array<SubjectPublicationClaims_Bool_Exp>>;
  _not?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
  _or?: InputMaybe<Array<SubjectPublicationClaims_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationClaim?: InputMaybe<String_Comparison_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  sectionIds?: InputMaybe<Jsonb_Comparison_Exp>;
  subjectId?: InputMaybe<Uuid_Comparison_Exp>;
  subjectType?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subjectPublicationClaims" */
export enum SubjectPublicationClaims_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubjectPublicationClaimsPkey = 'subjectPublicationClaims_pkey',
  /** unique or primary key constraint on columns "subjectId", "publicationId", "subjectType" */
  SubjectPublicationClaimsSubjectIdSubjectTypePublicationIKey = 'subjectPublicationClaims_subjectId_subjectType_publicationI_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SubjectPublicationClaims_Delete_At_Path_Input = {
  sectionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SubjectPublicationClaims_Delete_Elem_Input = {
  sectionIds?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SubjectPublicationClaims_Delete_Key_Input = {
  sectionIds?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationClaim?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  sectionIds?: InputMaybe<Scalars['jsonb']['input']>;
  subjectId?: InputMaybe<Scalars['uuid']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type SubjectPublicationClaims_Max_Fields = {
  __typename?: 'subjectPublicationClaims_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationClaim?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  subjectId?: Maybe<Scalars['uuid']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicationClaim?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  subjectType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SubjectPublicationClaims_Min_Fields = {
  __typename?: 'subjectPublicationClaims_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationClaim?: Maybe<Scalars['String']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  subjectId?: Maybe<Scalars['uuid']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicationClaim?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  subjectType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Mutation_Response = {
  __typename?: 'subjectPublicationClaims_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SubjectPublicationClaims>;
};

/** on_conflict condition type for table "subjectPublicationClaims" */
export type SubjectPublicationClaims_On_Conflict = {
  constraint: SubjectPublicationClaims_Constraint;
  update_columns?: Array<SubjectPublicationClaims_Update_Column>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};

/** Ordering options when selecting data from "subjectPublicationClaims". */
export type SubjectPublicationClaims_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationClaim?: InputMaybe<Order_By>;
  publicationId?: InputMaybe<Order_By>;
  sectionIds?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  subjectType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subjectPublicationClaims */
export type SubjectPublicationClaims_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SubjectPublicationClaims_Prepend_Input = {
  sectionIds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "subjectPublicationClaims" */
export enum SubjectPublicationClaims_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PublicationClaim = 'publicationClaim',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  SectionIds = 'sectionIds',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  SubjectType = 'subjectType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationClaim?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  sectionIds?: InputMaybe<Scalars['jsonb']['input']>;
  subjectId?: InputMaybe<Scalars['uuid']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "subjectPublicationClaims" */
export type SubjectPublicationClaims_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SubjectPublicationClaims_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SubjectPublicationClaims_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationClaim?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  sectionIds?: InputMaybe<Scalars['jsonb']['input']>;
  subjectId?: InputMaybe<Scalars['uuid']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "subjectPublicationClaims" */
export enum SubjectPublicationClaims_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PublicationClaim = 'publicationClaim',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  SectionIds = 'sectionIds',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  SubjectType = 'subjectType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SubjectPublicationClaims_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SubjectPublicationClaims_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SubjectPublicationClaims_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SubjectPublicationClaims_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SubjectPublicationClaims_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SubjectPublicationClaims_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SubjectPublicationClaims_Set_Input>;
  where: SubjectPublicationClaims_Bool_Exp;
};

/** columns and relationships of "subjectStoryClaims" */
export type SubjectStoryClaims = {
  __typename?: 'subjectStoryClaims';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  story: Stories;
  storyClaims: Scalars['jsonb']['output'];
  storyId: Scalars['String']['output'];
  subjectId: Scalars['uuid']['output'];
  subjectType: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "subjectStoryClaims" */
export type SubjectStoryClaimsStoryClaimsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "subjectStoryClaims" */
export type SubjectStoryClaims_Aggregate = {
  __typename?: 'subjectStoryClaims_aggregate';
  aggregate?: Maybe<SubjectStoryClaims_Aggregate_Fields>;
  nodes: Array<SubjectStoryClaims>;
};

export type SubjectStoryClaims_Aggregate_Bool_Exp = {
  count?: InputMaybe<SubjectStoryClaims_Aggregate_Bool_Exp_Count>;
};

export type SubjectStoryClaims_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subjectStoryClaims" */
export type SubjectStoryClaims_Aggregate_Fields = {
  __typename?: 'subjectStoryClaims_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SubjectStoryClaims_Max_Fields>;
  min?: Maybe<SubjectStoryClaims_Min_Fields>;
};


/** aggregate fields of "subjectStoryClaims" */
export type SubjectStoryClaims_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subjectStoryClaims" */
export type SubjectStoryClaims_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SubjectStoryClaims_Max_Order_By>;
  min?: InputMaybe<SubjectStoryClaims_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SubjectStoryClaims_Append_Input = {
  storyClaims?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "subjectStoryClaims" */
export type SubjectStoryClaims_Arr_Rel_Insert_Input = {
  data: Array<SubjectStoryClaims_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SubjectStoryClaims_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subjectStoryClaims". All fields are combined with a logical 'AND'. */
export type SubjectStoryClaims_Bool_Exp = {
  _and?: InputMaybe<Array<SubjectStoryClaims_Bool_Exp>>;
  _not?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
  _or?: InputMaybe<Array<SubjectStoryClaims_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  story?: InputMaybe<Stories_Bool_Exp>;
  storyClaims?: InputMaybe<Jsonb_Comparison_Exp>;
  storyId?: InputMaybe<String_Comparison_Exp>;
  subjectId?: InputMaybe<Uuid_Comparison_Exp>;
  subjectType?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subjectStoryClaims" */
export enum SubjectStoryClaims_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubjectStoryClaimsPkey = 'subjectStoryClaims_pkey',
  /** unique or primary key constraint on columns "subjectId", "subjectType", "storyId" */
  SubjectStoryClaimsSubjectIdSubjectTypeStoryIdKey = 'subjectStoryClaims_subjectId_subjectType_storyId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SubjectStoryClaims_Delete_At_Path_Input = {
  storyClaims?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SubjectStoryClaims_Delete_Elem_Input = {
  storyClaims?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SubjectStoryClaims_Delete_Key_Input = {
  storyClaims?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "subjectStoryClaims" */
export type SubjectStoryClaims_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  story?: InputMaybe<Stories_Obj_Rel_Insert_Input>;
  storyClaims?: InputMaybe<Scalars['jsonb']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['uuid']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type SubjectStoryClaims_Max_Fields = {
  __typename?: 'subjectStoryClaims_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['uuid']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subjectStoryClaims" */
export type SubjectStoryClaims_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  subjectType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SubjectStoryClaims_Min_Fields = {
  __typename?: 'subjectStoryClaims_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  storyId?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['uuid']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subjectStoryClaims" */
export type SubjectStoryClaims_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  subjectType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subjectStoryClaims" */
export type SubjectStoryClaims_Mutation_Response = {
  __typename?: 'subjectStoryClaims_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SubjectStoryClaims>;
};

/** on_conflict condition type for table "subjectStoryClaims" */
export type SubjectStoryClaims_On_Conflict = {
  constraint: SubjectStoryClaims_Constraint;
  update_columns?: Array<SubjectStoryClaims_Update_Column>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};

/** Ordering options when selecting data from "subjectStoryClaims". */
export type SubjectStoryClaims_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  story?: InputMaybe<Stories_Order_By>;
  storyClaims?: InputMaybe<Order_By>;
  storyId?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  subjectType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subjectStoryClaims */
export type SubjectStoryClaims_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SubjectStoryClaims_Prepend_Input = {
  storyClaims?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "subjectStoryClaims" */
export enum SubjectStoryClaims_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  StoryClaims = 'storyClaims',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  SubjectType = 'subjectType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "subjectStoryClaims" */
export type SubjectStoryClaims_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  storyClaims?: InputMaybe<Scalars['jsonb']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['uuid']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "subjectStoryClaims" */
export type SubjectStoryClaims_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SubjectStoryClaims_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SubjectStoryClaims_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  storyClaims?: InputMaybe<Scalars['jsonb']['input']>;
  storyId?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['uuid']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "subjectStoryClaims" */
export enum SubjectStoryClaims_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  StoryClaims = 'storyClaims',
  /** column name */
  StoryId = 'storyId',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  SubjectType = 'subjectType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SubjectStoryClaims_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SubjectStoryClaims_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SubjectStoryClaims_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SubjectStoryClaims_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SubjectStoryClaims_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SubjectStoryClaims_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SubjectStoryClaims_Set_Input>;
  where: SubjectStoryClaims_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "asyncJobs" */
  asyncJobs: Array<AsyncJobs>;
  /** fetch aggregated fields from the table: "asyncJobs" */
  asyncJobs_aggregate: AsyncJobs_Aggregate;
  /** fetch data from the table: "asyncJobs" using primary key columns */
  asyncJobs_by_pk?: Maybe<AsyncJobs>;
  /** fetch data from the table in a streaming manner: "asyncJobs" */
  asyncJobs_stream: Array<AsyncJobs>;
  /** fetch data from the table: "chartsConfig" */
  chartsConfig: Array<ChartsConfig>;
  /** fetch aggregated fields from the table: "chartsConfig" */
  chartsConfig_aggregate: ChartsConfig_Aggregate;
  /** fetch data from the table: "chartsConfig" using primary key columns */
  chartsConfig_by_pk?: Maybe<ChartsConfig>;
  /** fetch data from the table in a streaming manner: "chartsConfig" */
  chartsConfig_stream: Array<ChartsConfig>;
  /** fetch data from the table: "copyProcessStatuses" */
  copyProcessStatuses: Array<CopyProcessStatuses>;
  /** fetch aggregated fields from the table: "copyProcessStatuses" */
  copyProcessStatuses_aggregate: CopyProcessStatuses_Aggregate;
  /** fetch data from the table: "copyProcessStatuses" using primary key columns */
  copyProcessStatuses_by_pk?: Maybe<CopyProcessStatuses>;
  /** fetch data from the table in a streaming manner: "copyProcessStatuses" */
  copyProcessStatuses_stream: Array<CopyProcessStatuses>;
  /** fetch data from the table: "entityProgressTrackerSettings" */
  entityProgressTrackerSettings: Array<EntityProgressTrackerSettings>;
  /** fetch aggregated fields from the table: "entityProgressTrackerSettings" */
  entityProgressTrackerSettings_aggregate: EntityProgressTrackerSettings_Aggregate;
  /** fetch data from the table: "entityProgressTrackerSettings" using primary key columns */
  entityProgressTrackerSettings_by_pk?: Maybe<EntityProgressTrackerSettings>;
  /** fetch data from the table in a streaming manner: "entityProgressTrackerSettings" */
  entityProgressTrackerSettings_stream: Array<EntityProgressTrackerSettings>;
  /** fetch data from the table: "entityStoryColorSettings" */
  entityStoryColorSettings: Array<EntityStoryColorSettings>;
  /** fetch aggregated fields from the table: "entityStoryColorSettings" */
  entityStoryColorSettings_aggregate: EntityStoryColorSettings_Aggregate;
  /** fetch data from the table: "entityStoryColorSettings" using primary key columns */
  entityStoryColorSettings_by_pk?: Maybe<EntityStoryColorSettings>;
  /** fetch data from the table in a streaming manner: "entityStoryColorSettings" */
  entityStoryColorSettings_stream: Array<EntityStoryColorSettings>;
  /** fetch data from the table: "entityStorySettings" */
  entityStorySettings: Array<EntityStorySettings>;
  /** fetch aggregated fields from the table: "entityStorySettings" */
  entityStorySettings_aggregate: EntityStorySettings_Aggregate;
  /** fetch data from the table: "entityStorySettings" using primary key columns */
  entityStorySettings_by_pk?: Maybe<EntityStorySettings>;
  /** fetch data from the table in a streaming manner: "entityStorySettings" */
  entityStorySettings_stream: Array<EntityStorySettings>;
  /** fetch data from the table: "exportFolderPdfRequests" */
  exportFolderPdfRequests: Array<ExportFolderPdfRequests>;
  /** fetch aggregated fields from the table: "exportFolderPdfRequests" */
  exportFolderPdfRequests_aggregate: ExportFolderPdfRequests_Aggregate;
  /** fetch data from the table: "exportFolderPdfRequests" using primary key columns */
  exportFolderPdfRequests_by_pk?: Maybe<ExportFolderPdfRequests>;
  /** fetch data from the table in a streaming manner: "exportFolderPdfRequests" */
  exportFolderPdfRequests_stream: Array<ExportFolderPdfRequests>;
  /** fetch data from the table: "exportStoriesChunks" */
  exportStoriesChunks: Array<ExportStoriesChunks>;
  /** fetch aggregated fields from the table: "exportStoriesChunks" */
  exportStoriesChunks_aggregate: ExportStoriesChunks_Aggregate;
  /** fetch data from the table in a streaming manner: "exportStoriesChunks" */
  exportStoriesChunks_stream: Array<ExportStoriesChunks>;
  /** fetch data from the table: "internalPublishedStory" */
  internalPublishedStory: Array<InternalPublishedStory>;
  /** fetch aggregated fields from the table: "internalPublishedStory" */
  internalPublishedStory_aggregate: InternalPublishedStory_Aggregate;
  /** fetch data from the table: "internalPublishedStory" using primary key columns */
  internalPublishedStory_by_pk?: Maybe<InternalPublishedStory>;
  /** fetch data from the table in a streaming manner: "internalPublishedStory" */
  internalPublishedStory_stream: Array<InternalPublishedStory>;
  /** fetch data from the table: "portalStory" */
  portalStory: Array<PortalStory>;
  /** fetch aggregated fields from the table: "portalStory" */
  portalStory_aggregate: PortalStory_Aggregate;
  /** fetch data from the table: "portalStory" using primary key columns */
  portalStory_by_pk?: Maybe<PortalStory>;
  /** fetch data from the table in a streaming manner: "portalStory" */
  portalStory_stream: Array<PortalStory>;
  /** fetch data from the table: "publicationBrandings" */
  publicationBrandings: Array<PublicationBrandings>;
  /** fetch aggregated fields from the table: "publicationBrandings" */
  publicationBrandings_aggregate: PublicationBrandings_Aggregate;
  /** fetch data from the table: "publicationBrandings" using primary key columns */
  publicationBrandings_by_pk?: Maybe<PublicationBrandings>;
  /** fetch data from the table in a streaming manner: "publicationBrandings" */
  publicationBrandings_stream: Array<PublicationBrandings>;
  /** fetch data from the table: "publicationExportPdfRequest" */
  publicationExportPdfRequest: Array<PublicationExportPdfRequest>;
  /** fetch aggregated fields from the table: "publicationExportPdfRequest" */
  publicationExportPdfRequest_aggregate: PublicationExportPdfRequest_Aggregate;
  /** fetch data from the table: "publicationExportPdfRequest" using primary key columns */
  publicationExportPdfRequest_by_pk?: Maybe<PublicationExportPdfRequest>;
  /** fetch data from the table in a streaming manner: "publicationExportPdfRequest" */
  publicationExportPdfRequest_stream: Array<PublicationExportPdfRequest>;
  /** An array relationship */
  publicationFolders: Array<PublicationFolders>;
  /** An aggregate relationship */
  publicationFolders_aggregate: PublicationFolders_Aggregate;
  /** fetch data from the table: "publicationFolders" using primary key columns */
  publicationFolders_by_pk?: Maybe<PublicationFolders>;
  /** fetch data from the table in a streaming manner: "publicationFolders" */
  publicationFolders_stream: Array<PublicationFolders>;
  /** fetch data from the table: "publicationFooterSettings" */
  publicationFooterSettings: Array<PublicationFooterSettings>;
  /** fetch aggregated fields from the table: "publicationFooterSettings" */
  publicationFooterSettings_aggregate: PublicationFooterSettings_Aggregate;
  /** fetch data from the table: "publicationFooterSettings" using primary key columns */
  publicationFooterSettings_by_pk?: Maybe<PublicationFooterSettings>;
  /** fetch data from the table in a streaming manner: "publicationFooterSettings" */
  publicationFooterSettings_stream: Array<PublicationFooterSettings>;
  /** An array relationship */
  publicationNavigationMenuItems: Array<PublicationNavigationMenuItems>;
  /** An aggregate relationship */
  publicationNavigationMenuItems_aggregate: PublicationNavigationMenuItems_Aggregate;
  /** fetch data from the table: "publicationNavigationMenuItems" using primary key columns */
  publicationNavigationMenuItems_by_pk?: Maybe<PublicationNavigationMenuItems>;
  /** fetch data from the table in a streaming manner: "publicationNavigationMenuItems" */
  publicationNavigationMenuItems_stream: Array<PublicationNavigationMenuItems>;
  /** An array relationship */
  publicationNavigationMenuStories: Array<PublicationNavigationMenuStories>;
  /** An aggregate relationship */
  publicationNavigationMenuStories_aggregate: PublicationNavigationMenuStories_Aggregate;
  /** fetch data from the table: "publicationNavigationMenuStories" using primary key columns */
  publicationNavigationMenuStories_by_pk?: Maybe<PublicationNavigationMenuStories>;
  /** fetch data from the table in a streaming manner: "publicationNavigationMenuStories" */
  publicationNavigationMenuStories_stream: Array<PublicationNavigationMenuStories>;
  /** fetch data from the table: "publicationSetupPdfStyles" */
  publicationSetupPdfStyles: Array<PublicationSetupPdfStyles>;
  /** fetch aggregated fields from the table: "publicationSetupPdfStyles" */
  publicationSetupPdfStyles_aggregate: PublicationSetupPdfStyles_Aggregate;
  /** fetch data from the table: "publicationSetupPdfStyles" using primary key columns */
  publicationSetupPdfStyles_by_pk?: Maybe<PublicationSetupPdfStyles>;
  /** fetch data from the table in a streaming manner: "publicationSetupPdfStyles" */
  publicationSetupPdfStyles_stream: Array<PublicationSetupPdfStyles>;
  /** fetch data from the table: "publicationStoryPdfSettings" */
  publicationStoryPdfSettings: Array<PublicationStoryPdfSettings>;
  /** fetch aggregated fields from the table: "publicationStoryPdfSettings" */
  publicationStoryPdfSettings_aggregate: PublicationStoryPdfSettings_Aggregate;
  /** fetch data from the table: "publicationStoryPdfSettings" using primary key columns */
  publicationStoryPdfSettings_by_pk?: Maybe<PublicationStoryPdfSettings>;
  /** fetch data from the table in a streaming manner: "publicationStoryPdfSettings" */
  publicationStoryPdfSettings_stream: Array<PublicationStoryPdfSettings>;
  /** fetch data from the table: "publicationTOCSettings" */
  publicationTOCSettings: Array<PublicationTocSettings>;
  /** fetch aggregated fields from the table: "publicationTOCSettings" */
  publicationTOCSettings_aggregate: PublicationTocSettings_Aggregate;
  /** fetch data from the table: "publicationTOCSettings" using primary key columns */
  publicationTOCSettings_by_pk?: Maybe<PublicationTocSettings>;
  /** fetch data from the table in a streaming manner: "publicationTOCSettings" */
  publicationTOCSettings_stream: Array<PublicationTocSettings>;
  /** fetch data from the table: "publications" */
  publications: Array<Publications>;
  /** fetch aggregated fields from the table: "publications" */
  publications_aggregate: Publications_Aggregate;
  /** fetch data from the table: "publications" using primary key columns */
  publications_by_pk?: Maybe<Publications>;
  /** fetch data from the table in a streaming manner: "publications" */
  publications_stream: Array<Publications>;
  /** An array relationship */
  spreadsheetNamedRanges: Array<SpreadsheetNamedRanges>;
  /** An aggregate relationship */
  spreadsheetNamedRanges_aggregate: SpreadsheetNamedRanges_Aggregate;
  /** fetch data from the table: "spreadsheetNamedRanges" using primary key columns */
  spreadsheetNamedRanges_by_pk?: Maybe<SpreadsheetNamedRanges>;
  /** fetch data from the table in a streaming manner: "spreadsheetNamedRanges" */
  spreadsheetNamedRanges_stream: Array<SpreadsheetNamedRanges>;
  /** fetch data from the table: "spreadsheetSplitTables" */
  spreadsheetSplitTables: Array<SpreadsheetSplitTables>;
  /** fetch aggregated fields from the table: "spreadsheetSplitTables" */
  spreadsheetSplitTables_aggregate: SpreadsheetSplitTables_Aggregate;
  /** fetch data from the table: "spreadsheetSplitTables" using primary key columns */
  spreadsheetSplitTables_by_pk?: Maybe<SpreadsheetSplitTables>;
  /** fetch data from the table in a streaming manner: "spreadsheetSplitTables" */
  spreadsheetSplitTables_stream: Array<SpreadsheetSplitTables>;
  /** fetch data from the table: "spreadsheetStoryCounts" */
  spreadsheetStoryCounts: Array<SpreadsheetStoryCounts>;
  /** fetch aggregated fields from the table: "spreadsheetStoryCounts" */
  spreadsheetStoryCounts_aggregate: SpreadsheetStoryCounts_Aggregate;
  /** fetch data from the table in a streaming manner: "spreadsheetStoryCounts" */
  spreadsheetStoryCounts_stream: Array<SpreadsheetStoryCounts>;
  /** fetch data from the table: "spreadsheets" */
  spreadsheets: Array<Spreadsheets>;
  /** fetch data from the table: "spreadsheetsProcessingStatus" */
  spreadsheetsProcessingStatus: Array<SpreadsheetsProcessingStatus>;
  /** fetch aggregated fields from the table: "spreadsheetsProcessingStatus" */
  spreadsheetsProcessingStatus_aggregate: SpreadsheetsProcessingStatus_Aggregate;
  /** fetch data from the table: "spreadsheetsProcessingStatus" using primary key columns */
  spreadsheetsProcessingStatus_by_pk?: Maybe<SpreadsheetsProcessingStatus>;
  /** fetch data from the table in a streaming manner: "spreadsheetsProcessingStatus" */
  spreadsheetsProcessingStatus_stream: Array<SpreadsheetsProcessingStatus>;
  /** fetch aggregated fields from the table: "spreadsheets" */
  spreadsheets_aggregate: Spreadsheets_Aggregate;
  /** fetch data from the table: "spreadsheets" using primary key columns */
  spreadsheets_by_pk?: Maybe<Spreadsheets>;
  /** fetch data from the table in a streaming manner: "spreadsheets" */
  spreadsheets_stream: Array<Spreadsheets>;
  /** An array relationship */
  stories: Array<Stories>;
  /** An array relationship */
  storiesCopyProcesses: Array<StoriesCopyProcesses>;
  /** An aggregate relationship */
  storiesCopyProcesses_aggregate: StoriesCopyProcesses_Aggregate;
  /** fetch data from the table: "storiesCopyProcesses" using primary key columns */
  storiesCopyProcesses_by_pk?: Maybe<StoriesCopyProcesses>;
  /** fetch data from the table in a streaming manner: "storiesCopyProcesses" */
  storiesCopyProcesses_stream: Array<StoriesCopyProcesses>;
  /** An aggregate relationship */
  stories_aggregate: Stories_Aggregate;
  /** fetch data from the table: "stories" using primary key columns */
  stories_by_pk?: Maybe<Stories>;
  /** fetch data from the table in a streaming manner: "stories" */
  stories_stream: Array<Stories>;
  /** fetch data from the table: "storyBudgetProposals" */
  storyBudgetProposals: Array<StoryBudgetProposals>;
  /** fetch aggregated fields from the table: "storyBudgetProposals" */
  storyBudgetProposals_aggregate: StoryBudgetProposals_Aggregate;
  /** fetch data from the table: "storyBudgetProposals" using primary key columns */
  storyBudgetProposals_by_pk?: Maybe<StoryBudgetProposals>;
  /** fetch data from the table in a streaming manner: "storyBudgetProposals" */
  storyBudgetProposals_stream: Array<StoryBudgetProposals>;
  /** fetch data from the table: "storyContentBlockTypes" */
  storyContentBlockTypes: Array<StoryContentBlockTypes>;
  /** fetch aggregated fields from the table: "storyContentBlockTypes" */
  storyContentBlockTypes_aggregate: StoryContentBlockTypes_Aggregate;
  /** fetch data from the table: "storyContentBlockTypes" using primary key columns */
  storyContentBlockTypes_by_pk?: Maybe<StoryContentBlockTypes>;
  /** fetch data from the table in a streaming manner: "storyContentBlockTypes" */
  storyContentBlockTypes_stream: Array<StoryContentBlockTypes>;
  /** fetch data from the table: "storyContentBlocks" */
  storyContentBlocks: Array<StoryContentBlocks>;
  /** fetch aggregated fields from the table: "storyContentBlocks" */
  storyContentBlocks_aggregate: StoryContentBlocks_Aggregate;
  /** fetch data from the table: "storyContentBlocks" using primary key columns */
  storyContentBlocks_by_pk?: Maybe<StoryContentBlocks>;
  /** fetch data from the table in a streaming manner: "storyContentBlocks" */
  storyContentBlocks_stream: Array<StoryContentBlocks>;
  /** fetch data from the table: "storyContentColorTargets" */
  storyContentColorTargets: Array<StoryContentColorTargets>;
  /** fetch aggregated fields from the table: "storyContentColorTargets" */
  storyContentColorTargets_aggregate: StoryContentColorTargets_Aggregate;
  /** fetch data from the table: "storyContentColorTargets" using primary key columns */
  storyContentColorTargets_by_pk?: Maybe<StoryContentColorTargets>;
  /** fetch data from the table in a streaming manner: "storyContentColorTargets" */
  storyContentColorTargets_stream: Array<StoryContentColorTargets>;
  /** An array relationship */
  storyContentSpreadsheetReferences: Array<StoryContentSpreadsheetReferences>;
  /** An aggregate relationship */
  storyContentSpreadsheetReferences_aggregate: StoryContentSpreadsheetReferences_Aggregate;
  /** fetch data from the table: "storyContentSpreadsheetReferences" using primary key columns */
  storyContentSpreadsheetReferences_by_pk?: Maybe<StoryContentSpreadsheetReferences>;
  /** fetch data from the table in a streaming manner: "storyContentSpreadsheetReferences" */
  storyContentSpreadsheetReferences_stream: Array<StoryContentSpreadsheetReferences>;
  /** fetch data from the table: "storyContentTypes" */
  storyContentTypes: Array<StoryContentTypes>;
  /** fetch aggregated fields from the table: "storyContentTypes" */
  storyContentTypes_aggregate: StoryContentTypes_Aggregate;
  /** fetch data from the table: "storyContentTypes" using primary key columns */
  storyContentTypes_by_pk?: Maybe<StoryContentTypes>;
  /** fetch data from the table in a streaming manner: "storyContentTypes" */
  storyContentTypes_stream: Array<StoryContentTypes>;
  /** fetch data from the table: "storyContents" */
  storyContents: Array<StoryContents>;
  /** fetch aggregated fields from the table: "storyContents" */
  storyContents_aggregate: StoryContents_Aggregate;
  /** fetch data from the table: "storyContents" using primary key columns */
  storyContents_by_pk?: Maybe<StoryContents>;
  /** fetch data from the table in a streaming manner: "storyContents" */
  storyContents_stream: Array<StoryContents>;
  /** An array relationship */
  storyCopyProcesses: Array<StoryCopyProcesses>;
  /** An aggregate relationship */
  storyCopyProcesses_aggregate: StoryCopyProcesses_Aggregate;
  /** fetch data from the table: "storyCopyProcesses" using primary key columns */
  storyCopyProcesses_by_pk?: Maybe<StoryCopyProcesses>;
  /** fetch data from the table in a streaming manner: "storyCopyProcesses" */
  storyCopyProcesses_stream: Array<StoryCopyProcesses>;
  /** fetch data from the table: "storyCustomColors" */
  storyCustomColors: Array<StoryCustomColors>;
  /** fetch aggregated fields from the table: "storyCustomColors" */
  storyCustomColors_aggregate: StoryCustomColors_Aggregate;
  /** fetch data from the table: "storyCustomColors" using primary key columns */
  storyCustomColors_by_pk?: Maybe<StoryCustomColors>;
  /** fetch data from the table in a streaming manner: "storyCustomColors" */
  storyCustomColors_stream: Array<StoryCustomColors>;
  /** fetch data from the table: "storyEmbeds" */
  storyEmbeds: Array<StoryEmbeds>;
  /** fetch aggregated fields from the table: "storyEmbeds" */
  storyEmbeds_aggregate: StoryEmbeds_Aggregate;
  /** fetch data from the table: "storyEmbeds" using primary key columns */
  storyEmbeds_by_pk?: Maybe<StoryEmbeds>;
  /** fetch data from the table in a streaming manner: "storyEmbeds" */
  storyEmbeds_stream: Array<StoryEmbeds>;
  /** fetch data from the table: "storyFolderActionSets" */
  storyFolderActionSets: Array<StoryFolderActionSets>;
  /** fetch aggregated fields from the table: "storyFolderActionSets" */
  storyFolderActionSets_aggregate: StoryFolderActionSets_Aggregate;
  /** fetch data from the table: "storyFolderActionSets" using primary key columns */
  storyFolderActionSets_by_pk?: Maybe<StoryFolderActionSets>;
  /** fetch data from the table in a streaming manner: "storyFolderActionSets" */
  storyFolderActionSets_stream: Array<StoryFolderActionSets>;
  /** An array relationship */
  storyFolderGrants: Array<StoryFolderGrants>;
  /** An aggregate relationship */
  storyFolderGrants_aggregate: StoryFolderGrants_Aggregate;
  /** fetch data from the table: "storyFolderGrants" using primary key columns */
  storyFolderGrants_by_pk?: Maybe<StoryFolderGrants>;
  /** fetch data from the table in a streaming manner: "storyFolderGrants" */
  storyFolderGrants_stream: Array<StoryFolderGrants>;
  /** An array relationship */
  storyFolders: Array<StoryFolders>;
  /** fetch data from the table: "storyFoldersCopyProcesses" */
  storyFoldersCopyProcesses: Array<StoryFoldersCopyProcesses>;
  /** fetch aggregated fields from the table: "storyFoldersCopyProcesses" */
  storyFoldersCopyProcesses_aggregate: StoryFoldersCopyProcesses_Aggregate;
  /** fetch data from the table: "storyFoldersCopyProcesses" using primary key columns */
  storyFoldersCopyProcesses_by_pk?: Maybe<StoryFoldersCopyProcesses>;
  /** fetch data from the table in a streaming manner: "storyFoldersCopyProcesses" */
  storyFoldersCopyProcesses_stream: Array<StoryFoldersCopyProcesses>;
  /** fetch data from the table: "storyFoldersGrantsFlat" */
  storyFoldersGrantsFlat: Array<StoryFoldersGrantsFlat>;
  /** fetch aggregated fields from the table: "storyFoldersGrantsFlat" */
  storyFoldersGrantsFlat_aggregate: StoryFoldersGrantsFlat_Aggregate;
  /** fetch data from the table in a streaming manner: "storyFoldersGrantsFlat" */
  storyFoldersGrantsFlat_stream: Array<StoryFoldersGrantsFlat>;
  /** An aggregate relationship */
  storyFolders_aggregate: StoryFolders_Aggregate;
  /** fetch data from the table: "storyFolders" using primary key columns */
  storyFolders_by_pk?: Maybe<StoryFolders>;
  /** fetch data from the table in a streaming manner: "storyFolders" */
  storyFolders_stream: Array<StoryFolders>;
  /** fetch data from the table: "storyStates" */
  storyStates: Array<StoryStates>;
  /** fetch aggregated fields from the table: "storyStates" */
  storyStates_aggregate: StoryStates_Aggregate;
  /** fetch data from the table: "storyStates" using primary key columns */
  storyStates_by_pk?: Maybe<StoryStates>;
  /** fetch data from the table in a streaming manner: "storyStates" */
  storyStates_stream: Array<StoryStates>;
  /** fetch data from the table: "storyTemplateContentBlocks" */
  storyTemplateContentBlocks: Array<StoryTemplateContentBlocks>;
  /** fetch aggregated fields from the table: "storyTemplateContentBlocks" */
  storyTemplateContentBlocks_aggregate: StoryTemplateContentBlocks_Aggregate;
  /** fetch data from the table: "storyTemplateContentBlocks" using primary key columns */
  storyTemplateContentBlocks_by_pk?: Maybe<StoryTemplateContentBlocks>;
  /** fetch data from the table in a streaming manner: "storyTemplateContentBlocks" */
  storyTemplateContentBlocks_stream: Array<StoryTemplateContentBlocks>;
  /** fetch data from the table: "storyTemplateContents" */
  storyTemplateContents: Array<StoryTemplateContents>;
  /** fetch aggregated fields from the table: "storyTemplateContents" */
  storyTemplateContents_aggregate: StoryTemplateContents_Aggregate;
  /** fetch data from the table: "storyTemplateContents" using primary key columns */
  storyTemplateContents_by_pk?: Maybe<StoryTemplateContents>;
  /** fetch data from the table in a streaming manner: "storyTemplateContents" */
  storyTemplateContents_stream: Array<StoryTemplateContents>;
  /** fetch data from the table: "storyTemplateCustomColors" */
  storyTemplateCustomColors: Array<StoryTemplateCustomColors>;
  /** fetch aggregated fields from the table: "storyTemplateCustomColors" */
  storyTemplateCustomColors_aggregate: StoryTemplateCustomColors_Aggregate;
  /** fetch data from the table: "storyTemplateCustomColors" using primary key columns */
  storyTemplateCustomColors_by_pk?: Maybe<StoryTemplateCustomColors>;
  /** fetch data from the table in a streaming manner: "storyTemplateCustomColors" */
  storyTemplateCustomColors_stream: Array<StoryTemplateCustomColors>;
  /** fetch data from the table: "storyTemplates" */
  storyTemplates: Array<StoryTemplates>;
  /** fetch aggregated fields from the table: "storyTemplates" */
  storyTemplates_aggregate: StoryTemplates_Aggregate;
  /** fetch data from the table: "storyTemplates" using primary key columns */
  storyTemplates_by_pk?: Maybe<StoryTemplates>;
  /** fetch data from the table in a streaming manner: "storyTemplates" */
  storyTemplates_stream: Array<StoryTemplates>;
  /** fetch data from the table: "storyUsers" */
  storyUsers: Array<StoryUsers>;
  /** fetch aggregated fields from the table: "storyUsers" */
  storyUsers_aggregate: StoryUsers_Aggregate;
  /** fetch data from the table: "storyUsers" using primary key columns */
  storyUsers_by_pk?: Maybe<StoryUsers>;
  /** fetch data from the table in a streaming manner: "storyUsers" */
  storyUsers_stream: Array<StoryUsers>;
  /** fetch data from the table: "storyVisibilities" */
  storyVisibilities: Array<StoryVisibilities>;
  /** fetch aggregated fields from the table: "storyVisibilities" */
  storyVisibilities_aggregate: StoryVisibilities_Aggregate;
  /** fetch data from the table: "storyVisibilities" using primary key columns */
  storyVisibilities_by_pk?: Maybe<StoryVisibilities>;
  /** fetch data from the table in a streaming manner: "storyVisibilities" */
  storyVisibilities_stream: Array<StoryVisibilities>;
  /** An array relationship */
  subjectPublicationClaims: Array<SubjectPublicationClaims>;
  /** An aggregate relationship */
  subjectPublicationClaims_aggregate: SubjectPublicationClaims_Aggregate;
  /** fetch data from the table: "subjectPublicationClaims" using primary key columns */
  subjectPublicationClaims_by_pk?: Maybe<SubjectPublicationClaims>;
  /** fetch data from the table in a streaming manner: "subjectPublicationClaims" */
  subjectPublicationClaims_stream: Array<SubjectPublicationClaims>;
  /** An array relationship */
  subjectStoryClaims: Array<SubjectStoryClaims>;
  /** An aggregate relationship */
  subjectStoryClaims_aggregate: SubjectStoryClaims_Aggregate;
  /** fetch data from the table: "subjectStoryClaims" using primary key columns */
  subjectStoryClaims_by_pk?: Maybe<SubjectStoryClaims>;
  /** fetch data from the table in a streaming manner: "subjectStoryClaims" */
  subjectStoryClaims_stream: Array<SubjectStoryClaims>;
  /** fetch data from the table: "userPublicationViews" */
  userPublicationViews: Array<UserPublicationViews>;
  /** fetch aggregated fields from the table: "userPublicationViews" */
  userPublicationViews_aggregate: UserPublicationViews_Aggregate;
  /** fetch data from the table: "userPublicationViews" using primary key columns */
  userPublicationViews_by_pk?: Maybe<UserPublicationViews>;
  /** fetch data from the table in a streaming manner: "userPublicationViews" */
  userPublicationViews_stream: Array<UserPublicationViews>;
};


export type Subscription_RootAsyncJobsArgs = {
  distinct_on?: InputMaybe<Array<AsyncJobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AsyncJobs_Order_By>>;
  where?: InputMaybe<AsyncJobs_Bool_Exp>;
};


export type Subscription_RootAsyncJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AsyncJobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AsyncJobs_Order_By>>;
  where?: InputMaybe<AsyncJobs_Bool_Exp>;
};


export type Subscription_RootAsyncJobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsyncJobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AsyncJobs_Stream_Cursor_Input>>;
  where?: InputMaybe<AsyncJobs_Bool_Exp>;
};


export type Subscription_RootChartsConfigArgs = {
  distinct_on?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChartsConfig_Order_By>>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};


export type Subscription_RootChartsConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ChartsConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChartsConfig_Order_By>>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};


export type Subscription_RootChartsConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChartsConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChartsConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<ChartsConfig_Bool_Exp>;
};


export type Subscription_RootCopyProcessStatusesArgs = {
  distinct_on?: InputMaybe<Array<CopyProcessStatuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CopyProcessStatuses_Order_By>>;
  where?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
};


export type Subscription_RootCopyProcessStatuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CopyProcessStatuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CopyProcessStatuses_Order_By>>;
  where?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
};


export type Subscription_RootCopyProcessStatuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCopyProcessStatuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CopyProcessStatuses_Stream_Cursor_Input>>;
  where?: InputMaybe<CopyProcessStatuses_Bool_Exp>;
};


export type Subscription_RootEntityProgressTrackerSettingsArgs = {
  distinct_on?: InputMaybe<Array<EntityProgressTrackerSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityProgressTrackerSettings_Order_By>>;
  where?: InputMaybe<EntityProgressTrackerSettings_Bool_Exp>;
};


export type Subscription_RootEntityProgressTrackerSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityProgressTrackerSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityProgressTrackerSettings_Order_By>>;
  where?: InputMaybe<EntityProgressTrackerSettings_Bool_Exp>;
};


export type Subscription_RootEntityProgressTrackerSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEntityProgressTrackerSettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityProgressTrackerSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityProgressTrackerSettings_Bool_Exp>;
};


export type Subscription_RootEntityStoryColorSettingsArgs = {
  distinct_on?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStoryColorSettings_Order_By>>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};


export type Subscription_RootEntityStoryColorSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityStoryColorSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStoryColorSettings_Order_By>>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};


export type Subscription_RootEntityStoryColorSettings_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  entityId: Scalars['Int']['input'];
};


export type Subscription_RootEntityStoryColorSettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityStoryColorSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityStoryColorSettings_Bool_Exp>;
};


export type Subscription_RootEntityStorySettingsArgs = {
  distinct_on?: InputMaybe<Array<EntityStorySettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStorySettings_Order_By>>;
  where?: InputMaybe<EntityStorySettings_Bool_Exp>;
};


export type Subscription_RootEntityStorySettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityStorySettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityStorySettings_Order_By>>;
  where?: InputMaybe<EntityStorySettings_Bool_Exp>;
};


export type Subscription_RootEntityStorySettings_By_PkArgs = {
  entityId: Scalars['Int']['input'];
};


export type Subscription_RootEntityStorySettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityStorySettings_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityStorySettings_Bool_Exp>;
};


export type Subscription_RootExportFolderPdfRequestsArgs = {
  distinct_on?: InputMaybe<Array<ExportFolderPdfRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportFolderPdfRequests_Order_By>>;
  where?: InputMaybe<ExportFolderPdfRequests_Bool_Exp>;
};


export type Subscription_RootExportFolderPdfRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExportFolderPdfRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportFolderPdfRequests_Order_By>>;
  where?: InputMaybe<ExportFolderPdfRequests_Bool_Exp>;
};


export type Subscription_RootExportFolderPdfRequests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootExportFolderPdfRequests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ExportFolderPdfRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<ExportFolderPdfRequests_Bool_Exp>;
};


export type Subscription_RootExportStoriesChunksArgs = {
  distinct_on?: InputMaybe<Array<ExportStoriesChunks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportStoriesChunks_Order_By>>;
  where?: InputMaybe<ExportStoriesChunks_Bool_Exp>;
};


export type Subscription_RootExportStoriesChunks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExportStoriesChunks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExportStoriesChunks_Order_By>>;
  where?: InputMaybe<ExportStoriesChunks_Bool_Exp>;
};


export type Subscription_RootExportStoriesChunks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ExportStoriesChunks_Stream_Cursor_Input>>;
  where?: InputMaybe<ExportStoriesChunks_Bool_Exp>;
};


export type Subscription_RootInternalPublishedStoryArgs = {
  distinct_on?: InputMaybe<Array<InternalPublishedStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InternalPublishedStory_Order_By>>;
  where?: InputMaybe<InternalPublishedStory_Bool_Exp>;
};


export type Subscription_RootInternalPublishedStory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InternalPublishedStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InternalPublishedStory_Order_By>>;
  where?: InputMaybe<InternalPublishedStory_Bool_Exp>;
};


export type Subscription_RootInternalPublishedStory_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootInternalPublishedStory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InternalPublishedStory_Stream_Cursor_Input>>;
  where?: InputMaybe<InternalPublishedStory_Bool_Exp>;
};


export type Subscription_RootPortalStoryArgs = {
  distinct_on?: InputMaybe<Array<PortalStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortalStory_Order_By>>;
  where?: InputMaybe<PortalStory_Bool_Exp>;
};


export type Subscription_RootPortalStory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PortalStory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortalStory_Order_By>>;
  where?: InputMaybe<PortalStory_Bool_Exp>;
};


export type Subscription_RootPortalStory_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootPortalStory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PortalStory_Stream_Cursor_Input>>;
  where?: InputMaybe<PortalStory_Bool_Exp>;
};


export type Subscription_RootPublicationBrandingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationBrandings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationBrandings_Order_By>>;
  where?: InputMaybe<PublicationBrandings_Bool_Exp>;
};


export type Subscription_RootPublicationBrandings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationBrandings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationBrandings_Order_By>>;
  where?: InputMaybe<PublicationBrandings_Bool_Exp>;
};


export type Subscription_RootPublicationBrandings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationBrandings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationBrandings_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationBrandings_Bool_Exp>;
};


export type Subscription_RootPublicationExportPdfRequestArgs = {
  distinct_on?: InputMaybe<Array<PublicationExportPdfRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationExportPdfRequest_Order_By>>;
  where?: InputMaybe<PublicationExportPdfRequest_Bool_Exp>;
};


export type Subscription_RootPublicationExportPdfRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationExportPdfRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationExportPdfRequest_Order_By>>;
  where?: InputMaybe<PublicationExportPdfRequest_Bool_Exp>;
};


export type Subscription_RootPublicationExportPdfRequest_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationExportPdfRequest_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationExportPdfRequest_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationExportPdfRequest_Bool_Exp>;
};


export type Subscription_RootPublicationFoldersArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


export type Subscription_RootPublicationFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFolders_Order_By>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


export type Subscription_RootPublicationFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationFolders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationFolders_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationFolders_Bool_Exp>;
};


export type Subscription_RootPublicationFooterSettingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationFooterSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFooterSettings_Order_By>>;
  where?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
};


export type Subscription_RootPublicationFooterSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationFooterSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationFooterSettings_Order_By>>;
  where?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
};


export type Subscription_RootPublicationFooterSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationFooterSettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationFooterSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationFooterSettings_Bool_Exp>;
};


export type Subscription_RootPublicationNavigationMenuItemsArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuItems_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};


export type Subscription_RootPublicationNavigationMenuItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuItems_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};


export type Subscription_RootPublicationNavigationMenuItems_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationNavigationMenuItems_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationNavigationMenuItems_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationNavigationMenuItems_Bool_Exp>;
};


export type Subscription_RootPublicationNavigationMenuStoriesArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuStories_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};


export type Subscription_RootPublicationNavigationMenuStories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationNavigationMenuStories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationNavigationMenuStories_Order_By>>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};


export type Subscription_RootPublicationNavigationMenuStories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationNavigationMenuStories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationNavigationMenuStories_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationNavigationMenuStories_Bool_Exp>;
};


export type Subscription_RootPublicationSetupPdfStylesArgs = {
  distinct_on?: InputMaybe<Array<PublicationSetupPdfStyles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationSetupPdfStyles_Order_By>>;
  where?: InputMaybe<PublicationSetupPdfStyles_Bool_Exp>;
};


export type Subscription_RootPublicationSetupPdfStyles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationSetupPdfStyles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationSetupPdfStyles_Order_By>>;
  where?: InputMaybe<PublicationSetupPdfStyles_Bool_Exp>;
};


export type Subscription_RootPublicationSetupPdfStyles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationSetupPdfStyles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationSetupPdfStyles_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationSetupPdfStyles_Bool_Exp>;
};


export type Subscription_RootPublicationStoryPdfSettingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationStoryPdfSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationStoryPdfSettings_Order_By>>;
  where?: InputMaybe<PublicationStoryPdfSettings_Bool_Exp>;
};


export type Subscription_RootPublicationStoryPdfSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationStoryPdfSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationStoryPdfSettings_Order_By>>;
  where?: InputMaybe<PublicationStoryPdfSettings_Bool_Exp>;
};


export type Subscription_RootPublicationStoryPdfSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationStoryPdfSettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationStoryPdfSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationStoryPdfSettings_Bool_Exp>;
};


export type Subscription_RootPublicationTocSettingsArgs = {
  distinct_on?: InputMaybe<Array<PublicationTocSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationTocSettings_Order_By>>;
  where?: InputMaybe<PublicationTocSettings_Bool_Exp>;
};


export type Subscription_RootPublicationTocSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicationTocSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PublicationTocSettings_Order_By>>;
  where?: InputMaybe<PublicationTocSettings_Bool_Exp>;
};


export type Subscription_RootPublicationTocSettings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublicationTocSettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublicationTocSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicationTocSettings_Bool_Exp>;
};


export type Subscription_RootPublicationsArgs = {
  distinct_on?: InputMaybe<Array<Publications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Publications_Order_By>>;
  where?: InputMaybe<Publications_Bool_Exp>;
};


export type Subscription_RootPublications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Publications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Publications_Order_By>>;
  where?: InputMaybe<Publications_Bool_Exp>;
};


export type Subscription_RootPublications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Publications_Stream_Cursor_Input>>;
  where?: InputMaybe<Publications_Bool_Exp>;
};


export type Subscription_RootSpreadsheetNamedRangesArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetNamedRanges_Order_By>>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};


export type Subscription_RootSpreadsheetNamedRanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetNamedRanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetNamedRanges_Order_By>>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};


export type Subscription_RootSpreadsheetNamedRanges_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpreadsheetNamedRanges_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpreadsheetNamedRanges_Stream_Cursor_Input>>;
  where?: InputMaybe<SpreadsheetNamedRanges_Bool_Exp>;
};


export type Subscription_RootSpreadsheetSplitTablesArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetSplitTables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetSplitTables_Order_By>>;
  where?: InputMaybe<SpreadsheetSplitTables_Bool_Exp>;
};


export type Subscription_RootSpreadsheetSplitTables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetSplitTables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetSplitTables_Order_By>>;
  where?: InputMaybe<SpreadsheetSplitTables_Bool_Exp>;
};


export type Subscription_RootSpreadsheetSplitTables_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpreadsheetSplitTables_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpreadsheetSplitTables_Stream_Cursor_Input>>;
  where?: InputMaybe<SpreadsheetSplitTables_Bool_Exp>;
};


export type Subscription_RootSpreadsheetStoryCountsArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetStoryCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetStoryCounts_Order_By>>;
  where?: InputMaybe<SpreadsheetStoryCounts_Bool_Exp>;
};


export type Subscription_RootSpreadsheetStoryCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetStoryCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetStoryCounts_Order_By>>;
  where?: InputMaybe<SpreadsheetStoryCounts_Bool_Exp>;
};


export type Subscription_RootSpreadsheetStoryCounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpreadsheetStoryCounts_Stream_Cursor_Input>>;
  where?: InputMaybe<SpreadsheetStoryCounts_Bool_Exp>;
};


export type Subscription_RootSpreadsheetsArgs = {
  distinct_on?: InputMaybe<Array<Spreadsheets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spreadsheets_Order_By>>;
  where?: InputMaybe<Spreadsheets_Bool_Exp>;
};


export type Subscription_RootSpreadsheetsProcessingStatusArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetsProcessingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetsProcessingStatus_Order_By>>;
  where?: InputMaybe<SpreadsheetsProcessingStatus_Bool_Exp>;
};


export type Subscription_RootSpreadsheetsProcessingStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpreadsheetsProcessingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpreadsheetsProcessingStatus_Order_By>>;
  where?: InputMaybe<SpreadsheetsProcessingStatus_Bool_Exp>;
};


export type Subscription_RootSpreadsheetsProcessingStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSpreadsheetsProcessingStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpreadsheetsProcessingStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<SpreadsheetsProcessingStatus_Bool_Exp>;
};


export type Subscription_RootSpreadsheets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spreadsheets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spreadsheets_Order_By>>;
  where?: InputMaybe<Spreadsheets_Bool_Exp>;
};


export type Subscription_RootSpreadsheets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpreadsheets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spreadsheets_Stream_Cursor_Input>>;
  where?: InputMaybe<Spreadsheets_Bool_Exp>;
};


export type Subscription_RootStoriesArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


export type Subscription_RootStoriesCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoriesCopyProcesses_Order_By>>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoriesCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoriesCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoriesCopyProcesses_Order_By>>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoriesCopyProcesses_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootStoriesCopyProcesses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoriesCopyProcesses_Stream_Cursor_Input>>;
  where?: InputMaybe<StoriesCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stories_Order_By>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


export type Subscription_RootStories_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootStories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Stories_Stream_Cursor_Input>>;
  where?: InputMaybe<Stories_Bool_Exp>;
};


export type Subscription_RootStoryBudgetProposalsArgs = {
  distinct_on?: InputMaybe<Array<StoryBudgetProposals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryBudgetProposals_Order_By>>;
  where?: InputMaybe<StoryBudgetProposals_Bool_Exp>;
};


export type Subscription_RootStoryBudgetProposals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryBudgetProposals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryBudgetProposals_Order_By>>;
  where?: InputMaybe<StoryBudgetProposals_Bool_Exp>;
};


export type Subscription_RootStoryBudgetProposals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStoryBudgetProposals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryBudgetProposals_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryBudgetProposals_Bool_Exp>;
};


export type Subscription_RootStoryContentBlockTypesArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlockTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlockTypes_Order_By>>;
  where?: InputMaybe<StoryContentBlockTypes_Bool_Exp>;
};


export type Subscription_RootStoryContentBlockTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlockTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlockTypes_Order_By>>;
  where?: InputMaybe<StoryContentBlockTypes_Bool_Exp>;
};


export type Subscription_RootStoryContentBlockTypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStoryContentBlockTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryContentBlockTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryContentBlockTypes_Bool_Exp>;
};


export type Subscription_RootStoryContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlocks_Order_By>>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};


export type Subscription_RootStoryContentBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentBlocks_Order_By>>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};


export type Subscription_RootStoryContentBlocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStoryContentBlocks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryContentBlocks_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryContentBlocks_Bool_Exp>;
};


export type Subscription_RootStoryContentColorTargetsArgs = {
  distinct_on?: InputMaybe<Array<StoryContentColorTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentColorTargets_Order_By>>;
  where?: InputMaybe<StoryContentColorTargets_Bool_Exp>;
};


export type Subscription_RootStoryContentColorTargets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentColorTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentColorTargets_Order_By>>;
  where?: InputMaybe<StoryContentColorTargets_Bool_Exp>;
};


export type Subscription_RootStoryContentColorTargets_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStoryContentColorTargets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryContentColorTargets_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryContentColorTargets_Bool_Exp>;
};


export type Subscription_RootStoryContentSpreadsheetReferencesArgs = {
  distinct_on?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentSpreadsheetReferences_Order_By>>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};


export type Subscription_RootStoryContentSpreadsheetReferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentSpreadsheetReferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentSpreadsheetReferences_Order_By>>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};


export type Subscription_RootStoryContentSpreadsheetReferences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStoryContentSpreadsheetReferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryContentSpreadsheetReferences_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryContentSpreadsheetReferences_Bool_Exp>;
};


export type Subscription_RootStoryContentTypesArgs = {
  distinct_on?: InputMaybe<Array<StoryContentTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentTypes_Order_By>>;
  where?: InputMaybe<StoryContentTypes_Bool_Exp>;
};


export type Subscription_RootStoryContentTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContentTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContentTypes_Order_By>>;
  where?: InputMaybe<StoryContentTypes_Bool_Exp>;
};


export type Subscription_RootStoryContentTypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStoryContentTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryContentTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryContentTypes_Bool_Exp>;
};


export type Subscription_RootStoryContentsArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


export type Subscription_RootStoryContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryContents_Order_By>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


export type Subscription_RootStoryContents_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootStoryContents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryContents_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryContents_Bool_Exp>;
};


export type Subscription_RootStoryCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoryCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoryCopyProcesses_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootStoryCopyProcesses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryCopyProcesses_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoryCustomColorsArgs = {
  distinct_on?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCustomColors_Order_By>>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};


export type Subscription_RootStoryCustomColors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryCustomColors_Order_By>>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};


export type Subscription_RootStoryCustomColors_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  storyId: Scalars['String']['input'];
};


export type Subscription_RootStoryCustomColors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryCustomColors_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryCustomColors_Bool_Exp>;
};


export type Subscription_RootStoryEmbedsArgs = {
  distinct_on?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryEmbeds_Order_By>>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};


export type Subscription_RootStoryEmbeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryEmbeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryEmbeds_Order_By>>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};


export type Subscription_RootStoryEmbeds_By_PkArgs = {
  embedId: Scalars['uuid']['input'];
  storyId: Scalars['String']['input'];
};


export type Subscription_RootStoryEmbeds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryEmbeds_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryEmbeds_Bool_Exp>;
};


export type Subscription_RootStoryFolderActionSetsArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderActionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderActionSets_Order_By>>;
  where?: InputMaybe<StoryFolderActionSets_Bool_Exp>;
};


export type Subscription_RootStoryFolderActionSets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderActionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderActionSets_Order_By>>;
  where?: InputMaybe<StoryFolderActionSets_Bool_Exp>;
};


export type Subscription_RootStoryFolderActionSets_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStoryFolderActionSets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryFolderActionSets_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryFolderActionSets_Bool_Exp>;
};


export type Subscription_RootStoryFolderGrantsArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderGrants_Order_By>>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};


export type Subscription_RootStoryFolderGrants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolderGrants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolderGrants_Order_By>>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};


export type Subscription_RootStoryFolderGrants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStoryFolderGrants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryFolderGrants_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryFolderGrants_Bool_Exp>;
};


export type Subscription_RootStoryFoldersArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


export type Subscription_RootStoryFoldersCopyProcessesArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoryFoldersCopyProcesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersCopyProcesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersCopyProcesses_Order_By>>;
  where?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoryFoldersCopyProcesses_By_PkArgs = {
  destinationFolderId: Scalars['uuid']['input'];
};


export type Subscription_RootStoryFoldersCopyProcesses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryFoldersCopyProcesses_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryFoldersCopyProcesses_Bool_Exp>;
};


export type Subscription_RootStoryFoldersGrantsFlatArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersGrantsFlat_Order_By>>;
  where?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
};


export type Subscription_RootStoryFoldersGrantsFlat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFoldersGrantsFlat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFoldersGrantsFlat_Order_By>>;
  where?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
};


export type Subscription_RootStoryFoldersGrantsFlat_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryFoldersGrantsFlat_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryFoldersGrantsFlat_Bool_Exp>;
};


export type Subscription_RootStoryFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryFolders_Order_By>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


export type Subscription_RootStoryFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStoryFolders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryFolders_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryFolders_Bool_Exp>;
};


export type Subscription_RootStoryStatesArgs = {
  distinct_on?: InputMaybe<Array<StoryStates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryStates_Order_By>>;
  where?: InputMaybe<StoryStates_Bool_Exp>;
};


export type Subscription_RootStoryStates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryStates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryStates_Order_By>>;
  where?: InputMaybe<StoryStates_Bool_Exp>;
};


export type Subscription_RootStoryStates_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStoryStates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryStates_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryStates_Bool_Exp>;
};


export type Subscription_RootStoryTemplateContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContentBlocks_Order_By>>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};


export type Subscription_RootStoryTemplateContentBlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContentBlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContentBlocks_Order_By>>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};


export type Subscription_RootStoryTemplateContentBlocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStoryTemplateContentBlocks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryTemplateContentBlocks_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryTemplateContentBlocks_Bool_Exp>;
};


export type Subscription_RootStoryTemplateContentsArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContents_Order_By>>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};


export type Subscription_RootStoryTemplateContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateContents_Order_By>>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};


export type Subscription_RootStoryTemplateContents_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootStoryTemplateContents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryTemplateContents_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryTemplateContents_Bool_Exp>;
};


export type Subscription_RootStoryTemplateCustomColorsArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateCustomColors_Order_By>>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};


export type Subscription_RootStoryTemplateCustomColors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplateCustomColors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplateCustomColors_Order_By>>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};


export type Subscription_RootStoryTemplateCustomColors_By_PkArgs = {
  colorTarget: StoryContentColorTargets_Enum;
  contentType: StoryContentTypes_Enum;
  templateId: Scalars['String']['input'];
};


export type Subscription_RootStoryTemplateCustomColors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryTemplateCustomColors_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryTemplateCustomColors_Bool_Exp>;
};


export type Subscription_RootStoryTemplatesArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplates_Order_By>>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};


export type Subscription_RootStoryTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryTemplates_Order_By>>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};


export type Subscription_RootStoryTemplates_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootStoryTemplates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryTemplates_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryTemplates_Bool_Exp>;
};


export type Subscription_RootStoryUsersArgs = {
  distinct_on?: InputMaybe<Array<StoryUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryUsers_Order_By>>;
  where?: InputMaybe<StoryUsers_Bool_Exp>;
};


export type Subscription_RootStoryUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryUsers_Order_By>>;
  where?: InputMaybe<StoryUsers_Bool_Exp>;
};


export type Subscription_RootStoryUsers_By_PkArgs = {
  _id: Scalars['String']['input'];
};


export type Subscription_RootStoryUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryUsers_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryUsers_Bool_Exp>;
};


export type Subscription_RootStoryVisibilitiesArgs = {
  distinct_on?: InputMaybe<Array<StoryVisibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryVisibilities_Order_By>>;
  where?: InputMaybe<StoryVisibilities_Bool_Exp>;
};


export type Subscription_RootStoryVisibilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StoryVisibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StoryVisibilities_Order_By>>;
  where?: InputMaybe<StoryVisibilities_Bool_Exp>;
};


export type Subscription_RootStoryVisibilities_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStoryVisibilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StoryVisibilities_Stream_Cursor_Input>>;
  where?: InputMaybe<StoryVisibilities_Bool_Exp>;
};


export type Subscription_RootSubjectPublicationClaimsArgs = {
  distinct_on?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectPublicationClaims_Order_By>>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};


export type Subscription_RootSubjectPublicationClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SubjectPublicationClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectPublicationClaims_Order_By>>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};


export type Subscription_RootSubjectPublicationClaims_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubjectPublicationClaims_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SubjectPublicationClaims_Stream_Cursor_Input>>;
  where?: InputMaybe<SubjectPublicationClaims_Bool_Exp>;
};


export type Subscription_RootSubjectStoryClaimsArgs = {
  distinct_on?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectStoryClaims_Order_By>>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};


export type Subscription_RootSubjectStoryClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SubjectStoryClaims_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SubjectStoryClaims_Order_By>>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};


export type Subscription_RootSubjectStoryClaims_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubjectStoryClaims_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SubjectStoryClaims_Stream_Cursor_Input>>;
  where?: InputMaybe<SubjectStoryClaims_Bool_Exp>;
};


export type Subscription_RootUserPublicationViewsArgs = {
  distinct_on?: InputMaybe<Array<UserPublicationViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPublicationViews_Order_By>>;
  where?: InputMaybe<UserPublicationViews_Bool_Exp>;
};


export type Subscription_RootUserPublicationViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPublicationViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPublicationViews_Order_By>>;
  where?: InputMaybe<UserPublicationViews_Bool_Exp>;
};


export type Subscription_RootUserPublicationViews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserPublicationViews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserPublicationViews_Stream_Cursor_Input>>;
  where?: InputMaybe<UserPublicationViews_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "userPublicationViews" */
export type UserPublicationViews = {
  __typename?: 'userPublicationViews';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  lastSeenAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  publication: Publications;
  publicationId: Scalars['uuid']['output'];
  /** An object relationship */
  storyUser: StoryUsers;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId: Scalars['String']['output'];
};

/** aggregated selection of "userPublicationViews" */
export type UserPublicationViews_Aggregate = {
  __typename?: 'userPublicationViews_aggregate';
  aggregate?: Maybe<UserPublicationViews_Aggregate_Fields>;
  nodes: Array<UserPublicationViews>;
};

/** aggregate fields of "userPublicationViews" */
export type UserPublicationViews_Aggregate_Fields = {
  __typename?: 'userPublicationViews_aggregate_fields';
  avg?: Maybe<UserPublicationViews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserPublicationViews_Max_Fields>;
  min?: Maybe<UserPublicationViews_Min_Fields>;
  stddev?: Maybe<UserPublicationViews_Stddev_Fields>;
  stddev_pop?: Maybe<UserPublicationViews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserPublicationViews_Stddev_Samp_Fields>;
  sum?: Maybe<UserPublicationViews_Sum_Fields>;
  var_pop?: Maybe<UserPublicationViews_Var_Pop_Fields>;
  var_samp?: Maybe<UserPublicationViews_Var_Samp_Fields>;
  variance?: Maybe<UserPublicationViews_Variance_Fields>;
};


/** aggregate fields of "userPublicationViews" */
export type UserPublicationViews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserPublicationViews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UserPublicationViews_Avg_Fields = {
  __typename?: 'userPublicationViews_avg_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "userPublicationViews". All fields are combined with a logical 'AND'. */
export type UserPublicationViews_Bool_Exp = {
  _and?: InputMaybe<Array<UserPublicationViews_Bool_Exp>>;
  _not?: InputMaybe<UserPublicationViews_Bool_Exp>;
  _or?: InputMaybe<Array<UserPublicationViews_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastSeenAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  publication?: InputMaybe<Publications_Bool_Exp>;
  publicationId?: InputMaybe<Uuid_Comparison_Exp>;
  storyUser?: InputMaybe<StoryUsers_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "userPublicationViews" */
export enum UserPublicationViews_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPublicationViewsPkey = 'userPublicationViews_pkey',
  /** unique or primary key constraint on columns "userId", "publicationId" */
  UserPublicationViewsPublicationIdUserIdKey = 'userPublicationViews_publicationId_userId_key'
}

/** input type for incrementing numeric columns in table "userPublicationViews" */
export type UserPublicationViews_Inc_Input = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "userPublicationViews" */
export type UserPublicationViews_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publication?: InputMaybe<Publications_Obj_Rel_Insert_Input>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  storyUser?: InputMaybe<StoryUsers_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserPublicationViews_Max_Fields = {
  __typename?: 'userPublicationViews_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeenAt?: Maybe<Scalars['timestamptz']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserPublicationViews_Min_Fields = {
  __typename?: 'userPublicationViews_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeenAt?: Maybe<Scalars['timestamptz']['output']>;
  publicationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "userPublicationViews" */
export type UserPublicationViews_Mutation_Response = {
  __typename?: 'userPublicationViews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPublicationViews>;
};

/** on_conflict condition type for table "userPublicationViews" */
export type UserPublicationViews_On_Conflict = {
  constraint: UserPublicationViews_Constraint;
  update_columns?: Array<UserPublicationViews_Update_Column>;
  where?: InputMaybe<UserPublicationViews_Bool_Exp>;
};

/** Ordering options when selecting data from "userPublicationViews". */
export type UserPublicationViews_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeenAt?: InputMaybe<Order_By>;
  publication?: InputMaybe<Publications_Order_By>;
  publicationId?: InputMaybe<Order_By>;
  storyUser?: InputMaybe<StoryUsers_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userPublicationViews */
export type UserPublicationViews_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "userPublicationViews" */
export enum UserPublicationViews_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeenAt = 'lastSeenAt',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userPublicationViews" */
export type UserPublicationViews_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type UserPublicationViews_Stddev_Fields = {
  __typename?: 'userPublicationViews_stddev_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type UserPublicationViews_Stddev_Pop_Fields = {
  __typename?: 'userPublicationViews_stddev_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type UserPublicationViews_Stddev_Samp_Fields = {
  __typename?: 'userPublicationViews_stddev_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "userPublicationViews" */
export type UserPublicationViews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserPublicationViews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPublicationViews_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publicationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type UserPublicationViews_Sum_Fields = {
  __typename?: 'userPublicationViews_sum_fields';
  entityId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "userPublicationViews" */
export enum UserPublicationViews_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeenAt = 'lastSeenAt',
  /** column name */
  PublicationId = 'publicationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserPublicationViews_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserPublicationViews_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPublicationViews_Set_Input>;
  where: UserPublicationViews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserPublicationViews_Var_Pop_Fields = {
  __typename?: 'userPublicationViews_var_pop_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type UserPublicationViews_Var_Samp_Fields = {
  __typename?: 'userPublicationViews_var_samp_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UserPublicationViews_Variance_Fields = {
  __typename?: 'userPublicationViews_variance_fields';
  entityId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type GetNamedRangesForAddReportTableModalQueryVariables = Exact<{
  spreadsheetId: Scalars['uuid']['input'];
}>;


export type GetNamedRangesForAddReportTableModalQuery = { __typename?: 'query_root', spreadsheetNamedRanges: Array<{ __typename?: 'spreadsheetNamedRanges', id: string, name: string }> };

export type GetSpreadsheetsForAddReportTableModalQueryVariables = Exact<{
  publicationId: Scalars['uuid']['input'];
}>;


export type GetSpreadsheetsForAddReportTableModalQuery = { __typename?: 'query_root', spreadsheets: Array<{ __typename?: 'spreadsheets', id: string, name: string }> };

export type CustomReportsTable_CustomReportFragmentFragment = (
  { __typename?: 'spreadsheets', id: string, name: string, processingStatus: SpreadsheetsProcessingStatus_Enum, spreadsheetNamedRanges_aggregate: { __typename?: 'spreadsheetNamedRanges_aggregate', aggregate?: { __typename?: 'spreadsheetNamedRanges_aggregate_fields', count: number } | null } }
  & { ' $fragmentRefs'?: { 'CustomReportsTableStatusCell_CustomReportFragmentFragment': CustomReportsTableStatusCell_CustomReportFragmentFragment;'CustomReportsTableExpandedRow_CustomReportFragmentFragment': CustomReportsTableExpandedRow_CustomReportFragmentFragment } }
) & { ' $fragmentName'?: 'CustomReportsTable_CustomReportFragmentFragment' };

export type CustomReportsTable_StoryCountFragmentFragment = { __typename?: 'spreadsheetStoryCounts', spreadsheetId?: string | null, countOfUniqueStories?: number | null } & { ' $fragmentName'?: 'CustomReportsTable_StoryCountFragmentFragment' };

export type CustomReportsTableExpandedRow_CustomReportFragmentFragment = { __typename?: 'spreadsheets', processingStatus: SpreadsheetsProcessingStatus_Enum } & { ' $fragmentName'?: 'CustomReportsTableExpandedRow_CustomReportFragmentFragment' };

export type CustomReportsTableExpandedRowStoryList_CustomReportFragmentFragment = { __typename?: 'spreadsheetNamedRanges', id: string, name: string, storyContentSpreadsheetReferences: Array<{ __typename?: 'storyContentSpreadsheetReferences', storyContentId: string, storyContent: { __typename?: 'storyContents', story: { __typename?: 'stories', _id: string, title: string } } }> } & { ' $fragmentName'?: 'CustomReportsTableExpandedRowStoryList_CustomReportFragmentFragment' };

export type CustomReportsTableStatusCell_CustomReportFragmentFragment = { __typename?: 'spreadsheets', id: string, processingStatus: SpreadsheetsProcessingStatus_Enum, processingErrors?: string | null, updatedAt: string } & { ' $fragmentName'?: 'CustomReportsTableStatusCell_CustomReportFragmentFragment' };

export type GetSpreadsheetNamedRangesQueryVariables = Exact<{
  spreadsheetId: Scalars['uuid']['input'];
}>;


export type GetSpreadsheetNamedRangesQuery = { __typename?: 'query_root', spreadsheetNamedRanges: Array<{ __typename?: 'spreadsheetNamedRanges', id: string, name: string }> };

export type GetSpreadsheetsForEditCustomSpreadsheetModalQueryVariables = Exact<{
  publicationId: Scalars['uuid']['input'];
}>;


export type GetSpreadsheetsForEditCustomSpreadsheetModalQuery = { __typename?: 'query_root', spreadsheets: Array<{ __typename?: 'spreadsheets', id: string, name: string }> };

export type GetStoryContentSpreadsheetReferencesQueryVariables = Exact<{
  storyContentId: Scalars['String']['input'];
}>;


export type GetStoryContentSpreadsheetReferencesQuery = { __typename?: 'query_root', storyContentSpreadsheetReferences: Array<{ __typename?: 'storyContentSpreadsheetReferences', namedRangeId: string, spreadsheetId: string, title?: string | null }> };

export type EditReportModal_NamedRangesFragmentFragment = { __typename?: 'spreadsheetNamedRanges', id: string, name: string } & { ' $fragmentName'?: 'EditReportModal_NamedRangesFragmentFragment' };

export type GetSpreadsheetNamedRangesForEditReportModalQueryVariables = Exact<{
  spreadsheetId: Scalars['uuid']['input'];
}>;


export type GetSpreadsheetNamedRangesForEditReportModalQuery = { __typename?: 'query_root', spreadsheetNamedRanges: Array<(
    { __typename?: 'spreadsheetNamedRanges' }
    & { ' $fragmentRefs'?: { 'EditReportModal_NamedRangesFragmentFragment': EditReportModal_NamedRangesFragmentFragment } }
  )> };

export type UpdateSpreadsheetNameMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateSpreadsheetNameMutation = { __typename?: 'mutation_root', update_spreadsheets_by_pk?: { __typename?: 'spreadsheets', id: string, name: string } | null };

export type CreateSpreadsheetMutationVariables = Exact<{
  entityId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  publicationId: Scalars['uuid']['input'];
}>;


export type CreateSpreadsheetMutation = { __typename?: 'mutation_root', insert_spreadsheets_one?: { __typename?: 'spreadsheets', id: string } | null };

export type GetCustomReportStoryCountsQueryVariables = Exact<{
  where?: InputMaybe<SpreadsheetStoryCounts_Bool_Exp>;
}>;


export type GetCustomReportStoryCountsQuery = { __typename?: 'query_root', spreadsheetStoryCounts: Array<(
    { __typename?: 'spreadsheetStoryCounts' }
    & { ' $fragmentRefs'?: { 'CustomReportsTable_StoryCountFragmentFragment': CustomReportsTable_StoryCountFragmentFragment } }
  )> };

export type UseFetchCustomReports_TrackingFragmentFragment = { __typename?: 'spreadsheets', id: string, name: string, processingStatus: SpreadsheetsProcessingStatus_Enum, spreadsheetNamedRanges_aggregate: { __typename?: 'spreadsheetNamedRanges_aggregate', aggregate?: { __typename?: 'spreadsheetNamedRanges_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'UseFetchCustomReports_TrackingFragmentFragment' };

export type GetCustomReportsForTableQueryVariables = Exact<{
  where?: InputMaybe<Spreadsheets_Bool_Exp>;
  orderBy?: InputMaybe<Array<Spreadsheets_Order_By> | Spreadsheets_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomReportsForTableQuery = { __typename?: 'query_root', spreadsheets: Array<(
    { __typename?: 'spreadsheets' }
    & { ' $fragmentRefs'?: { 'UseFetchCustomReports_TrackingFragmentFragment': UseFetchCustomReports_TrackingFragmentFragment;'CustomReportsTable_CustomReportFragmentFragment': CustomReportsTable_CustomReportFragmentFragment } }
  )>, spreadsheets_aggregate: { __typename?: 'spreadsheets_aggregate', aggregate?: { __typename?: 'spreadsheets_aggregate_fields', count: number } | null } };

export type GetSpreadsheetNamedRangesForExpandedRowQueryVariables = Exact<{
  spreadsheetId: Scalars['uuid']['input'];
}>;


export type GetSpreadsheetNamedRangesForExpandedRowQuery = { __typename?: 'query_root', spreadsheetNamedRanges: Array<(
    { __typename?: 'spreadsheetNamedRanges' }
    & { ' $fragmentRefs'?: { 'CustomReportsTableExpandedRowStoryList_CustomReportFragmentFragment': CustomReportsTableExpandedRowStoryList_CustomReportFragmentFragment } }
  )> };

export type UpdateSpreadsheetForUploadedFileMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  processingStatus: SpreadsheetsProcessingStatus_Enum;
}>;


export type UpdateSpreadsheetForUploadedFileMutation = { __typename?: 'mutation_root', update_spreadsheets_by_pk?: { __typename?: 'spreadsheets', id: string, name: string, processingStatus: SpreadsheetsProcessingStatus_Enum } | null };

export type DeleteNavigationMenuByIdForOnlinePublicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteNavigationMenuByIdForOnlinePublicationMutation = { __typename?: 'mutation_root', delete_publicationNavigationMenuItems?: { __typename?: 'publicationNavigationMenuItems_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'publicationNavigationMenuItems', publicationId: string }> } | null };

export type DeleteNavigationMenuStoryByIdForOnlinePublicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteNavigationMenuStoryByIdForOnlinePublicationMutation = { __typename?: 'mutation_root', delete_publicationNavigationMenuStories?: { __typename?: 'publicationNavigationMenuStories_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'publicationNavigationMenuStories', id: string }> } | null };

export type GetFolderHierarchyWithStoriesForOnlinePublicationQueryVariables = Exact<{
  publicationId: Scalars['uuid']['input'];
  entityId: Scalars['Int']['input'];
}>;


export type GetFolderHierarchyWithStoriesForOnlinePublicationQuery = { __typename?: 'query_root', publicationRootFolder: Array<{ __typename?: 'storyFolders', id: string }>, publicationFolders: Array<{ __typename?: 'storyFolders', id: string, title: string, parentFolderId?: string | null, stories: Array<{ __typename?: 'stories', title: string, state: StoryStates_Enum, order: number, id: string }> }> };

export type InsertNavigationMenuItemForOnlinePublicationMutationVariables = Exact<{
  object: PublicationNavigationMenuItems_Insert_Input;
}>;


export type InsertNavigationMenuItemForOnlinePublicationMutation = { __typename?: 'mutation_root', insert_publicationNavigationMenuItems_one?: { __typename?: 'publicationNavigationMenuItems', id: string } | null };

export type GetMenuStoriesForOnlinePublicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMenuStoriesForOnlinePublicationQuery = { __typename?: 'query_root', menuStories: Array<{ __typename?: 'publicationNavigationMenuStories', order: number, menuId: string, id: string, displayName?: string | null, createdBy: string, createdAt?: string | null, storyId: string, updatedAt?: string | null, story: { __typename?: 'stories', _id: string, order: number, title: string } }> };

export type GetNavigationMenusForOnlinePublicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetNavigationMenusForOnlinePublicationQuery = { __typename?: 'query_root', menuItems: Array<{ __typename?: 'publicationNavigationMenuItems', id: string, publicationId: string, title: string, order: number, createdAt?: string | null, createdBy: string, updatedAt?: string | null, publicationNavigationMenuStories: Array<{ __typename?: 'publicationNavigationMenuStories', id: string, displayName?: string | null, menuId: string, storyId: string, order: number, story: { __typename?: 'stories', title: string } }> }> };

export type GetPublicationBrandingsForOnlinePublicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPublicationBrandingsForOnlinePublicationQuery = { __typename?: 'query_root', publicationBrandings: Array<{ __typename?: 'publicationBrandings', id: string, idleBackgroundColor: string, activeBackgroundColor: string, activeFontColor: string, createdAt: string, enableLogoNavigation: boolean, enableGoogleTranslate: boolean, fontStyle: string, idleFontColor: string, isNavigationMenuSticky: boolean, logoUrl?: string | null, publicationId: string, showLogoOnFooter: boolean, updatedAt: string }> };

export type GetPublicationFooterSettingsForOnlinePublicationQueryVariables = Exact<{
  entityId: Scalars['Int']['input'];
  publicationId: Scalars['uuid']['input'];
}>;


export type GetPublicationFooterSettingsForOnlinePublicationQuery = { __typename?: 'query_root', publicationFooterSettings: Array<{ __typename?: 'publicationFooterSettings', id: string, publicationId: string, backgroundColors: string, fontColors: string, mediaLinks: string }> };

export type UpdateFooterSettingsForOnlinePublicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: PublicationFooterSettings_Set_Input;
}>;


export type UpdateFooterSettingsForOnlinePublicationMutation = { __typename?: 'mutation_root', update_publicationFooterSettings_by_pk?: { __typename?: 'publicationFooterSettings', id: string, publicationId: string, backgroundColors: string, fontColors: string, mediaLinks: string } | null };

export type UpdatePublicationBrandingsForOnlinePublicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: PublicationBrandings_Set_Input;
}>;


export type UpdatePublicationBrandingsForOnlinePublicationMutation = { __typename?: 'mutation_root', update_publicationBrandings_by_pk?: { __typename?: 'publicationBrandings', id: string, idleBackgroundColor: string, activeBackgroundColor: string, activeFontColor: string, createdAt: string, enableLogoNavigation: boolean, fontStyle: string, idleFontColor: string, isNavigationMenuSticky: boolean, logoUrl?: string | null, publicationId: string, showLogoOnFooter: boolean, updatedAt: string, enableGoogleTranslate: boolean } | null };

export type UpdatePublicationTocSettingsForOnlinePublicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: PublicationTocSettings_Set_Input;
}>;


export type UpdatePublicationTocSettingsForOnlinePublicationMutation = { __typename?: 'mutation_root', update_publicationTOCSettings_by_pk?: { __typename?: 'publicationTOCSettings', id: string, columnLayoutNumber: number, createdBy: string, headerHeightSize?: string | null, headerImageUrl?: string | null, menuTitle?: string | null, pageTitle?: string | null, showTableOfContents: boolean, createdAt: string, publicationId: string, updatedAt: string, description?: string | null, hasUserToggledToc: boolean } | null };

export type InsertStoriesForMenuIdForOnlinePublicationMutationVariables = Exact<{
  objects: Array<PublicationNavigationMenuStories_Insert_Input> | PublicationNavigationMenuStories_Insert_Input;
}>;


export type InsertStoriesForMenuIdForOnlinePublicationMutation = { __typename?: 'mutation_root', storiesList?: { __typename?: 'publicationNavigationMenuStories_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'publicationNavigationMenuStories', id: string }> } | null };

export type GetPublicationTocSettingsForOnlinePublicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPublicationTocSettingsForOnlinePublicationQuery = { __typename?: 'query_root', publicationTOCSettings: Array<{ __typename?: 'publicationTOCSettings', id: string, columnLayoutNumber: number, createdBy: string, headerHeightSize?: string | null, headerImageUrl?: string | null, menuTitle?: string | null, pageTitle?: string | null, showTableOfContents: boolean, createdAt: string, publicationId: string, updatedAt: string, description?: string | null, hasUserToggledToc: boolean }> };

export type UpdateMenuStoryNameByIdForOnlinePublicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMenuStoryNameByIdForOnlinePublicationMutation = { __typename?: 'mutation_root', update_publicationNavigationMenuStories?: { __typename?: 'publicationNavigationMenuStories_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'publicationNavigationMenuStories', id: string }> } | null };

export type UpdateMenuTitleByIdForOnlinePublicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMenuTitleByIdForOnlinePublicationMutation = { __typename?: 'mutation_root', update_publicationNavigationMenuItems?: { __typename?: 'publicationNavigationMenuItems_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'publicationNavigationMenuItems', id: string }> } | null };

export type CustomCss_StoryFolderFieldsFragment = { __typename?: 'storyFolders', id: string, title: string, order: number, parentFolderId?: string | null, stories: Array<{ __typename?: 'stories', title: string, order: number, id: string }> } & { ' $fragmentName'?: 'CustomCss_StoryFolderFieldsFragment' };

export type GetPublicationWithSectionsAndStoriesForCustomCssQueryVariables = Exact<{
  publicationId: Scalars['uuid']['input'];
  entityId: Scalars['Int']['input'];
}>;


export type GetPublicationWithSectionsAndStoriesForCustomCssQuery = { __typename?: 'query_root', publicationRootFolder: Array<(
    { __typename?: 'storyFolders' }
    & { ' $fragmentRefs'?: { 'CustomCss_StoryFolderFieldsFragment': CustomCss_StoryFolderFieldsFragment } }
  )>, publication?: { __typename?: 'publications', id: string, status: string, title: string, description?: string | null, updatedAt?: string | null, customCssCode?: string | null, publicUrl?: string | null, publicationFolders: Array<(
      { __typename?: 'storyFolders', subFolders: Array<(
        { __typename?: 'storyFolders' }
        & { ' $fragmentRefs'?: { 'CustomCss_StoryFolderFieldsFragment': CustomCss_StoryFolderFieldsFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'CustomCss_StoryFolderFieldsFragment': CustomCss_StoryFolderFieldsFragment } }
    )> } | null };

export type UpdatePublicationCustomCssCodeForCustomCssMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  customCssCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePublicationCustomCssCodeForCustomCssMutation = { __typename?: 'mutation_root', publication?: { __typename?: 'publications', id: string, customCssCode?: string | null } | null };

export type UpdateStoryCustomCssCodeForCustomCssMutationVariables = Exact<{
  id: Scalars['String']['input'];
  customCssCode: Scalars['String']['input'];
}>;


export type UpdateStoryCustomCssCodeForCustomCssMutation = { __typename?: 'mutation_root', story?: { __typename?: 'stories', _id: string, customCssCode?: string | null } | null };

export type UpdatePublicationUpdatedAtForCustomCssMutationVariables = Exact<{
  publicationId: Scalars['uuid']['input'];
  updatedAt: Scalars['timestamptz']['input'];
  userId: Scalars['String']['input'];
}>;


export type UpdatePublicationUpdatedAtForCustomCssMutation = { __typename?: 'mutation_root', publication?: { __typename?: 'publications', id: string, updatedAt?: string | null } | null };

export type GetStoryWithContentForCustomCssQueryVariables = Exact<{
  storyId: Scalars['String']['input'];
}>;


export type GetStoryWithContentForCustomCssQuery = { __typename?: 'query_root', stories: Array<{ __typename?: 'stories', _id: string, title: string, description?: string | null, state: StoryStates_Enum, customCssCode?: string | null, contents: Array<{ __typename?: 'storyContents', _id: string, active?: boolean | null, content: string, contentHtml?: string | null, createdAt: string, description?: string | null, entityId: number, format?: string | null, group?: string | null, layout?: string | null, order: number, storyId: string, title?: string | null, type: StoryContentTypes_Enum, updatedAt: string, authorId: string, author: { __typename?: 'storyUsers', _id: string, email: string, firstName: string, lastName: string, opengovId: number }, contentChartConfig: Array<{ __typename?: 'chartsConfig', id: string, contentId: string, storyId: string, config: string, type: string }> }> }> };

export type SetupPdf_StoryFolderFieldsFragment = { __typename?: 'storyFolders', id: string, title: string, order: number, parentFolderId?: string | null, stories: Array<{ __typename?: 'stories', title: string, order: number, id: string }> } & { ' $fragmentName'?: 'SetupPdf_StoryFolderFieldsFragment' };

export type GetPublicationHierarchyForSetupPdfQueryVariables = Exact<{
  publicationId: Scalars['uuid']['input'];
  entityId: Scalars['Int']['input'];
  state?: InputMaybe<Array<StoryStates_Enum> | StoryStates_Enum>;
}>;


export type GetPublicationHierarchyForSetupPdfQuery = { __typename?: 'query_root', publicationRootFolder: Array<(
    { __typename?: 'storyFolders' }
    & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
  )>, publication?: { __typename?: 'publications', title: string, customCssCode?: string | null, publicationFolders: Array<(
      { __typename?: 'storyFolders', subFolders: Array<(
        { __typename?: 'storyFolders' }
        & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
    )> } | null };

export type GetSectionHierarchyForSetupPdfQueryVariables = Exact<{
  sectionId: Scalars['uuid']['input'];
  entityId: Scalars['Int']['input'];
  state?: InputMaybe<Array<StoryStates_Enum> | StoryStates_Enum>;
}>;


export type GetSectionHierarchyForSetupPdfQuery = { __typename?: 'query_root', storyFolders: Array<(
    { __typename?: 'storyFolders', subFolders: Array<(
      { __typename?: 'storyFolders', subFolders: Array<(
        { __typename?: 'storyFolders', subFolders: Array<(
          { __typename?: 'storyFolders', subFolders: Array<(
            { __typename?: 'storyFolders', subFolders: Array<(
              { __typename?: 'storyFolders' }
              & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
            )> }
            & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
          )> }
          & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
        )> }
        & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'SetupPdf_StoryFolderFieldsFragment': SetupPdf_StoryFolderFieldsFragment } }
  )> };

export type GetStoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoriesQuery = { __typename?: 'query_root', stories: Array<{ __typename?: 'stories', _id: string, title: string }> };

export const CustomReportsTableStatusCell_CustomReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableStatusCell_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processingErrors"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CustomReportsTableStatusCell_CustomReportFragmentFragment, unknown>;
export const CustomReportsTableExpandedRow_CustomReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableExpandedRow_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]} as unknown as DocumentNode<CustomReportsTableExpandedRow_CustomReportFragmentFragment, unknown>;
export const CustomReportsTable_CustomReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTable_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomReportsTableStatusCell_CustomReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomReportsTableExpandedRow_CustomReportFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableStatusCell_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processingErrors"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableExpandedRow_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]} as unknown as DocumentNode<CustomReportsTable_CustomReportFragmentFragment, unknown>;
export const CustomReportsTable_StoryCountFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTable_StoryCountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetStoryCounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetId"}},{"kind":"Field","name":{"kind":"Name","value":"countOfUniqueStories"}}]}}]} as unknown as DocumentNode<CustomReportsTable_StoryCountFragmentFragment, unknown>;
export const CustomReportsTableExpandedRowStoryList_CustomReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableExpandedRowStoryList_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetNamedRanges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"storyContentSpreadsheetReferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"storyContentId"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storyContentId"}},{"kind":"Field","name":{"kind":"Name","value":"storyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomReportsTableExpandedRowStoryList_CustomReportFragmentFragment, unknown>;
export const EditReportModal_NamedRangesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReportModal_NamedRangesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetNamedRanges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<EditReportModal_NamedRangesFragmentFragment, unknown>;
export const UseFetchCustomReports_TrackingFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseFetchCustomReports_TrackingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<UseFetchCustomReports_TrackingFragmentFragment, unknown>;
export const CustomCss_StoryFolderFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomCss_StoryFolderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"storyFolders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<CustomCss_StoryFolderFieldsFragment, unknown>;
export const SetupPdf_StoryFolderFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"storyFolders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<SetupPdf_StoryFolderFieldsFragment, unknown>;
export const GetNamedRangesForAddReportTableModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNamedRangesForAddReportTableModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"spreadsheetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetNamedRangesForAddReportTableModalQuery, GetNamedRangesForAddReportTableModalQueryVariables>;
export const GetSpreadsheetsForAddReportTableModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpreadsheetsForAddReportTableModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSpreadsheetsForAddReportTableModalQuery, GetSpreadsheetsForAddReportTableModalQueryVariables>;
export const GetSpreadsheetNamedRangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpreadsheetNamedRanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"spreadsheetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSpreadsheetNamedRangesQuery, GetSpreadsheetNamedRangesQueryVariables>;
export const GetSpreadsheetsForEditCustomSpreadsheetModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpreadsheetsForEditCustomSpreadsheetModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSpreadsheetsForEditCustomSpreadsheetModalQuery, GetSpreadsheetsForEditCustomSpreadsheetModalQueryVariables>;
export const GetStoryContentSpreadsheetReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoryContentSpreadsheetReferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storyContentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storyContentSpreadsheetReferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"storyContentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storyContentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namedRangeId"}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheetId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetStoryContentSpreadsheetReferencesQuery, GetStoryContentSpreadsheetReferencesQueryVariables>;
export const GetSpreadsheetNamedRangesForEditReportModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpreadsheetNamedRangesForEditReportModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"spreadsheetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditReportModal_NamedRangesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReportModal_NamedRangesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetNamedRanges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetSpreadsheetNamedRangesForEditReportModalQuery, GetSpreadsheetNamedRangesForEditReportModalQueryVariables>;
export const UpdateSpreadsheetNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSpreadsheetName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_spreadsheets_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateSpreadsheetNameMutation, UpdateSpreadsheetNameMutationVariables>;
export const CreateSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_spreadsheets_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSpreadsheetMutation, CreateSpreadsheetMutationVariables>;
export const GetCustomReportStoryCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomReportStoryCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetStoryCounts_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetStoryCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomReportsTable_StoryCountFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTable_StoryCountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetStoryCounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetId"}},{"kind":"Field","name":{"kind":"Name","value":"countOfUniqueStories"}}]}}]} as unknown as DocumentNode<GetCustomReportStoryCountsQuery, GetCustomReportStoryCountsQueryVariables>;
export const GetCustomReportsForTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomReportsForTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseFetchCustomReports_TrackingFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomReportsTable_CustomReportFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheets_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableStatusCell_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processingErrors"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableExpandedRow_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseFetchCustomReports_TrackingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTable_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomReportsTableStatusCell_CustomReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomReportsTableExpandedRow_CustomReportFragment"}}]}}]} as unknown as DocumentNode<GetCustomReportsForTableQuery, GetCustomReportsForTableQueryVariables>;
export const GetSpreadsheetNamedRangesForExpandedRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpreadsheetNamedRangesForExpandedRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreadsheetNamedRanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"spreadsheetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomReportsTableExpandedRowStoryList_CustomReportFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomReportsTableExpandedRowStoryList_CustomReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetNamedRanges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"storyContentSpreadsheetReferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"storyContentId"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storyContentId"}},{"kind":"Field","name":{"kind":"Name","value":"storyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSpreadsheetNamedRangesForExpandedRowQuery, GetSpreadsheetNamedRangesForExpandedRowQueryVariables>;
export const UpdateSpreadsheetForUploadedFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSpreadsheetForUploadedFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processingStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"spreadsheetsProcessingStatus_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_spreadsheets_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processingStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processingStatus"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]}}]} as unknown as DocumentNode<UpdateSpreadsheetForUploadedFileMutation, UpdateSpreadsheetForUploadedFileMutationVariables>;
export const DeleteNavigationMenuByIdForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNavigationMenuByIdForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_publicationNavigationMenuItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteNavigationMenuByIdForOnlinePublicationMutation, DeleteNavigationMenuByIdForOnlinePublicationMutationVariables>;
export const DeleteNavigationMenuStoryByIdForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNavigationMenuStoryByIdForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_publicationNavigationMenuStories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteNavigationMenuStoryByIdForOnlinePublicationMutation, DeleteNavigationMenuStoryByIdForOnlinePublicationMutationVariables>;
export const GetFolderHierarchyWithStoriesForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFolderHierarchyWithStoriesForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicationRootFolder"},"name":{"kind":"Name","value":"storyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentFolder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentFolderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"publicationFolders"},"name":{"kind":"Name","value":"storyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]} as unknown as DocumentNode<GetFolderHierarchyWithStoriesForOnlinePublicationQuery, GetFolderHierarchyWithStoriesForOnlinePublicationQueryVariables>;
export const InsertNavigationMenuItemForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertNavigationMenuItemForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"publicationNavigationMenuItems_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_publicationNavigationMenuItems_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertNavigationMenuItemForOnlinePublicationMutation, InsertNavigationMenuItemForOnlinePublicationMutationVariables>;
export const GetMenuStoriesForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMenuStoriesForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"menuStories"},"name":{"kind":"Name","value":"publicationNavigationMenuStories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"menuId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"storyId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetMenuStoriesForOnlinePublicationQuery, GetMenuStoriesForOnlinePublicationQueryVariables>;
export const GetNavigationMenusForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNavigationMenusForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"menuItems"},"name":{"kind":"Name","value":"publicationNavigationMenuItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicationNavigationMenuStories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"storyId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNavigationMenusForOnlinePublicationQuery, GetNavigationMenusForOnlinePublicationQueryVariables>;
export const GetPublicationBrandingsForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicationBrandingsForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationBrandings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idleBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"activeBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"activeFontColor"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"enableLogoNavigation"}},{"kind":"Field","name":{"kind":"Name","value":"enableGoogleTranslate"}},{"kind":"Field","name":{"kind":"Name","value":"fontStyle"}},{"kind":"Field","name":{"kind":"Name","value":"idleFontColor"}},{"kind":"Field","name":{"kind":"Name","value":"isNavigationMenuSticky"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"showLogoOnFooter"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetPublicationBrandingsForOnlinePublicationQuery, GetPublicationBrandingsForOnlinePublicationQueryVariables>;
export const GetPublicationFooterSettingsForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicationFooterSettingsForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationFooterSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publication"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColors"}},{"kind":"Field","name":{"kind":"Name","value":"fontColors"}},{"kind":"Field","name":{"kind":"Name","value":"mediaLinks"}}]}}]}}]} as unknown as DocumentNode<GetPublicationFooterSettingsForOnlinePublicationQuery, GetPublicationFooterSettingsForOnlinePublicationQueryVariables>;
export const UpdateFooterSettingsForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFooterSettingsForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"publicationFooterSettings_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_publicationFooterSettings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColors"}},{"kind":"Field","name":{"kind":"Name","value":"fontColors"}},{"kind":"Field","name":{"kind":"Name","value":"mediaLinks"}}]}}]}}]} as unknown as DocumentNode<UpdateFooterSettingsForOnlinePublicationMutation, UpdateFooterSettingsForOnlinePublicationMutationVariables>;
export const UpdatePublicationBrandingsForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePublicationBrandingsForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"publicationBrandings_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_publicationBrandings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idleBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"activeBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"activeFontColor"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"enableLogoNavigation"}},{"kind":"Field","name":{"kind":"Name","value":"fontStyle"}},{"kind":"Field","name":{"kind":"Name","value":"idleFontColor"}},{"kind":"Field","name":{"kind":"Name","value":"isNavigationMenuSticky"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"showLogoOnFooter"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"enableGoogleTranslate"}}]}}]}}]} as unknown as DocumentNode<UpdatePublicationBrandingsForOnlinePublicationMutation, UpdatePublicationBrandingsForOnlinePublicationMutationVariables>;
export const UpdatePublicationTocSettingsForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePublicationTocSettingsForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"publicationTOCSettings_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_publicationTOCSettings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"columnLayoutNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"headerHeightSize"}},{"kind":"Field","name":{"kind":"Name","value":"headerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"menuTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"showTableOfContents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hasUserToggledToc"}}]}}]}}]} as unknown as DocumentNode<UpdatePublicationTocSettingsForOnlinePublicationMutation, UpdatePublicationTocSettingsForOnlinePublicationMutationVariables>;
export const InsertStoriesForMenuIdForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertStoriesForMenuIdForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"publicationNavigationMenuStories_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"storiesList"},"name":{"kind":"Name","value":"insert_publicationNavigationMenuStories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertStoriesForMenuIdForOnlinePublicationMutation, InsertStoriesForMenuIdForOnlinePublicationMutationVariables>;
export const GetPublicationTocSettingsForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicationTocSettingsForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationTOCSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"columnLayoutNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"headerHeightSize"}},{"kind":"Field","name":{"kind":"Name","value":"headerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"menuTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"showTableOfContents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hasUserToggledToc"}}]}}]}}]} as unknown as DocumentNode<GetPublicationTocSettingsForOnlinePublicationQuery, GetPublicationTocSettingsForOnlinePublicationQueryVariables>;
export const UpdateMenuStoryNameByIdForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMenuStoryNameByIdForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_publicationNavigationMenuStories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMenuStoryNameByIdForOnlinePublicationMutation, UpdateMenuStoryNameByIdForOnlinePublicationMutationVariables>;
export const UpdateMenuTitleByIdForOnlinePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMenuTitleByIdForOnlinePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_publicationNavigationMenuItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMenuTitleByIdForOnlinePublicationMutation, UpdateMenuTitleByIdForOnlinePublicationMutationVariables>;
export const GetPublicationWithSectionsAndStoriesForCustomCssDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicationWithSectionsAndStoriesForCustomCss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicationRootFolder"},"name":{"kind":"Name","value":"storyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentFolder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentFolderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomCss_StoryFolderFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"publication"},"name":{"kind":"Name","value":"publications_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customCssCode"}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"publicationFolders"},"name":{"kind":"Name","value":"storyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomCss_StoryFolderFields"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomCss_StoryFolderFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomCss_StoryFolderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"storyFolders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<GetPublicationWithSectionsAndStoriesForCustomCssQuery, GetPublicationWithSectionsAndStoriesForCustomCssQueryVariables>;
export const UpdatePublicationCustomCssCodeForCustomCssDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePublicationCustomCssCodeForCustomCss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customCssCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publication"},"name":{"kind":"Name","value":"update_publications_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customCssCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customCssCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customCssCode"}}]}}]}}]} as unknown as DocumentNode<UpdatePublicationCustomCssCodeForCustomCssMutation, UpdatePublicationCustomCssCodeForCustomCssMutationVariables>;
export const UpdateStoryCustomCssCodeForCustomCssDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStoryCustomCssCodeForCustomCss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customCssCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"story"},"name":{"kind":"Name","value":"update_stories_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customCssCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customCssCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customCssCode"}}]}}]}}]} as unknown as DocumentNode<UpdateStoryCustomCssCodeForCustomCssMutation, UpdateStoryCustomCssCodeForCustomCssMutationVariables>;
export const UpdatePublicationUpdatedAtForCustomCssDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePublicationUpdatedAtForCustomCss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publication"},"name":{"kind":"Name","value":"update_publications_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdatePublicationUpdatedAtForCustomCssMutation, UpdatePublicationUpdatedAtForCustomCssMutationVariables>;
export const GetStoryWithContentForCustomCssDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoryWithContentForCustomCss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"customCssCode"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"storyId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"opengovId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentChartConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentId"}},{"kind":"Field","name":{"kind":"Name","value":"storyId"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStoryWithContentForCustomCssQuery, GetStoryWithContentForCustomCssQueryVariables>;
export const GetPublicationHierarchyForSetupPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicationHierarchyForSetupPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"storyStates_enum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicationRootFolder"},"name":{"kind":"Name","value":"storyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentFolder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentFolderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"publication"},"name":{"kind":"Name","value":"publications_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"customCssCode"}},{"kind":"Field","alias":{"kind":"Name","value":"publicationFolders"},"name":{"kind":"Name","value":"storyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"storyFolders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<GetPublicationHierarchyForSetupPdfQuery, GetPublicationHierarchyForSetupPdfQueryVariables>;
export const GetSectionHierarchyForSetupPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSectionHierarchyForSetupPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"storyStates_enum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SetupPdf_StoryFolderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"storyFolders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<GetSectionHierarchyForSetupPdfQuery, GetSectionHierarchyForSetupPdfQueryVariables>;
export const GetStoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetStoriesQuery, GetStoriesQueryVariables>;